import React from 'react';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

// export const FacebookIcon = (
//   <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M34 17C34 7.61122 26.3888 0 17 0C7.61122 0 0 7.61122 0 17C0 25.4851 6.21669 32.5182 14.3438 33.7935V21.9141H10.0273V17H14.3438V13.2547C14.3438 8.99406 16.8818 6.64062 20.765 6.64062C22.6249 6.64062 24.5703 6.97266 24.5703 6.97266V11.1562H22.4267C20.3149 11.1562 19.6562 12.4667 19.6562 13.8112V17H24.3711L23.6174 21.9141H19.6562V33.7935C27.7833 32.5182 34 25.4853 34 17Z" fill="#1877F2"/>
// <path d="M23.6135 21.9141L24.3672 17H19.6523V13.8112C19.6523 12.4666 20.311 11.1562 22.4228 11.1562H24.5664V6.97266C24.5664 6.97266 22.621 6.64062 20.7609 6.64062C16.8779 6.64062 14.3398 8.99406 14.3398 13.2547V17H10.0234V21.9141H14.3398V33.7935C15.2186 33.9312 16.1067 34.0002 16.9961 34C17.8855 34.0002 18.7736 33.9312 19.6523 33.7935V21.9141H23.6135Z" fill="white"/>
// </svg>

// )
export const StaticProfileImg = (
  <svg
    width='62'
    height='62'
    viewBox='0 0 62 62'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M30.9999 3.40607e-10C35.0709 -1.90824e-05 39.102 0.801803 42.8631 2.35969C46.6242 3.91757 50.0417 6.20101 52.9203 9.07962C55.7989 11.9582 58.0824 15.3756 59.6403 19.1367C61.1982 22.8978 62 26.9289 62 30.9999C62 48.1208 48.1208 62 30.9999 62C13.8792 62 0 48.1208 0 30.9999C0 13.8792 13.8792 3.40607e-10 30.9999 3.40607e-10ZM34.1 34.1H27.9C20.2253 34.1 13.6364 38.7481 10.7945 45.3832C15.2911 51.6885 22.6654 55.8 30.9999 55.8C39.3345 55.8 46.7088 51.6885 51.2055 45.3828C48.3636 38.7481 41.7747 34.1 34.1 34.1ZM30.9999 9.29999C25.8637 9.29999 21.6999 13.4638 21.6999 18.6C21.6999 23.7362 25.8637 27.9 30.9999 27.9C36.1361 27.9 40.2999 23.7362 40.2999 18.6C40.2999 13.4638 36.1363 9.29999 30.9999 9.29999Z'
      fill='#D9D9D9'
    />
  </svg>
);

export const PostMesgIcon = (
  <svg
    width='34'
    height='34'
    viewBox='0 0 34 34'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='17' cy='17' r='17' fill='#F3F3F3' />
    <path
      d='M11.957 11.2656H23.0404C23.6703 11.2656 24.2743 11.5158 24.7197 11.9612C25.1651 12.4066 25.4154 13.0107 25.4154 13.6406V19.974C25.4154 20.6038 25.1651 21.2079 24.7197 21.6533C24.2743 22.0987 23.6703 22.349 23.0404 22.349H17.5319L12.4304 26.1553C12.3127 26.2431 12.1729 26.2965 12.0266 26.3094C11.8802 26.3223 11.7332 26.2942 11.6019 26.2283C11.4706 26.1624 11.3603 26.0613 11.2832 25.9363C11.2061 25.8113 11.1653 25.6673 11.1654 25.5204V22.349C10.7454 22.349 10.3427 22.1821 10.0458 21.8852C9.74885 21.5883 9.58203 21.1856 9.58203 20.7656V13.6406C9.58203 13.0107 9.83225 12.4066 10.2777 11.9612C10.7231 11.5158 11.3271 11.2656 11.957 11.2656ZM19.8737 18.3906C20.2936 18.3906 20.6964 18.2238 20.9933 17.9269C21.2902 17.6299 21.457 17.2272 21.457 16.8073C21.457 16.3874 21.2902 15.9846 20.9933 15.6877C20.6964 15.3908 20.2936 15.224 19.8737 15.224C19.4538 15.224 19.051 15.3908 18.7541 15.6877C18.4572 15.9846 18.2904 16.3874 18.2904 16.8073C18.2904 17.2272 18.4572 17.6299 18.7541 17.9269C19.051 18.2238 19.4538 18.3906 19.8737 18.3906ZM15.1237 18.3906C15.5436 18.3906 15.9464 18.2238 16.2433 17.9269C16.5402 17.6299 16.707 17.2272 16.707 16.8073C16.707 16.3874 16.5402 15.9846 16.2433 15.6877C15.9464 15.3908 15.5436 15.224 15.1237 15.224C14.7038 15.224 14.301 15.3908 14.0041 15.6877C13.7072 15.9846 13.5404 16.3874 13.5404 16.8073C13.5404 17.2272 13.7072 17.6299 14.0041 17.9269C14.301 18.2238 14.7038 18.3906 15.1237 18.3906Z'
      fill='black'
    />
  </svg>
);

export const EmojiHeartIcon = (
  <svg
    width='20'
    height='20'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clip-path='url(#clip0_7264_12523)'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M14 7C14 10.85 10.85 14 7 14C3.15 14 0 10.85 0 7C0 3.15 3.15 0 7 0C10.85 0 14 3.15 14 7Z'
        fill='url(#paint0_linear_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M14 7C14 10.85 10.85 14 7 14C3.15 14 0 10.85 0 7C0 3.15 3.15 0 7 0C10.85 0 14 3.15 14 7Z'
        fill='url(#paint1_radial_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M14 7C14 10.85 10.85 14 7 14C3.15 14 0 10.85 0 7C0 3.15 3.15 0 7 0C10.85 0 14 3.15 14 7Z'
        fill='url(#paint2_radial_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M14 7C14 10.85 10.85 14 7 14C3.15 14 0 10.85 0 7C0 3.15 3.15 0 7 0C10.85 0 14 3.15 14 7Z'
        fill='url(#paint3_radial_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M14 7C14 10.85 10.85 14 7 14C3.15 14 0 10.85 0 7C0 3.15 3.15 0 7 0C10.85 0 14 3.15 14 7Z'
        fill='url(#paint4_radial_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M14 7C14 10.85 10.85 14 7 14C3.15 14 0 10.85 0 7C0 3.15 3.15 0 7 0C10.85 0 14 3.15 14 7Z'
        fill='url(#paint5_radial_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.4911 5.16563C8.4036 4.90312 5.6036 4.90312 5.5161 5.16563C5.4286 5.42813 6.0411 5.77812 7.0036 5.77812C7.9661 5.77812 8.5786 5.42813 8.4911 5.16563Z'
        fill='url(#paint6_linear_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.25156 3.58437C5.25156 4.19687 4.90156 4.37187 4.37656 4.45937C3.85156 4.54687 3.41406 4.28437 3.41406 3.58437C3.41406 3.05937 3.67656 2.35938 4.37656 2.35938C4.98906 2.35938 5.25156 3.05937 5.25156 3.58437Z'
        fill='url(#paint7_radial_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.28438 2.71406C4.37187 2.80156 4.37188 3.06406 4.19688 3.15156C4.10938 3.23906 3.93438 3.32656 3.84688 3.15156C3.75938 2.97656 3.75938 2.88906 3.84688 2.71406C4.02188 2.62656 4.19687 2.62656 4.28438 2.71406Z'
        fill='#4E506A'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.75 3.58437C8.75 4.19687 9.1 4.37187 9.7125 4.45937C10.2375 4.54687 10.675 4.28437 10.675 3.58437C10.675 3.05937 10.4125 2.35938 9.7125 2.35938C9.0125 2.35938 8.75 3.05937 8.75 3.58437Z'
        fill='url(#paint8_radial_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.62218 2.70938C9.70968 2.79688 9.62218 2.97187 9.53468 3.14687C9.44718 3.23438 9.27218 3.23438 9.18468 3.14687C9.09718 3.05937 9.18468 2.88438 9.27218 2.70938C9.44718 2.53438 9.53468 2.53438 9.62218 2.70938Z'
        fill='#4E506A'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M2.97669 1.8337C2.80169 2.0087 2.97669 2.2712 3.23919 2.1837C3.76419 1.9212 4.81419 1.6587 5.68919 1.7462C5.95169 1.7462 6.03919 1.7462 5.95169 1.3962C5.95169 1.1337 5.60169 0.958699 4.90169 1.0462C3.85169 1.1337 3.15169 1.6587 2.97669 1.8337Z'
        fill='url(#paint9_radial_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.09844 1.0462C8.39844 0.958699 8.04844 1.1337 8.04844 1.3962C7.96094 1.7462 8.04844 1.7462 8.31094 1.7462C9.27344 1.6587 10.3234 1.9212 10.7609 2.1837C11.1109 2.3587 11.1984 2.0087 11.0234 1.8337C10.8484 1.6587 10.1484 1.1337 9.09844 1.0462Z'
        fill='url(#paint10_radial_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.48775 7.43614C6.65025 6.91114 6.03775 8.13614 6.03775 8.13614C6.03775 8.13614 6.21275 6.73614 4.37525 6.12364C2.62525 5.59864 1.57525 7.26114 1.48775 8.22364C1.31275 10.4111 3.23775 12.8611 3.93775 13.7361C4.02525 13.9986 4.28775 13.9986 4.55025 13.9986C5.60025 13.7361 8.57525 12.7736 9.71275 10.8486C10.1503 9.88614 10.2378 7.96114 8.48775 7.43614Z'
        fill='url(#paint11_linear_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.48775 7.43614C6.65025 6.91114 6.03775 8.13614 6.03775 8.13614C6.03775 8.13614 6.21275 6.73614 4.37525 6.12364C2.62525 5.59864 1.57525 7.26114 1.48775 8.22364C1.31275 10.4111 3.23775 12.8611 3.93775 13.7361C4.02525 13.9986 4.28775 13.9986 4.55025 13.9986C5.60025 13.7361 8.57525 12.7736 9.71275 10.8486C10.1503 9.88614 10.2378 7.96114 8.48775 7.43614Z'
        fill='url(#paint12_radial_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.48775 7.43614C6.65025 6.91114 6.03775 8.13614 6.03775 8.13614C6.03775 8.13614 6.21275 6.73614 4.37525 6.12364C2.62525 5.59864 1.57525 7.26114 1.48775 8.22364C1.31275 10.4111 3.23775 12.8611 3.93775 13.7361C4.02525 13.9986 4.28775 13.9986 4.55025 13.9986C5.60025 13.7361 8.57525 12.7736 9.71275 10.8486C10.1503 9.88614 10.2378 7.96114 8.48775 7.43614Z'
        fill='url(#paint13_radial_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.48775 7.43614C6.65025 6.91114 6.03775 8.13614 6.03775 8.13614C6.03775 8.13614 6.21275 6.73614 4.37525 6.12364C2.62525 5.59864 1.57525 7.26114 1.48775 8.22364C1.31275 10.4111 3.23775 12.8611 3.93775 13.7361C4.02525 13.9986 4.28775 13.9986 4.55025 13.9986C5.60025 13.7361 8.57525 12.7736 9.71275 10.8486C10.1503 9.88614 10.2378 7.96114 8.48775 7.43614Z'
        fill='url(#paint14_radial_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.48775 7.43614C6.65025 6.91114 6.03775 8.13614 6.03775 8.13614C6.03775 8.13614 6.21275 6.73614 4.37525 6.12364C2.62525 5.59864 1.57525 7.26114 1.48775 8.22364C1.31275 10.4111 3.23775 12.8611 3.93775 13.7361C4.02525 13.9986 4.28775 13.9986 4.55025 13.9986C5.60025 13.7361 8.57525 12.7736 9.71275 10.8486C10.1503 9.88614 10.2378 7.96114 8.48775 7.43614Z'
        fill='url(#paint15_radial_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.48775 7.43614C6.65025 6.91114 6.03775 8.13614 6.03775 8.13614C6.03775 8.13614 6.21275 6.73614 4.37525 6.12364C2.62525 5.59864 1.57525 7.26114 1.48775 8.22364C1.31275 10.4111 3.23775 12.8611 3.93775 13.7361C4.02525 13.9986 4.28775 13.9986 4.55025 13.9986C5.60025 13.7361 8.57525 12.7736 9.71275 10.8486C10.1503 9.88614 10.2378 7.96114 8.48775 7.43614Z'
        fill='url(#paint16_radial_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.48775 7.43614C6.65025 6.91114 6.03775 8.13614 6.03775 8.13614C6.03775 8.13614 6.21275 6.73614 4.37525 6.12364C2.62525 5.59864 1.57525 7.26114 1.48775 8.22364C1.31275 10.4111 3.23775 12.8611 3.93775 13.7361C4.02525 13.9986 4.28775 13.9986 4.55025 13.9986C5.60025 13.7361 8.57525 12.7736 9.71275 10.8486C10.1503 9.88614 10.2378 7.96114 8.48775 7.43614Z'
        fill='url(#paint17_radial_7264_12523)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M1.13795 6.73486C0.700455 6.29736 -0.0870449 6.03486 -0.174545 7.08486C-0.262045 7.87236 0.087955 9.27236 1.05046 10.0599C3.50045 11.9849 5.68795 10.9349 5.77545 9.53486C5.86295 8.48486 4.55046 8.57236 4.20046 8.57236V8.48486C4.28796 8.39736 4.46295 8.30986 4.55045 8.22236C4.90045 7.95986 4.72545 7.52236 4.28795 7.60986C4.20046 7.60986 3.15045 7.95986 2.45046 7.69736C1.75046 7.43486 1.66296 7.17236 1.13795 6.73486Z'
        fill='url(#paint18_radial_7264_12523)'
      />
      <path
        d='M12.5099 6.82309C12.7724 6.29809 13.2099 6.47309 13.4724 6.56059C13.8224 6.64809 14.0849 6.91059 14.0849 7.43559C14.0849 8.74809 13.9099 9.97309 12.7724 11.1981C10.7599 13.4731 7.34743 13.1231 6.99743 11.7231C6.73493 10.6731 7.95993 10.4981 8.39743 10.4981V10.4106C8.22243 10.3231 8.13493 10.2356 7.95993 10.1481C7.60993 9.88559 7.69743 9.36059 8.13493 9.44809C8.65993 9.53559 9.35993 9.71059 9.88493 9.62309C11.5474 9.44809 11.8099 8.13559 12.5099 6.82309Z'
        fill='url(#paint19_radial_7264_12523)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_7264_12523'
        x1='6.993'
        y1='13.307'
        x2='6.993'
        y2='1.043'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#F28A2D' />
        <stop offset='1' stop-color='#FDE86F' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(6.993 6.993) scale(7)'
      >
        <stop stop-color='#F28A2D' stop-opacity='0' />
        <stop offset='1' stop-color='#F08423' stop-opacity='0.34' />
      </radialGradient>
      <radialGradient
        id='paint2_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(1.51435 7.28053) rotate(24.1484) scale(1.414 1.09371)'
      >
        <stop stop-color='#F28A2D' stop-opacity='0.5' />
        <stop offset='1' stop-color='#F28A2D' stop-opacity='0' />
      </radialGradient>
      <radialGradient
        id='paint3_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(10.3843 10.3019) rotate(-38.243) scale(3.96201 1.44141)'
      >
        <stop stop-color='#F28A2D' stop-opacity='0.5' />
        <stop offset='1' stop-color='#F28A2D' stop-opacity='0' />
      </radialGradient>
      <radialGradient
        id='paint4_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(4.45699 1.77604) rotate(-10.3559) scale(1.498 0.29789)'
      >
        <stop stop-color='#D45F00' stop-opacity='0.15' />
        <stop offset='1' stop-color='#F28A2D' stop-opacity='0' />
      </radialGradient>
      <radialGradient
        id='paint5_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(9.53 1.87866) rotate(11.5352) scale(1.484 0.295119)'
      >
        <stop stop-color='#D45F00' stop-opacity='0.15' />
        <stop offset='1' stop-color='#D45F00' stop-opacity='0' />
      </radialGradient>
      <linearGradient
        id='paint6_linear_7264_12523'
        x1='7.00337'
        y1='4.64878'
        x2='7.00337'
        y2='5.8947'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#482314' />
        <stop offset='1' stop-color='#9A4111' />
      </linearGradient>
      <radialGradient
        id='paint7_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(4.37025 3.73412) rotate(-90) scale(1.62717 1.62725)'
      >
        <stop stop-color='#3B446B' />
        <stop offset='0.688' stop-color='#202340' />
      </radialGradient>
      <radialGradient
        id='paint8_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(9.63094 3.73312) rotate(-90) scale(1.62717 1.62725)'
      >
        <stop stop-color='#3B446B' />
        <stop offset='0.688' stop-color='#202340' />
      </radialGradient>
      <radialGradient
        id='paint9_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(4.37801 1.49301) rotate(-104.427) scale(0.354779 1.64454)'
      >
        <stop stop-color='#E38200' />
        <stop offset='1' stop-color='#CD6700' />
      </radialGradient>
      <radialGradient
        id='paint10_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(9.56641 1.33604) rotate(-79.0815) scale(0.373805 2.21832)'
      >
        <stop stop-color='#E38200' />
        <stop offset='1' stop-color='#CD6700' />
      </radialGradient>
      <linearGradient
        id='paint11_linear_7264_12523'
        x1='5.90945'
        y1='8.52789'
        x2='4.13259'
        y2='14.2522'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#F34462' />
        <stop offset='1' stop-color='#CC0820' />
      </linearGradient>
      <radialGradient
        id='paint12_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(7.73572 9.56677) rotate(20.3927) scale(2.3038 2.30381)'
      >
        <stop stop-color='#FF7091' stop-opacity='0.7' />
        <stop offset='1' stop-color='#FE6D8E' stop-opacity='0' />
      </radialGradient>
      <radialGradient
        id='paint13_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(3.73497 8.40635) rotate(20.3927) scale(2.3038 2.30381)'
      >
        <stop stop-color='#FF7091' stop-opacity='0.7' />
        <stop offset='1' stop-color='#FE6D8E' stop-opacity='0' />
      </radialGradient>
      <radialGradient
        id='paint14_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(3.48659 10.2907) rotate(101.61) scale(1.97808 2.72382)'
      >
        <stop stop-color='#9C0600' />
        <stop offset='1' stop-color='#9C0600' stop-opacity='0' />
      </radialGradient>
      <radialGradient
        id='paint15_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(9.98759 10.4923) rotate(30.6331) scale(1.19162 1.49552)'
      >
        <stop stop-color='#9C0600' stop-opacity='0.5' />
        <stop offset='1' stop-color='#9C0600' stop-opacity='0' />
      </radialGradient>
      <radialGradient
        id='paint16_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(1.79989 7.9729) rotate(-20.1593) scale(1.03274 1.33085)'
      >
        <stop stop-color='#9C0600' stop-opacity='0.5' />
        <stop offset='1' stop-color='#9C0600' stop-opacity='0' />
      </radialGradient>
      <radialGradient
        id='paint17_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(7.81838 12.1739) rotate(34.0715) scale(1.39022 1.50569)'
      >
        <stop stop-color='#9C0600' stop-opacity='0.999' />
        <stop offset='1' stop-color='#9C0600' stop-opacity='0' />
      </radialGradient>
      <radialGradient
        id='paint18_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(-0.0703192 6.53287) rotate(36.5187) scale(5.81744 5.81738)'
      >
        <stop stop-color='#EDA83A' />
        <stop offset='1' stop-color='#FFDC5E' />
      </radialGradient>
      <radialGradient
        id='paint19_radial_7264_12523'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(13.6947 6.76796) scale(7.74025)'
      >
        <stop stop-color='#EDA83A' />
        <stop offset='1' stop-color='#FFDC5E' />
      </radialGradient>
      <clipPath id='clip0_7264_12523'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export const HomeIcon = (
  <svg
    width='22'
    height='21'
    viewBox='0 0 22 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1 8.33463L9.7506 1.43213C10.481 0.855957 11.519 0.855957 12.2494 1.43213L21 8.33463'
      fill='black'
    />
    <path
      d='M8.47763 2.46735L4.47763 5.67186C3.75138 6.25368 3.38825 6.54459 3.19412 6.94673C3 7.34887 3 7.81021 3 8.73288V12.2786C3 15.9971 3 17.8564 4.17157 19.0115C5.34315 20.1667 7.22876 20.1667 11 20.1667C14.7712 20.1667 16.6569 20.1667 17.8284 19.0115C19 17.8564 19 15.9971 19 12.2786V8.73288C19 7.81021 19 7.34887 18.8059 6.94673C18.6117 6.54459 18.2486 6.25368 17.5224 5.67186L13.5224 2.46735C12.3142 1.49943 11.7101 1.01547 11 1.01547C10.2899 1.01547 9.6858 1.49943 8.47763 2.46735Z'
      fill='black'
    />
    <path
      d='M0.53551 7.74578C0.210295 8.00231 0.154615 8.47391 0.411146 8.79912C0.667677 9.12434 1.13927 9.18002 1.46449 8.92349L0.53551 7.74578ZM9.7506 1.43213L10.2151 2.02098L10.2151 2.02097L9.7506 1.43213ZM12.2494 1.43213L11.7849 2.02097L11.7849 2.02098L12.2494 1.43213ZM20.5355 8.92349C20.8607 9.18002 21.3323 9.12434 21.5889 8.79912C21.8454 8.47391 21.7897 8.00231 21.4645 7.74578L20.5355 8.92349ZM8.47763 2.46735L8.94655 3.05268L8.94656 3.05268L8.47763 2.46735ZM4.47763 5.67186L4.00871 5.08653L4.00871 5.08653L4.47763 5.67186ZM3.19412 6.94673L2.5187 6.62068L2.51869 6.62069L3.19412 6.94673ZM4.17157 19.0115L4.69815 18.4774L4.69813 18.4774L4.17157 19.0115ZM17.8284 19.0115L17.3018 18.4774L17.3018 18.4774L17.8284 19.0115ZM18.8059 6.94673L19.4813 6.62072L19.4813 6.62059L18.8059 6.94673ZM17.5224 5.67186L17.9913 5.08655L17.9913 5.08653L17.5224 5.67186ZM13.5224 2.46735L13.9913 1.88202L13.9913 1.88202L13.5224 2.46735ZM8.75 13.7471C8.33579 13.7471 8 14.0829 8 14.4971C8 14.9114 8.33579 15.2471 8.75 15.2471V13.7471ZM13.25 15.2471C13.6642 15.2471 14 14.9114 14 14.4971C14 14.0829 13.6642 13.7471 13.25 13.7471V15.2471ZM1.46449 8.92349L10.2151 2.02098L9.28611 0.843274L0.53551 7.74578L1.46449 8.92349ZM10.2151 2.02097C10.6731 1.65968 11.3269 1.65968 11.7849 2.02097L12.7139 0.843285C11.7111 0.0522382 10.2889 0.0522382 9.2861 0.843285L10.2151 2.02097ZM11.7849 2.02098L20.5355 8.92349L21.4645 7.74578L12.7139 0.843274L11.7849 2.02098ZM8.00871 1.88202L4.00871 5.08653L4.94655 6.25719L8.94655 3.05268L8.00871 1.88202ZM4.00871 5.08653C3.33882 5.6232 2.80408 6.02951 2.5187 6.62068L3.86954 7.27279C3.97242 7.05967 4.16394 6.88416 4.94655 6.25719L4.00871 5.08653ZM2.51869 6.62069C2.23256 7.21345 2.25 7.8822 2.25 8.73288H3.75C3.75 7.73821 3.76744 7.48429 3.86954 7.27277L2.51869 6.62069ZM2.25 8.73288V12.2786H3.75V8.73288H2.25ZM2.25 12.2786C2.25 14.1164 2.24836 15.5712 2.40332 16.7076C2.56137 17.8667 2.89477 18.8058 3.64501 19.5455L4.69813 18.4774C4.2768 18.062 4.02441 17.4939 3.88957 16.505C3.75164 15.4934 3.75 14.1593 3.75 12.2786H2.25ZM3.64499 19.5455C4.39374 20.2838 5.34183 20.6106 6.51235 20.7658C7.66236 20.9182 9.13529 20.9167 11 20.9167V19.4167C9.09347 19.4167 7.73798 19.4151 6.70948 19.2788C5.70148 19.1451 5.12098 18.8943 4.69815 18.4774L3.64499 19.5455ZM11 20.9167C12.8647 20.9167 14.3376 20.9182 15.4876 20.7658C16.6582 20.6106 17.6063 20.2838 18.355 19.5455L17.3018 18.4774C16.879 18.8943 16.2985 19.1451 15.2905 19.2788C14.262 19.4151 12.9065 19.4167 11 19.4167V20.9167ZM18.355 19.5455C19.1052 18.8058 19.4386 17.8667 19.5967 16.7076C19.7516 15.5712 19.75 14.1164 19.75 12.2786H18.25C18.25 14.1593 18.2484 15.4934 18.1104 16.505C17.9756 17.4939 17.7232 18.062 17.3018 18.4774L18.355 19.5455ZM19.75 12.2786V8.73288H18.25V12.2786H19.75ZM19.75 8.73288C19.75 7.8822 19.7674 7.21347 19.4813 6.62072L18.1305 7.27274C18.2326 7.48428 18.25 7.73821 18.25 8.73288H19.75ZM19.4813 6.62059C19.1958 6.02951 18.6612 5.62325 17.9913 5.08655L17.0535 6.25717C17.836 6.88412 18.0276 7.05967 18.1305 7.27288L19.4813 6.62059ZM17.9913 5.08653L13.9913 1.88202L13.0535 3.05268L17.0535 6.25719L17.9913 5.08653ZM13.9913 1.88202C13.4017 1.4097 12.9078 1.01231 12.4692 0.740779C12.0131 0.458346 11.5462 0.265473 11 0.265473V1.76547C11.1639 1.76547 11.3541 1.81458 11.6796 2.01611C12.0227 2.22854 12.4348 2.55708 13.0535 3.05268L13.9913 1.88202ZM11 0.265473C10.4538 0.265473 9.98691 0.458346 9.53077 0.740781C9.09223 1.01231 8.59826 1.4097 8.0087 1.88203L8.94656 3.05268C9.56517 2.55708 9.97733 2.22853 10.3204 2.0161C10.6459 1.81458 10.8361 1.76547 11 1.76547V0.265473ZM8.75 15.2471H13.25V13.7471H8.75V15.2471Z'
      fill='black'
    />
  </svg>
);

export const AlertIcon = (
  <svg
    width='21'
    height='19'
    viewBox='0 0 21 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      id='Vector'
      d='M11.433 1.05965L20.067 16.4242C20.1986 16.6584 20.2679 16.9242 20.2679 17.1947C20.2679 17.4653 20.1986 17.731 20.067 17.9653C19.9353 18.1996 19.746 18.3942 19.518 18.5294C19.2899 18.6647 19.0313 18.7359 18.768 18.7359H1.49996C1.23666 18.7359 0.977999 18.6647 0.749975 18.5294C0.521952 18.3942 0.3326 18.1996 0.200952 17.9653C0.0693043 17.731 -1.67225e-06 17.4653 0 17.1947C1.67231e-06 16.9242 0.0693109 16.6584 0.200962 16.4242L8.83496 1.05965C9.41196 0.0321997 10.855 0.0321997 11.433 1.05965ZM10.134 2.85769L2.36596 16.681H17.902L10.134 2.85769ZM10.134 13.237C10.3992 13.237 10.6535 13.3453 10.8411 13.5379C11.0286 13.7306 11.134 13.992 11.134 14.2645C11.134 14.5369 11.0286 14.7983 10.8411 14.991C10.6535 15.1837 10.3992 15.2919 10.134 15.2919C9.86874 15.2919 9.61439 15.1837 9.42686 14.991C9.23932 14.7983 9.13396 14.5369 9.13396 14.2645C9.13396 13.992 9.23932 13.7306 9.42686 13.5379C9.61439 13.3453 9.86874 13.237 10.134 13.237ZM10.134 6.04484C10.3992 6.04484 10.6535 6.15309 10.8411 6.34578C11.0286 6.53846 11.134 6.7998 11.134 7.07229V11.1821C11.134 11.4546 11.0286 11.7159 10.8411 11.9086C10.6535 12.1013 10.3992 12.2095 10.134 12.2095C9.86874 12.2095 9.61439 12.1013 9.42686 11.9086C9.23932 11.7159 9.13396 11.4546 9.13396 11.1821V7.07229C9.13396 6.7998 9.23932 6.53846 9.42686 6.34578C9.61439 6.15309 9.86874 6.04484 10.134 6.04484Z'
      fill='#A2A2A2'
    />
  </svg>
);

export const ListenerIcon = (
  <svg
    width='21'
    height='20'
    viewBox='0 0 21 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.52148 1.01632e-08C6.43393 -1.65806e-05 6.34724 0.0206654 6.26635 0.0608633C6.18546 0.101061 6.11196 0.159988 6.05005 0.234278C5.98814 0.308568 5.93903 0.396767 5.90554 0.493835C5.87204 0.590903 5.8548 0.694939 5.85482 0.800002V19.2C5.85482 19.4122 5.92506 19.6157 6.05008 19.7657C6.1751 19.9157 6.34467 20 6.52148 20C6.6983 20 6.86786 19.9157 6.99289 19.7657C7.11791 19.6157 7.18815 19.4122 7.18815 19.2V0.8C7.18816 0.694938 7.17093 0.590901 7.13743 0.493833C7.10393 0.396765 7.05483 0.308568 6.99292 0.234278C6.93101 0.159988 6.85751 0.10106 6.77662 0.0608624C6.69573 0.0206646 6.60904 -1.67372e-05 6.52148 1.01632e-08Z'
      fill='black'
    />
    <path
      d='M3.59968 3.66842C3.68057 3.62841 3.76727 3.60783 3.85482 3.60784C3.94237 3.60783 4.02907 3.62841 4.10996 3.66842C4.19085 3.70843 4.26434 3.76708 4.32625 3.84102C4.38816 3.91496 4.43727 4.00275 4.47077 4.09936C4.50426 4.19597 4.5215 4.29952 4.52148 4.40409V15.5959C4.52148 15.8071 4.45125 16.0096 4.32622 16.1589C4.2012 16.3083 4.03163 16.3922 3.85482 16.3922C3.67801 16.3922 3.50844 16.3083 3.38341 16.1589C3.25839 16.0096 3.18815 15.8071 3.18815 15.5959V4.40409C3.18814 4.29952 3.20537 4.19597 3.23887 4.09936C3.27237 4.00275 3.32147 3.91496 3.38338 3.84102C3.44529 3.76708 3.51879 3.70843 3.59968 3.66842Z'
      fill='black'
    />
    <path
      d='M0.933012 6.72713C1.0139 6.68719 1.1006 6.66665 1.18815 6.66667C1.2757 6.66665 1.3624 6.68719 1.44329 6.72713C1.52418 6.76706 1.59768 6.82559 1.65959 6.89939C1.72149 6.97319 1.7706 7.0608 1.8041 7.15722C1.8376 7.25365 1.85483 7.35699 1.85482 7.46136V12.5386C1.85482 12.643 1.83757 12.7463 1.80407 12.8428C1.77057 12.9392 1.72146 13.0268 1.65956 13.1006C1.59765 13.1744 1.52416 13.2329 1.44327 13.2728C1.36239 13.3128 1.2757 13.3333 1.18815 13.3333C1.1006 13.3333 1.01391 13.3128 0.933029 13.2728C0.852145 13.2329 0.778653 13.1744 0.716747 13.1006C0.654841 13.0268 0.605735 12.9392 0.572232 12.8428C0.538729 12.7463 0.521484 12.643 0.521484 12.5386V7.46136C0.52147 7.35699 0.538705 7.25365 0.572203 7.15722C0.605701 7.0608 0.654807 6.97319 0.716716 6.89939C0.778624 6.82559 0.852122 6.76706 0.933012 6.72713Z'
      fill='black'
    />
    <path
      d='M8.93301 3.66842C9.0139 3.62841 9.1006 3.60783 9.18815 3.60784C9.2757 3.60783 9.3624 3.62841 9.44329 3.66842C9.52418 3.70843 9.59768 3.76708 9.65958 3.84102C9.72149 3.91496 9.7706 4.00275 9.8041 4.09936C9.8376 4.19597 9.85483 4.29952 9.85482 4.40409V15.5959C9.85482 15.8071 9.78458 16.0096 9.65956 16.1589C9.53453 16.3083 9.36496 16.3922 9.18815 16.3922C9.01134 16.3922 8.84177 16.3083 8.71675 16.1589C8.59172 16.0096 8.52148 15.8071 8.52148 15.5959V4.40409C8.52147 4.29952 8.5387 4.19597 8.5722 4.09936C8.6057 4.00275 8.65481 3.91496 8.71671 3.84102C8.77862 3.76708 8.85212 3.70843 8.93301 3.66842Z'
      fill='black'
    />
    <path
      d='M11.8548 6.66667C11.7673 6.66665 11.6806 6.68719 11.5997 6.72712C11.5188 6.76706 11.4453 6.82559 11.3834 6.89939C11.3215 6.97319 11.2724 7.0608 11.2389 7.15722C11.2054 7.25365 11.1881 7.35699 11.1882 7.46136V12.5386C11.1882 12.7494 11.2584 12.9515 11.3834 13.1006C11.5084 13.2496 11.678 13.3333 11.8548 13.3333C12.0316 13.3333 12.2012 13.2496 12.3262 13.1006C12.4512 12.9515 12.5215 12.7494 12.5215 12.5386V7.46136C12.5215 7.35699 12.5043 7.25365 12.4708 7.15722C12.4373 7.0608 12.3882 6.97319 12.3263 6.89939C12.2643 6.82559 12.1908 6.76706 12.11 6.72713C12.0291 6.68719 11.9424 6.66665 11.8548 6.66667Z'
      fill='black'
    />
    <path
      d='M14.2663 3.66842C14.3472 3.62841 14.4339 3.60783 14.5215 3.60784C14.609 3.60783 14.6957 3.62841 14.7766 3.66842C14.8575 3.70843 14.931 3.76708 14.9929 3.84102C15.0548 3.91496 15.1039 4.00275 15.1374 4.09936C15.1709 4.19597 15.1882 4.29952 15.1882 4.40409V15.5959C15.1882 15.8071 15.1179 16.0096 14.9929 16.1589C14.8679 16.3083 14.6983 16.3922 14.5215 16.3922C14.3447 16.3922 14.1751 16.3083 14.0501 16.1589C13.9251 16.0096 13.8548 15.8071 13.8548 15.5959V4.40409C13.8548 4.29952 13.872 4.19597 13.9055 4.09936C13.939 4.00275 13.9881 3.91496 14.05 3.84102C14.112 3.76708 14.1855 3.70843 14.2663 3.66842Z'
      fill='black'
    />
    <path
      d='M17.1882 6.66667C17.1006 6.66665 17.0139 6.68719 16.933 6.72713C16.8521 6.76706 16.7786 6.82559 16.7167 6.89939C16.6548 6.97319 16.6057 7.0608 16.5722 7.15722C16.5387 7.25365 16.5215 7.35699 16.5215 7.46136V12.5386C16.5215 12.7494 16.5917 12.9515 16.7167 13.1006C16.8418 13.2496 17.0113 13.3333 17.1882 13.3333C17.365 13.3333 17.5345 13.2496 17.6596 13.1006C17.7846 12.9515 17.8548 12.7494 17.8548 12.5386V7.46136C17.8548 7.35699 17.8376 7.25365 17.8041 7.15722C17.7706 7.0608 17.7215 6.97319 17.6596 6.89939C17.5977 6.82559 17.5242 6.76706 17.4433 6.72713C17.3624 6.68719 17.2757 6.66665 17.1882 6.66667Z'
      fill='black'
    />
    <path
      d='M19.8548 9.17647C19.4866 9.17647 19.1882 9.52762 19.1882 9.96078C19.1882 10.3939 19.4866 10.7451 19.8548 10.7451C20.223 10.7451 20.5215 10.3939 20.5215 9.96078C20.5215 9.52762 20.223 9.17647 19.8548 9.17647Z'
      fill='black'
    />
  </svg>
);

export const SettingIcon = (
  <svg
    width='21'
    height='20'
    viewBox='0 0 21 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.5001 6.24998C9.98621 6.24998 9.47739 6.34698 9.00265 6.53543C8.52791 6.72389 8.09655 7.00011 7.7332 7.34833C7.36985 7.69655 7.08163 8.10995 6.88498 8.56491C6.68834 9.01989 6.58713 9.50752 6.58713 9.99997C6.58713 10.4924 6.68834 10.9801 6.88498 11.435C7.08163 11.89 7.36985 12.3034 7.7332 12.6516C8.09655 12.9998 8.52791 13.2761 9.00265 13.4645C9.47739 13.653 9.98621 13.75 10.5001 13.75C11.5378 13.75 12.5331 13.3549 13.2669 12.6516C14.0007 11.9484 14.413 10.9945 14.413 9.99997C14.413 9.00541 14.0007 8.05159 13.2669 7.34833C12.5331 6.64507 11.5378 6.24998 10.5001 6.24998ZM7.89144 9.99997C7.89144 9.67167 7.95891 9.34658 8.09001 9.04327C8.22111 8.73995 8.41325 8.46436 8.65549 8.23221C8.89772 8.00007 9.18529 7.81592 9.50179 7.69028C9.81828 7.56464 10.1575 7.49998 10.5001 7.49998C10.8426 7.49998 11.1818 7.56464 11.4983 7.69028C11.8148 7.81592 12.1024 8.00007 12.3446 8.23221C12.5869 8.46436 12.779 8.73995 12.9101 9.04327C13.0412 9.34658 13.1087 9.67167 13.1087 9.99997C13.1087 10.663 12.8338 11.2989 12.3446 11.7677C11.8554 12.2366 11.1919 12.5 10.5001 12.5C9.80821 12.5 9.1447 12.2366 8.65549 11.7677C8.16628 11.2989 7.89144 10.663 7.89144 9.99997ZM17.2042 16.9958L15.7017 16.3633C15.4878 16.2742 15.2552 16.2343 15.0224 16.2468C14.7896 16.2592 14.563 16.3237 14.3608 16.435C13.9547 16.66 13.6956 17.0575 13.6443 17.505L13.4635 19.0716C13.4452 19.229 13.3767 19.3773 13.2673 19.496C13.1579 19.6147 13.0129 19.6982 12.8522 19.7349C11.3052 20.0884 9.69319 20.0884 8.14622 19.7349C7.98562 19.698 7.84082 19.6145 7.73157 19.4958C7.62233 19.3771 7.55396 19.2289 7.5358 19.0716L7.35493 17.5075C7.32896 17.2873 7.24952 17.0761 7.12298 16.8907C6.99643 16.7053 6.82631 16.5509 6.62626 16.44C6.42642 16.3292 6.2022 16.265 5.97171 16.2526C5.74122 16.2401 5.5109 16.2798 5.29934 16.3683L3.79678 17.0008C3.64488 17.0647 3.476 17.0818 3.31351 17.0497C3.15102 17.0176 3.00297 16.9379 2.88985 16.8216C1.80837 15.711 1.0036 14.3798 0.535999 12.9283C0.486832 12.7757 0.488372 12.6123 0.540405 12.4606C0.592438 12.3089 0.69239 12.1765 0.826426 12.0816L2.15421 11.1416C2.34114 11.01 2.49312 10.8381 2.59788 10.6398C2.70263 10.4414 2.75722 10.2223 2.75722 9.99997C2.75722 9.77768 2.70263 9.55851 2.59788 9.36018C2.49312 9.16185 2.34114 8.98992 2.15421 8.85831L0.826426 7.92081C0.692218 7.82591 0.592153 7.69334 0.540112 7.54147C0.488071 7.38961 0.486634 7.22599 0.535999 7.07331C1.00457 5.62304 1.80992 4.29337 2.89158 3.18416C3.00481 3.06799 3.15291 2.98843 3.3154 2.95648C3.47788 2.92453 3.64671 2.94178 3.79851 3.00583L5.29412 3.63666C5.50693 3.72443 5.73822 3.76325 5.96949 3.75C6.20075 3.73675 6.42557 3.6718 6.62595 3.56036C6.82633 3.44891 6.9967 3.29406 7.12344 3.10819C7.25017 2.92233 7.32975 2.71062 7.3558 2.48999L7.53841 0.924998C7.55679 0.765791 7.62658 0.616057 7.73804 0.496693C7.8495 0.377329 7.99706 0.294291 8.16013 0.259166C8.92619 0.0958332 9.70791 0.00916664 10.5114 0C11.2957 0.00833331 12.0765 0.0958332 12.8417 0.259166C13.005 0.294224 13.1527 0.377351 13.2642 0.496901C13.3757 0.616451 13.4454 0.766432 13.4635 0.925831L13.6452 2.49083C13.6844 2.83789 13.8558 3.15889 14.1267 3.39232C14.3975 3.62575 14.7487 3.75518 15.113 3.75582C15.3156 3.75582 15.5164 3.71499 15.7043 3.63582L17.1999 3.00499C17.3517 2.94094 17.5205 2.9237 17.683 2.95565C17.8455 2.9876 17.9936 3.06716 18.1068 3.18333C19.1882 4.29259 19.9933 5.62226 20.4615 7.07248C20.5108 7.22496 20.5094 7.38834 20.4575 7.54003C20.4056 7.69171 20.3058 7.82419 20.172 7.91915L18.8459 8.85831C18.4677 9.12498 18.239 9.54914 18.239 9.99997C18.239 10.45 18.4677 10.8741 18.8468 11.1416L20.1737 12.08C20.4485 12.275 20.565 12.615 20.4641 12.9275C19.9959 14.3775 19.1912 15.7071 18.1103 16.8166C17.9972 16.9329 17.8491 17.0126 17.6866 17.0447C17.5241 17.0768 17.3561 17.0597 17.2042 16.9958ZM12.4678 16.8308C12.6753 16.208 13.117 15.6814 13.7069 15.3533C14.0865 15.1437 14.512 15.0224 14.9494 14.9991C15.3867 14.9758 15.8237 15.0512 16.2251 15.2191L17.3938 15.7108C18.1444 14.8778 18.7255 13.9173 19.1068 12.8791L18.0729 12.1483C17.7209 11.9006 17.4345 11.5764 17.2368 11.2032C17.0391 10.8301 16.9356 10.4176 16.9347 9.99914C16.9347 9.14331 17.3668 8.34914 18.0711 7.85248L18.0729 7.85165L19.105 7.12081C18.7235 6.0828 18.1421 5.12259 17.3912 4.28999L16.2321 4.77832L16.2303 4.77915C15.8773 4.92915 15.4973 5.00582 15.1121 5.00582C14.4271 5.00483 13.7665 4.76187 13.2567 4.32339C12.7468 3.88492 12.4236 3.28172 12.3487 2.62916V2.62749L12.207 1.41083C11.6476 1.31099 11.0803 1.25718 10.5114 1.25C9.9352 1.25694 9.36069 1.31075 8.79402 1.41083L8.65229 2.62833C8.60355 3.0438 8.45377 3.44251 8.215 3.79242C7.97624 4.14233 7.65514 4.43367 7.27752 4.64302C6.8999 4.85238 6.4763 4.97391 6.04076 4.99784C5.60522 5.02177 5.1699 4.94744 4.76979 4.78082L3.60809 4.29082C2.85708 5.1234 2.27574 6.08362 1.89422 7.12165L2.92897 7.85248C3.28023 8.10038 3.56577 8.42393 3.76255 8.79703C3.95934 9.17013 4.06187 9.58233 4.06187 10.0004C4.06187 10.4184 3.95934 10.8307 3.76255 11.2038C3.56577 11.5769 3.28023 11.9004 2.92897 12.1483L1.89422 12.88C2.27502 13.9196 2.85608 14.8816 3.60722 15.7158L4.77675 15.2241C5.17559 15.0568 5.60989 14.9817 6.0446 15.0049C6.47931 15.028 6.90225 15.1488 7.27928 15.3575C7.65616 15.5661 7.97671 15.8566 8.21516 16.2055C8.45362 16.5545 8.60334 16.9522 8.65229 17.3666V17.3708L8.79315 18.5908C9.92095 18.8033 11.08 18.8033 12.2078 18.5908L12.3487 17.3683C12.3696 17.185 12.4087 17.0041 12.4678 16.8308Z'
      fill='black'
    />
  </svg>
);

export const NotificationIcon = (
  <svg
    width='18'
    height='21'
    viewBox='0 0 18 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.35543 16.4854H1.9061C1.22203 16.4854 0.66748 15.9308 0.66748 15.2468V14.4384C0.66748 13.9705 0.853379 13.5217 1.18428 13.1908C2.0391 12.336 2.51933 11.1766 2.51933 9.96769V7.22611C2.51933 3.64649 5.42119 0.744629 9.00081 0.744629C12.5804 0.744629 15.4823 3.64649 15.4823 7.22611V9.96769C15.4823 11.1766 15.9626 12.336 16.8174 13.1908C17.1482 13.5217 17.3341 13.9705 17.3341 14.4384V15.2468C17.3341 15.9308 16.7796 16.4854 16.0955 16.4854H12.6462C12.6462 16.823 12.6392 17.5571 12.246 18.271C11.6184 19.4104 10.4018 20.1891 9.00081 20.1891C7.5998 20.1891 6.38319 19.4104 5.75558 18.271C5.36235 17.5571 5.35543 16.823 5.35543 16.4854ZM13.6304 9.96769C13.6304 11.6556 14.2962 13.2749 15.4823 14.4745V14.6335H2.51933V14.4745C3.70543 13.2749 4.37118 11.6556 4.37118 9.96769V7.22611C4.37118 4.66924 6.44394 2.59648 9.00081 2.59648C11.5577 2.59648 13.6304 4.66924 13.6304 7.22611V9.96769ZM10.7943 16.4854H7.2073C7.2073 16.7928 7.22933 17.1083 7.37767 17.3776C7.69183 17.948 8.29794 18.3349 8.99461 18.3372H9.00081H9.00693C9.70368 18.3349 10.3098 17.948 10.624 17.3776C10.7723 17.1083 10.7943 16.7928 10.7943 16.4854Z'
      fill='#A2A2A2'
    />
  </svg>
);

export const SearchIcon = (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.7323 10.3185H10.9909L10.7281 10.0653C11.3146 9.38432 11.7433 8.58221 11.9834 7.71636C12.2235 6.8505 12.2691 5.94231 12.1171 5.05676C11.676 2.44933 9.49871 0.367141 6.87099 0.0482465C5.94717 -0.0685572 5.00885 0.027398 4.12785 0.328769C3.24684 0.630141 2.44649 1.12894 1.78805 1.787C1.1296 2.44506 0.63051 3.24494 0.328962 4.12543C0.027414 5.00592 -0.0685974 5.94368 0.0482748 6.86696C0.367356 9.49315 2.45077 11.6691 5.05973 12.11C5.94579 12.2619 6.85452 12.2163 7.72088 11.9764C8.58724 11.7364 9.38982 11.308 10.0712 10.7218L10.3246 10.9844V11.7254L14.3131 15.7116C14.6979 16.0961 15.3266 16.0961 15.7114 15.7116C16.0962 15.327 16.0962 14.6986 15.7114 14.3141L11.7323 10.3185ZM6.10144 10.3185C3.76463 10.3185 1.8783 8.43329 1.8783 6.09786C1.8783 3.76243 3.76463 1.8772 6.10144 1.8772C8.43824 1.8772 10.3246 3.76243 10.3246 6.09786C10.3246 8.43329 8.43824 10.3185 6.10144 10.3185Z'
      fill='black'
    />
  </svg>
);

export const DeleteIcon = (
  <svg
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.5 6H16.5C16.5 5.33696 16.2366 4.70107 15.7678 4.23223C15.2989 3.76339 14.663 3.5 14 3.5C13.337 3.5 12.7011 3.76339 12.2322 4.23223C11.7634 4.70107 11.5 5.33696 11.5 6ZM10 6C10 4.93913 10.4214 3.92172 11.1716 3.17157C11.9217 2.42143 12.9391 2 14 2C15.0609 2 16.0783 2.42143 16.8284 3.17157C17.5786 3.92172 18 4.93913 18 6H24.25C24.4489 6 24.6397 6.07902 24.7803 6.21967C24.921 6.36032 25 6.55109 25 6.75C25 6.94891 24.921 7.13968 24.7803 7.28033C24.6397 7.42098 24.4489 7.5 24.25 7.5H22.94L21.723 22.103C21.6345 23.1653 21.1499 24.1556 20.3655 24.8774C19.5811 25.5992 18.554 25.9999 17.488 26H10.512C9.44599 25.9999 8.41894 25.5992 7.6345 24.8774C6.85007 24.1556 6.36554 23.1653 6.277 22.103L5.06 7.5H3.75C3.55109 7.5 3.36032 7.42098 3.21967 7.28033C3.07902 7.13968 3 6.94891 3 6.75C3 6.55109 3.07902 6.36032 3.21967 6.21967C3.36032 6.07902 3.55109 6 3.75 6H10ZM7.772 21.978C7.82919 22.6654 8.14262 23.3062 8.65015 23.7734C9.15767 24.2405 9.82222 24.4999 10.512 24.5H17.488C18.1778 24.4999 18.8423 24.2405 19.3499 23.7734C19.8574 23.3062 20.1708 22.6654 20.228 21.978L21.436 7.5H6.565L7.772 21.978ZM11.75 11C11.9489 11 12.1397 11.079 12.2803 11.2197C12.421 11.3603 12.5 11.5511 12.5 11.75V20.25C12.5 20.4489 12.421 20.6397 12.2803 20.7803C12.1397 20.921 11.9489 21 11.75 21C11.5511 21 11.3603 20.921 11.2197 20.7803C11.079 20.6397 11 20.4489 11 20.25V11.75C11 11.5511 11.079 11.3603 11.2197 11.2197C11.3603 11.079 11.5511 11 11.75 11ZM17 11.75C17 11.5511 16.921 11.3603 16.7803 11.2197C16.6397 11.079 16.4489 11 16.25 11C16.0511 11 15.8603 11.079 15.7197 11.2197C15.579 11.3603 15.5 11.5511 15.5 11.75V20.25C15.5 20.4489 15.579 20.6397 15.7197 20.7803C15.8603 20.921 16.0511 21 16.25 21C16.4489 21 16.6397 20.921 16.7803 20.7803C16.921 20.6397 17 20.4489 17 20.25V11.75Z'
      fill='#FC6758'
    />
  </svg>
);

export const DeleteIconSentinalHub = (
  <svg
    width='18'
    height='18'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.5 6H16.5C16.5 5.33696 16.2366 4.70107 15.7678 4.23223C15.2989 3.76339 14.663 3.5 14 3.5C13.337 3.5 12.7011 3.76339 12.2322 4.23223C11.7634 4.70107 11.5 5.33696 11.5 6ZM10 6C10 4.93913 10.4214 3.92172 11.1716 3.17157C11.9217 2.42143 12.9391 2 14 2C15.0609 2 16.0783 2.42143 16.8284 3.17157C17.5786 3.92172 18 4.93913 18 6H24.25C24.4489 6 24.6397 6.07902 24.7803 6.21967C24.921 6.36032 25 6.55109 25 6.75C25 6.94891 24.921 7.13968 24.7803 7.28033C24.6397 7.42098 24.4489 7.5 24.25 7.5H22.94L21.723 22.103C21.6345 23.1653 21.1499 24.1556 20.3655 24.8774C19.5811 25.5992 18.554 25.9999 17.488 26H10.512C9.44599 25.9999 8.41894 25.5992 7.6345 24.8774C6.85007 24.1556 6.36554 23.1653 6.277 22.103L5.06 7.5H3.75C3.55109 7.5 3.36032 7.42098 3.21967 7.28033C3.07902 7.13968 3 6.94891 3 6.75C3 6.55109 3.07902 6.36032 3.21967 6.21967C3.36032 6.07902 3.55109 6 3.75 6H10ZM7.772 21.978C7.82919 22.6654 8.14262 23.3062 8.65015 23.7734C9.15767 24.2405 9.82222 24.4999 10.512 24.5H17.488C18.1778 24.4999 18.8423 24.2405 19.3499 23.7734C19.8574 23.3062 20.1708 22.6654 20.228 21.978L21.436 7.5H6.565L7.772 21.978ZM11.75 11C11.9489 11 12.1397 11.079 12.2803 11.2197C12.421 11.3603 12.5 11.5511 12.5 11.75V20.25C12.5 20.4489 12.421 20.6397 12.2803 20.7803C12.1397 20.921 11.9489 21 11.75 21C11.5511 21 11.3603 20.921 11.2197 20.7803C11.079 20.6397 11 20.4489 11 20.25V11.75C11 11.5511 11.079 11.3603 11.2197 11.2197C11.3603 11.079 11.5511 11 11.75 11ZM17 11.75C17 11.5511 16.921 11.3603 16.7803 11.2197C16.6397 11.079 16.4489 11 16.25 11C16.0511 11 15.8603 11.079 15.7197 11.2197C15.579 11.3603 15.5 11.5511 15.5 11.75V20.25C15.5 20.4489 15.579 20.6397 15.7197 20.7803C15.8603 20.921 16.0511 21 16.25 21C16.4489 21 16.6397 20.921 16.7803 20.7803C16.921 20.6397 17 20.4489 17 20.25V11.75Z'
      fill='#FC6758'
    />
  </svg>
);

export const StyledAddIcon = <AddCircleOutlineOutlinedIcon />;

export const StyledAddIcon2 = (
  <svg
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14 0C10.3009 0.0448832 6.76597 1.53429 4.15013 4.15013C1.53429 6.76597 0.0448832 10.3009 0 14C0.0448832 17.6991 1.53429 21.234 4.15013 23.8499C6.76597 26.4657 10.3009 27.9551 14 28C17.6991 27.9551 21.234 26.4657 23.8499 23.8499C26.4657 21.234 27.9551 17.6991 28 14C27.9551 10.3009 26.4657 6.76597 23.8499 4.15013C21.234 1.53429 17.6991 0.0448832 14 0ZM22 15H15V22H13V15H6V13H13V6H15V13H22V15Z'
      fill='#2D8955'
    />
  </svg>
);
export const AddIcon = (
  <svg
    width='19'
    height='19'
    viewBox='0 0 19 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.5281 5.43648C9.973 5.43648 10.3337 5.79714 10.3337 6.24204V8.6587H12.7503C13.1952 8.6587 13.5559 9.01936 13.5559 9.46426C13.5559 9.90916 13.1952 10.2698 12.7503 10.2698H10.3337V12.6865C10.3337 13.1314 9.973 13.492 9.5281 13.492C9.08321 13.492 8.72255 13.1314 8.72255 12.6865V10.2698H6.30588C5.86098 10.2698 5.50033 9.90916 5.50033 9.46426C5.50033 9.01936 5.86098 8.6587 6.30588 8.6587H8.72255V6.24204C8.72255 5.79714 9.08321 5.43648 9.5281 5.43648Z'
      fill='#2A2929'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.666992 9.46426C0.666992 4.5704 4.63425 0.603149 9.5281 0.603149C14.422 0.603149 18.3892 4.5704 18.3892 9.46426C18.3892 14.3581 14.422 18.3254 9.5281 18.3254C4.63425 18.3254 0.666992 14.3581 0.666992 9.46426ZM9.5281 2.21426C5.52404 2.21426 2.2781 5.4602 2.2781 9.46426C2.2781 13.4683 5.52404 16.7143 9.5281 16.7143C13.5322 16.7143 16.7781 13.4683 16.7781 9.46426C16.7781 5.4602 13.5322 2.21426 9.5281 2.21426Z'
      fill='#2A2929'
    />
  </svg>
);

export const SubIcon = (
  <svg
    width='19'
    height='19'
    viewBox='0 0 19 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.37126 8.68739C5.92645 8.68739 5.56585 9.04799 5.56585 9.4928C5.56585 9.93762 5.92645 10.2982 6.37126 10.2982H12.8145C13.2594 10.2982 13.6199 9.93762 13.6199 9.4928C13.6199 9.04799 13.2594 8.68739 12.8145 8.68739H6.37126Z'
      fill='#2A2929'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.5929 0.633301C4.69993 0.633301 0.733398 4.59983 0.733398 9.4928C0.733398 14.3858 4.69993 18.3523 9.5929 18.3523C14.4859 18.3523 18.4524 14.3858 18.4524 9.4928C18.4524 4.59983 14.4859 0.633301 9.5929 0.633301ZM2.34422 9.4928C2.34422 5.48946 5.58956 2.24412 9.5929 2.24412C13.5962 2.24412 16.8416 5.48946 16.8416 9.4928C16.8416 13.4961 13.5962 16.7415 9.5929 16.7415C5.58956 16.7415 2.34422 13.4961 2.34422 9.4928Z'
      fill='#2A2929'
    />
  </svg>
);

export const AddIconBlue = (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.99967 5.8335C10.4599 5.8335 10.833 6.20659 10.833 6.66683V9.16683H13.333C13.7932 9.16683 14.1663 9.53992 14.1663 10.0002C14.1663 10.4604 13.7932 10.8335 13.333 10.8335H10.833V13.3335C10.833 13.7937 10.4599 14.1668 9.99967 14.1668C9.53944 14.1668 9.16634 13.7937 9.16634 13.3335V10.8335H6.66634C6.2061 10.8335 5.83301 10.4604 5.83301 10.0002C5.83301 9.53992 6.2061 9.16683 6.66634 9.16683H9.16634V6.66683C9.16634 6.20659 9.53944 5.8335 9.99967 5.8335Z'
      fill='#353CF7'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.833008 10.0002C0.833008 4.93755 4.93706 0.833496 9.99967 0.833496C15.0623 0.833496 19.1663 4.93755 19.1663 10.0002C19.1663 15.0628 15.0623 19.1668 9.99967 19.1668C4.93706 19.1668 0.833008 15.0628 0.833008 10.0002ZM9.99967 2.50016C5.85754 2.50016 2.49967 5.85803 2.49967 10.0002C2.49967 14.1423 5.85754 17.5002 9.99967 17.5002C14.1418 17.5002 17.4997 14.1423 17.4997 10.0002C17.4997 5.85803 14.1418 2.50016 9.99967 2.50016Z'
      fill='#353CF7'
    />
  </svg>
);

export const TwitterIcon = (
  <svg
    width='20'
    height='20'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14.9333 1.72331C14.4481 1.96558 13.938 2.13428 13.4156 2.22524C13.6598 2.17667 14.0192 1.66664 14.1622 1.46019C14.3795 1.1488 14.5452 0.793309 14.6507 0.411792C14.6507 0.383457 14.6751 0.342978 14.6507 0.322739C14.6384 0.314944 14.6246 0.31086 14.6106 0.31086C14.5965 0.31086 14.5827 0.314944 14.5704 0.322739C14.0032 0.679123 13.3995 0.951126 12.7736 1.13232C12.7518 1.14005 12.7286 1.14074 12.7064 1.13432C12.6843 1.1279 12.6641 1.11462 12.648 1.09588C12.5993 1.02858 12.5468 0.965029 12.491 0.905634C12.2357 0.640274 11.9461 0.423089 11.6327 0.26202C11.2097 0.0606693 10.7527 -0.0265314 10.2964 0.00700364C9.85364 0.0394466 9.42135 0.177232 9.02643 0.411792C8.63753 0.659087 8.29574 0.995044 8.0216 1.39948C7.73323 1.81574 7.52503 2.29883 7.41102 2.81624C7.31701 3.3084 7.30635 3.81707 7.37962 4.31395C7.37962 4.39896 7.37962 4.4111 7.31682 4.39896C4.82917 3.97393 2.78811 2.94982 1.12038 0.751814C1.04711 0.654665 1.00873 0.654665 0.949415 0.751814C0.223705 2.03095 0.576093 4.05489 1.48323 5.05472C1.60534 5.1883 1.73095 5.31783 1.86353 5.43926C1.44761 5.40501 1.04185 5.27424 0.670296 5.05472C0.600516 5.00209 0.562137 5.03043 0.558648 5.12758C0.548757 5.26226 0.548757 5.39768 0.558648 5.53237C0.631448 6.17784 0.850703 6.7893 1.19399 7.30422C1.53728 7.81914 1.99229 8.21904 2.51248 8.46303C2.63929 8.52605 2.77143 8.57353 2.90674 8.60471C2.5217 8.69266 2.1268 8.70633 1.73793 8.64519C1.65419 8.62495 1.62279 8.67757 1.65419 8.77067C2.16707 10.3898 3.28006 10.8837 4.09648 11.1589C4.20813 11.1792 4.31978 11.1792 4.44538 11.2115C4.44538 11.2115 4.44538 11.2115 4.42445 11.2358C4.18371 11.7459 3.21028 12.0899 2.76369 12.268C1.94855 12.6077 1.07945 12.7376 0.216727 12.6485C0.0806563 12.6243 0.0492554 12.6283 0.0143655 12.6485C-0.0205244 12.6688 0.0143655 12.7133 0.0527444 12.7538C0.227194 12.8874 0.401643 13.0048 0.583071 13.1181C1.12318 13.4599 1.69419 13.7314 2.2857 13.9277C5.34903 14.9073 8.79615 14.1867 11.0954 11.5354C12.9027 9.45477 13.5377 6.58482 13.5377 3.71082C13.5377 3.60152 13.6528 3.53676 13.7191 3.48009C14.1764 3.06676 14.5795 2.57862 14.9158 2.03095C14.9741 1.94931 15.004 1.84536 14.9996 1.7395V1.7395C14.9996 1.67878 14.9996 1.69092 14.9333 1.72331Z'
      fill='#55ACEE'
    />
  </svg>
);

export const Graph = (
  <svg
    width='360'
    height='212'
    viewBox='0 0 360 212'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1.51953 1V208C1.51953 209.657 2.86268 211 4.51953 211H358.52'
      stroke='black'
      stroke-opacity='0.38'
      strokeWidth='2'
      strokeLinecap='round'
    />
  </svg>
);

export const LogoutIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <path
      d='M1.77778 1.77778H8V0H0V16H8V14.2222H1.77778V1.77778Z'
      fill='black'
    />
    <path
      d='M16.0007 8.00087L12.4451 4.44531V7.11198H5.33398V8.88976H12.4451V11.5564L16.0007 8.00087Z'
      fill='black'
    />
  </svg>
);

export const BoxTwitterIcon = (
  <svg
    width='49'
    height='48'
    viewBox='0 0 49 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g filter='url(#filter0_di_3004_2690)'>
      <rect x='3' y='3' width='43' height='42' rx='7' fill='white' />
    </g>
    <path
      d='M33.9244 18.8019C33.3745 19.0552 32.7964 19.2316 32.2043 19.3267C32.4811 19.276 32.8884 18.7427 33.0505 18.5268C33.2968 18.2012 33.4845 17.8295 33.6041 17.4306C33.6041 17.4009 33.6318 17.3586 33.6041 17.3375C33.5902 17.3293 33.5745 17.325 33.5586 17.325C33.5427 17.325 33.5271 17.3293 33.5132 17.3375C32.8703 17.7101 32.1861 17.9945 31.4767 18.184C31.452 18.192 31.4257 18.1928 31.4006 18.1861C31.3756 18.1794 31.3527 18.1655 31.3344 18.1459C31.2792 18.0755 31.2197 18.009 31.1565 17.9469C30.8671 17.6695 30.5389 17.4424 30.1837 17.274C29.7043 17.0634 29.1864 16.9723 28.6693 17.0073C28.1675 17.0412 27.6775 17.1853 27.2299 17.4306C26.7892 17.6892 26.4018 18.0404 26.0911 18.4633C25.7643 18.8986 25.5284 19.4037 25.3992 19.9447C25.2926 20.4593 25.2805 20.9912 25.3636 21.5107C25.3636 21.5996 25.3636 21.6123 25.2924 21.5996C22.4731 21.1552 20.1599 20.0844 18.2698 17.7861C18.1867 17.6845 18.1432 17.6845 18.076 17.7861C17.2535 19.1236 17.6529 21.2398 18.681 22.2853C18.8194 22.425 18.9617 22.5604 19.112 22.6874C18.6406 22.6516 18.1808 22.5148 17.7597 22.2853C17.6806 22.2303 17.6371 22.2599 17.6331 22.3615C17.6219 22.5023 17.6219 22.6439 17.6331 22.7847C17.7156 23.4596 17.9641 24.099 18.3532 24.6374C18.7423 25.1758 19.2579 25.5939 19.8475 25.8491C19.9912 25.915 20.141 25.9646 20.2943 25.9972C19.8579 26.0892 19.4104 26.1035 18.9696 26.0395C18.8747 26.0184 18.8392 26.0734 18.8747 26.1707C19.456 27.8637 20.7174 28.3801 21.6427 28.6679C21.7692 28.6891 21.8957 28.6891 22.0381 28.723C22.0381 28.723 22.0381 28.723 22.0144 28.7483C21.7415 29.2816 20.6383 29.6414 20.1322 29.8276C19.2084 30.1828 18.2234 30.3186 17.2456 30.2255C17.0914 30.2001 17.0558 30.2043 17.0163 30.2255C16.9767 30.2467 17.0163 30.2932 17.0598 30.3355C17.2575 30.4752 17.4552 30.598 17.6608 30.7165C18.2729 31.0738 18.9201 31.3577 19.5905 31.563C23.0622 32.5872 26.969 31.8339 29.5748 29.0616C31.6231 26.886 32.3427 23.8852 32.3427 20.8801C32.3427 20.7658 32.4732 20.6981 32.5483 20.6388C33.0665 20.2066 33.5234 19.6962 33.9046 19.1236C33.9706 19.0382 34.0045 18.9295 33.9995 18.8188C33.9995 18.7554 33.9995 18.7681 33.9244 18.8019Z'
      fill='#55ACEE'
    />
    <defs>
      <filter
        id='filter0_di_3004_2690'
        x='0'
        y='0'
        width='49'
        height='48'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset />
        <feGaussianBlur stdDeviation='1.5' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_3004_2690'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_3004_2690'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset />
        <feGaussianBlur stdDeviation='4.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.567676 0 0 0 0 0.567676 0 0 0 0 0.567676 0 0 0 0.25 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect2_innerShadow_3004_2690'
        />
      </filter>
    </defs>
  </svg>
);

export const RectangleBlue = (
  <svg
    width='53'
    height='140'
    viewBox='0 0 53 140'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0 12C0 5.37258 5.37258 0 12 0H41C47.6274 0 53 5.37258 53 12V140H0V12Z'
      fill='url(#paint0_linear_3004_2487)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_3004_2487'
        x1='26.5'
        y1='0'
        x2='26.5'
        y2='140'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#877DFE' />
        <stop offset='1' stopColor='#675AFF' />
      </linearGradient>
    </defs>
  </svg>
);

export const RectYellow = (
  <svg
    width='53'
    height='61'
    viewBox='0 0 53 61'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0 12C0 5.37258 5.37258 0 12 0H41C47.6274 0 53 5.37258 53 12V61H0V12Z'
      fill='url(#paint0_linear_3004_2480)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_3004_2480'
        x1='26.5'
        y1='0'
        x2='26.5'
        y2='61'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FDAD8B' />
        <stop offset='1' stopColor='#FF9A6E' />
      </linearGradient>
    </defs>
  </svg>
);
export const Indicator = (
  <svg
    width='64'
    height='73'
    viewBox='0 0 64 73'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='0.00683594'
      width='17.7133'
      height='17.7133'
      fill='url(#paint0_linear_3004_2742)'
    />
    <rect
      x='0.00683594'
      y='28.3467'
      width='17.7133'
      height='17.7133'
      fill='url(#paint1_linear_3004_2742)'
    />
    <rect
      y='54.3311'
      width='17.7133'
      height='17.7133'
      fill='url(#paint2_linear_3004_2742)'
    />
    <path
      d='M28.5693 13.1494H27.2082L23.9048 7.76517H23.8633C23.8756 7.94664 23.8863 8.13888 23.8956 8.34189C23.9079 8.54489 23.9171 8.75405 23.9233 8.96936C23.9325 9.18466 23.9402 9.40305 23.9463 9.62451V13.1494H22.9405V6.40411H24.2924L27.5912 11.7514H27.6235C27.6173 11.5946 27.6096 11.4146 27.6004 11.2116C27.5912 11.0086 27.582 10.7995 27.5727 10.5842C27.5666 10.3658 27.562 10.1551 27.5589 9.95208V6.40411H28.5693V13.1494ZM32.2649 7.9451C32.7201 7.9451 33.1108 8.03892 33.4368 8.22654C33.7628 8.41417 34.0135 8.68023 34.1889 9.02472C34.3642 9.36921 34.4518 9.78138 34.4518 10.2612V10.8425H31.0423C31.0546 11.3377 31.1868 11.7192 31.4391 11.9867C31.6944 12.2543 32.0511 12.3881 32.5094 12.3881C32.8355 12.3881 33.1277 12.3574 33.3861 12.2959C33.6475 12.2313 33.9166 12.1375 34.1935 12.0144V12.8957C33.9382 13.0156 33.6783 13.1033 33.4137 13.1586C33.1492 13.214 32.8324 13.2417 32.4633 13.2417C31.9619 13.2417 31.5206 13.1448 31.1392 12.951C30.7608 12.7542 30.464 12.462 30.2487 12.0744C30.0365 11.6869 29.9304 11.2055 29.9304 10.6303C29.9304 10.0582 30.0272 9.57222 30.221 9.17236C30.4148 8.7725 30.687 8.468 31.0377 8.25884C31.3883 8.04968 31.7974 7.9451 32.2649 7.9451ZM32.2649 8.76174C31.9235 8.76174 31.6467 8.87247 31.4344 9.09393C31.2253 9.31539 31.1023 9.63989 31.0653 10.0674H33.3907C33.3876 9.81213 33.3445 9.58606 33.2615 9.38921C33.1815 9.19235 33.0585 9.03856 32.8924 8.92783C32.7294 8.8171 32.5202 8.76174 32.2649 8.76174ZM37.1324 15.4194C36.4404 15.4194 35.9098 15.2948 35.5407 15.0457C35.1716 14.7965 34.987 14.4474 34.987 13.9983C34.987 13.6846 35.0855 13.4185 35.2823 13.2002C35.4792 12.9849 35.7606 12.8357 36.1266 12.7526C35.9882 12.6911 35.8683 12.5958 35.7668 12.4666C35.6683 12.3343 35.6191 12.1882 35.6191 12.0283C35.6191 11.8376 35.6729 11.6746 35.7806 11.5392C35.8882 11.4039 36.0497 11.2732 36.265 11.147C35.9974 11.0332 35.7821 10.8487 35.6191 10.5934C35.4592 10.335 35.3792 10.0321 35.3792 9.68449C35.3792 9.31539 35.4576 9.00165 35.6145 8.74328C35.7714 8.48184 36.0005 8.28345 36.3019 8.14811C36.6034 8.0097 36.9679 7.94049 37.3954 7.94049C37.4877 7.94049 37.5876 7.94664 37.6953 7.95894C37.806 7.96817 37.9075 7.98048 37.9998 7.99585C38.0952 8.00816 38.1674 8.022 38.2167 8.03738H39.9837V8.64178L39.1163 8.80326C39.1994 8.92014 39.2655 9.05394 39.3147 9.20466C39.3639 9.3523 39.3885 9.51378 39.3885 9.6891C39.3885 10.2181 39.2055 10.6349 38.8395 10.9394C38.4766 11.2409 37.9752 11.3916 37.3354 11.3916C37.1816 11.3854 37.0325 11.3731 36.8879 11.3547C36.7772 11.4223 36.6926 11.4977 36.6341 11.5807C36.5757 11.6607 36.5465 11.7514 36.5465 11.853C36.5465 11.936 36.5757 12.0037 36.6341 12.056C36.6926 12.1052 36.7787 12.1421 36.8925 12.1667C37.0094 12.1913 37.1509 12.2036 37.317 12.2036H38.1982C38.758 12.2036 39.1855 12.322 39.4808 12.5589C39.7761 12.7957 39.9237 13.1433 39.9237 13.6016C39.9237 14.1829 39.6838 14.6304 39.204 14.9442C38.7242 15.261 38.0336 15.4194 37.1324 15.4194ZM37.1739 14.6581C37.5523 14.6581 37.8706 14.6212 38.129 14.5474C38.3874 14.4736 38.5827 14.3674 38.7149 14.229C38.8472 14.0937 38.9133 13.9322 38.9133 13.7446C38.9133 13.5785 38.8718 13.4508 38.7888 13.3616C38.7057 13.2724 38.5811 13.2109 38.415 13.1771C38.249 13.1433 38.0429 13.1263 37.7968 13.1263H36.994C36.7941 13.1263 36.6172 13.1571 36.4634 13.2186C36.3096 13.2832 36.1897 13.3755 36.1036 13.4954C36.0205 13.6154 35.979 13.76 35.979 13.9291C35.979 14.1629 36.082 14.3428 36.2881 14.4689C36.4973 14.5951 36.7925 14.6581 37.1739 14.6581ZM37.3862 10.6811C37.703 10.6811 37.9383 10.5949 38.0921 10.4227C38.2459 10.2474 38.3228 10.0013 38.3228 9.68449C38.3228 9.33999 38.2428 9.08162 38.0829 8.90938C37.926 8.73713 37.6922 8.65101 37.3816 8.65101C37.0771 8.65101 36.8448 8.73867 36.6849 8.91399C36.528 9.08931 36.4496 9.34922 36.4496 9.69371C36.4496 10.0044 36.528 10.2474 36.6849 10.4227C36.8448 10.5949 37.0786 10.6811 37.3862 10.6811ZM42.9181 7.9451C43.564 7.9451 44.0515 8.08813 44.3806 8.37418C44.7128 8.66023 44.8789 9.10623 44.8789 9.71217V13.1494H44.1084L43.9008 12.4251H43.8639C43.7193 12.6096 43.5701 12.7619 43.4164 12.8818C43.2626 13.0018 43.0842 13.091 42.8812 13.1494C42.6812 13.2109 42.4367 13.2417 42.1476 13.2417C41.8431 13.2417 41.5709 13.1863 41.3309 13.0756C41.091 12.9618 40.9019 12.7895 40.7634 12.5589C40.625 12.3282 40.5558 12.036 40.5558 11.6822C40.5558 11.1563 40.7511 10.761 41.1418 10.4965C41.5355 10.232 42.1291 10.0859 42.9227 10.0582L43.8085 10.0259V9.75831C43.8085 9.40459 43.7255 9.15237 43.5594 9.00165C43.3964 8.85094 43.1657 8.77558 42.8673 8.77558C42.612 8.77558 42.3644 8.81249 42.1245 8.88631C41.8846 8.96013 41.6508 9.05087 41.4232 9.15852L41.0726 8.39264C41.3217 8.26038 41.6047 8.15272 41.9215 8.06967C42.2414 7.98663 42.5736 7.9451 42.9181 7.9451ZM43.8039 10.7087L43.1441 10.7318C42.6028 10.7503 42.2229 10.8425 42.0045 11.0086C41.7862 11.1747 41.677 11.4023 41.677 11.6915C41.677 11.9437 41.7523 12.1282 41.903 12.2451C42.0538 12.3589 42.2522 12.4158 42.4982 12.4158C42.8735 12.4158 43.1841 12.3097 43.4302 12.0975C43.6793 11.8822 43.8039 11.5669 43.8039 11.1517V10.7087ZM48.2977 12.3651C48.4392 12.3651 48.5791 12.3528 48.7176 12.3282C48.856 12.3005 48.9821 12.2682 49.0959 12.2313V13.0525C48.9759 13.1048 48.8206 13.1494 48.6299 13.1863C48.4392 13.2232 48.2408 13.2417 48.0347 13.2417C47.7456 13.2417 47.4857 13.194 47.255 13.0987C47.0243 13.0002 46.8413 12.8326 46.706 12.5958C46.5706 12.3589 46.503 12.0313 46.503 11.613V8.86785H45.8063V8.38341L46.5537 8.00047L46.909 6.90701H47.5918V8.04199H49.0544V8.86785H47.5918V11.5992C47.5918 11.8576 47.6564 12.0498 47.7856 12.1759C47.9148 12.302 48.0855 12.3651 48.2977 12.3651ZM51.2182 8.04199V13.1494H50.134V8.04199H51.2182ZM50.683 6.08576C50.8491 6.08576 50.9921 6.13036 51.1121 6.21956C51.2351 6.30876 51.2966 6.46255 51.2966 6.68094C51.2966 6.89624 51.2351 7.05004 51.1121 7.14231C50.9921 7.23151 50.8491 7.27611 50.683 7.27611C50.5108 7.27611 50.3647 7.23151 50.2447 7.14231C50.1278 7.05004 50.0694 6.89624 50.0694 6.68094C50.0694 6.46255 50.1278 6.30876 50.2447 6.21956C50.3647 6.13036 50.5108 6.08576 50.683 6.08576ZM53.9403 13.1494L51.9979 8.04199H53.1468L54.1987 11.0409C54.2664 11.2316 54.3279 11.4377 54.3832 11.6592C54.4386 11.8806 54.4771 12.0667 54.4986 12.2174H54.5355C54.557 12.0606 54.5985 11.8729 54.6601 11.6546C54.7216 11.4331 54.7846 11.2286 54.8492 11.0409L55.9012 8.04199H57.0454L55.103 13.1494H53.9403ZM59.8551 7.9451C60.3104 7.9451 60.701 8.03892 61.027 8.22654C61.3531 8.41417 61.6038 8.68023 61.7791 9.02472C61.9544 9.36921 62.0421 9.78138 62.0421 10.2612V10.8425H58.6325C58.6448 11.3377 58.7771 11.7192 59.0293 11.9867C59.2846 12.2543 59.6414 12.3881 60.0997 12.3881C60.4257 12.3881 60.7179 12.3574 60.9763 12.2959C61.2377 12.2313 61.5069 12.1375 61.7837 12.0144V12.8957C61.5284 13.0156 61.2685 13.1033 61.004 13.1586C60.7394 13.214 60.4226 13.2417 60.0535 13.2417C59.5522 13.2417 59.1108 13.1448 58.7294 12.951C58.3511 12.7542 58.0542 12.462 57.8389 12.0744C57.6267 11.6869 57.5206 11.2055 57.5206 10.6303C57.5206 10.0582 57.6175 9.57222 57.8113 9.17236C58.005 8.7725 58.2772 8.468 58.6279 8.25884C58.9785 8.04968 59.3876 7.9451 59.8551 7.9451ZM59.8551 8.76174C59.5137 8.76174 59.2369 8.87247 59.0247 9.09393C58.8155 9.31539 58.6925 9.63989 58.6556 10.0674H60.9809C60.9778 9.81213 60.9348 9.58606 60.8517 9.38921C60.7717 9.19235 60.6487 9.03856 60.4826 8.92783C60.3196 8.8171 60.1104 8.76174 59.8551 8.76174Z'
      fill='#636363'
    />
    <path
      d='M26.0859 34.7508C26.9564 34.7508 27.5916 34.9292 27.9914 35.286C28.3913 35.6428 28.5912 36.1426 28.5912 36.7855C28.5912 37.0777 28.5451 37.356 28.4528 37.6205C28.3636 37.882 28.216 38.1142 28.0099 38.3172C27.8038 38.5171 27.5316 38.6756 27.1932 38.7924C26.858 38.9093 26.4443 38.9678 25.9521 38.9678H25.2324V41.4961H24.1251V34.7508H26.0859ZM26.0121 35.6689H25.2324V38.045H25.8368C26.1844 38.045 26.4796 38.005 26.7226 37.9251C26.9656 37.842 27.1502 37.7113 27.2763 37.5329C27.4024 37.3545 27.4655 37.1192 27.4655 36.827C27.4655 36.4363 27.347 36.1457 27.1102 35.955C26.8764 35.7643 26.5104 35.6689 26.0121 35.6689ZM34.3492 38.9308C34.3492 39.3553 34.2938 39.7321 34.1831 40.0612C34.0723 40.3903 33.9109 40.6687 33.6986 40.8963C33.4864 41.1208 33.2311 41.2931 32.9327 41.413C32.6344 41.5299 32.2976 41.5884 31.9223 41.5884C31.5717 41.5884 31.2503 41.5299 30.9581 41.413C30.6659 41.2931 30.4121 41.1208 30.1968 40.8963C29.9846 40.6687 29.82 40.3903 29.7031 40.0612C29.5862 39.7321 29.5278 39.3553 29.5278 38.9308C29.5278 38.368 29.6247 37.8912 29.8185 37.5006C30.0153 37.1069 30.2952 36.807 30.6582 36.6009C31.0211 36.3948 31.4533 36.2918 31.9546 36.2918C32.4252 36.2918 32.8405 36.3948 33.2003 36.6009C33.5602 36.807 33.8417 37.1069 34.0447 37.5006C34.2477 37.8943 34.3492 38.371 34.3492 38.9308ZM30.6443 38.9308C30.6443 39.303 30.6889 39.6214 30.7781 39.8859C30.8704 40.1504 31.0119 40.3534 31.2026 40.4949C31.3933 40.6333 31.6394 40.7025 31.9408 40.7025C32.2422 40.7025 32.4883 40.6333 32.679 40.4949C32.8697 40.3534 33.0096 40.1504 33.0988 39.8859C33.188 39.6214 33.2326 39.303 33.2326 38.9308C33.2326 38.5587 33.188 38.2434 33.0988 37.985C33.0096 37.7236 32.8697 37.5252 32.679 37.3899C32.4883 37.2514 32.2407 37.1822 31.9362 37.1822C31.4871 37.1822 31.1595 37.333 30.9534 37.6344C30.7474 37.9358 30.6443 38.368 30.6443 38.9308ZM39.0275 40.0381C39.0275 40.3734 38.946 40.6564 38.783 40.8871C38.62 41.1178 38.3816 41.2931 38.0679 41.413C37.7572 41.5299 37.3758 41.5884 36.9236 41.5884C36.5668 41.5884 36.2593 41.5622 36.0009 41.5099C35.7456 41.4607 35.5041 41.3838 35.2765 41.2792V40.3427C35.5195 40.4565 35.7917 40.5549 36.0932 40.6379C36.3977 40.721 36.6853 40.7625 36.9559 40.7625C37.3127 40.7625 37.5696 40.7071 37.7264 40.5964C37.8833 40.4826 37.9617 40.3319 37.9617 40.1443C37.9617 40.0335 37.9294 39.9351 37.8648 39.849C37.8033 39.7598 37.6864 39.669 37.5142 39.5768C37.345 39.4814 37.0959 39.3676 36.7668 39.2354C36.4438 39.1062 36.1716 38.977 35.9501 38.8478C35.7287 38.7186 35.561 38.5633 35.4472 38.3818C35.3334 38.1973 35.2765 37.962 35.2765 37.6759C35.2765 37.2238 35.4549 36.8808 35.8117 36.647C36.1716 36.4102 36.6468 36.2918 37.2374 36.2918C37.5511 36.2918 37.8464 36.3241 38.1232 36.3887C38.4031 36.4502 38.6769 36.5409 38.9445 36.6609L38.603 37.4775C38.3724 37.376 38.1401 37.293 37.9064 37.2284C37.6757 37.1607 37.4404 37.1269 37.2005 37.1269C36.9206 37.1269 36.7068 37.1699 36.5592 37.2561C36.4146 37.3422 36.3423 37.4652 36.3423 37.6252C36.3423 37.7451 36.3777 37.8466 36.4484 37.9297C36.5192 38.0127 36.6407 38.0958 36.8129 38.1788C36.9882 38.2619 37.2312 38.3649 37.5419 38.4879C37.8464 38.6048 38.1094 38.7278 38.3308 38.857C38.5554 38.9831 38.7276 39.1385 38.8476 39.323C38.9675 39.5076 39.0275 39.7459 39.0275 40.0381ZM41.2836 36.3887V41.4961H40.1994V36.3887H41.2836ZM40.7484 34.4324C40.9145 34.4324 41.0576 34.477 41.1775 34.5662C41.3006 34.6554 41.3621 34.8092 41.3621 35.0276C41.3621 35.2429 41.3006 35.3967 41.1775 35.489C41.0576 35.5782 40.9145 35.6228 40.7484 35.6228C40.5762 35.6228 40.4301 35.5782 40.3101 35.489C40.1933 35.3967 40.1348 35.2429 40.1348 35.0276C40.1348 34.8092 40.1933 34.6554 40.3101 34.5662C40.4301 34.477 40.5762 34.4324 40.7484 34.4324ZM44.7393 40.7118C44.8808 40.7118 45.0208 40.6995 45.1592 40.6748C45.2976 40.6472 45.4237 40.6149 45.5375 40.578V41.3992C45.4176 41.4515 45.2622 41.4961 45.0715 41.533C44.8808 41.5699 44.6824 41.5884 44.4764 41.5884C44.1872 41.5884 43.9273 41.5407 43.6966 41.4453C43.4659 41.3469 43.2829 41.1793 43.1476 40.9424C43.0123 40.7056 42.9446 40.378 42.9446 39.9597V37.2145H42.2479V36.7301L42.9953 36.3471L43.3506 35.2537H44.0334V36.3887H45.496V37.2145H44.0334V39.9459C44.0334 40.2042 44.098 40.3965 44.2272 40.5226C44.3564 40.6487 44.5271 40.7118 44.7393 40.7118ZM47.6598 36.3887V41.4961H46.5756V36.3887H47.6598ZM47.1246 34.4324C47.2907 34.4324 47.4338 34.477 47.5537 34.5662C47.6768 34.6554 47.7383 34.8092 47.7383 35.0276C47.7383 35.2429 47.6768 35.3967 47.5537 35.489C47.4338 35.5782 47.2907 35.6228 47.1246 35.6228C46.9524 35.6228 46.8063 35.5782 46.6863 35.489C46.5695 35.3967 46.511 35.2429 46.511 35.0276C46.511 34.8092 46.5695 34.6554 46.6863 34.5662C46.8063 34.477 46.9524 34.4324 47.1246 34.4324ZM50.382 41.4961L48.4396 36.3887H49.5884L50.6403 39.3876C50.708 39.5783 50.7695 39.7844 50.8249 40.0059C50.8802 40.2273 50.9187 40.4134 50.9402 40.5641H50.9771C50.9987 40.4072 51.0402 40.2196 51.1017 40.0012C51.1632 39.7798 51.2263 39.5752 51.2909 39.3876L52.3428 36.3887H53.487L51.5446 41.4961H50.382ZM56.2968 36.2918C56.752 36.2918 57.1426 36.3856 57.4687 36.5732C57.7947 36.7608 58.0454 37.0269 58.2207 37.3714C58.396 37.7159 58.4837 38.1281 58.4837 38.6079V39.1892H55.0741C55.0864 39.6844 55.2187 40.0658 55.4709 40.3334C55.7262 40.601 56.083 40.7348 56.5413 40.7348C56.8673 40.7348 57.1596 40.7041 57.4179 40.6425C57.6794 40.578 57.9485 40.4841 58.2253 40.3611V41.2423C57.97 41.3623 57.7101 41.45 57.4456 41.5053C57.1811 41.5607 56.8643 41.5884 56.4952 41.5884C55.9938 41.5884 55.5524 41.4915 55.171 41.2977C54.7927 41.1008 54.4959 40.8086 54.2806 40.4211C54.0683 40.0335 53.9622 39.5522 53.9622 38.977C53.9622 38.4049 54.0591 37.9189 54.2529 37.519C54.4467 37.1192 54.7189 36.8147 55.0695 36.6055C55.4202 36.3964 55.8293 36.2918 56.2968 36.2918ZM56.2968 37.1084C55.9554 37.1084 55.6785 37.2191 55.4663 37.4406C55.2571 37.6621 55.1341 37.9866 55.0972 38.4141H57.4225C57.4195 38.1588 57.3764 37.9327 57.2934 37.7359C57.2134 37.539 57.0903 37.3852 56.9243 37.2745C56.7612 37.1638 56.5521 37.1084 56.2968 37.1084Z'
      fill='#636363'
    />
    <path
      d='M27.7822 67.4805H26.4211L23.1177 62.0962H23.0762C23.0885 62.2777 23.0992 62.4699 23.1085 62.6729C23.1208 62.8759 23.13 63.0851 23.1361 63.3004C23.1454 63.5157 23.1531 63.7341 23.1592 63.9556V67.4805H22.1534V60.7352H23.5052L26.8041 66.0825H26.8364C26.8302 65.9256 26.8225 65.7457 26.8133 65.5427C26.8041 65.3397 26.7949 65.1305 26.7856 64.9152C26.7795 64.6968 26.7749 64.4861 26.7718 64.2831V60.7352H27.7822V67.4805ZM31.4778 62.2762C31.933 62.2762 32.3237 62.37 32.6497 62.5576C32.9757 62.7452 33.2264 63.0113 33.4017 63.3558C33.5771 63.7003 33.6647 64.1124 33.6647 64.5923V65.1736H30.2552C30.2675 65.6688 30.3997 66.0502 30.6519 66.3178C30.9072 66.5854 31.264 66.7192 31.7223 66.7192C32.0484 66.7192 32.3406 66.6884 32.5989 66.6269C32.8604 66.5623 33.1295 66.4685 33.4064 66.3455V67.2267C33.1511 67.3467 32.8912 67.4343 32.6266 67.4897C32.3621 67.5451 32.0453 67.5727 31.6762 67.5727C31.1748 67.5727 30.7335 67.4759 30.3521 67.2821C29.9737 67.0852 29.6769 66.793 29.4616 66.4055C29.2494 66.0179 29.1433 65.5365 29.1433 64.9614C29.1433 64.3893 29.2401 63.9033 29.4339 63.5034C29.6277 63.1036 29.8999 62.799 30.2506 62.5899C30.6012 62.3807 31.0103 62.2762 31.4778 62.2762ZM31.4778 63.0928C31.1364 63.0928 30.8596 63.2035 30.6473 63.425C30.4382 63.6464 30.3151 63.9709 30.2782 64.3985H32.6036C32.6005 64.1432 32.5574 63.9171 32.4744 63.7203C32.3944 63.5234 32.2714 63.3696 32.1053 63.2589C31.9423 63.1482 31.7331 63.0928 31.4778 63.0928ZM39.3396 62.373V67.4805H38.4861L38.3385 66.793H38.2785C38.1708 66.9683 38.0339 67.1144 37.8679 67.2313C37.7018 67.3451 37.5172 67.4297 37.3142 67.4851C37.1112 67.5435 36.8974 67.5727 36.6729 67.5727C36.2884 67.5727 35.9593 67.5082 35.6855 67.379C35.4149 67.2467 35.2073 67.0437 35.0627 66.77C34.9181 66.4962 34.8458 66.1425 34.8458 65.7088V62.373H35.9347V65.5058C35.9347 65.9026 36.0147 66.1994 36.1746 66.3962C36.3376 66.5931 36.5898 66.6915 36.9313 66.6915C37.2604 66.6915 37.5218 66.6238 37.7156 66.4885C37.9094 66.3532 38.0463 66.1532 38.1262 65.8887C38.2093 65.6242 38.2508 65.2997 38.2508 64.9152V62.373H39.3396ZM42.7953 66.6961C42.9368 66.6961 43.0768 66.6838 43.2152 66.6592C43.3536 66.6315 43.4797 66.5992 43.5935 66.5623V67.3836C43.4736 67.4359 43.3182 67.4805 43.1275 67.5174C42.9368 67.5543 42.7384 67.5727 42.5324 67.5727C42.2432 67.5727 41.9833 67.5251 41.7526 67.4297C41.5219 67.3313 41.3389 67.1637 41.2036 66.9268C41.0683 66.69 41.0006 66.3624 41.0006 65.9441V63.1989H40.3039V62.7145L41.0513 62.3315L41.4066 61.2381H42.0894V62.373H43.552V63.1989H42.0894V65.9302C42.0894 66.1886 42.154 66.3809 42.2832 66.507C42.4124 66.6331 42.5831 66.6961 42.7953 66.6961ZM47.2199 62.2762C47.306 62.2762 47.3999 62.2808 47.5014 62.29C47.6029 62.2992 47.6905 62.3115 47.7643 62.3269L47.6628 63.3419C47.5983 63.3235 47.5183 63.3096 47.4229 63.3004C47.3307 63.2912 47.2476 63.2866 47.1738 63.2866C46.98 63.2866 46.7955 63.3189 46.6201 63.3835C46.4448 63.445 46.2895 63.5403 46.1541 63.6695C46.0188 63.7956 45.9127 63.954 45.8358 64.1447C45.7589 64.3354 45.7205 64.5569 45.7205 64.8091V67.4805H44.6316V62.373H45.4805L45.6282 63.2727H45.6789C45.7804 63.0913 45.9065 62.9252 46.0573 62.7744C46.208 62.6237 46.3802 62.5038 46.574 62.4146C46.7709 62.3223 46.9862 62.2762 47.2199 62.2762ZM50.7125 62.2762C51.3585 62.2762 51.846 62.4192 52.1751 62.7052C52.5073 62.9913 52.6734 63.4373 52.6734 64.0432V67.4805H51.9029L51.6953 66.7561H51.6584C51.5138 66.9407 51.3646 67.0929 51.2108 67.2129C51.057 67.3328 50.8786 67.422 50.6756 67.4805C50.4757 67.542 50.2312 67.5727 49.942 67.5727C49.6375 67.5727 49.3653 67.5174 49.1254 67.4066C48.8855 67.2928 48.6963 67.1206 48.5579 66.8899C48.4195 66.6592 48.3503 66.367 48.3503 66.0133C48.3503 65.4873 48.5456 65.0921 48.9362 64.8276C49.3299 64.563 49.9236 64.4169 50.7171 64.3893L51.603 64.357V64.0894C51.603 63.7356 51.5199 63.4834 51.3538 63.3327C51.1908 63.182 50.9601 63.1066 50.6618 63.1066C50.4065 63.1066 50.1589 63.1435 49.919 63.2174C49.6791 63.2912 49.4453 63.3819 49.2177 63.4896L48.867 62.7237C49.1162 62.5914 49.3992 62.4838 49.716 62.4007C50.0359 62.3177 50.368 62.2762 50.7125 62.2762ZM51.5984 65.0398L50.9386 65.0629C50.3973 65.0813 50.0174 65.1736 49.799 65.3397C49.5806 65.5058 49.4714 65.7334 49.4714 66.0225C49.4714 66.2747 49.5468 66.4593 49.6975 66.5762C49.8482 66.69 50.0466 66.7469 50.2927 66.7469C50.6679 66.7469 50.9786 66.6408 51.2247 66.4285C51.4738 66.2132 51.5984 65.898 51.5984 65.4827V65.0398ZM55.2801 67.4805H54.1913V60.3015H55.2801V67.4805Z'
      fill='#636363'
    />
    <defs>
      <linearGradient
        id='paint0_linear_3004_2742'
        x1='8.8635'
        y1='0'
        x2='8.8635'
        y2='17.7133'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FF8C86' />
        <stop offset='1' stopColor='#FA6961' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_3004_2742'
        x1='8.8635'
        y1='28.3467'
        x2='8.8635'
        y2='46.06'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#A1FCC6' />
        <stop offset='1' stopColor='#5FE495' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_3004_2742'
        x1='8.85666'
        y1='54.3311'
        x2='8.85666'
        y2='72.0444'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFE092' />
        <stop offset='1' stopColor='#F9D16D' />
      </linearGradient>
    </defs>
  </svg>
);

export const PieGraph = (
  <svg
    width='256'
    height='220'
    viewBox='0 0 256 220'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g filter='url(#filter0_d_3004_2731)'>
      <circle
        cx='116.345'
        cy='94.2727'
        r='87.2727'
        fill='url(#paint0_linear_3004_2731)'
      />
    </g>
    <g filter='url(#filter1_d_3004_2731)'>
      <path
        d='M203.618 94.2727C203.618 117.155 194.631 139.121 178.593 155.442C162.555 171.763 140.749 181.132 117.871 181.532C94.9923 181.932 72.8719 173.331 56.2732 157.581C39.6746 141.831 29.9255 120.192 29.1256 97.3237C28.3257 74.4557 36.5389 52.1883 51.9964 35.3169C67.454 18.4454 88.9193 8.31958 111.77 7.12001C134.62 5.92044 157.028 13.7431 174.167 28.9033C191.306 44.0636 201.806 65.3486 203.404 88.1746L116.345 94.2727H203.618Z'
        fill='url(#paint1_linear_3004_2731)'
      />
    </g>
    <g filter='url(#filter2_d_3004_2731)'>
      <path
        d='M203.618 94.2727C203.618 105.734 201.36 117.082 196.974 127.671C192.589 138.259 186.16 147.88 178.056 155.984C169.952 164.088 160.331 170.516 149.743 174.902C139.154 179.288 127.806 181.545 116.345 181.545C104.884 181.545 93.5356 179.288 82.9472 174.902C72.3587 170.516 62.7379 164.088 54.6339 155.984C46.5298 147.88 40.1014 138.259 35.7155 127.671C31.3296 117.082 29.0723 105.734 29.0723 94.2727L116.345 94.2727H203.618Z'
        fill='url(#paint2_linear_3004_2731)'
      />
    </g>
    <g filter='url(#filter3_i_3004_2731)'>
      <circle cx='116.346' cy='94.2723' r='69.8182' fill='white' />
    </g>
    <path
      d='M206.529 90.3702C206.301 90.4498 206.181 90.6988 206.261 90.9262C206.341 91.1537 206.59 91.2736 206.817 91.1939L206.529 90.3702ZM231.546 90.7821L227.182 88.2627V93.3014L231.546 90.7821ZM223.399 90.6745L223.55 90.265L223.399 90.6745ZM214.808 87.9346L214.664 87.5228L214.808 87.9346ZM215.988 87.9443L215.838 88.3537L215.988 87.9443ZM206.817 91.1939L214.953 88.3465L214.664 87.5228L206.529 90.3702L206.817 91.1939ZM215.838 88.3537L223.248 91.0839L223.55 90.265L216.139 87.5348L215.838 88.3537ZM224.002 91.2184H227.618V90.3457H224.002V91.2184ZM223.248 91.0839C223.49 91.1729 223.745 91.2184 224.002 91.2184V90.3457C223.848 90.3457 223.695 90.3184 223.55 90.265L223.248 91.0839ZM214.953 88.3465C215.239 88.2461 215.552 88.2487 215.838 88.3537L216.139 87.5348C215.664 87.3597 215.142 87.3554 214.664 87.5228L214.953 88.3465Z'
      fill='#636363'
      fill-opacity='0.58'
    />
    <path
      d='M240.744 92.208C240.744 93.1299 240.671 93.9554 240.525 94.6846C240.385 95.4085 240.161 96.0231 239.854 96.5283C239.546 97.0335 239.145 97.4189 238.65 97.6846C238.156 97.9502 237.557 98.083 236.854 98.083C235.973 98.083 235.247 97.8512 234.674 97.3877C234.101 96.9189 233.676 96.2471 233.4 95.3721C233.124 94.4919 232.986 93.4372 232.986 92.208C232.986 90.9788 233.111 89.9268 233.361 89.0518C233.617 88.1715 234.028 87.4971 234.596 87.0283C235.163 86.5596 235.916 86.3252 236.854 86.3252C237.739 86.3252 238.468 86.5596 239.041 87.0283C239.619 87.4919 240.046 88.1637 240.322 89.0439C240.604 89.9189 240.744 90.9736 240.744 92.208ZM234.838 92.208C234.838 93.1715 234.9 93.9762 235.025 94.6221C235.156 95.2679 235.369 95.7523 235.666 96.0752C235.963 96.3929 236.359 96.5518 236.854 96.5518C237.348 96.5518 237.744 96.3929 238.041 96.0752C238.338 95.7575 238.551 95.2757 238.682 94.6299C238.817 93.984 238.885 93.1768 238.885 92.208C238.885 91.2497 238.82 90.4476 238.689 89.8018C238.559 89.1559 238.346 88.6715 238.049 88.3486C237.752 88.0205 237.354 87.8564 236.854 87.8564C236.354 87.8564 235.955 88.0205 235.658 88.3486C235.367 88.6715 235.156 89.1559 235.025 89.8018C234.9 90.4476 234.838 91.2497 234.838 92.208ZM244.604 86.3408C245.442 86.3408 246.077 86.6533 246.51 87.2783C246.942 87.8981 247.158 88.7757 247.158 89.9111C247.158 91.0413 246.95 91.9242 246.533 92.5596C246.122 93.195 245.479 93.5127 244.604 93.5127C243.786 93.5127 243.163 93.195 242.736 92.5596C242.309 91.9242 242.096 91.0413 242.096 89.9111C242.096 88.7757 242.296 87.8981 242.697 87.2783C243.104 86.6533 243.739 86.3408 244.604 86.3408ZM244.611 87.6221C244.273 87.6221 244.023 87.8122 243.861 88.1924C243.705 88.5726 243.627 89.1481 243.627 89.9189C243.627 90.6846 243.705 91.2627 243.861 91.6533C244.023 92.0387 244.273 92.2314 244.611 92.2314C244.955 92.2314 245.21 92.0387 245.377 91.6533C245.549 91.2679 245.635 90.6898 245.635 89.9189C245.635 89.1533 245.551 88.5804 245.385 88.2002C245.218 87.8148 244.96 87.6221 244.611 87.6221ZM252.275 86.5049L245.939 97.9268H244.432L250.768 86.5049H252.275ZM252.064 90.9111C252.903 90.9111 253.538 91.2236 253.971 91.8486C254.408 92.4684 254.627 93.346 254.627 94.4814C254.627 95.6064 254.419 96.4867 254.002 97.1221C253.59 97.7575 252.945 98.0752 252.064 98.0752C251.247 98.0752 250.624 97.7575 250.197 97.1221C249.77 96.4867 249.557 95.6064 249.557 94.4814C249.557 93.346 249.757 92.4684 250.158 91.8486C250.564 91.2236 251.2 90.9111 252.064 90.9111ZM252.072 92.1924C251.734 92.1924 251.484 92.3825 251.322 92.7627C251.166 93.1429 251.088 93.7184 251.088 94.4893C251.088 95.2549 251.166 95.833 251.322 96.2236C251.484 96.609 251.734 96.8018 252.072 96.8018C252.421 96.8018 252.679 96.6117 252.846 96.2314C253.012 95.846 253.096 95.2653 253.096 94.4893C253.096 93.7236 253.012 93.1507 252.846 92.7705C252.679 92.3851 252.421 92.1924 252.072 92.1924Z'
      fill='black'
    />
    <path
      d='M8.86719 60.7646H7.32031V63.2725H5.50781V60.7646H0.3125V59.374L5.53125 51.8193H7.32031V59.2412H8.86719V60.7646ZM5.50781 59.2412V56.4053C5.50781 56.1709 5.51042 55.9339 5.51562 55.6943C5.52604 55.4495 5.53646 55.2152 5.54688 54.9912C5.55729 54.7673 5.56771 54.5615 5.57812 54.374C5.58854 54.1813 5.59635 54.0225 5.60156 53.8975H5.53906C5.4401 54.1058 5.33073 54.3193 5.21094 54.5381C5.09115 54.7516 4.96354 54.96 4.82812 55.1631L2.01562 59.2412H5.50781ZM13.7266 51.6943C14.388 51.6943 14.9844 51.7985 15.5156 52.0068C16.0469 52.21 16.4688 52.5146 16.7812 52.9209C17.0938 53.3271 17.25 53.8298 17.25 54.4287C17.25 54.8923 17.1536 55.2959 16.9609 55.6396C16.7734 55.9834 16.5182 56.2855 16.1953 56.5459C15.8724 56.8011 15.5104 57.0277 15.1094 57.2256C15.5573 57.4443 15.9688 57.6969 16.3438 57.9834C16.724 58.2646 17.0286 58.5954 17.2578 58.9756C17.4922 59.3558 17.6094 59.8011 17.6094 60.3115C17.6094 60.9521 17.4453 61.5068 17.1172 61.9756C16.7943 62.4391 16.3438 62.7985 15.7656 63.0537C15.1875 63.3037 14.513 63.4287 13.7422 63.4287C12.9141 63.4287 12.2083 63.3063 11.625 63.0615C11.0417 62.8167 10.599 62.4678 10.2969 62.0146C9.99479 61.5563 9.84375 61.0094 9.84375 60.374C9.84375 59.848 9.94792 59.3923 10.1562 59.0068C10.3646 58.6214 10.6432 58.2881 10.9922 58.0068C11.3464 57.7256 11.7344 57.4886 12.1562 57.2959C11.7969 57.0824 11.4688 56.8428 11.1719 56.5771C10.875 56.3063 10.638 55.9964 10.4609 55.6475C10.2891 55.2933 10.2031 54.8844 10.2031 54.4209C10.2031 53.8271 10.362 53.3298 10.6797 52.9287C10.9974 52.5225 11.4219 52.2152 11.9531 52.0068C12.4896 51.7985 13.0807 51.6943 13.7266 51.6943ZM11.5938 60.3037C11.5938 60.8037 11.7708 61.2152 12.125 61.5381C12.4792 61.861 13.0078 62.0225 13.7109 62.0225C14.4089 62.0225 14.9401 61.8636 15.3047 61.5459C15.6693 61.2282 15.8516 60.8089 15.8516 60.2881C15.8516 59.9548 15.7578 59.6605 15.5703 59.4053C15.388 59.1501 15.1406 58.9235 14.8281 58.7256C14.5208 58.5225 14.1797 58.335 13.8047 58.1631L13.5547 58.0615C13.1484 58.2334 12.7995 58.4287 12.5078 58.6475C12.2161 58.861 11.9896 59.1032 11.8281 59.374C11.6719 59.6449 11.5938 59.9548 11.5938 60.3037ZM13.7109 53.1084C13.2057 53.1084 12.7891 53.2334 12.4609 53.4834C12.138 53.7282 11.9766 54.0824 11.9766 54.5459C11.9766 54.874 12.0547 55.1553 12.2109 55.3896C12.3724 55.624 12.5885 55.8271 12.8594 55.999C13.1302 56.1657 13.4297 56.3219 13.7578 56.4678C14.0755 56.3271 14.362 56.1735 14.6172 56.0068C14.8776 55.835 15.0833 55.6318 15.2344 55.3975C15.3906 55.1579 15.4688 54.8714 15.4688 54.5381C15.4688 54.0798 15.3047 53.7282 14.9766 53.4834C14.6536 53.2334 14.2318 53.1084 13.7109 53.1084ZM21.4688 51.6865C22.3073 51.6865 22.9427 51.999 23.375 52.624C23.8073 53.2438 24.0234 54.1214 24.0234 55.2568C24.0234 56.387 23.8151 57.2699 23.3984 57.9053C22.987 58.5407 22.3438 58.8584 21.4688 58.8584C20.651 58.8584 20.0286 58.5407 19.6016 57.9053C19.1745 57.2699 18.9609 56.387 18.9609 55.2568C18.9609 54.1214 19.1615 53.2438 19.5625 52.624C19.9688 51.999 20.6042 51.6865 21.4688 51.6865ZM21.4766 52.9678C21.138 52.9678 20.888 53.1579 20.7266 53.5381C20.5703 53.9183 20.4922 54.4938 20.4922 55.2646C20.4922 56.0303 20.5703 56.6084 20.7266 56.999C20.888 57.3844 21.138 57.5771 21.4766 57.5771C21.8203 57.5771 22.0755 57.3844 22.2422 56.999C22.4141 56.6136 22.5 56.0355 22.5 55.2646C22.5 54.499 22.4167 53.9261 22.25 53.5459C22.0833 53.1605 21.8255 52.9678 21.4766 52.9678ZM29.1406 51.8506L22.8047 63.2725H21.2969L27.6328 51.8506H29.1406ZM28.9297 56.2568C29.7682 56.2568 30.4036 56.5693 30.8359 57.1943C31.2734 57.8141 31.4922 58.6917 31.4922 59.8271C31.4922 60.9521 31.2839 61.8324 30.8672 62.4678C30.4557 63.1032 29.8099 63.4209 28.9297 63.4209C28.112 63.4209 27.4896 63.1032 27.0625 62.4678C26.6354 61.8324 26.4219 60.9521 26.4219 59.8271C26.4219 58.6917 26.6224 57.8141 27.0234 57.1943C27.4297 56.5693 28.0651 56.2568 28.9297 56.2568ZM28.9375 57.5381C28.599 57.5381 28.349 57.7282 28.1875 58.1084C28.0312 58.4886 27.9531 59.0641 27.9531 59.835C27.9531 60.6006 28.0312 61.1787 28.1875 61.5693C28.349 61.9548 28.599 62.1475 28.9375 62.1475C29.2865 62.1475 29.5443 61.9574 29.7109 61.5771C29.8776 61.1917 29.9609 60.611 29.9609 59.835C29.9609 59.0693 29.8776 58.4964 29.7109 58.1162C29.5443 57.7308 29.2865 57.5381 28.9375 57.5381Z'
      fill='black'
    />
    <path
      d='M107.583 207.113C108.317 207.113 108.963 207.246 109.521 207.512C110.083 207.772 110.521 208.158 110.833 208.668C111.146 209.173 111.302 209.793 111.302 210.527C111.302 211.329 111.132 212.022 110.794 212.605C110.455 213.184 109.958 213.629 109.302 213.941C108.646 214.254 107.846 214.41 106.903 214.41C106.304 214.41 105.744 214.358 105.224 214.254C104.708 214.15 104.263 213.993 103.888 213.785V212.129C104.278 212.348 104.747 212.527 105.294 212.668C105.841 212.803 106.364 212.871 106.864 212.871C107.396 212.871 107.851 212.793 108.231 212.637C108.612 212.48 108.903 212.241 109.106 211.918C109.315 211.595 109.419 211.186 109.419 210.691C109.419 210.035 109.208 209.53 108.786 209.176C108.369 208.816 107.716 208.637 106.825 208.637C106.513 208.637 106.179 208.665 105.825 208.723C105.476 208.775 105.185 208.832 104.95 208.895L104.146 208.418L104.575 202.832H110.513V204.449H106.192L105.942 207.293C106.13 207.251 106.354 207.212 106.614 207.176C106.875 207.134 107.198 207.113 107.583 207.113ZM118.255 214.254H116.411V206.902C116.411 206.658 116.414 206.413 116.419 206.168C116.424 205.923 116.429 205.684 116.435 205.449C116.445 205.215 116.458 204.991 116.474 204.777C116.364 204.897 116.229 205.027 116.067 205.168C115.911 205.309 115.744 205.454 115.567 205.605L114.255 206.652L113.333 205.488L116.724 202.832H118.255V214.254ZM124.45 202.668C125.289 202.668 125.924 202.98 126.356 203.605C126.789 204.225 127.005 205.103 127.005 206.238C127.005 207.368 126.797 208.251 126.38 208.887C125.968 209.522 125.325 209.84 124.45 209.84C123.632 209.84 123.01 209.522 122.583 208.887C122.156 208.251 121.942 207.368 121.942 206.238C121.942 205.103 122.143 204.225 122.544 203.605C122.95 202.98 123.586 202.668 124.45 202.668ZM124.458 203.949C124.119 203.949 123.869 204.139 123.708 204.52C123.552 204.9 123.474 205.475 123.474 206.246C123.474 207.012 123.552 207.59 123.708 207.98C123.869 208.366 124.119 208.559 124.458 208.559C124.802 208.559 125.057 208.366 125.224 207.98C125.396 207.595 125.481 207.017 125.481 206.246C125.481 205.48 125.398 204.908 125.231 204.527C125.065 204.142 124.807 203.949 124.458 203.949ZM132.122 202.832L125.786 214.254H124.278L130.614 202.832H132.122ZM131.911 207.238C132.75 207.238 133.385 207.551 133.817 208.176C134.255 208.796 134.474 209.673 134.474 210.809C134.474 211.934 134.265 212.814 133.849 213.449C133.437 214.085 132.791 214.402 131.911 214.402C131.093 214.402 130.471 214.085 130.044 213.449C129.617 212.814 129.403 211.934 129.403 210.809C129.403 209.673 129.604 208.796 130.005 208.176C130.411 207.551 131.047 207.238 131.911 207.238ZM131.919 208.52C131.58 208.52 131.33 208.71 131.169 209.09C131.013 209.47 130.935 210.046 130.935 210.816C130.935 211.582 131.013 212.16 131.169 212.551C131.33 212.936 131.58 213.129 131.919 213.129C132.268 213.129 132.526 212.939 132.692 212.559C132.859 212.173 132.942 211.592 132.942 210.816C132.942 210.051 132.859 209.478 132.692 209.098C132.526 208.712 132.268 208.52 131.919 208.52Z'
      fill='black'
    />
    <path
      d='M43.346 45.3812C43.5766 45.4514 43.8204 45.3213 43.8906 45.0908C43.9607 44.8602 43.8307 44.6164 43.6002 44.5463L43.346 45.3812ZM26.0186 47.1455L31.0364 46.6873L28.1306 42.5709L26.0186 47.1455ZM43.6002 44.5463L34.3808 41.7404L34.1267 42.5753L43.346 45.3812L43.6002 44.5463ZM32.4874 42.0452L28.9754 44.5243L29.4787 45.2372L32.9906 42.7582L32.4874 42.0452ZM34.3808 41.7404C33.7365 41.5443 33.0376 41.6568 32.4874 42.0452L32.9906 42.7582C33.3208 42.5251 33.7401 42.4576 34.1267 42.5753L34.3808 41.7404Z'
      fill='#636363'
      fill-opacity='0.58'
    />
    <path
      d='M119.955 184.314C120.038 184.088 119.921 183.837 119.695 183.754C119.469 183.671 119.218 183.788 119.135 184.014L119.955 184.314ZM120.709 199L123.228 194.637H118.189L120.709 199ZM120.205 193.545L120.515 193.238L120.205 193.545ZM117.598 189.483L117.188 189.333L117.598 189.483ZM119.135 184.014L117.188 189.333L118.008 189.633L119.955 184.314L119.135 184.014ZM117.685 191.617L119.894 193.852L120.515 193.238L118.306 191.003L117.685 191.617ZM120.272 194.772V195.073H121.145V194.772H120.272ZM119.894 193.852C120.137 194.097 120.272 194.427 120.272 194.772H121.145C121.145 194.198 120.919 193.647 120.515 193.238L119.894 193.852ZM117.188 189.333C116.898 190.126 117.092 191.016 117.685 191.617L118.306 191.003C117.95 190.643 117.834 190.109 118.008 189.633L117.188 189.333Z'
      fill='#636363'
      fill-opacity='0.58'
    />
    <defs>
      <filter
        id='filter0_d_3004_2731'
        x='22.0904'
        y='0.0181818'
        width='188.51'
        height='188.51'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset />
        <feGaussianBlur stdDeviation='3.49091' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.204194 0 0 0 0 0.204194 0 0 0 0 0.204194 0 0 0 0.25 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_3004_2731'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_3004_2731'
          result='shape'
        />
      </filter>
      <filter
        id='filter1_d_3004_2731'
        x='25.5814'
        y='3.50909'
        width='181.528'
        height='181.528'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset />
        <feGaussianBlur stdDeviation='1.74545' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.455176 0 0 0 0 0.455176 0 0 0 0 0.455176 0 0 0 0.25 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_3004_2731'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_3004_2731'
          result='shape'
        />
      </filter>
      <filter
        id='filter2_d_3004_2731'
        x='25.5814'
        y='90.7816'
        width='181.528'
        height='94.2553'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset />
        <feGaussianBlur stdDeviation='1.74545' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.416694 0 0 0 0 0.416694 0 0 0 0 0.416694 0 0 0 0.25 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_3004_2731'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_3004_2731'
          result='shape'
        />
      </filter>
      <filter
        id='filter3_i_3004_2731'
        x='46.5273'
        y='24.4541'
        width='139.637'
        height='139.637'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset />
        <feGaussianBlur stdDeviation='3.49091' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_3004_2731'
        />
      </filter>
      <linearGradient
        id='paint0_linear_3004_2731'
        x1='203.618'
        y1='70.2727'
        x2='179.181'
        y2='80.3091'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFCA63' />
        <stop offset='1' stopColor='#FFE178' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_3004_2731'
        x1='116.345'
        y1='7'
        x2='116.345'
        y2='181.545'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F95D54' />
        <stop offset='0.0995144' stopColor='#FC746C' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_3004_2731'
        x1='116.345'
        y1='7'
        x2='116.345'
        y2='181.545'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#98FFF3' />
        <stop offset='1' stopColor='#57E188' />
      </linearGradient>
    </defs>
  </svg>
);

export const GreenEllipseIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='23'
    height='21'
    viewBox='0 0 23 21'
    fill='none'
  >
    <ellipse cx='11.5' cy='10.5' rx='11.5' ry='10.5' fill='#5CE390' />
  </svg>
);

export const RedEllipseIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='23'
    height='21'
    viewBox='0 0 23 21'
    fill='none'
  >
    <ellipse cx='11.5' cy='10.5' rx='11.5' ry='10.5' fill='#FC6758' />
  </svg>
);

export const NeutralEllipseIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='23'
    height='21'
    viewBox='0 0 23 21'
    fill='none'
  >
    <ellipse cx='11.5' cy='10.5' rx='11.5' ry='10.5' fill='#F5CC61' />
  </svg>
);

export const iIcon = (
  <svg
    width='21'
    height='20'
    viewBox='0 0 21 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20.5 10C20.5 15.224 16.0461 19.5 10.5 19.5C4.95388 19.5 0.5 15.224 0.5 10C0.5 4.776 4.95388 0.5 10.5 0.5C16.0461 0.5 20.5 4.776 20.5 10Z'
      fill='white'
      stroke='black'
    />
    <path
      d='M10.066 15V8.058H11.691V15H10.066ZM10.885 6.914C10.5817 6.914 10.3303 6.81867 10.131 6.628C9.94033 6.43733 9.845 6.20767 9.845 5.939C9.845 5.66167 9.94033 5.432 10.131 5.25C10.3303 5.05933 10.5817 4.964 10.885 4.964C11.1883 4.964 11.4353 5.055 11.626 5.237C11.8253 5.41033 11.925 5.63133 11.925 5.9C11.925 6.186 11.8297 6.42867 11.639 6.628C11.4483 6.81867 11.197 6.914 10.885 6.914Z'
      fill='black'
    />
  </svg>
);

export const ImpIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='33'
    height='33'
    viewBox='0 0 33 33'
    fill='none'
  >
    <path
      d='M16.4997 3.60938C18.1925 3.60938 19.8687 3.9428 21.4327 4.59062C22.9967 5.23843 24.4177 6.18795 25.6147 7.38495C26.8117 8.58196 27.7612 10.003 28.409 11.567C29.0569 13.1309 29.3903 14.8072 29.3903 16.5C29.3903 20.2269 26.841 23.2031 23.7184 23.2031C22.2169 23.2031 21.0949 22.605 20.3318 21.5449C19.8449 22.0744 19.2522 22.4957 18.592 22.7814C17.9318 23.0671 17.219 23.2108 16.4997 23.2031C13.014 23.2031 10.8278 20.0743 10.8278 16.5C10.8278 12.9257 13.014 9.79688 16.4997 9.79688C17.4822 9.7879 18.4468 10.0598 19.2799 10.5806C19.438 10.2972 19.6814 10.0709 19.9756 9.93382C20.2697 9.79675 20.5996 9.75592 20.9183 9.81715C21.237 9.87837 21.5282 10.0385 21.7506 10.2748C21.973 10.5111 22.1153 10.8116 22.1571 11.1334L22.1715 11.3438V16.5C22.1715 19.0637 22.7511 20.1094 23.7184 20.1094C25.0178 20.1094 26.2965 18.6161 26.2965 16.5C26.2958 14.4595 25.6578 12.4701 24.4719 10.8097C23.2859 9.14918 21.611 7.90047 19.6811 7.23783C17.7512 6.57519 15.6625 6.53171 13.7066 7.11345C11.7508 7.69519 10.0254 8.87311 8.77136 10.4828C7.51729 12.0925 6.79714 14.0535 6.71143 16.0923C6.62572 18.131 7.17874 20.1456 8.29328 21.8548C9.40781 23.5641 11.0282 24.8827 12.9284 25.6265C14.8285 26.3703 16.9134 26.5023 18.8922 26.004L19.4655 25.839L19.8677 25.7029C20.2359 25.5681 20.6414 25.5781 21.0024 25.7309C21.3635 25.8837 21.653 26.1679 21.8125 26.526C21.9721 26.8841 21.9897 27.2894 21.8618 27.66C21.734 28.0305 21.4702 28.3388 21.1238 28.5223L20.932 28.6089L20.4019 28.7884C18.6297 29.35 16.757 29.5216 14.9122 29.2915C13.0674 29.0614 11.2943 28.435 9.71432 27.4552C8.13438 26.4755 6.78504 25.1656 5.75887 23.6154C4.73271 22.0652 4.05398 20.3114 3.76926 18.4742C3.48454 16.6371 3.60056 14.7601 4.10936 12.972C4.61816 11.1839 5.50771 9.52705 6.71697 8.11503C7.92624 6.70301 9.42662 5.56926 11.1152 4.79154C12.8038 4.01383 14.6406 3.61055 16.4997 3.60938ZM16.4997 12.8906C15.0085 12.8906 13.9215 14.4458 13.9215 16.5C13.9215 18.5542 15.0085 20.1094 16.4997 20.1094C17.9908 20.1094 19.0778 18.5542 19.0778 16.5C19.0778 14.4458 17.9908 12.8906 16.4997 12.8906Z'
      fill='#55ACEE'
    />
  </svg>
);

export const TwitterIconSmall = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
  >
    <path
      d='M11.9466 1.37865C11.5585 1.57246 11.1504 1.70742 10.7325 1.7802C10.9278 1.74134 11.2153 1.33331 11.3298 1.16816C11.5036 0.919036 11.6361 0.634647 11.7205 0.329434C11.7205 0.306766 11.7401 0.274382 11.7205 0.258191C11.7107 0.251955 11.6997 0.248688 11.6884 0.248688C11.6772 0.248688 11.6662 0.251955 11.6563 0.258191C11.2026 0.543299 10.7196 0.760901 10.2189 0.905852C10.2014 0.912038 10.1829 0.912593 10.1652 0.907458C10.1475 0.902323 10.1313 0.891693 10.1184 0.876708C10.0794 0.822864 10.0375 0.772023 9.99279 0.724507C9.78857 0.512219 9.55687 0.338471 9.30616 0.209616C8.96774 0.0485355 8.6022 -0.0212251 8.23713 0.00560291C7.88291 0.0315572 7.53708 0.141786 7.22114 0.329434C6.91003 0.527269 6.63659 0.796035 6.41728 1.11958C6.18658 1.45259 6.02003 1.83906 5.92882 2.25299C5.85361 2.64672 5.84508 3.05366 5.9037 3.45116C5.9037 3.51917 5.9037 3.52888 5.85346 3.51917C3.86334 3.17914 2.23049 2.35985 0.8963 0.601452C0.837685 0.523732 0.806982 0.523732 0.759532 0.601452C0.178964 1.62476 0.460874 3.24391 1.18658 4.04377C1.28428 4.15064 1.38476 4.25426 1.49082 4.35141C1.15809 4.32401 0.833484 4.21939 0.536236 4.04377C0.480413 4.00167 0.44971 4.02434 0.446918 4.10206C0.439006 4.20981 0.439006 4.31814 0.446918 4.42589C0.505158 4.94227 0.680563 5.43144 0.955195 5.84338C1.22983 6.25531 1.59383 6.57523 2.00999 6.77043C2.11143 6.82084 2.21714 6.85883 2.32539 6.88377C2.01736 6.95413 1.70144 6.96507 1.39034 6.91615C1.32335 6.89996 1.29823 6.94206 1.32335 7.01654C1.73366 8.31186 2.62405 8.70693 3.27719 8.92714C3.36651 8.94333 3.45582 8.94333 3.55631 8.96924C3.55631 8.96924 3.55631 8.96924 3.53956 8.98867C3.34697 9.39669 2.56822 9.67195 2.21095 9.81444C1.55884 10.0862 0.863563 10.1901 0.173382 10.1188C0.0645251 10.0994 0.0394043 10.1026 0.0114924 10.1188C-0.0164195 10.135 0.0114924 10.1707 0.0421955 10.203C0.181755 10.3099 0.321315 10.4038 0.466457 10.4945C0.898546 10.7679 1.35535 10.9851 1.82856 11.1421C4.27922 11.9258 7.03692 11.3494 8.87632 9.2283C10.3222 7.56381 10.8302 5.26785 10.8302 2.96865C10.8302 2.88122 10.9223 2.82941 10.9753 2.78407C11.3411 2.4534 11.6636 2.0629 11.9327 1.62476C11.9793 1.55945 12.0032 1.47629 11.9997 1.3916C11.9997 1.34302 11.9997 1.35274 11.9466 1.37865Z'
      fill='#55ACEE'
    />
  </svg>
);

export const BuildingIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='18'
    viewBox='0 0 20 18'
    fill='none'
  >
    <path
      d='M15.8501 12H13.9219V14H15.8501M15.8501 8H13.9219V10H15.8501M17.7782 16H10.0657V14H11.9938V12H10.0657V10H11.9938V8H10.0657V6H17.7782M8.13761 4H6.2095V2H8.13761M8.13761 8H6.2095V6H8.13761M8.13761 12H6.2095V10H8.13761M8.13761 16H6.2095V14H8.13761M4.28139 4H2.35328V2H4.28139M4.28139 8H2.35328V6H4.28139M4.28139 12H2.35328V10H4.28139M4.28139 16H2.35328V14H4.28139M10.0657 4V0H0.425171V18H19.7063V4H10.0657Z'
      fill='black'
    />
  </svg>
);

export const CrossIconWithOutBorder = (
  <svg
    width='17'
    height='18'
    viewBox='0 0 14 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.2983 1.00841C13.2058 0.929095 13.0959 0.866166 12.9749 0.82323C12.8539 0.780294 12.7242 0.758194 12.5933 0.758194C12.4623 0.758194 12.3326 0.780294 12.2116 0.82323C12.0907 0.866166 11.9808 0.929095 11.8883 1.00841L6.99827 5.18381L2.10827 0.999857C2.01569 0.920642 1.90578 0.857806 1.78481 0.814936C1.66385 0.772065 1.5342 0.75 1.40327 0.75C1.27234 0.75 1.14269 0.772065 1.02173 0.814936C0.900763 0.857806 0.790852 0.920642 0.69827 0.999857C0.605688 1.07907 0.532248 1.17311 0.482143 1.27661C0.432038 1.38011 0.40625 1.49104 0.40625 1.60307C0.40625 1.71509 0.432038 1.82602 0.482143 1.92952C0.532248 2.03302 0.605688 2.12706 0.69827 2.20627L5.58827 6.39023L0.69827 10.5742C0.605688 10.6534 0.532248 10.7474 0.482143 10.8509C0.432038 10.9544 0.40625 11.0654 0.40625 11.1774C0.40625 11.2894 0.432038 11.4004 0.482143 11.5039C0.532248 11.6073 0.605688 11.7014 0.69827 11.7806C0.790852 11.8598 0.900763 11.9227 1.02173 11.9655C1.14269 12.0084 1.27234 12.0305 1.40327 12.0305C1.5342 12.0305 1.66385 12.0084 1.78481 11.9655C1.90578 11.9227 2.01569 11.8598 2.10827 11.7806L6.99827 7.59665L11.8883 11.7806C11.9809 11.8598 12.0908 11.9227 12.2117 11.9655C12.3327 12.0084 12.4623 12.0305 12.5933 12.0305C12.7242 12.0305 12.8538 12.0084 12.9748 11.9655C13.0958 11.9227 13.2057 11.8598 13.2983 11.7806C13.3909 11.7014 13.4643 11.6073 13.5144 11.5039C13.5645 11.4004 13.5903 11.2894 13.5903 11.1774C13.5903 11.0654 13.5645 10.9544 13.5144 10.8509C13.4643 10.7474 13.3909 10.6534 13.2983 10.5742L8.40827 6.39023L13.2983 2.20627C13.6783 1.88114 13.6783 1.33355 13.2983 1.00841Z'
      fill='black'
    />
  </svg>
);
export const CrossCompIcon = (
  <svg
    width='23'
    height='23'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10 0.375C4.6375 0.375 0.375 4.6375 0.375 10C0.375 15.3625 4.6375 19.625 10 19.625C15.3625 19.625 19.625 15.3625 19.625 10C19.625 4.6375 15.3625 0.375 10 0.375ZM13.7125 14.8125L10 11.1L6.2875 14.8125L5.1875 13.7125L8.9 10L5.1875 6.2875L6.2875 5.1875L10 8.9L13.7125 5.1875L14.8125 6.2875L11.1 10L14.8125 13.7125L13.7125 14.8125Z'
      fill='#636363'
    />
  </svg>
);
export const CrossIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 17 18'
    fill='none'
  >
    <path
      d='M10.8848 6.339C11.1688 6.6385 11.1688 7.12408 10.8848 7.42357L9.342 9.05044L10.8848 10.6773C11.1688 10.9768 11.1688 11.4624 10.8848 11.7619C10.6008 12.0614 10.1403 12.0614 9.85626 11.7619L8.31348 10.135L6.7707 11.7619C6.48668 12.0614 6.0262 12.0614 5.74218 11.7619C5.45816 11.4624 5.45816 10.9768 5.74218 10.6773L7.28496 9.05044L5.74218 7.42357C5.45816 7.12408 5.45816 6.6385 5.74218 6.339C6.0262 6.0395 6.48668 6.0395 6.7707 6.339L8.31348 7.96586L9.85625 6.339C10.1403 6.0395 10.6008 6.0395 10.8848 6.339Z'
      fill='#2A2929'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.65662 3.08528C5.78082 -0.20919 10.8461 -0.20919 13.9703 3.08528C17.0945 6.37974 17.0945 11.7211 13.9703 15.0156C10.8461 18.3101 5.78082 18.3101 2.65662 15.0156C-0.467572 11.7211 -0.467572 6.37974 2.65662 3.08528ZM12.9418 4.16985C10.3857 1.47438 6.2413 1.47438 3.68514 4.16985C1.12898 6.86532 1.12898 11.2355 3.68514 13.931C6.2413 16.6265 10.3857 16.6265 12.9418 13.931C15.498 11.2355 15.498 6.86532 12.9418 4.16985Z'
      fill='#2A2929'
    />
  </svg>
);
export const CrossIconBig = (
  <svg
    width='25'
    height='23'
    viewBox='0 0 22 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.7792 0C5.01302 0 0.429688 4.42857 0.429688 10C0.429688 15.5714 5.01302 20 10.7792 20C16.5453 20 21.1286 15.5714 21.1286 10C21.1286 4.42857 16.5453 0 10.7792 0ZM10.7792 18.5714C5.90012 18.5714 1.90818 14.7143 1.90818 10C1.90818 5.28571 5.90012 1.42857 10.7792 1.42857C15.6582 1.42857 19.6501 5.28571 19.6501 10C19.6501 14.7143 15.6582 18.5714 10.7792 18.5714Z'
      fill='#636363'
    />
    <path
      d='M14.7682 15L10.7763 11.1429L6.78436 15L5.60156 13.8571L9.5935 10L5.60156 6.14286L6.78436 5L10.7763 8.85714L14.7682 5L15.951 6.14286L11.9591 10L15.951 13.8571L14.7682 15Z'
      fill='#636363'
    />
  </svg>
);

export const AddIconWhite = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='19'
    height='19'
    viewBox='0 0 19 19'
    fill='none'
  >
    <path
      d='M9.16667 5C9.6269 5 10 5.3731 10 5.83333V8.33333H12.5C12.9602 8.33333 13.3333 8.70643 13.3333 9.16667C13.3333 9.6269 12.9602 10 12.5 10H10V12.5C10 12.9602 9.6269 13.3333 9.16667 13.3333C8.70643 13.3333 8.33333 12.9602 8.33333 12.5V10H5.83333C5.3731 10 5 9.6269 5 9.16667C5 8.70643 5.3731 8.33333 5.83333 8.33333H8.33333V5.83333C8.33333 5.3731 8.70643 5 9.16667 5Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 9.16667C0 4.10406 4.10406 0 9.16667 0C14.2293 0 18.3333 4.10406 18.3333 9.16667C18.3333 14.2293 14.2293 18.3333 9.16667 18.3333C4.10406 18.3333 0 14.2293 0 9.16667ZM9.16667 1.66667C5.02453 1.66667 1.66667 5.02453 1.66667 9.16667C1.66667 13.3088 5.02453 16.6667 9.16667 16.6667C13.3088 16.6667 16.6667 13.3088 16.6667 9.16667C16.6667 5.02453 13.3088 1.66667 9.16667 1.66667Z'
      fill='white'
    />
  </svg>
);

export const LineGraph = (
  <svg
    width='387'
    height='247'
    viewBox='0 0 387 247'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.9366 202.945C11.2152 202.945 10.5739 202.758 10.0128 202.384C9.45174 202.001 9.01089 201.458 8.69027 200.754C8.36964 200.042 8.20933 199.187 8.20933 198.189C8.20933 197.192 8.36964 196.341 8.69027 195.638C9.01089 194.925 9.45174 194.382 10.0128 194.008C10.5739 193.625 11.2152 193.434 11.9366 193.434C12.658 193.434 13.2992 193.625 13.8603 194.008C14.4214 194.382 14.8623 194.925 15.1829 195.638C15.5124 196.341 15.6772 197.192 15.6772 198.189C15.6772 199.187 15.5124 200.042 15.1829 200.754C14.8623 201.458 14.4214 202.001 13.8603 202.384C13.2992 202.758 12.658 202.945 11.9366 202.945ZM11.9366 202.064C12.4888 202.064 12.9697 201.917 13.3794 201.623C13.7891 201.32 14.1097 200.884 14.3412 200.314C14.5728 199.735 14.6886 199.027 14.6886 198.189C14.6886 197.352 14.5728 196.649 14.3412 196.079C14.1097 195.5 13.7891 195.063 13.3794 194.77C12.9697 194.467 12.4888 194.315 11.9366 194.315C11.4022 194.315 10.9257 194.467 10.5071 194.77C10.0885 195.063 9.76346 195.5 9.5319 196.079C9.30034 196.649 9.18456 197.352 9.18456 198.189C9.18456 199.027 9.30034 199.735 9.5319 200.314C9.76346 200.884 10.0885 201.32 10.5071 201.623C10.9257 201.917 11.4022 202.064 11.9366 202.064Z'
      fill='#636363'
    />
    <path
      d='M11.9967 171.217C11.3287 171.217 10.6919 171.11 10.0863 170.896C9.4807 170.674 8.99976 170.38 8.64351 170.015L9.11109 169.253C9.40499 169.565 9.80577 169.823 10.3134 170.028C10.83 170.233 11.3866 170.335 11.9833 170.335C12.776 170.335 13.3772 170.161 13.7868 169.814C14.2054 169.458 14.4147 168.995 14.4147 168.425C14.4147 168.024 14.3168 167.681 14.1208 167.396C13.9338 167.102 13.6132 166.875 13.159 166.715C12.7047 166.554 12.0813 166.474 11.2887 166.474H9.29812L9.77905 161.785H14.8957V162.64H10.1665L10.6608 162.173L10.2466 166.1L9.75233 165.619H11.5024C12.4465 165.619 13.2035 165.735 13.7735 165.967C14.3435 166.198 14.7532 166.523 15.0025 166.942C15.2608 167.352 15.39 167.833 15.39 168.385C15.39 168.91 15.2653 169.391 15.0159 169.828C14.7665 170.255 14.3925 170.593 13.8937 170.843C13.395 171.092 12.7626 171.217 11.9967 171.217Z'
      fill='#636363'
    />
    <path
      d='M4.82842 139.408V130.457L5.25592 130.912H2.62414V130.057H5.79029V139.408H4.82842ZM11.7529 139.488C11.0315 139.488 10.3903 139.301 9.82918 138.927C9.26809 138.544 8.82723 138.001 8.50661 137.297C8.18599 136.585 8.02567 135.73 8.02567 134.732C8.02567 133.735 8.18599 132.884 8.50661 132.181C8.82723 131.468 9.26809 130.925 9.82918 130.551C10.3903 130.168 11.0315 129.977 11.7529 129.977C12.4743 129.977 13.1156 130.168 13.6767 130.551C14.2377 130.925 14.6786 131.468 14.9992 132.181C15.3288 132.884 15.4935 133.735 15.4935 134.732C15.4935 135.73 15.3288 136.585 14.9992 137.297C14.6786 138.001 14.2377 138.544 13.6767 138.927C13.1156 139.301 12.4743 139.488 11.7529 139.488ZM11.7529 138.607C12.3051 138.607 12.786 138.46 13.1957 138.166C13.6054 137.863 13.926 137.427 14.1576 136.857C14.3891 136.278 14.5049 135.57 14.5049 134.732C14.5049 133.895 14.3891 133.192 14.1576 132.622C13.926 132.043 13.6054 131.606 13.1957 131.312C12.786 131.01 12.3051 130.858 11.7529 130.858C11.2185 130.858 10.7421 131.01 10.3235 131.312C9.90488 131.606 9.5798 132.043 9.34824 132.622C9.11668 133.192 9.0009 133.895 9.0009 134.732C9.0009 135.57 9.11668 136.278 9.34824 136.857C9.5798 137.427 9.90488 137.863 10.3235 138.166C10.7421 138.46 11.2185 138.607 11.7529 138.607Z'
      fill='#636363'
    />
    <path
      d='M6.49932 107.68V98.729L6.92682 99.1832H4.29504V98.3282H7.46119V107.68H6.49932ZM12.649 107.76C11.981 107.76 11.3442 107.653 10.7386 107.439C10.133 107.217 9.65204 106.923 9.29579 106.558L9.76337 105.796C10.0573 106.108 10.4581 106.366 10.9657 106.571C11.4823 106.776 12.0389 106.878 12.6356 106.878C13.4283 106.878 14.0294 106.704 14.4391 106.357C14.8577 106.001 15.067 105.538 15.067 104.968C15.067 104.567 14.969 104.224 14.7731 103.939C14.5861 103.645 14.2654 103.418 13.8112 103.258C13.357 103.097 12.7336 103.017 11.9409 103.017H9.9504L10.4313 98.3282H15.5479V99.1832H10.8188L11.313 98.7156L10.8989 102.643L10.4046 102.162H12.1547C13.0987 102.162 13.8558 102.278 14.4258 102.51C14.9958 102.741 15.4054 103.066 15.6548 103.485C15.9131 103.895 16.0422 104.375 16.0422 104.928C16.0422 105.453 15.9175 105.934 15.6682 106.37C15.4188 106.798 15.0447 107.136 14.546 107.386C14.0472 107.635 13.4149 107.76 12.649 107.76Z'
      fill='#636363'
    />
    <path
      d='M0.521012 75.9521V75.2708L4.40856 71.4634C4.76481 71.1161 5.032 70.8133 5.21012 70.555C5.38825 70.2878 5.50848 70.0384 5.57082 69.8069C5.63317 69.5753 5.66434 69.3571 5.66434 69.1523C5.66434 68.609 5.47731 68.1815 5.10325 67.8698C4.73809 67.5581 4.19482 67.4022 3.47341 67.4022C2.92123 67.4022 2.43139 67.4868 2.00389 67.656C1.5853 67.8252 1.2246 68.088 0.921791 68.4442L0.240467 67.8564C0.605621 67.4289 1.0732 67.0994 1.64319 66.8678C2.21319 66.6363 2.84998 66.5205 3.55357 66.5205C4.18591 66.5205 4.73364 66.6229 5.19676 66.8278C5.65988 67.0237 6.01613 67.3131 6.2655 67.6961C6.52378 68.0791 6.65292 68.5288 6.65292 69.0454C6.65292 69.3482 6.60839 69.6466 6.51933 69.9405C6.43918 70.2344 6.28777 70.5461 6.06512 70.8756C5.85137 71.1962 5.5352 71.5614 5.11661 71.9711L1.54968 75.4712L1.28249 75.0972H7.08042V75.9521H0.521012ZM11.9887 76.0323C11.2673 76.0323 10.6261 75.8453 10.065 75.4712C9.50388 75.0882 9.06302 74.545 8.7424 73.8414C8.42178 73.1289 8.26147 72.2739 8.26147 71.2764C8.26147 70.2789 8.42178 69.4284 8.7424 68.7248C9.06302 68.0123 9.50388 67.469 10.065 67.0949C10.6261 66.712 11.2673 66.5205 11.9887 66.5205C12.7101 66.5205 13.3514 66.712 13.9124 67.0949C14.4735 67.469 14.9144 68.0123 15.235 68.7248C15.5645 69.4284 15.7293 70.2789 15.7293 71.2764C15.7293 72.2739 15.5645 73.1289 15.235 73.8414C14.9144 74.545 14.4735 75.0882 13.9124 75.4712C13.3514 75.8453 12.7101 76.0323 11.9887 76.0323ZM11.9887 75.1506C12.5409 75.1506 13.0218 75.0036 13.4315 74.7097C13.8412 74.4069 14.1618 73.9705 14.3934 73.4005C14.6249 72.8216 14.7407 72.1136 14.7407 71.2764C14.7407 70.4392 14.6249 69.7356 14.3934 69.1656C14.1618 68.5867 13.8412 68.1503 13.4315 67.8564C13.0218 67.5536 12.5409 67.4022 11.9887 67.4022C11.4543 67.4022 10.9779 67.5536 10.5593 67.8564C10.1407 68.1503 9.8156 68.5867 9.58404 69.1656C9.35247 69.7356 9.23669 70.4392 9.23669 71.2764C9.23669 72.1136 9.35247 72.8216 9.58404 73.4005C9.8156 73.9705 10.1407 74.4069 10.5593 74.7097C10.9779 75.0036 11.4543 75.1506 11.9887 75.1506Z'
      fill='#636363'
    />
    <path
      d='M1.35597 44.2236V43.5423L5.24353 39.7349C5.59977 39.3876 5.86696 39.0848 6.04508 38.8265C6.22321 38.5593 6.34344 38.3099 6.40578 38.0784C6.46813 37.8468 6.4993 37.6286 6.4993 37.4238C6.4993 36.8805 6.31227 36.453 5.93821 36.1413C5.57305 35.8295 5.02978 35.6737 4.30838 35.6737C3.75619 35.6737 3.26635 35.7583 2.83885 35.9275C2.42026 36.0967 2.05956 36.3595 1.75675 36.7157L1.07543 36.1279C1.44058 35.7004 1.90816 35.3709 2.47815 35.1393C3.04815 34.9078 3.68494 34.792 4.38853 34.792C5.02087 34.792 5.5686 34.8944 6.03172 35.0992C6.49485 35.2952 6.85109 35.5846 7.10047 35.9676C7.35875 36.3506 7.48789 36.8003 7.48789 37.3169C7.48789 37.6197 7.44335 37.918 7.35429 38.212C7.27414 38.5059 7.12273 38.8176 6.90008 39.1471C6.68633 39.4677 6.37016 39.8329 5.95157 40.2426L2.38464 43.7427L2.11745 43.3686H7.91538V44.2236H1.35597ZM12.0749 44.3038C11.407 44.3038 10.7702 44.1969 10.1645 43.9832C9.55892 43.7605 9.07799 43.4666 8.72174 43.1015L9.18932 42.34C9.48322 42.6517 9.884 42.91 10.3917 43.1148C10.9082 43.3197 11.4648 43.4221 12.0616 43.4221C12.8542 43.4221 13.4554 43.2484 13.8651 42.9011C14.2837 42.5448 14.493 42.0817 14.493 41.5117C14.493 41.1109 14.395 40.768 14.199 40.483C14.012 40.1891 13.6914 39.962 13.2372 39.8017C12.783 39.6414 12.1595 39.5612 11.3669 39.5612H9.37635L9.85728 34.8721H14.9739V35.7271H10.2447L10.739 35.2596L10.3249 39.1872L9.83056 38.7062H11.5806C12.5247 38.7062 13.2817 38.822 13.8517 39.0536C14.4217 39.2851 14.8314 39.6102 15.0808 40.0288C15.339 40.4385 15.4682 40.9194 15.4682 41.4716C15.4682 41.9971 15.3435 42.478 15.0941 42.9144C14.8447 43.3419 14.4707 43.6804 13.9719 43.9297C13.4732 44.1791 12.8409 44.3038 12.0749 44.3038Z'
      fill='#636363'
    />
    <path
      d='M4.32173 15.0802C3.64486 15.0802 3.00362 14.9733 2.398 14.7595C1.80128 14.5369 1.32035 14.243 0.955195 13.8778L1.42277 13.1163C1.72558 13.4281 2.13081 13.6863 2.63846 13.8912C3.15502 14.096 3.71611 14.1984 4.32173 14.1984C5.09657 14.1984 5.68883 14.0292 6.09852 13.6908C6.51711 13.3524 6.72641 12.8981 6.72641 12.3281C6.72641 11.7581 6.52156 11.3039 6.11188 10.9655C5.7111 10.6271 5.07431 10.4578 4.2015 10.4578H3.53354V9.7498L6.41914 6.12943L6.55274 6.50349H1.34261V5.6485H7.35429V6.32982L4.46869 9.95019L4.00111 9.64293H4.36181C5.48399 9.64293 6.32117 9.8923 6.87336 10.391C7.43445 10.8898 7.71499 11.531 7.71499 12.3148C7.71499 12.8402 7.59031 13.3123 7.34093 13.7309C7.09156 14.1495 6.71305 14.479 6.20539 14.7195C5.70665 14.9599 5.07876 15.0802 4.32173 15.0802ZM12.7976 15.0802C12.0762 15.0802 11.4349 14.8931 10.8738 14.5191C10.3127 14.1361 9.87189 13.5928 9.55127 12.8892C9.23065 12.1767 9.07033 11.3217 9.07033 10.3242C9.07033 9.32676 9.23065 8.47622 9.55127 7.77263C9.87189 7.06013 10.3127 6.51685 10.8738 6.14279C11.4349 5.75983 12.0762 5.56834 12.7976 5.56834C13.519 5.56834 14.1602 5.75983 14.7213 6.14279C15.2824 6.51685 15.7233 7.06013 16.0439 7.77263C16.3734 8.47622 16.5382 9.32676 16.5382 10.3242C16.5382 11.3217 16.3734 12.1767 16.0439 12.8892C15.7233 13.5928 15.2824 14.1361 14.7213 14.5191C14.1602 14.8931 13.519 15.0802 12.7976 15.0802ZM12.7976 14.1984C13.3498 14.1984 13.8307 14.0515 14.2404 13.7576C14.6501 13.4548 14.9707 13.0184 15.2022 12.4484C15.4338 11.8695 15.5496 11.1614 15.5496 10.3242C15.5496 9.48707 15.4338 8.78348 15.2022 8.21348C14.9707 7.63458 14.6501 7.19818 14.2404 6.90427C13.8307 6.60146 13.3498 6.45006 12.7976 6.45006C12.2632 6.45006 11.7867 6.60146 11.3681 6.90427C10.9495 7.19818 10.6245 7.63458 10.3929 8.21348C10.1613 8.78348 10.0456 9.48707 10.0456 10.3242C10.0456 11.1614 10.1613 11.8695 10.3929 12.4484C10.6245 13.0184 10.9495 13.4548 11.3681 13.7576C11.7867 14.0515 12.2632 14.1984 12.7976 14.1984Z'
      fill='#636363'
    />
    <path
      d='M28.5195 1V208C28.5195 209.657 29.8627 211 31.5195 211H385.52'
      stroke='black'
      stroke-opacity='0.38'
      strokeWidth='2'
      strokeLinecap='round'
    />
    <path
      d='M32.8943 240.074C32.3448 240.28 31.7996 240.323 31.2586 240.205C30.7244 240.084 30.2296 239.803 29.7742 239.363C29.3255 238.919 28.9581 238.316 28.672 237.552C28.3859 236.788 28.2665 236.092 28.3137 235.463C28.3676 234.831 28.5562 234.294 28.8797 233.852C29.2099 233.408 29.6497 233.083 30.1992 232.877C30.742 232.674 31.2839 232.631 31.8248 232.749C32.3658 232.868 32.8606 233.149 33.3093 233.592C33.758 234.035 34.1254 234.639 34.4115 235.403C34.6975 236.166 34.817 236.863 34.7698 237.492C34.7226 238.121 34.5339 238.658 34.2038 239.102C33.8736 239.547 33.4371 239.871 32.8943 240.074ZM32.5593 239.179C32.9279 239.041 33.2119 238.82 33.4113 238.516C33.6175 238.21 33.7224 237.827 33.7259 237.367C33.7362 236.905 33.6296 236.375 33.4063 235.779C33.183 235.183 32.9156 234.713 32.6042 234.372C32.2995 234.027 31.9688 233.807 31.6121 233.712C31.2621 233.614 30.9028 233.633 30.5342 233.771C30.1657 233.91 29.8783 234.132 29.6721 234.438C29.466 234.745 29.3578 235.129 29.3475 235.591C29.3439 236.051 29.4538 236.579 29.6772 237.175C29.9005 237.772 30.1645 238.242 30.4692 238.587C30.7806 238.928 31.1147 239.147 31.4714 239.243C31.8281 239.338 32.1908 239.317 32.5593 239.179ZM37.8799 238.115L35.3955 231.481L36.0047 231.792L33.9843 232.548L33.6568 231.674L36.2401 230.706L38.875 237.742L37.8799 238.115ZM39.6275 234.79L39.315 233.956L42.0189 232.943L42.3313 233.778L39.6275 234.79ZM45.5733 235.326C45.1578 235.481 44.7365 235.54 44.3094 235.501C43.8823 235.462 43.4934 235.321 43.1426 235.078L43.4696 234.177C43.7643 234.372 44.0599 234.498 44.3563 234.555C44.657 234.603 44.9547 234.572 45.2496 234.461C46.0537 234.16 46.2776 233.534 45.9213 232.582L44.442 228.632L41.8989 229.584L41.5714 228.71L45.1096 227.385L46.8975 232.159C47.1911 232.943 47.2231 233.6 46.9934 234.129C46.7704 234.656 46.297 235.055 45.5733 235.326ZM52.9582 232.469L52.5366 231.343L52.4073 231.151L51.6883 229.231C51.5353 228.822 51.2967 228.552 50.9727 228.421C50.6528 228.281 50.255 228.3 49.7792 228.479C49.4643 228.597 49.1761 228.766 48.9147 228.986C48.6508 229.199 48.4476 229.432 48.3051 229.684L47.632 229.111C47.8239 228.787 48.0896 228.496 48.4289 228.239C48.7724 227.973 49.1552 227.761 49.5774 227.603C50.3078 227.329 50.9372 227.296 51.4655 227.503C51.9939 227.71 52.3948 228.179 52.6683 228.91L53.8729 232.126L52.9582 232.469ZM51.2318 233.184C50.8364 233.332 50.4629 233.395 50.1111 233.374C49.7661 233.351 49.4693 233.252 49.2206 233.077C48.9694 232.896 48.7874 232.655 48.6745 232.354C48.5666 232.065 48.5357 231.779 48.5819 231.494C48.6348 231.207 48.789 230.935 49.0446 230.679C49.3068 230.421 49.7026 230.192 50.232 229.994L51.9207 229.361L52.1804 230.055L50.5319 230.672C50.0495 230.853 49.7546 231.055 49.6473 231.279C49.54 231.502 49.529 231.728 49.6143 231.956C49.7122 232.217 49.8951 232.389 50.1631 232.472C50.4285 232.549 50.7455 232.518 51.1141 232.38C51.4759 232.244 51.7608 232.046 51.9686 231.785C52.1831 231.521 52.2929 231.212 52.2981 230.859L52.7375 231.451C52.7282 231.814 52.5978 232.149 52.3464 232.457C52.0925 232.758 51.721 233.001 51.2318 233.184ZM56.4894 225.014C56.925 224.851 57.3383 224.792 57.7294 224.837C58.1272 224.879 58.4839 225.035 58.7995 225.307C59.1151 225.578 59.3707 225.976 59.5665 226.498L60.7145 229.564L59.7496 229.925L58.6429 226.97C58.4497 226.454 58.1768 226.113 57.8243 225.947C57.4785 225.779 57.0778 225.78 56.6221 225.95C56.2804 226.078 56.0073 226.257 55.8028 226.486C55.5984 226.716 55.4747 226.988 55.4319 227.302C55.3957 227.613 55.4504 227.963 55.5959 228.352L56.6235 231.096L55.6586 231.457L53.6636 226.13L54.5884 225.784L55.1266 227.221L54.8328 226.896C54.8765 226.482 55.043 226.11 55.332 225.78C55.6211 225.45 56.0069 225.195 56.4894 225.014ZM61.2815 226.681L60.9691 225.847L63.673 224.834L63.9854 225.669L61.2815 226.681ZM65.6778 227.705L65.4219 227.022L67.2514 223.185C67.4157 222.848 67.5243 222.567 67.5772 222.341C67.6342 222.105 67.654 221.903 67.6365 221.734C67.6232 221.556 67.5889 221.393 67.5337 221.245C67.3982 220.883 67.1642 220.646 66.8318 220.534C66.4994 220.422 66.0886 220.457 65.5994 220.64C65.2241 220.781 64.9096 220.971 64.6557 221.211C64.3993 221.445 64.2095 221.734 64.0862 222.078L63.1806 221.741C63.3207 221.299 63.5813 220.903 63.9625 220.554C64.348 220.196 64.812 219.915 65.3548 219.712C65.844 219.529 66.2996 219.45 66.7217 219.475C67.1413 219.494 67.5035 219.614 67.8082 219.836C68.1196 220.056 68.3507 220.366 68.5012 220.768C68.5865 220.996 68.6405 221.232 68.663 221.476C68.6855 221.719 68.6594 221.997 68.5847 222.307C68.51 222.618 68.3729 222.986 68.1734 223.413L66.5425 226.831L66.1545 226.53L70.4063 224.937L70.7338 225.812L65.6778 227.705ZM73.7413 224.777C73.2455 224.963 72.7341 225.067 72.2073 225.088C71.6873 225.107 71.2308 225.041 70.8381 224.89L71.0031 223.923C71.3205 224.056 71.6931 224.123 72.1211 224.123C72.5491 224.124 72.9775 224.043 73.4063 223.883C73.929 223.687 74.293 223.425 74.4984 223.096C74.7079 222.757 74.7411 222.397 74.5981 222.015C74.4601 221.647 74.2089 221.405 73.8447 221.289C73.4846 221.164 73.003 221.214 72.3999 221.44L71.8371 221.651L71.5736 220.947L72.7007 217.591L72.992 217.941L69.1422 219.382L68.8147 218.508L73.4586 216.769L73.7145 217.452L72.5937 220.795L71.9543 220.679L72.286 220.555C73.1371 220.236 73.8452 220.188 74.4104 220.412C74.9823 220.634 75.3787 221.039 75.5995 221.629C75.7475 222.024 75.7859 222.422 75.7145 222.824C75.6431 223.225 75.4462 223.596 75.1236 223.939C74.8052 224.272 74.3444 224.552 73.7413 224.777Z'
      fill='#636363'
    />
    <path
      d='M89.4959 242.068L87.0115 235.434L87.6207 235.745L85.6003 236.501L85.2728 235.627L87.8561 234.659L90.491 241.696L89.4959 242.068ZM94.3318 240.349C93.8359 240.535 93.3246 240.638 92.7978 240.66C92.2777 240.679 91.8213 240.613 91.4286 240.462L91.5936 239.495C91.9109 239.628 92.2836 239.695 92.7116 239.695C93.1395 239.695 93.5646 239.616 93.9867 239.458C94.5228 239.257 94.8923 238.989 95.0951 238.653C95.2979 238.318 95.3278 237.959 95.1848 237.577C95.0869 237.315 94.9379 237.111 94.7378 236.965C94.5378 236.818 94.2614 236.754 93.9088 236.771C93.5604 236.779 93.1148 236.885 92.572 237.088L90.9738 237.687L89.9681 233.869L93.9384 232.382L94.2659 233.256L90.6675 234.604L91.0057 233.915L91.802 236.93L91.0987 236.643L92.4556 236.135C93.1593 235.871 93.7594 235.75 94.256 235.77C94.7526 235.79 95.1583 235.925 95.4731 236.174C95.7854 236.416 96.0193 236.745 96.1749 237.16C96.3255 237.562 96.3663 237.967 96.2974 238.375C96.2261 238.776 96.0304 239.151 95.7103 239.5C95.3944 239.84 94.9349 240.123 94.3318 240.349ZM97.0153 236.582L96.7028 235.748L99.4067 234.735L99.7191 235.569L97.0153 236.582ZM102.961 237.117C102.546 237.273 102.124 237.331 101.697 237.293C101.27 237.254 100.881 237.113 100.53 236.87L100.857 235.968C101.152 236.163 101.448 236.29 101.744 236.347C102.045 236.395 102.343 236.363 102.637 236.253C103.441 235.952 103.665 235.325 103.309 234.374L101.83 230.424L99.2867 231.376L98.9592 230.501L102.497 229.177L104.285 233.951C104.579 234.735 104.611 235.392 104.381 235.921C104.158 236.448 103.685 236.846 102.961 237.117ZM110.346 234.26L109.924 233.134L109.795 232.942L109.076 231.022C108.923 230.614 108.684 230.344 108.36 230.213C108.041 230.073 107.643 230.092 107.167 230.27C106.852 230.388 106.564 230.557 106.302 230.777C106.039 230.991 105.835 231.223 105.693 231.476L105.02 230.902C105.212 230.578 105.477 230.288 105.817 230.031C106.16 229.765 106.543 229.553 106.965 229.395C107.696 229.121 108.325 229.088 108.853 229.295C109.382 229.502 109.783 229.971 110.056 230.701L111.261 233.918L110.346 234.26ZM108.62 234.975C108.224 235.124 107.851 235.187 107.499 235.166C107.154 235.142 106.857 235.043 106.608 234.869C106.357 234.688 106.175 234.447 106.062 234.145C105.954 233.857 105.924 233.571 105.97 233.286C106.023 232.999 106.177 232.727 106.432 232.471C106.695 232.212 107.09 231.984 107.62 231.785L109.308 231.153L109.568 231.847L107.92 232.464C107.437 232.645 107.142 232.847 107.035 233.07C106.928 233.294 106.917 233.52 107.002 233.747C107.1 234.009 107.283 234.181 107.551 234.264C107.816 234.34 108.133 234.309 108.502 234.171C108.864 234.036 109.149 233.838 109.356 233.576C109.571 233.313 109.681 233.004 109.686 232.651L110.125 233.243C110.116 233.605 109.986 233.941 109.734 234.249C109.48 234.55 109.109 234.792 108.62 234.975ZM113.877 226.806C114.313 226.643 114.726 226.584 115.117 226.628C115.515 226.67 115.872 226.827 116.187 227.099C116.503 227.37 116.759 227.767 116.954 228.29L118.102 231.356L117.137 231.717L116.031 228.762C115.837 228.246 115.565 227.905 115.212 227.739C114.866 227.57 114.466 227.571 114.01 227.742C113.668 227.87 113.395 228.049 113.191 228.278C112.986 228.507 112.862 228.779 112.82 229.093C112.783 229.405 112.838 229.755 112.984 230.143L114.011 232.888L113.046 233.249L111.051 227.922L111.976 227.575L112.514 229.013L112.221 228.687C112.264 228.273 112.431 227.902 112.72 227.572C113.009 227.242 113.395 226.987 113.877 226.806ZM118.669 228.473L118.357 227.638L121.061 226.626L121.373 227.46L118.669 228.473ZM123.066 229.497L122.81 228.813L124.639 224.976C124.804 224.64 124.912 224.358 124.965 224.132C125.022 223.897 125.042 223.695 125.024 223.526C125.011 223.347 124.977 223.184 124.921 223.037C124.786 222.675 124.552 222.438 124.22 222.326C123.887 222.213 123.476 222.249 122.987 222.432C122.612 222.572 122.297 222.763 122.043 223.003C121.787 223.237 121.597 223.525 121.474 223.87L120.568 223.532C120.708 223.09 120.969 222.695 121.35 222.346C121.736 221.987 122.2 221.707 122.743 221.503C123.232 221.32 123.687 221.241 124.11 221.267C124.529 221.285 124.891 221.406 125.196 221.628C125.507 221.847 125.738 222.158 125.889 222.56C125.974 222.788 126.028 223.024 126.051 223.267C126.073 223.511 126.047 223.788 125.972 224.099C125.898 224.41 125.761 224.778 125.561 225.204L123.93 228.623L123.542 228.321L127.794 226.729L128.122 227.604L123.066 229.497ZM131.129 226.569C130.633 226.755 130.122 226.858 129.595 226.88C129.075 226.899 128.619 226.833 128.226 226.682L128.391 225.715C128.708 225.848 129.081 225.915 129.509 225.915C129.937 225.915 130.365 225.835 130.794 225.674C131.317 225.479 131.681 225.216 131.886 224.887C132.096 224.549 132.129 224.189 131.986 223.807C131.848 223.438 131.597 223.196 131.232 223.08C130.872 222.955 130.391 223.006 129.788 223.232L129.225 223.443L128.961 222.739L130.088 219.383L130.38 219.732L126.53 221.174L126.203 220.299L130.846 218.56L131.102 219.244L129.981 222.586L129.342 222.47L129.674 222.346C130.525 222.027 131.233 221.98 131.798 222.204C132.37 222.425 132.766 222.831 132.987 223.42C133.135 223.816 133.174 224.214 133.102 224.615C133.031 225.016 132.834 225.388 132.511 225.73C132.193 226.064 131.732 226.343 131.129 226.569Z'
      fill='#636363'
    />
    <path
      d='M145.597 241.111C145.048 241.317 144.503 241.36 143.962 241.242C143.428 241.121 142.933 240.84 142.477 240.4C142.029 239.957 141.661 239.353 141.375 238.589C141.089 237.825 140.97 237.129 141.017 236.5C141.071 235.868 141.259 235.332 141.583 234.889C141.913 234.445 142.353 234.12 142.902 233.914C143.445 233.711 143.987 233.668 144.528 233.787C145.069 233.905 145.564 234.186 146.012 234.629C146.461 235.072 146.829 235.676 147.115 236.44C147.401 237.204 147.52 237.9 147.473 238.529C147.426 239.158 147.237 239.695 146.907 240.139C146.577 240.584 146.14 240.908 145.597 241.111ZM145.262 240.216C145.631 240.078 145.915 239.857 146.114 239.553C146.321 239.247 146.425 238.864 146.429 238.404C146.439 237.942 146.333 237.412 146.109 236.816C145.886 236.22 145.619 235.751 145.307 235.409C145.003 235.064 144.672 234.844 144.315 234.749C143.965 234.651 143.606 234.671 143.237 234.809C142.869 234.947 142.581 235.169 142.375 235.475C142.169 235.782 142.061 236.166 142.051 236.628C142.047 237.088 142.157 237.616 142.38 238.213C142.604 238.809 142.868 239.279 143.172 239.624C143.484 239.966 143.818 240.184 144.175 240.28C144.531 240.376 144.894 240.354 145.262 240.216ZM150.583 239.152L148.099 232.518L148.708 232.829L146.687 233.585L146.36 232.711L148.943 231.743L151.578 238.78L150.583 239.152ZM152.331 235.827L152.018 234.993L154.722 233.981L155.034 234.815L152.331 235.827ZM157.054 232.5L160.682 231.141L161.006 232.006L157.377 233.364L157.054 232.5ZM158.543 236.171L157.538 236.548L154.903 229.512L159.869 227.652L160.196 228.527L156.236 230.01L158.543 236.171ZM166.006 233.446C165.436 233.659 164.889 233.73 164.366 233.658C163.849 233.584 163.394 233.388 163 233.07C162.612 232.749 162.319 232.324 162.121 231.794C161.923 231.265 161.861 230.753 161.936 230.259C162.017 229.763 162.216 229.325 162.533 228.947C162.854 228.559 163.269 228.27 163.778 228.079C164.294 227.886 164.792 227.829 165.273 227.909C165.754 227.989 166.183 228.195 166.559 228.528C166.94 228.851 167.234 229.288 167.439 229.837C167.454 229.877 167.469 229.925 167.482 229.982C167.502 230.035 167.517 230.087 167.528 230.136L162.995 231.834L162.735 231.14L166.766 229.631L166.464 230.019C166.343 229.674 166.159 229.396 165.911 229.183C165.663 228.97 165.381 228.839 165.064 228.79C164.752 228.731 164.425 228.765 164.083 228.893C163.748 229.019 163.479 229.208 163.275 229.46C163.069 229.705 162.944 229.992 162.899 230.322C162.852 230.646 162.894 230.982 163.024 231.33L163.084 231.491C163.217 231.846 163.417 232.134 163.683 232.355C163.954 232.567 164.265 232.695 164.618 232.739C164.97 232.783 165.338 232.733 165.72 232.59C166.034 232.472 166.299 232.312 166.514 232.109C166.735 231.904 166.902 231.658 167.016 231.371L167.783 231.794C167.647 232.166 167.426 232.494 167.119 232.776C166.819 233.057 166.448 233.28 166.006 233.446ZM172.612 230.971C172.157 231.142 171.707 231.196 171.263 231.133C170.824 231.061 170.421 230.864 170.056 230.542C169.698 230.218 169.406 229.754 169.18 229.151C168.954 228.548 168.873 228.005 168.937 227.523C169.008 227.038 169.186 226.627 169.473 226.29C169.766 225.951 170.134 225.699 170.576 225.533C171.099 225.338 171.604 225.279 172.091 225.356C172.579 225.433 173.016 225.632 173.404 225.953C173.789 226.267 174.083 226.696 174.286 227.239C174.489 227.781 174.55 228.301 174.469 228.798C174.387 229.294 174.188 229.732 173.872 230.11C173.555 230.489 173.135 230.776 172.612 230.971ZM169.765 231.969L166.972 224.511L167.937 224.149L169.266 227.697L169.629 228.971L170.152 230.185L170.69 231.622L169.765 231.969ZM172.216 230.157C172.558 230.029 172.834 229.838 173.044 229.583C173.261 229.326 173.394 229.028 173.443 228.689C173.496 228.341 173.452 227.979 173.311 227.604C173.168 227.222 172.965 226.924 172.701 226.709C172.442 226.485 172.146 226.348 171.813 226.297C171.487 226.243 171.154 226.28 170.812 226.408C170.477 226.533 170.201 226.725 169.984 226.982C169.773 227.236 169.641 227.534 169.585 227.876C169.534 228.208 169.58 228.566 169.723 228.948C169.863 229.323 170.065 229.626 170.327 229.856C170.593 230.077 170.889 230.215 171.215 230.269C171.547 230.32 171.881 230.283 172.216 230.157ZM175.496 227.152L175.184 226.318L177.888 225.305L178.2 226.14L175.496 227.152ZM179.893 228.176L179.637 227.493L181.466 223.656C181.631 223.319 181.739 223.038 181.792 222.812C181.849 222.577 181.869 222.374 181.851 222.205C181.838 222.027 181.804 221.864 181.748 221.716C181.613 221.355 181.379 221.117 181.047 221.005C180.714 220.893 180.303 220.928 179.814 221.111C179.439 221.252 179.124 221.442 178.87 221.682C178.614 221.916 178.424 222.205 178.301 222.549L177.395 222.212C177.535 221.77 177.796 221.374 178.177 221.025C178.563 220.667 179.027 220.386 179.57 220.183C180.059 220 180.514 219.921 180.937 219.946C181.356 219.965 181.718 220.085 182.023 220.307C182.334 220.527 182.565 220.837 182.716 221.239C182.801 221.467 182.855 221.703 182.878 221.947C182.9 222.19 182.874 222.468 182.799 222.778C182.725 223.089 182.588 223.457 182.388 223.884L180.757 227.302L180.369 227.001L184.621 225.408L184.949 226.283L179.893 228.176ZM187.956 225.248C187.46 225.434 186.949 225.538 186.422 225.559C185.902 225.578 185.446 225.512 185.053 225.361L185.218 224.394C185.535 224.527 185.908 224.594 186.336 224.594C186.764 224.595 187.192 224.514 187.621 224.354C188.144 224.158 188.508 223.896 188.713 223.567C188.923 223.228 188.956 222.868 188.813 222.486C188.675 222.118 188.424 221.876 188.059 221.76C187.699 221.635 187.218 221.685 186.615 221.911L186.052 222.122L185.788 221.418L186.915 218.062L187.207 218.412L183.357 219.853L183.03 218.979L187.673 217.24L187.929 217.923L186.808 221.266L186.169 221.15L186.501 221.026C187.352 220.707 188.06 220.659 188.625 220.883C189.197 221.105 189.593 221.51 189.814 222.1C189.962 222.495 190.001 222.893 189.929 223.295C189.858 223.696 189.661 224.067 189.338 224.41C189.02 224.743 188.559 225.023 187.956 225.248Z'
      fill='#636363'
    />
    <path
      d='M201.071 242.634L198.588 236L199.197 236.31L197.176 237.067L196.849 236.192L199.432 235.225L202.066 242.261L201.071 242.634ZM205.907 240.915C205.412 241.101 204.9 241.204 204.373 241.226C203.853 241.245 203.397 241.179 203.004 241.028L203.169 240.061C203.487 240.194 203.859 240.261 204.287 240.261C204.715 240.261 205.14 240.182 205.562 240.024C206.099 239.824 206.468 239.555 206.671 239.22C206.874 238.884 206.904 238.525 206.761 238.143C206.663 237.882 206.514 237.678 206.314 237.531C206.114 237.384 205.837 237.32 205.485 237.337C205.136 237.345 204.691 237.451 204.148 237.654L202.55 238.253L201.544 234.434L205.515 232.948L205.842 233.822L202.244 235.17L202.582 234.481L203.378 237.496L202.675 237.209L204.032 236.701C204.735 236.437 205.335 236.316 205.832 236.336C206.329 236.356 206.734 236.491 207.049 236.74C207.361 236.982 207.595 237.311 207.751 237.726C207.901 238.129 207.942 238.534 207.873 238.941C207.802 239.342 207.606 239.718 207.286 240.067C206.97 240.406 206.511 240.689 205.907 240.915ZM208.591 237.148L208.279 236.314L210.983 235.302L211.295 236.136L208.591 237.148ZM213.314 233.821L216.943 232.463L217.267 233.327L213.638 234.686L213.314 233.821ZM214.804 237.493L213.799 237.869L211.164 230.833L216.13 228.974L216.457 229.848L212.497 231.331L214.804 237.493ZM222.266 234.768C221.697 234.981 221.15 235.052 220.627 234.98C220.11 234.906 219.655 234.71 219.26 234.392C218.873 234.071 218.58 233.645 218.382 233.116C218.183 232.587 218.122 232.075 218.197 231.581C218.278 231.084 218.477 230.647 218.794 230.268C219.115 229.881 219.53 229.592 220.039 229.401C220.555 229.208 221.054 229.151 221.534 229.231C222.015 229.311 222.444 229.517 222.82 229.85C223.201 230.173 223.495 230.61 223.7 231.159C223.715 231.199 223.73 231.247 223.743 231.304C223.763 231.357 223.779 231.409 223.789 231.458L219.256 233.155L218.996 232.462L223.027 230.953L222.725 231.341C222.604 230.996 222.42 230.718 222.172 230.505C221.924 230.292 221.642 230.161 221.325 230.111C221.013 230.053 220.686 230.087 220.344 230.215C220.009 230.341 219.74 230.529 219.536 230.781C219.33 231.027 219.205 231.314 219.16 231.644C219.113 231.967 219.155 232.303 219.285 232.652L219.345 232.813C219.478 233.168 219.678 233.456 219.944 233.677C220.215 233.889 220.526 234.017 220.879 234.061C221.231 234.105 221.598 234.055 221.98 233.912C222.295 233.794 222.56 233.634 222.775 233.431C222.996 233.226 223.163 232.98 223.277 232.693L224.044 233.117C223.908 233.488 223.686 233.816 223.38 234.099C223.08 234.379 222.709 234.602 222.266 234.768ZM228.873 232.294C228.418 232.464 227.968 232.518 227.524 232.455C227.085 232.383 226.682 232.186 226.317 231.864C225.959 231.54 225.667 231.076 225.441 230.473C225.215 229.87 225.134 229.327 225.198 228.845C225.269 228.36 225.448 227.949 225.734 227.613C226.027 227.274 226.395 227.021 226.837 226.856C227.36 226.66 227.865 226.601 228.353 226.678C228.84 226.756 229.277 226.955 229.665 227.276C230.05 227.59 230.344 228.018 230.547 228.561C230.751 229.104 230.812 229.624 230.73 230.12C230.649 230.617 230.449 231.054 230.133 231.433C229.816 231.811 229.396 232.098 228.873 232.294ZM226.026 233.291L223.234 225.833L224.199 225.471L225.527 229.02L225.89 230.294L226.413 231.507L226.951 232.945L226.026 233.291ZM228.477 231.48C228.819 231.352 229.095 231.16 229.305 230.906C229.522 230.649 229.655 230.351 229.704 230.012C229.757 229.663 229.713 229.302 229.572 228.926C229.429 228.544 229.226 228.246 228.962 228.032C228.703 227.808 228.407 227.67 228.074 227.619C227.749 227.565 227.415 227.602 227.073 227.73C226.738 227.856 226.462 228.047 226.245 228.304C226.035 228.558 225.902 228.856 225.846 229.198C225.795 229.531 225.841 229.888 225.984 230.27C226.124 230.645 226.326 230.948 226.588 231.178C226.854 231.4 227.15 231.537 227.476 231.591C227.808 231.642 228.142 231.605 228.477 231.48ZM231.758 228.475L231.445 227.641L234.149 226.628L234.462 227.463L231.758 228.475ZM236.154 229.499L235.898 228.816L237.728 224.979C237.892 224.642 238.001 224.361 238.054 224.135C238.111 223.9 238.13 223.697 238.113 223.528C238.1 223.35 238.065 223.187 238.01 223.04C237.875 222.678 237.641 222.441 237.308 222.328C236.976 222.216 236.565 222.251 236.076 222.434C235.701 222.575 235.386 222.765 235.132 223.005C234.876 223.239 234.686 223.528 234.563 223.872L233.657 223.535C233.797 223.093 234.058 222.697 234.439 222.348C234.825 221.99 235.289 221.709 235.831 221.506C236.321 221.323 236.776 221.244 237.198 221.269C237.618 221.288 237.98 221.408 238.285 221.63C238.596 221.85 238.827 222.161 238.978 222.563C239.063 222.791 239.117 223.026 239.139 223.27C239.162 223.514 239.136 223.791 239.061 224.102C238.986 224.412 238.849 224.781 238.65 225.207L237.019 228.626L236.631 228.324L240.882 226.732L241.21 227.606L236.154 229.499ZM244.218 226.572C243.722 226.758 243.21 226.861 242.684 226.883C242.163 226.902 241.707 226.836 241.314 226.685L241.479 225.718C241.797 225.851 242.169 225.918 242.597 225.918C243.025 225.918 243.454 225.838 243.883 225.677C244.405 225.482 244.769 225.219 244.975 224.89C245.184 224.552 245.218 224.192 245.075 223.81C244.937 223.441 244.685 223.199 244.321 223.084C243.961 222.959 243.48 223.009 242.876 223.235L242.314 223.446L242.05 222.742L243.177 219.386L243.469 219.735L239.619 221.177L239.291 220.302L243.935 218.563L244.191 219.247L243.07 222.589L242.431 222.473L242.763 222.349C243.614 222.03 244.322 221.983 244.887 222.207C245.459 222.428 245.855 222.834 246.076 223.424C246.224 223.819 246.262 224.217 246.191 224.618C246.119 225.02 245.922 225.391 245.6 225.734C245.281 226.067 244.821 226.346 244.218 226.572Z'
      fill='#636363'
    />
    <path
      d='M259.047 242.565C258.497 242.771 257.952 242.815 257.411 242.696C256.877 242.575 256.382 242.295 255.927 241.854C255.478 241.411 255.11 240.807 254.824 240.043C254.538 239.279 254.419 238.583 254.466 237.954C254.52 237.322 254.709 236.786 255.032 236.344C255.362 235.899 255.802 235.574 256.352 235.368C256.894 235.165 257.436 235.122 257.977 235.241C258.518 235.359 259.013 235.64 259.462 236.083C259.91 236.526 260.278 237.13 260.564 237.894C260.85 238.658 260.969 239.354 260.922 239.983C260.875 240.612 260.686 241.149 260.356 241.593C260.026 242.038 259.589 242.362 259.047 242.565ZM258.712 241.67C259.08 241.532 259.364 241.311 259.564 241.008C259.77 240.701 259.875 240.318 259.878 239.858C259.889 239.396 259.782 238.867 259.559 238.27C259.335 237.674 259.068 237.205 258.757 236.863C258.452 236.519 258.121 236.299 257.764 236.203C257.414 236.105 257.055 236.125 256.687 236.263C256.318 236.401 256.031 236.623 255.824 236.929C255.618 237.236 255.51 237.62 255.5 238.082C255.496 238.542 255.606 239.07 255.83 239.667C256.053 240.263 256.317 240.733 256.622 241.078C256.933 241.42 257.267 241.638 257.624 241.734C257.98 241.83 258.343 241.808 258.712 241.67ZM264.032 240.606L261.548 233.972L262.157 234.283L260.137 235.039L259.809 234.165L262.392 233.198L265.027 240.234L264.032 240.606ZM265.78 237.281L265.467 236.447L268.171 235.435L268.484 236.269L265.78 237.281ZM270.987 238.002L268.352 230.966L269.177 230.657L274.324 234.792L273.882 234.958L275.006 228.474L275.831 228.165L278.476 235.198L277.511 235.559L275.434 230.044L275.665 229.958L274.638 235.661L274.175 235.834L269.634 232.216L269.886 232.122L271.952 237.64L270.987 238.002ZM283.753 233.221L283.332 232.095L283.203 231.903L282.484 229.983C282.331 229.574 282.092 229.305 281.768 229.174C281.448 229.034 281.05 229.053 280.575 229.231C280.26 229.349 279.971 229.518 279.71 229.738C279.446 229.952 279.243 230.184 279.1 230.436L278.427 229.863C278.619 229.539 278.885 229.249 279.224 228.992C279.568 228.726 279.95 228.514 280.373 228.355C281.103 228.082 281.732 228.049 282.261 228.256C282.789 228.463 283.19 228.932 283.464 229.662L284.668 232.879L283.753 233.221ZM282.027 233.936C281.632 234.084 281.258 234.148 280.906 234.127C280.561 234.103 280.265 234.004 280.016 233.83C279.765 233.649 279.583 233.408 279.47 233.106C279.362 232.818 279.331 232.532 279.377 232.247C279.43 231.96 279.584 231.688 279.84 231.432C280.102 231.173 280.498 230.945 281.027 230.746L282.716 230.114L282.976 230.808L281.327 231.425C280.845 231.606 280.55 231.808 280.443 232.031C280.335 232.255 280.324 232.48 280.41 232.708C280.507 232.97 280.69 233.142 280.958 233.225C281.224 233.301 281.541 233.27 281.909 233.132C282.271 232.997 282.556 232.798 282.764 232.537C282.978 232.274 283.088 231.965 283.093 231.612L283.533 232.203C283.523 232.566 283.393 232.901 283.142 233.21C282.888 233.511 282.516 233.753 282.027 233.936ZM286.454 232.21L284.459 226.882L285.384 226.536L285.926 227.984L285.7 227.656C285.709 227.232 285.852 226.858 286.127 226.533C286.403 226.208 286.796 225.95 287.305 225.759L287.655 226.694C287.612 226.703 287.571 226.714 287.53 226.729C287.497 226.742 287.463 226.754 287.43 226.767C286.914 226.96 286.563 227.267 286.377 227.689C286.191 228.11 286.207 228.612 286.425 229.195L287.419 231.848L286.454 232.21ZM289.269 228.485L288.957 227.651L291.661 226.638L291.973 227.472L289.269 228.485ZM293.666 229.509L293.41 228.826L295.239 224.989C295.404 224.652 295.512 224.371 295.565 224.145C295.622 223.909 295.642 223.707 295.624 223.538C295.611 223.359 295.577 223.197 295.522 223.049C295.386 222.687 295.152 222.45 294.82 222.338C294.487 222.225 294.076 222.261 293.587 222.444C293.212 222.585 292.897 222.775 292.644 223.015C292.387 223.249 292.197 223.538 292.074 223.882L291.169 223.545C291.309 223.103 291.569 222.707 291.95 222.358C292.336 222 292.8 221.719 293.343 221.516C293.832 221.332 294.288 221.253 294.71 221.279C295.129 221.297 295.491 221.418 295.796 221.64C296.108 221.859 296.339 222.17 296.489 222.572C296.574 222.8 296.628 223.036 296.651 223.28C296.673 223.523 296.647 223.8 296.573 224.111C296.498 224.422 296.361 224.79 296.161 225.216L294.53 228.635L294.142 228.334L298.394 226.741L298.722 227.616L293.666 229.509ZM301.729 226.581C301.233 226.767 300.722 226.87 300.195 226.892C299.675 226.911 299.219 226.845 298.826 226.694L298.991 225.727C299.308 225.86 299.681 225.927 300.109 225.927C300.537 225.927 300.965 225.847 301.394 225.687C301.917 225.491 302.281 225.228 302.486 224.899C302.696 224.561 302.729 224.201 302.586 223.819C302.448 223.451 302.197 223.208 301.833 223.093C301.473 222.968 300.991 223.018 300.388 223.244L299.825 223.455L299.562 222.751L300.689 219.395L300.98 219.744L297.13 221.186L296.803 220.312L301.446 218.573L301.702 219.256L300.582 222.598L299.942 222.483L300.274 222.358C301.125 222.04 301.833 221.992 302.398 222.216C302.97 222.437 303.367 222.843 303.587 223.433C303.735 223.828 303.774 224.226 303.702 224.627C303.631 225.029 303.434 225.4 303.112 225.743C302.793 226.076 302.332 226.355 301.729 226.581Z'
      fill='#636363'
    />
    <path
      d='M314.521 243.071L312.037 236.437L312.646 236.748L310.626 237.504L310.298 236.63L312.881 235.662L315.516 242.698L314.521 243.071ZM319.357 241.352C318.861 241.538 318.35 241.641 317.823 241.663C317.303 241.682 316.847 241.616 316.454 241.465L316.619 240.498C316.936 240.631 317.309 240.698 317.737 240.698C318.165 240.698 318.59 240.619 319.012 240.461C319.548 240.26 319.918 239.992 320.12 239.656C320.323 239.321 320.353 238.962 320.21 238.58C320.112 238.318 319.963 238.114 319.763 237.968C319.563 237.821 319.287 237.756 318.934 237.774C318.586 237.782 318.14 237.888 317.597 238.091L315.999 238.69L314.993 234.871L318.964 233.385L319.291 234.259L315.693 235.607L316.031 234.918L316.827 237.932L316.124 237.646L317.481 237.138C318.185 236.874 318.785 236.752 319.281 236.773C319.778 236.793 320.184 236.928 320.498 237.177C320.811 237.419 321.045 237.748 321.2 238.163C321.351 238.565 321.392 238.97 321.323 239.378C321.251 239.779 321.056 240.154 320.736 240.503C320.42 240.843 319.96 241.126 319.357 241.352ZM322.041 237.585L321.728 236.75L324.432 235.738L324.745 236.572L322.041 237.585ZM327.248 238.305L324.613 231.269L325.437 230.96L330.585 235.096L330.143 235.261L331.267 228.777L332.092 228.469L334.736 235.501L333.772 235.862L331.695 230.348L331.926 230.261L330.898 235.964L330.436 236.137L325.895 232.52L326.146 232.425L328.213 237.944L327.248 238.305ZM340.014 233.524L339.593 232.399L339.463 232.206L338.744 230.287C338.591 229.878 338.353 229.608 338.029 229.477C337.709 229.337 337.311 229.356 336.835 229.534C336.52 229.652 336.232 229.821 335.971 230.042C335.707 230.255 335.504 230.488 335.361 230.74L334.688 230.167C334.88 229.843 335.146 229.552 335.485 229.295C335.829 229.029 336.211 228.817 336.633 228.659C337.364 228.385 337.993 228.352 338.522 228.559C339.05 228.766 339.451 229.235 339.724 229.965L340.929 233.182L340.014 233.524ZM338.288 234.24C337.893 234.388 337.519 234.451 337.167 234.43C336.822 234.407 336.525 234.308 336.277 234.133C336.026 233.952 335.844 233.711 335.731 233.409C335.623 233.121 335.592 232.835 335.638 232.55C335.691 232.263 335.845 231.991 336.101 231.735C336.363 231.476 336.759 231.248 337.288 231.05L338.977 230.417L339.237 231.111L337.588 231.728C337.106 231.909 336.811 232.111 336.703 232.335C336.596 232.558 336.585 232.784 336.67 233.012C336.768 233.273 336.951 233.445 337.219 233.528C337.485 233.604 337.802 233.574 338.17 233.436C338.532 233.3 338.817 233.102 339.025 232.841C339.239 232.577 339.349 232.268 339.354 231.915L339.794 232.507C339.784 232.869 339.654 233.205 339.403 233.513C339.149 233.814 338.777 234.056 338.288 234.24ZM342.715 232.513L340.72 227.186L341.644 226.84L342.187 228.287L341.961 227.959C341.97 227.535 342.113 227.161 342.388 226.836C342.664 226.511 343.056 226.253 343.566 226.063L343.916 226.998C343.873 227.006 343.832 227.018 343.791 227.033C343.758 227.045 343.724 227.058 343.691 227.07C343.175 227.264 342.824 227.571 342.638 227.992C342.452 228.413 342.468 228.915 342.686 229.498L343.68 232.152L342.715 232.513ZM345.53 228.788L345.218 227.954L347.922 226.941L348.234 227.776L345.53 228.788ZM349.927 229.812L349.671 229.129L351.5 225.292C351.664 224.955 351.773 224.674 351.826 224.448C351.883 224.213 351.903 224.01 351.885 223.841C351.872 223.663 351.838 223.5 351.782 223.352C351.647 222.991 351.413 222.754 351.081 222.641C350.748 222.529 350.337 222.564 349.848 222.747C349.473 222.888 349.158 223.078 348.904 223.319C348.648 223.552 348.458 223.841 348.335 224.185L347.429 223.848C347.569 223.406 347.83 223.01 348.211 222.661C348.597 222.303 349.061 222.022 349.604 221.819C350.093 221.636 350.548 221.557 350.97 221.582C351.39 221.601 351.752 221.721 352.057 221.943C352.368 222.163 352.599 222.473 352.75 222.876C352.835 223.103 352.889 223.339 352.912 223.583C352.934 223.827 352.908 224.104 352.833 224.414C352.759 224.725 352.622 225.094 352.422 225.52L350.791 228.938L350.403 228.637L354.655 227.045L354.983 227.919L349.927 229.812ZM357.99 226.884C357.494 227.07 356.983 227.174 356.456 227.195C355.936 227.214 355.48 227.148 355.087 226.997L355.252 226.03C355.569 226.164 355.942 226.23 356.37 226.231C356.798 226.231 357.226 226.151 357.655 225.99C358.178 225.794 358.542 225.532 358.747 225.203C358.957 224.864 358.99 224.504 358.847 224.122C358.709 223.754 358.458 223.512 358.093 223.396C357.733 223.271 357.252 223.321 356.649 223.547L356.086 223.758L355.822 223.055L356.949 219.698L357.241 220.048L353.391 221.489L353.064 220.615L357.707 218.876L357.963 219.559L356.842 222.902L356.203 222.786L356.535 222.662C357.386 222.343 358.094 222.296 358.659 222.519C359.231 222.741 359.627 223.146 359.848 223.736C359.996 224.131 360.035 224.53 359.963 224.931C359.892 225.332 359.695 225.704 359.372 226.046C359.054 226.379 358.593 226.659 357.99 226.884Z'
      fill='#636363'
    />
    <path
      d='M48.5195 191H51.7353C52.1695 191 52.5541 191.28 52.6872 191.694L54.4945 197.306C54.6276 197.72 55.0122 198 55.4464 198H56.8426C57.2592 198 57.6322 197.742 57.7787 197.352L59.5455 192.648C59.6921 192.258 60.065 192 60.4817 192H64.5942C65.0753 192 65.4882 192.343 65.577 192.815L66.0313 195.234C66.2051 196.159 67.4442 196.354 67.8931 195.526L72.7181 186.634C73.1439 185.849 74.3066 185.973 74.5569 186.83L77.6102 197.28C77.7348 197.707 78.1258 198 78.57 198H80.0985C80.4351 198 80.7491 197.831 80.9341 197.549L84.2859 192.451C84.4708 192.169 84.7848 192 85.1215 192H87.3278C87.7155 192 88.0682 192.224 88.233 192.575L90.5104 197.425C90.6752 197.776 91.0279 198 91.4156 198H98.1298C98.4664 198 98.7804 197.831 98.9654 197.549L101.852 193.159C102.226 192.589 103.05 192.553 103.472 193.089L105.866 196.123C106.235 196.591 106.929 196.634 107.353 196.216L110.606 193.009C111.102 192.52 111.933 192.675 112.22 193.31L112.412 193.736C112.828 194.659 114.194 194.451 114.316 193.446L115.565 183.193C115.696 182.12 117.2 181.989 117.514 183.023L121.569 196.334C121.691 196.734 122.049 197.016 122.466 197.041L137.741 197.945C138.267 197.976 138.727 197.593 138.792 197.071L140.257 185.376C140.319 184.875 140.745 184.5 141.249 184.5H149.662C150.151 184.5 150.568 184.853 150.649 185.335L152.624 197.165C152.704 197.647 153.121 198 153.61 198H154.199C154.675 198 155.085 197.665 155.179 197.198L158.103 182.743C158.313 181.704 159.784 181.664 160.051 182.69L163.103 194.427C163.36 195.414 164.757 195.429 165.034 194.447L165.338 193.365C165.526 192.7 166.316 192.421 166.88 192.821L173.018 197.179C173.582 197.579 174.372 197.3 174.56 196.635L175.138 194.582C175.389 193.691 176.612 193.59 177.006 194.428L178.413 197.425C178.578 197.776 178.931 198 179.318 198H181.992C182.38 198 182.733 197.776 182.897 197.425L184.782 193.411C185.092 192.751 185.981 192.634 186.451 193.191L189.652 196.978C190.083 197.488 190.884 197.44 191.251 196.882L193.461 193.52C193.894 192.861 194.884 192.94 195.208 193.659L196.49 196.502C196.63 196.812 196.918 197.03 197.255 197.08L202.606 197.871C203.103 197.945 203.578 197.637 203.715 197.153L205.741 189.961C206.025 188.952 207.473 189.005 207.683 190.032L208.239 192.748C208.452 193.787 209.925 193.823 210.188 192.795L210.809 190.369C211.075 189.332 212.563 189.381 212.761 190.432L214.029 197.185C214.118 197.657 214.531 198 215.012 198H225.323C225.739 198 226.112 197.742 226.259 197.352L227.628 193.706C227.906 192.967 228.89 192.826 229.364 193.457L232.455 197.572C232.656 197.839 232.978 197.989 233.312 197.969L249.664 197.033C250.023 197.013 250.343 196.801 250.503 196.479L256.167 185.056C256.336 184.715 256.683 184.5 257.063 184.5H258.448C258.921 184.5 259.33 184.832 259.426 185.296L261.912 197.204C262.008 197.668 262.417 198 262.891 198H282.547C282.791 198 283.028 197.91 283.21 197.748L288.671 192.902C289.176 192.455 289.97 192.624 290.247 193.239L291.13 195.198C291.467 195.945 292.51 195.992 292.913 195.278L293.707 193.869C294.124 193.129 295.215 193.213 295.514 194.008L296.77 197.352C296.916 197.742 297.289 198 297.706 198H301.585C301.9 198 302.196 197.852 302.385 197.601L305.863 192.971C306.241 192.468 306.984 192.434 307.406 192.902L310.829 196.699C311.003 196.892 311.245 197.01 311.504 197.028L325.121 197.957C325.506 197.983 325.871 197.786 326.061 197.45L331.676 187.485C332.051 186.82 333.003 186.803 333.401 187.455L338.769 196.25C339.203 196.961 340.266 196.86 340.559 196.08L341.24 194.268C341.553 193.433 342.721 193.396 343.087 194.209L343.533 195.198C343.87 195.945 344.914 195.992 345.316 195.278L346.319 193.497C346.631 192.944 347.457 193.043 347.629 193.654V193.654C347.85 194.437 348.998 194.301 349.03 193.489L353.352 83.2413C353.358 83.0827 353.402 82.9279 353.48 82.7896L354.649 80.7147C355.126 79.8676 356.41 80.1312 356.514 81.0979L358.972 103.776C358.988 103.923 359.036 104.066 359.114 104.192L362.244 109.284C362.331 109.426 362.382 109.587 362.391 109.754L363.26 125.951C363.317 127.022 364.791 127.264 365.188 126.267L366.821 122.161C366.863 122.054 366.887 121.941 366.891 121.827L368.012 90L370.233 23.9664C370.251 23.4275 370.693 23 371.233 23H372.52'
      stroke='#353CF7'
    />
  </svg>
);

export const Twitter = (
  <svg
    width='27'
    height='22'
    viewBox='0 0 27 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M25.9757 3.14552C25.138 3.4883 24.2572 3.72699 23.3553 3.85569C23.777 3.78697 24.3974 3.06534 24.6444 2.77325C25.0196 2.33266 25.3056 1.8297 25.4878 1.28991C25.4878 1.24981 25.5299 1.19254 25.4878 1.16391C25.4665 1.15288 25.4427 1.1471 25.4185 1.1471C25.3943 1.1471 25.3705 1.15288 25.3492 1.16391C24.3698 1.66814 23.3275 2.05299 22.2469 2.30935C22.2092 2.32029 22.1691 2.32127 22.1309 2.31219C22.0927 2.30311 22.0578 2.28431 22.03 2.2578C21.9459 2.16258 21.8554 2.07266 21.759 1.98862C21.3182 1.61318 20.8181 1.30589 20.2771 1.078C19.5467 0.793114 18.7578 0.669737 17.9699 0.717185C17.2054 0.763087 16.459 0.958035 15.7772 1.28991C15.1057 1.63979 14.5156 2.11513 14.0423 2.68734C13.5444 3.2763 13.1849 3.9598 12.9881 4.69187C12.8258 5.38821 12.8073 6.10791 12.9339 6.81093C12.9339 6.9312 12.9339 6.94838 12.8254 6.9312C8.53036 6.32985 5.00635 4.88086 2.1269 1.77099C2.0004 1.63354 1.93413 1.63354 1.83173 1.77099C0.578745 3.58079 1.18716 6.44439 2.75339 7.85901C2.96423 8.04801 3.18109 8.23128 3.41 8.40309C2.6919 8.35462 1.99133 8.16961 1.34981 7.85901C1.22933 7.78456 1.16307 7.82465 1.15704 7.9621C1.13997 8.15266 1.13997 8.34426 1.15704 8.53482C1.28274 9.44808 1.6613 10.3132 2.25401 11.0418C2.84672 11.7703 3.63231 12.3361 4.53046 12.6813C4.7494 12.7705 4.97754 12.8377 5.21116 12.8818C4.54637 13.0062 3.86455 13.0256 3.19314 12.939C3.04856 12.9104 2.99435 12.9849 3.04856 13.1166C3.93408 15.4075 5.85572 16.1062 7.26533 16.4956C7.4581 16.5243 7.65086 16.5243 7.86772 16.5701C7.86772 16.5701 7.86772 16.5701 7.83158 16.6045C7.41593 17.3261 5.73525 17.8129 4.96418 18.0649C3.55679 18.5455 2.05625 18.7292 0.566697 18.6032C0.331763 18.5689 0.277547 18.5746 0.217308 18.6032C0.157068 18.6319 0.217308 18.6949 0.283571 18.7522C0.584769 18.9412 0.885966 19.1072 1.19921 19.2676C2.13175 19.7512 3.11762 20.1353 4.1389 20.413C9.42793 21.799 15.3796 20.7796 19.3494 17.0283C22.4698 14.0845 23.5661 10.0239 23.5661 5.95758C23.5661 5.80294 23.7649 5.71131 23.8794 5.63113C24.6688 5.04632 25.3648 4.35567 25.9456 3.58079C26.0462 3.46528 26.0977 3.31821 26.0902 3.16843C26.0902 3.08252 26.0902 3.0997 25.9757 3.14552Z'
      fill='white'
    />
  </svg>
);

export const YouTubeRedIcon = (
  <svg width="38" height="26" viewBox="0 0 38 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1105_19789)">
      <path d="M37.1608 4.05528C36.9428 3.27146 36.5176 2.55687 35.9276 1.98268C35.3376 1.4085 34.6032 0.994733 33.7978 0.7826C30.8489 0 18.9807 0 18.9807 0C18.9807 0 7.11197 0.0236888 4.16311 0.806289C3.35761 1.01843 2.62328 1.43222 2.03324 2.00643C1.4432 2.58065 1.01805 3.29526 0.800107 4.07911C-0.0918543 9.17771 -0.437862 16.9468 0.824599 21.8414C1.04256 22.6253 1.46773 23.3398 2.05777 23.914C2.6478 24.4882 3.38212 24.902 4.1876 25.1141C7.13646 25.8967 19.0049 25.8967 19.0049 25.8967C19.0049 25.8967 30.8732 25.8967 33.822 25.1141C34.6275 24.902 35.3618 24.4883 35.9519 23.9141C36.5419 23.3399 36.9671 22.6253 37.1851 21.8414C38.1259 16.7356 38.4158 8.9713 37.1608 4.05528Z" fill="#FF0000" />
      <path d="M15.2031 18.497L25.0487 12.9477L15.2031 7.39844V18.497Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_1105_19789">
        <rect width="38" height="26" fill="white" />
      </clipPath>
    </defs>
  </svg>

);
export const YoutubeIcon = (
  <svg
    width='31'
    height='21'
    viewBox='0 0 31 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M30.26 3.16912C29.906 1.92361 28.8588 0.941049 27.5265 0.604301C25.1175 2.38419e-07 15.452 0 15.452 0C15.452 0 5.79143 2.38419e-07 3.37751 0.604301C2.05011 0.936436 1.00293 1.919 0.644038 3.16912C0 5.42948 0 10.1486 0 10.1486C0 10.1486 0 14.8676 0.644038 17.128C0.998013 18.3735 2.04519 19.3561 3.37751 19.6928C5.79143 20.2971 15.452 20.2971 15.452 20.2971C15.452 20.2971 25.1175 20.2971 27.5265 19.6928C28.8539 19.3607 29.9011 18.3781 30.26 17.128C30.904 14.8676 30.904 10.1486 30.904 10.1486C30.904 10.1486 30.904 5.42948 30.26 3.16912Z'
      fill='white'
    />
    <path
      d='M12.3645 14.4986L20.3929 10.1486L12.3645 5.79852V14.4986Z'
      fill='black'
    />
  </svg>
);

export const QuoraIcon = (
  <svg
    width='22'
    height='22'
    viewBox='0 0 22 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M21.175 16.825H19.7875C19.7125 17.475 19.2875 18.2875 18.225 18.2875C17.25 18.2875 16.55 17.6125 15.875 16.5875C16.9897 15.7354 17.8907 14.6356 18.5069 13.3751C19.123 12.1146 19.4374 10.728 19.425 9.325C19.425 3.75 14.825 0 10.0125 0C5.2625 0 0.625 3.7875 0.625 9.3375C0.625 14.8375 5.2625 18.625 10.0125 18.625C10.8375 18.625 11.6625 18.5125 12.45 18.3C13.375 19.8875 14.6125 21.25 16.95 21.25C20.825 21.25 21.2625 17.675 21.175 16.825ZM14.3625 14.1C13.45 12.7125 12.2875 11.625 10.0375 11.625C8.5875 11.625 7.4625 12.1 6.7625 12.7L7.3375 13.85C7.6375 13.7125 7.95 13.6625 8.275 13.6625C9.9625 13.6625 10.825 15.125 11.5625 16.575C11.0875 16.7125 10.575 16.775 10.0125 16.775C6.45 16.775 4.9125 14.2625 4.9125 9.3375C4.9125 4.3875 6.45 1.85 10.0125 1.85C13.625 1.85 15.175 4.3875 15.175 9.3375C15.1625 11.3125 14.9125 12.9125 14.3625 14.1Z'
      fill='white'
    />
  </svg>
);

export const RedditIcon = (
  <svg
    width='26'
    height='26'
    viewBox='0 0 26 26'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.875 15.0273C6.875 15.4987 7.03633 15.9508 7.32349 16.2841C7.61066 16.6174 8.00014 16.8047 8.40625 16.8047C8.81236 16.8047 9.20184 16.6174 9.48901 16.2841C9.77617 15.9508 9.9375 15.4987 9.9375 15.0273C9.9375 14.556 9.77617 14.1039 9.48901 13.7706C9.20184 13.4373 8.81236 13.25 8.40625 13.25C8.00014 13.25 7.61066 13.4373 7.32349 13.7706C7.03633 14.1039 6.875 14.556 6.875 15.0273ZM16.1363 18.8264C15.5047 19.4041 14.2523 20.0261 13 20.0261C11.7477 20.0261 10.4953 19.4041 9.86367 18.8264C9.46992 18.4678 8.89844 18.5439 8.58672 19.001C8.275 19.458 8.34336 20.1213 8.73711 20.4832C9.83633 21.4893 11.5098 22.1367 13 22.1367C14.4902 22.1367 16.1637 21.4893 17.2629 20.4832C17.4522 20.3098 17.5743 20.0562 17.6026 19.7782C17.6308 19.5003 17.5627 19.2207 17.4133 19.001C17.2639 18.7813 17.0454 18.6395 16.806 18.6067C16.5665 18.574 16.3256 18.653 16.1363 18.8264ZM25.25 11.4727C25.25 9.50806 23.8801 7.91797 22.1875 7.91797C21.0363 7.91797 20.0355 8.6543 19.5105 9.74609C17.9355 8.74634 16.0188 8.10205 13.9297 7.95288L15.759 3.18896L19.2563 4.36011C19.5707 5.39477 20.4211 6.14062 21.4219 6.14062C22.6906 6.14062 23.7188 4.94727 23.7188 3.47461C23.7188 2.00195 22.6906 0.808594 21.4219 0.808594C20.5469 0.808594 19.7867 1.37671 19.3984 2.21143L15.502 0.903809C15.2911 0.832733 15.0653 0.852732 14.8662 0.960103C14.6671 1.06747 14.5083 1.25494 14.4191 1.48779L11.9363 7.95923C9.89922 8.12427 8.02891 8.76538 6.48945 9.74292C6.22398 9.1893 5.83579 8.72816 5.3651 8.40728C4.89442 8.0864 4.35837 7.91746 3.8125 7.91797C2.11992 7.91797 0.75 9.50806 0.75 11.4727C0.75 12.9263 1.50195 14.1736 2.57656 14.7258C2.38242 15.3923 2.28125 16.0906 2.28125 16.8047C2.28125 21.7114 7.08008 25.6914 13 25.6914C18.9199 25.6914 23.7188 21.7114 23.7188 16.8047C23.7188 16.0874 23.6148 15.3923 23.4234 14.7258C24.498 14.1736 25.25 12.9263 25.25 11.4727ZM21.4219 2.47485C21.535 2.47485 21.647 2.50071 21.7515 2.55096C21.856 2.6012 21.9509 2.67484 22.0309 2.76767C22.1109 2.86051 22.1744 2.97072 22.2176 3.09202C22.2609 3.21331 22.2832 3.34332 22.2832 3.47461C22.2832 3.6059 22.2609 3.7359 22.2176 3.8572C22.1744 3.9785 22.1109 4.08871 22.0309 4.18154C21.9509 4.27438 21.856 4.34802 21.7515 4.39826C21.647 4.44851 21.535 4.47436 21.4219 4.47436C21.1934 4.47436 20.9744 4.36903 20.8128 4.18154C20.6513 3.99405 20.5605 3.73976 20.5605 3.47461C20.5605 3.20946 20.6513 2.95517 20.8128 2.76767C20.9744 2.58018 21.1934 2.47485 21.4219 2.47485ZM2.28125 11.4727C2.28125 10.4919 2.96758 9.69531 3.8125 9.69531C4.10258 9.69557 4.38663 9.79147 4.63157 9.97184C4.87652 10.1522 5.07229 10.4096 5.19609 10.7141C4.39492 11.4187 3.7332 12.2312 3.24102 13.123C2.95786 12.9898 2.71534 12.7616 2.5444 12.4677C2.37346 12.1737 2.28184 11.8273 2.28125 11.4727ZM13 23.5808C8.08359 23.5808 4.09961 20.5466 4.09961 16.8047C4.09961 13.0627 8.08359 10.0286 13 10.0286C17.9164 10.0286 21.9004 13.0627 21.9004 16.8047C21.9004 20.5466 17.9164 23.5808 13 23.5808ZM22.7563 13.123C22.2668 12.2312 21.6023 11.4187 20.8012 10.7141C21.0473 10.1143 21.575 9.69531 22.1848 9.69531C23.0297 9.69531 23.716 10.4919 23.716 11.4727C23.7188 12.2185 23.3195 12.8596 22.7563 13.123ZM16.0625 15.0273C16.0625 15.4987 16.2238 15.9508 16.511 16.2841C16.7982 16.6174 17.1876 16.8047 17.5938 16.8047C17.9999 16.8047 18.3893 16.6174 18.6765 16.2841C18.9637 15.9508 19.125 15.4987 19.125 15.0273C19.125 14.556 18.9637 14.1039 18.6765 13.7706C18.3893 13.4373 17.9999 13.25 17.5938 13.25C17.1876 13.25 16.7982 13.4373 16.511 13.7706C16.2238 14.1039 16.0625 14.556 16.0625 15.0273Z'
      fill='white'
    />
  </svg>
);
// export const TwitterLogoX = (
// <svg width="22" height="22" viewBox="0 0 35 31" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M27.066 0.46875H32.1658L21.0242 13.2029L34.1314 30.5312H23.867L15.8288 20.0217L6.63117 30.5312H1.52826L13.4453 16.9106L0.873047 0.46875H11.3949L18.6608 10.0749L27.066 0.46875ZM25.2761 27.4788H28.102L9.86096 3.36092H6.82851L25.2761 27.4788Z" fill="white"/>
// </svg>

// );

export const Instagram = (
  <svg
    width='22'
    height='21'
    viewBox='0 0 22 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.23392 10.1486C7.23392 8.28033 8.85266 6.76544 10.85 6.76544C12.8474 6.76544 14.467 8.28033 14.467 10.1486C14.467 12.0168 12.8474 13.5317 10.85 13.5317C8.85266 13.5317 7.23392 12.0168 7.23392 10.1486ZM5.27866 10.1486C5.27866 13.0267 7.77295 15.3597 10.85 15.3597C13.9271 15.3597 16.4214 13.0267 16.4214 10.1486C16.4214 7.27043 13.9271 4.9374 10.85 4.9374C7.77295 4.9374 5.27866 7.27043 5.27866 10.1486ZM15.3399 4.73077C15.3398 4.97164 15.4161 5.20712 15.5591 5.40744C15.702 5.60777 15.9053 5.76394 16.1432 5.8562C16.3811 5.94846 16.6428 5.97268 16.8954 5.92578C17.148 5.87889 17.3801 5.76299 17.5622 5.59274C17.7444 5.42249 17.8685 5.20554 17.9188 4.96932C17.9691 4.73311 17.9435 4.48823 17.845 4.26567C17.7466 4.0431 17.5798 3.85284 17.3657 3.71894C17.1517 3.58505 16.9 3.51353 16.6424 3.51343H16.6419C16.2968 3.51358 15.9658 3.64187 15.7216 3.87012C15.4775 4.09837 15.3402 4.40792 15.3399 4.73077ZM6.46661 18.4093C5.40878 18.3642 4.83381 18.1994 4.45172 18.0601C3.94515 17.8757 3.58372 17.656 3.20371 17.301C2.82369 16.9461 2.58847 16.6083 2.39212 16.1345C2.24318 15.7773 2.06697 15.2393 2.01888 14.2499C1.96628 13.1801 1.95578 12.8588 1.95578 10.1486C1.95578 7.43849 1.96715 7.11804 2.01888 6.04741C2.06706 5.05796 2.24456 4.52106 2.39212 4.16278C2.58933 3.68896 2.82422 3.35089 3.20371 2.99545C3.5832 2.64001 3.94428 2.41999 4.45172 2.23634C4.83364 2.09702 5.40878 1.93221 6.46661 1.88723C7.61029 1.83803 7.95384 1.8282 10.85 1.8282C13.7462 1.8282 14.0901 1.83884 15.2347 1.88723C16.2926 1.93229 16.8666 2.09832 17.2496 2.23634C17.7562 2.41999 18.1176 2.64049 18.4976 2.99545C18.8776 3.35041 19.112 3.68896 19.3092 4.16278C19.4582 4.52001 19.6344 5.05796 19.6824 6.04741C19.7351 7.11804 19.7456 7.43849 19.7456 10.1486C19.7456 12.8588 19.7351 13.1792 19.6824 14.2499C19.6343 15.2393 19.4572 15.7771 19.3092 16.1345C19.112 16.6083 18.8771 16.9464 18.4976 17.301C18.1181 17.6557 17.7562 17.8757 17.2496 18.0601C16.8677 18.1995 16.2926 18.3643 15.2347 18.4093C14.091 18.4585 13.7475 18.4683 10.85 18.4683C7.95254 18.4683 7.60994 18.4585 6.46661 18.4093ZM6.37677 0.0614597C5.22172 0.11066 4.43245 0.281968 3.74317 0.53284C3.02932 0.791913 2.42502 1.13948 1.82115 1.70342C1.21728 2.26735 0.846648 2.83348 0.569669 3.50117C0.301457 4.1463 0.118309 4.88414 0.0657077 5.96451C0.0122388 7.04659 0 7.39254 0 10.1486C0 12.9046 0.0122388 13.2505 0.0657077 14.3326C0.118309 15.4131 0.301457 16.1508 0.569669 16.796C0.846648 17.4632 1.21737 18.03 1.82115 18.5937C2.42493 19.1574 3.02932 19.5045 3.74317 19.7643C4.43375 20.0152 5.22172 20.1865 6.37677 20.2357C7.53425 20.2849 7.9035 20.2971 10.85 20.2971C13.7965 20.2971 14.1664 20.2857 15.3233 20.2357C16.4784 20.1865 17.2671 20.0152 17.9569 19.7643C18.6703 19.5045 19.275 19.1576 19.8789 18.5937C20.4827 18.0298 20.8526 17.4632 21.1304 16.796C21.3986 16.1508 21.5826 15.413 21.6343 14.3326C21.6869 13.2497 21.6992 12.9046 21.6992 10.1486C21.6992 7.39254 21.6869 7.04659 21.6343 5.96451C21.5817 4.88406 21.3986 4.14589 21.1304 3.50117C20.8526 2.83388 20.4818 2.26824 19.8789 1.70342C19.276 1.13859 18.6703 0.791913 17.9577 0.53284C17.2671 0.281968 16.4783 0.109848 15.3241 0.0614597C14.1673 0.0122595 13.7974 0 10.8509 0C7.90437 0 7.53425 0.0114476 6.37677 0.0614597Z'
      fill='white'
    />
  </svg>
);
export const NewsIcon = (
  <svg
    width='22px'
    height='25px'
    viewBox='0 0 42 42'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.105 24.2601C11.8187 24.2601 11.5416 24.1264 11.3646 23.8876L9.51594 21.3981V23.338C9.51594 23.847 9.10287 24.2601 8.59391 24.2601C8.08494 24.2601 7.67188 23.847 7.67188 23.338V18.6099C7.67188 18.212 7.92682 17.8593 8.30439 17.7344C8.68242 17.609 9.09734 17.7409 9.33384 18.0603L11.1825 20.5498V18.6099C11.1825 18.1009 11.5956 17.6878 12.1045 17.6878C12.6135 17.6878 13.0266 18.1009 13.0266 18.6099V23.338C13.0266 23.7354 12.7716 24.0886 12.3941 24.2131C12.2991 24.2449 12.2014 24.2601 12.105 24.2601Z'
      fill='white'
    />
    <path
      d='M17.8948 21.8956C18.4037 21.8956 18.8168 21.4826 18.8168 20.9736C18.8168 20.4647 18.4037 20.0516 17.8948 20.0516H16.432V19.5316H17.8948C18.4037 19.5316 18.8168 19.1185 18.8168 18.6095C18.8168 18.1006 18.4037 17.6875 17.8948 17.6875H15.5099C15.001 17.6875 14.5879 18.1006 14.5879 18.6095V23.3377C14.5879 23.8467 15.001 24.2597 15.5099 24.2597H17.8948C18.4037 24.2597 18.8168 23.8467 18.8168 23.3377C18.8168 22.8287 18.4037 22.4157 17.8948 22.4157H16.432V21.8956H17.8948Z'
      fill='white'
    />
    <path
      d='M25.229 24.2604C24.833 24.2604 24.4789 24.0064 24.354 23.6269L23.6712 21.5551L22.9885 23.6269C22.8589 24.0202 22.4708 24.2733 22.072 24.2594C21.6589 24.241 21.309 23.9501 21.215 23.5476L20.1122 18.8195C19.9965 18.3234 20.3049 17.8278 20.801 17.7121C21.2975 17.5955 21.7926 17.9048 21.9079 18.4009L22.2647 19.9314L22.7953 18.3216C22.9203 17.9435 23.2729 17.6881 23.6708 17.6881C24.0686 17.6881 24.4218 17.9435 24.5463 18.3216L25.0769 19.9319L25.4342 18.4009C25.5494 17.9048 26.0464 17.5959 26.5411 17.7126C27.0371 17.8283 27.3451 18.3243 27.2294 18.8199L26.1262 23.5476C26.0326 23.9501 25.6822 24.241 25.2696 24.2594C25.2567 24.2599 25.2428 24.2604 25.229 24.2604Z'
      fill='white'
    />
    <path
      d='M30.8245 24.2593H29.0607C28.5517 24.2593 28.1387 23.8462 28.1387 23.3372C28.1387 22.8283 28.5517 22.4152 29.0607 22.4152H30.8245C30.9679 22.4152 31.0841 22.2986 31.0841 22.1552C31.0841 22.0118 30.9675 21.8956 30.8245 21.8956H30.2423C29.0819 21.8956 28.1387 20.952 28.1387 19.7916C28.1387 18.6312 29.0824 17.6875 30.2423 17.6875H31.6046C32.1135 17.6875 32.5266 18.1006 32.5266 18.6095C32.5266 19.1185 32.1135 19.5316 31.6046 19.5316H30.2423C30.0989 19.5316 29.9827 19.6482 29.9827 19.7916C29.9827 19.935 30.0994 20.0511 30.2427 20.0511H30.825C31.9854 20.0511 32.9286 20.9948 32.9286 22.1547C32.9286 23.3151 31.9849 24.2593 30.8245 24.2593Z'
      fill='white'
    />
    <path
      d='M40.1466 14.9263C37.5289 6.62663 29.7263 0.875 20.9762 0.875C12.2261 0.875 4.42341 6.62617 1.80576 14.9258C0.891104 15.2522 0.230469 16.1185 0.230469 17.1438V24.81C0.230469 25.8353 0.891104 26.7011 1.8053 27.027C4.42341 35.3267 12.2261 41.0783 20.9762 41.0783C29.7263 41.0783 37.5289 35.3272 40.147 27.027C41.0612 26.7006 41.7219 25.8348 41.7219 24.8095V17.1438C41.7219 16.1185 41.0612 15.2522 40.1466 14.9263ZM3.80057 27.1718H10.3461C10.631 28.7909 11.0192 30.3049 11.4958 31.6939H6.20477C5.20621 30.3256 4.39114 28.8079 3.80057 27.1718ZM12.2215 27.1718H20.0541V31.6939H13.4607C12.948 30.3251 12.5281 28.8075 12.2215 27.1718ZM20.0541 33.538V39.1384C17.8237 38.6921 15.7695 36.6512 14.25 33.538H20.0541ZM21.8982 39.1384V33.538H27.7024C26.1829 36.6512 24.1286 38.6921 21.8982 39.1384ZM21.8982 31.6939V27.1718H29.7304C29.4243 28.8075 29.0043 30.3247 28.4917 31.6939H21.8982ZM31.6067 27.1718H38.1522C37.5617 28.8079 36.7461 30.3251 35.7471 31.6939H30.457C30.9337 30.3053 31.3218 28.7913 31.6067 27.1718ZM35.7471 10.259C36.7461 11.6277 37.5612 13.1449 38.1522 14.7811H31.6072C31.3223 13.162 30.9341 11.648 30.4574 10.259H35.7471ZM34.2082 8.41491H29.7387C28.8987 6.49709 27.873 4.88676 26.7107 3.65354C29.5686 4.60646 32.1452 6.25183 34.2082 8.41491ZM21.8982 2.81495C24.1291 3.26076 26.1833 5.30167 27.7029 8.41491H21.8982V2.81495ZM21.8982 10.259H28.4917C29.0043 11.6277 29.4243 13.1454 29.7304 14.7811H21.8982V10.259ZM20.0541 2.81495V8.41491H14.25C15.7695 5.30213 17.8237 3.26076 20.0541 2.81495ZM20.0541 10.259V14.7811H12.2219C12.5281 13.1454 12.948 11.6277 13.4612 10.259H20.0541ZM15.2425 3.65308C14.0798 4.8863 13.0541 6.49709 12.2141 8.41491H7.7441C9.80761 6.25137 12.3847 4.606 15.2425 3.65308ZM6.20523 10.259H11.4954C11.0187 11.6476 10.6305 13.162 10.3456 14.7811H3.80057C4.39114 13.1454 5.20621 11.6277 6.20523 10.259ZM2.07453 17.1438C2.07453 16.858 2.30688 16.6251 2.59271 16.6251H39.3596C39.6455 16.6251 39.8778 16.8575 39.8778 17.1438V24.81C39.8778 25.0958 39.6455 25.3282 39.3596 25.3282H2.59271C2.30688 25.3277 2.07453 25.0958 2.07453 24.8095V17.1438ZM7.74364 33.538H12.2141C13.0541 35.4558 14.0803 37.067 15.243 38.3003C12.3847 37.3473 9.80715 35.7015 7.74364 33.538ZM26.7094 38.3003C27.872 37.0666 28.8983 35.4558 29.7382 33.538H34.2087C32.1447 35.7015 29.5677 37.3473 26.7094 38.3003Z'
      fill='white'
    />
  </svg>
);

export const NewsLogo = (
  <svg
    width='42'
    height='42'
    viewBox='0 0 42 42'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clip-path='url(#clip0_4938_11445)'>
      <path
        d='M12.105 24.2601C11.8187 24.2601 11.5416 24.1264 11.3646 23.8876L9.51594 21.3981V23.338C9.51594 23.847 9.10287 24.2601 8.59391 24.2601C8.08494 24.2601 7.67188 23.847 7.67188 23.338V18.6099C7.67188 18.212 7.92682 17.8593 8.30439 17.7344C8.68242 17.609 9.09734 17.7409 9.33384 18.0603L11.1825 20.5498V18.6099C11.1825 18.1009 11.5956 17.6878 12.1045 17.6878C12.6135 17.6878 13.0266 18.1009 13.0266 18.6099V23.338C13.0266 23.7354 12.7716 24.0886 12.3941 24.2131C12.2991 24.2449 12.2014 24.2601 12.105 24.2601Z'
        fill='black'
      />
      <path
        d='M17.8948 21.8956C18.4037 21.8956 18.8168 21.4826 18.8168 20.9736C18.8168 20.4647 18.4037 20.0516 17.8948 20.0516H16.432V19.5316H17.8948C18.4037 19.5316 18.8168 19.1185 18.8168 18.6095C18.8168 18.1006 18.4037 17.6875 17.8948 17.6875H15.5099C15.001 17.6875 14.5879 18.1006 14.5879 18.6095V23.3377C14.5879 23.8467 15.001 24.2597 15.5099 24.2597H17.8948C18.4037 24.2597 18.8168 23.8467 18.8168 23.3377C18.8168 22.8287 18.4037 22.4157 17.8948 22.4157H16.432V21.8956H17.8948Z'
        fill='black'
      />
      <path
        d='M25.229 24.2604C24.833 24.2604 24.4789 24.0064 24.354 23.6269L23.6712 21.5551L22.9885 23.6269C22.8589 24.0202 22.4708 24.2733 22.072 24.2594C21.6589 24.241 21.309 23.9501 21.215 23.5476L20.1122 18.8195C19.9965 18.3234 20.3049 17.8278 20.801 17.7121C21.2975 17.5955 21.7926 17.9048 21.9079 18.4009L22.2647 19.9314L22.7953 18.3216C22.9203 17.9435 23.2729 17.6881 23.6708 17.6881C24.0686 17.6881 24.4218 17.9435 24.5463 18.3216L25.0769 19.9319L25.4342 18.4009C25.5494 17.9048 26.0464 17.5959 26.5411 17.7126C27.0371 17.8283 27.3451 18.3243 27.2294 18.8199L26.1262 23.5476C26.0326 23.9501 25.6822 24.241 25.2696 24.2594C25.2567 24.2599 25.2428 24.2604 25.229 24.2604Z'
        fill='black'
      />
      <path
        d='M30.8245 24.2593H29.0607C28.5517 24.2593 28.1387 23.8462 28.1387 23.3372C28.1387 22.8283 28.5517 22.4152 29.0607 22.4152H30.8245C30.9679 22.4152 31.0841 22.2986 31.0841 22.1552C31.0841 22.0118 30.9675 21.8956 30.8245 21.8956H30.2423C29.0819 21.8956 28.1387 20.952 28.1387 19.7916C28.1387 18.6312 29.0824 17.6875 30.2423 17.6875H31.6046C32.1135 17.6875 32.5266 18.1006 32.5266 18.6095C32.5266 19.1185 32.1135 19.5316 31.6046 19.5316H30.2423C30.0989 19.5316 29.9827 19.6482 29.9827 19.7916C29.9827 19.935 30.0994 20.0511 30.2427 20.0511H30.825C31.9854 20.0511 32.9286 20.9948 32.9286 22.1547C32.9286 23.3151 31.9849 24.2593 30.8245 24.2593Z'
        fill='black'
      />
      <path
        d='M40.1466 14.9263C37.5289 6.62663 29.7263 0.875 20.9762 0.875C12.2261 0.875 4.42341 6.62617 1.80576 14.9258C0.891104 15.2522 0.230469 16.1185 0.230469 17.1438V24.81C0.230469 25.8353 0.891104 26.7011 1.8053 27.027C4.42341 35.3267 12.2261 41.0783 20.9762 41.0783C29.7263 41.0783 37.5289 35.3272 40.147 27.027C41.0612 26.7006 41.7219 25.8348 41.7219 24.8095V17.1438C41.7219 16.1185 41.0612 15.2522 40.1466 14.9263ZM3.80057 27.1718H10.3461C10.631 28.7909 11.0192 30.3049 11.4958 31.6939H6.20477C5.20621 30.3256 4.39114 28.8079 3.80057 27.1718ZM12.2215 27.1718H20.0541V31.6939H13.4607C12.948 30.3251 12.5281 28.8075 12.2215 27.1718ZM20.0541 33.538V39.1384C17.8237 38.6921 15.7695 36.6512 14.25 33.538H20.0541ZM21.8982 39.1384V33.538H27.7024C26.1829 36.6512 24.1286 38.6921 21.8982 39.1384ZM21.8982 31.6939V27.1718H29.7304C29.4243 28.8075 29.0043 30.3247 28.4917 31.6939H21.8982ZM31.6067 27.1718H38.1522C37.5617 28.8079 36.7461 30.3251 35.7471 31.6939H30.457C30.9337 30.3053 31.3218 28.7913 31.6067 27.1718ZM35.7471 10.259C36.7461 11.6277 37.5612 13.1449 38.1522 14.7811H31.6072C31.3223 13.162 30.9341 11.648 30.4574 10.259H35.7471ZM34.2082 8.41491H29.7387C28.8987 6.49709 27.873 4.88676 26.7107 3.65354C29.5686 4.60646 32.1452 6.25183 34.2082 8.41491ZM21.8982 2.81495C24.1291 3.26076 26.1833 5.30167 27.7029 8.41491H21.8982V2.81495ZM21.8982 10.259H28.4917C29.0043 11.6277 29.4243 13.1454 29.7304 14.7811H21.8982V10.259ZM20.0541 2.81495V8.41491H14.25C15.7695 5.30213 17.8237 3.26076 20.0541 2.81495ZM20.0541 10.259V14.7811H12.2219C12.5281 13.1454 12.948 11.6277 13.4612 10.259H20.0541ZM15.2425 3.65308C14.0798 4.8863 13.0541 6.49709 12.2141 8.41491H7.7441C9.80761 6.25137 12.3847 4.606 15.2425 3.65308ZM6.20523 10.259H11.4954C11.0187 11.6476 10.6305 13.162 10.3456 14.7811H3.80057C4.39114 13.1454 5.20621 11.6277 6.20523 10.259ZM2.07453 17.1438C2.07453 16.858 2.30688 16.6251 2.59271 16.6251H39.3596C39.6455 16.6251 39.8778 16.8575 39.8778 17.1438V24.81C39.8778 25.0958 39.6455 25.3282 39.3596 25.3282H2.59271C2.30688 25.3277 2.07453 25.0958 2.07453 24.8095V17.1438ZM7.74364 33.538H12.2141C13.0541 35.4558 14.0803 37.067 15.243 38.3003C12.3847 37.3473 9.80715 35.7015 7.74364 33.538ZM26.7094 38.3003C27.872 37.0666 28.8983 35.4558 29.7382 33.538H34.2087C32.1447 35.7015 29.5677 37.3473 26.7094 38.3003Z'
        fill='black'
      />
    </g>
    <defs>
      <clipPath id='clip0_4938_11445'>
        <rect width='42' height='42' fill='black' />
      </clipPath>
    </defs>
  </svg>
);

export const FacebookIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='23'
    height='23'
    viewBox='0 0 23 23'
    fill='none'
  >
    <path
      d='M22.75 11.5001C22.75 5.29012 17.71 0.250122 11.5 0.250122C5.29 0.250122 0.25 5.29012 0.25 11.5001C0.25 16.9451 4.12 21.4789 9.25 22.5251V14.8751H7V11.5001H9.25V8.68762C9.25 6.51637 11.0162 4.75012 13.1875 4.75012H16V8.12512H13.75C13.1313 8.12512 12.625 8.63137 12.625 9.25012V11.5001H16V14.8751H12.625V22.6939C18.3062 22.1314 22.75 17.3389 22.75 11.5001Z'
      fill='white'
    />
  </svg>
);
export const FacebookLogoSmall = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='23'
    height='23'
    viewBox='0 0 23 23'
    fill='none'
  >
    <path
      d='M22.75 11.5001C22.75 5.29012 17.71 0.250122 11.5 0.250122C5.29 0.250122 0.25 5.29012 0.25 11.5001C0.25 16.9451 4.12 21.4789 9.25 22.5251V14.8751H7V11.5001H9.25V8.68762C9.25 6.51637 11.0162 4.75012 13.1875 4.75012H16V8.12512H13.75C13.1313 8.12512 12.625 8.63137 12.625 9.25012V11.5001H16V14.8751H12.625V22.6939C18.3062 22.1314 22.75 17.3389 22.75 11.5001Z'
      fill='blue'
    />
  </svg>
);

export const Shape = (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.73782 1.41354C6.94249 1.14136 8.20288 1.26589 9.331 1.76855C9.65203 1.91159 10.0282 1.76731 10.1713 1.44628C10.3143 1.12525 10.17 0.749048 9.849 0.606007C8.47019 -0.00835751 6.92971 -0.160556 5.45733 0.172109C3.98495 0.504774 2.65955 1.30448 1.6788 2.45196C0.698045 3.59943 0.114494 5.0332 0.0151737 6.53942C-0.0841461 8.04565 0.306086 9.54363 1.12767 10.8099C1.94926 12.0763 3.15818 13.0431 4.57413 13.5662C5.99008 14.0893 7.5372 14.1407 8.98475 13.7127C10.4323 13.2847 11.7027 12.4003 12.6065 11.1913C13.5103 9.98228 13.9991 8.5135 14 7.004V6.41819C14 6.06673 13.7151 5.78182 13.3636 5.78182C13.0122 5.78182 12.7273 6.06673 12.7273 6.41819V7.00328C12.7266 8.23832 12.3266 9.44004 11.5872 10.4292C10.8477 11.4184 9.80824 12.1421 8.62389 12.4922C7.43953 12.8424 6.1737 12.8004 5.0152 12.3724C3.85669 11.9443 2.86757 11.1533 2.19537 10.1172C1.52316 9.08115 1.20388 7.85553 1.28514 6.62317C1.3664 5.3908 1.84386 4.21772 2.64629 3.27887C3.44872 2.34003 4.53314 1.68572 5.73782 1.41354Z'
      fill='rgb(45, 137, 85)'
    />
    <path
      d='M13.8138 2.36249C14.0622 2.11385 14.062 1.71093 13.8134 1.46254C13.5647 1.21415 13.1618 1.21435 12.9134 1.46299L6.99977 7.38256L5.54088 5.92367C5.29237 5.67516 4.88945 5.67516 4.64093 5.92367C4.39242 6.17219 4.39242 6.57511 4.64093 6.82363L6.55002 8.73272C6.6694 8.8521 6.83133 8.91914 7.00016 8.9191C7.16899 8.91906 7.33088 8.85193 7.4502 8.73249L13.8138 2.36249Z'
      fill='rgb(45, 137, 85)'
    />
  </svg>
);

export const CheckIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <g clip-path='url(#clip0_5149_11272)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.96875 8.28906C0.96875 6.29994 1.75895 4.39228 3.1655 2.98576C4.57206 1.57924 6.47976 0.789063 8.46893 0.789062C10.4581 0.789063 12.3658 1.57924 13.7724 2.98576C15.1789 4.39228 15.9691 6.29994 15.9691 8.28906C15.9691 10.2782 15.1789 12.1858 13.7724 13.5924C12.3658 14.9989 10.4581 15.7891 8.46893 15.7891C6.47976 15.7891 4.57206 14.9989 3.1655 13.5924C1.75895 12.1858 0.96875 10.2782 0.96875 8.28906ZM8.04092 11.4991L12.047 6.49111C12.2193 6.27569 12.1844 5.96136 11.969 5.78904C11.7536 5.61673 11.4393 5.65162 11.267 5.86698L7.89692 10.0781L5.67287 8.22502C5.46078 8.04831 5.14559 8.07697 4.96886 8.28905C4.79212 8.50114 4.82076 8.81634 5.03284 8.99309L8.04092 11.5001V11.4991Z'
        fill='#353CF7'
      />
    </g>
    <defs>
      <clipPath id='clip0_5149_11272'>
        <rect
          width='15.0004'
          height='15'
          fill='white'
          transform='translate(0.96875 0.789062)'
        />
      </clipPath>
    </defs>
  </svg>
);

export const ChatterTrackerIcon = (
  <svg
    width='20'
    height='23'
    viewBox='0 0 20 23'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16 5H14C14 3.67392 13.4732 2.40215 12.5355 1.46447C11.5979 0.526784 10.3261 0 9 0C7.67392 0 6.40215 0.526784 5.46447 1.46447C4.52678 2.40215 4 3.67392 4 5H2C1.46957 5 0.960859 5.21071 0.585786 5.58579C0.210714 5.96086 0 6.46957 0 7V19C0 19.5304 0.210714 20.0391 0.585786 20.4142C0.960859 20.7893 1.46957 21 2 21H9.05C8.11779 20.4162 7.34897 19.6054 6.81554 18.6434C6.2821 17.6815 6.0015 16.5999 6 15.5C5.99564 14.1255 6.43393 12.7861 7.25 11.68C6.2962 11.3236 5.47393 10.6846 4.89315 9.84823C4.31237 9.01191 4.00076 8.0182 4 7H6C6 7.79565 6.31607 8.55871 6.87868 9.12132C7.44129 9.68393 8.20435 10 9 10H9.06C9.67232 9.60501 10.3493 9.32069 11.06 9.16C11.3543 8.88202 11.5893 8.54734 11.7509 8.17612C11.9124 7.80491 11.9972 7.40483 12 7H14C14.0032 7.72212 13.8461 8.43595 13.54 9.09C14.4544 9.24307 15.3254 9.58996 16.0946 10.1074C16.8639 10.6248 17.5135 11.3008 18 12.09V7C18 6.46957 17.7893 5.96086 17.4142 5.58579C17.0391 5.21071 16.5304 5 16 5ZM6 5C6 4.20435 6.31607 3.44129 6.87868 2.87868C7.44129 2.31607 8.20435 2 9 2C9.79565 2 10.5587 2.31607 11.1213 2.87868C11.6839 3.44129 12 4.20435 12 5M16.31 17.9C16.9002 16.965 17.1255 15.8455 16.943 14.755C16.7604 13.6645 16.1828 12.6793 15.3202 11.9876C14.4577 11.2958 13.3707 10.9457 12.2666 11.0043C11.1624 11.0628 10.1185 11.5257 9.33392 12.3048C8.54935 13.0839 8.07907 14.1246 8.01281 15.2283C7.94654 16.332 8.28893 17.4214 8.97465 18.2888C9.66037 19.1561 10.6414 19.7407 11.7306 19.9309C12.8198 20.1211 13.9409 19.9036 14.88 19.32L18 22.39L19.39 21M12.5 18C12.0055 18 11.5222 17.8534 11.1111 17.5787C10.7 17.304 10.3795 16.9135 10.1903 16.4567C10.0011 15.9999 9.95157 15.4972 10.048 15.0123C10.1445 14.5273 10.3826 14.0819 10.7322 13.7322C11.0819 13.3826 11.5273 13.1445 12.0123 13.048C12.4972 12.9516 12.9999 13.0011 13.4567 13.1903C13.9135 13.3795 14.304 13.7 14.5787 14.1111C14.8534 14.5222 15 15.0055 15 15.5C15 16.163 14.7366 16.7989 14.2678 17.2678C13.7989 17.7366 13.163 18 12.5 18Z'
      fill='black'
    />
  </svg>
);

export const ChatsIcon = (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.1875 5.90625H12.6562V3.375C12.6562 3.15122 12.5674 2.93661 12.4091 2.77838C12.2509 2.62014 12.0363 2.53125 11.8125 2.53125H2.8125C2.58872 2.53125 2.37411 2.62014 2.21588 2.77838C2.05764 2.93661 1.96875 3.15122 1.96875 3.375V12.375C1.96875 12.4496 1.99838 12.5211 2.05113 12.5739C2.10387 12.6266 2.17541 12.6562 2.25 12.6562C2.31425 12.6562 2.37653 12.6341 2.42648 12.5937L5.13281 10.4062H5.34375V12.9375C5.34375 13.1613 5.43264 13.3759 5.59088 13.5341C5.74911 13.6924 5.96372 13.7812 6.1875 13.7812H12.8672L15.5735 15.9687C15.6235 16.0091 15.6858 16.0312 15.75 16.0312C15.8246 16.0312 15.8961 16.0016 15.9489 15.9489C16.0016 15.8961 16.0312 15.8246 16.0312 15.75V6.75C16.0312 6.52622 15.9424 6.31161 15.7841 6.15338C15.6259 5.99514 15.4113 5.90625 15.1875 5.90625ZM5.03297 9.84375C4.96872 9.84384 4.90644 9.86592 4.85648 9.90633L2.53125 11.7858V3.375C2.53125 3.30041 2.56088 3.22887 2.61363 3.17613C2.66637 3.12338 2.73791 3.09375 2.8125 3.09375H11.8125C11.8871 3.09375 11.9586 3.12338 12.0114 3.17613C12.0641 3.22887 12.0938 3.30041 12.0938 3.375V9.5625C12.0938 9.63709 12.0641 9.70863 12.0114 9.76137C11.9586 9.81412 11.8871 9.84375 11.8125 9.84375H5.03297ZM15.4688 15.1608L13.1435 13.2813C13.0936 13.2409 13.0313 13.2188 12.967 13.2188H6.1875C6.11291 13.2188 6.04137 13.1891 5.98863 13.1364C5.93588 13.0836 5.90625 13.0121 5.90625 12.9375V10.4062H11.8125C12.0363 10.4062 12.2509 10.3174 12.4091 10.1591C12.5674 10.0009 12.6562 9.78628 12.6562 9.5625V6.46875H15.1875C15.2621 6.46875 15.3336 6.49838 15.3864 6.55113C15.4391 6.60387 15.4688 6.67541 15.4688 6.75V15.1608Z'
      fill='white'
    />
  </svg>
);

export const CompetitiveInteligence = (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1.28571 0H0V16.7143C0 17.0553 0.135459 17.3823 0.376577 17.6234C0.617695 17.8645 0.944722 18 1.28571 18H18V16.7143H1.28571V0Z'
      fill='black'
    />
    <path
      d='M18 5H13.625V6.28571H15.8687L11.125 11.165L8.44375 8.40071C8.38565 8.34046 8.31652 8.29264 8.24036 8.26C8.1642 8.22736 8.08251 8.21056 8 8.21056C7.91749 8.21056 7.8358 8.22736 7.75964 8.26C7.68348 8.29264 7.61435 8.34046 7.55625 8.40071L3 13.0936L3.88125 14L8 9.76357L10.6813 12.5279C10.7394 12.5881 10.8085 12.6359 10.8846 12.6686C10.9608 12.7012 11.0425 12.718 11.125 12.718C11.2075 12.718 11.2892 12.7012 11.3654 12.6686C11.4415 12.6359 11.5106 12.5881 11.5687 12.5279L16.75 7.19214V9.5H18V5Z'
      fill='black'
    />
  </svg>
);

export const tenantCount = (
  <svg viewBox='0.00 0.00 512.00 512.00'>
    <path
      fill='#ffffff'
      d='
  M 144.56 0.00
  L 367.31 0.00
  Q 375.50 1.46 375.50 9.50
  Q 375.50 68.59 375.50 127.60
  A 0.41 0.40 0.0 0 0 375.91 128.00
  Q 438.04 127.99 500.08 128.01
  C 506.61 128.01 511.08 129.42 512.00 136.31
  L 512.00 444.31
  Q 510.41 452.22 502.25 452.19
  Q 494.24 452.16 486.09 452.30
  Q 485.53 452.31 485.59 452.86
  C 487.25 468.10 486.52 483.84 486.47 499.16
  C 486.45 506.04 485.52 510.82 478.19 512.00
  L 33.69 512.00
  Q 25.66 510.42 25.53 502.25
  C 25.36 491.08 24.86 471.70 26.31 452.92
  A 0.63 0.63 0.0 0 0 25.67 452.24
  Q 18.79 452.28 11.84 452.24
  C 5.41 452.19 1.10 450.93 0.00 444.19
  L 0.00 135.94
  C 1.21 129.36 5.45 128.01 11.83 128.01
  Q 74.01 127.99 135.94 128.00
  A 0.58 0.57 0.0 0 0 136.52 127.43
  Q 136.47 69.75 136.52 12.18
  C 136.53 5.65 137.75 1.19 144.56 0.00
  Z
  M 267.44 308.61
  C 300.40 317.78 308.65 358.73 284.07 381.58
  A 0.74 0.73 -52.5 0 0 284.22 382.76
  Q 299.02 390.87 307.53 405.42
  A 0.55 0.55 0.0 0 0 308.45 405.46
  Q 314.81 396.39 324.48 390.93
  A 0.83 0.82 54.9 0 0 324.69 389.67
  C 302.46 364.49 324.59 327.30 357.85 333.83
  Q 358.50 333.96 358.50 333.29
  L 358.50 17.75
  A 0.75 0.75 0.0 0 0 357.75 17.00
  L 154.03 17.00
  A 0.53 0.53 0.0 0 0 153.50 17.53
  L 153.50 333.27
  Q 153.50 333.83 154.06 333.78
  C 156.17 333.60 158.63 333.08 160.25 332.99
  C 190.70 331.14 208.24 367.39 187.20 389.69
  A 0.72 0.72 0.0 0 0 187.37 390.81
  Q 197.09 396.35 203.60 405.45
  A 0.52 0.52 0.0 0 0 204.48 405.41
  Q 213.08 390.68 228.11 382.59
  A 0.50 0.49 51.9 0 0 228.20 381.78
  C 217.36 372.03 212.01 358.44 213.83 343.97
  C 217.02 318.57 242.76 301.75 267.44 308.61
  Z
  M 135.88 145.00
  L 17.50 145.00
  A 0.50 0.50 0.0 0 0 17.00 145.50
  L 17.00 434.72
  A 0.53 0.53 0.0 0 0 17.53 435.25
  L 32.15 435.25
  A 0.86 0.86 0.0 0 0 32.89 434.83
  Q 39.75 423.29 51.35 416.56
  A 0.91 0.91 0.0 0 0 51.58 415.18
  C 38.32 400.12 40.27 377.48 56.37 365.25
  C 75.22 350.92 101.66 360.06 109.00 381.83
  Q 114.89 399.31 102.00 415.44
  Q 101.68 415.84 102.10 416.15
  L 111.93 423.42
  A 0.33 0.33 0.0 0 0 112.45 423.24
  Q 117.98 402.02 136.74 390.84
  A 0.73 0.73 0.0 0 0 136.92 389.75
  C 125.74 376.55 124.92 358.78 136.16 345.25
  Q 136.50 344.84 136.50 344.31
  L 136.50 145.63
  Q 136.50 145.00 135.88 145.00
  Z
  M 375.16 390.79
  Q 394.10 401.99 399.56 423.38
  A 0.26 0.26 0.0 0 0 399.97 423.52
  L 409.84 416.15
  A 0.65 0.65 0.0 0 0 409.95 415.20
  C 390.88 393.02 405.37 358.72 435.01 358.39
  C 464.87 358.05 479.65 393.29 460.33 415.31
  A 0.74 0.73 -54.2 0 0 460.51 416.43
  Q 472.02 423.16 478.96 434.53
  A 1.53 1.53 0.0 0 0 480.26 435.25
  L 494.60 435.25
  A 0.41 0.40 90.0 0 0 495.00 434.84
  L 495.00 145.75
  A 0.75 0.75 0.0 0 0 494.25 145.00
  L 376.00 145.00
  A 0.50 0.50 0.0 0 0 375.50 145.50
  L 375.50 344.45
  Q 375.50 344.88 375.77 345.20
  C 386.95 358.57 386.47 377.00 374.99 389.66
  Q 374.38 390.33 375.16 390.79
  Z
  M 281.47 349.87
  A 25.47 25.47 0.0 0 0 256.00 324.40
  A 25.47 25.47 0.0 0 0 230.53 349.87
  A 25.47 25.47 0.0 0 0 256.00 375.34
  A 25.47 25.47 0.0 0 0 281.47 349.87
  Z
  M 179.10 366.94
  A 16.97 16.97 0.0 0 0 162.13 349.97
  A 16.97 16.97 0.0 0 0 145.16 366.94
  A 16.97 16.97 0.0 0 0 162.13 383.91
  A 16.97 16.97 0.0 0 0 179.10 366.94
  Z
  M 366.84 366.94
  A 16.97 16.97 0.0 0 0 349.87 349.97
  A 16.97 16.97 0.0 0 0 332.90 366.94
  A 16.97 16.97 0.0 0 0 349.87 383.91
  A 16.97 16.97 0.0 0 0 366.84 366.94
  Z
  M 93.77 392.53
  A 16.97 16.97 0.0 0 0 76.80 375.56
  A 16.97 16.97 0.0 0 0 59.83 392.53
  A 16.97 16.97 0.0 0 0 76.80 409.50
  A 16.97 16.97 0.0 0 0 93.77 392.53
  Z
  M 452.17 392.53
  A 16.98 16.98 0.0 0 0 435.19 375.55
  A 16.98 16.98 0.0 0 0 418.21 392.53
  A 16.98 16.98 0.0 0 0 435.19 409.51
  A 16.98 16.98 0.0 0 0 452.17 392.53
  Z
  M 214.12 495.00
  L 297.90 495.00
  A 0.90 0.90 0.0 0 0 298.80 494.10
  L 298.80 436.32
  A 43.60 42.68 -90.0 0 0 256.12 392.72
  L 255.90 392.72
  A 43.60 42.68 -90.0 0 0 213.22 436.32
  L 213.22 494.10
  A 0.90 0.90 0.0 0 0 214.12 495.00
  Z
  M 129.47 495.17
  L 194.93 495.17
  A 1.58 1.58 0.0 0 0 196.51 493.59
  L 196.51 436.56
  A 35.33 34.15 -90.0 0 0 162.36 401.23
  L 162.04 401.23
  A 35.33 34.15 90.0 0 0 127.89 436.56
  L 127.89 493.59
  A 1.58 1.58 0.0 0 0 129.47 495.17
  Z
  M 316.40 495.00
  L 383.32 495.00
  A 0.71 0.71 0.0 0 0 384.03 494.29
  L 384.03 435.90
  A 34.68 34.12 90.0 0 0 349.91 401.22
  L 349.81 401.22
  A 34.68 34.12 90.0 0 0 315.69 435.90
  L 315.69 494.29
  A 0.71 0.71 0.0 0 0 316.40 495.00
  Z
  M 43.99 495.30
  L 109.57 495.08
  A 1.57 1.57 0.0 0 0 111.13 493.50
  L 111.02 462.34
  A 35.71 34.27 89.8 0 0 76.63 426.75
  L 76.45 426.75
  A 35.71 34.27 89.8 0 0 42.31 462.58
  L 42.41 493.74
  A 1.57 1.57 0.0 0 0 43.99 495.30
  Z
  M 401.64 495.01
  L 468.62 495.01
  A 0.69 0.69 0.0 0 0 469.31 494.32
  L 469.31 461.52
  A 34.75 34.15 90.0 0 0 435.16 426.77
  L 435.10 426.77
  A 34.75 34.15 90.0 0 0 400.95 461.52
  L 400.95 494.32
  A 0.69 0.69 0.0 0 0 401.64 495.01
  Z'
    />
    <path
      fill='#ffffff'
      d='
  M 315.74 110.59
  A 8.90 8.90 0.0 0 1 306.84 119.49
  L 205.16 119.49
  A 8.90 8.90 0.0 0 1 196.26 110.59
  L 196.26 43.15
  A 8.90 8.90 0.0 0 1 205.16 34.25
  L 306.84 34.25
  A 8.90 8.90 0.0 0 1 315.74 43.15
  L 315.74 110.59
  Z
  M 298.75 52.02
  A 0.78 0.78 0.0 0 0 297.97 51.24
  L 214.03 51.24
  A 0.78 0.78 0.0 0 0 213.25 52.02
  L 213.25 101.72
  A 0.78 0.78 0.0 0 0 214.03 102.50
  L 297.97 102.50
  A 0.78 0.78 0.0 0 0 298.75 101.72
  L 298.75 52.02
  Z'
    />
    <rect
      fill='#ffffff'
      x='-8.62'
      y='-8.52'
      transform='translate(221.88,145.01) rotate(0.1)'
      width='17.24'
      height='17.04'
      rx='0.88'
    />
    <rect
      fill='#ffffff'
      x='-8.50'
      y='-8.50'
      transform='translate(256.00,145.01) rotate(0.1)'
      width='17.00'
      height='17.00'
      rx='0.59'
    />
    <rect
      fill='#ffffff'
      x='-8.62'
      y='-8.50'
      transform='translate(290.12,145.00) rotate(-0.1)'
      width='17.24'
      height='17.00'
      rx='0.64'
    />
    <rect
      fill='#ffffff'
      x='-8.50'
      y='-8.51'
      transform='translate(324.25,179.24) rotate(0.1)'
      width='17.00'
      height='17.02'
      rx='0.40'
    />
    <rect
      fill='#ffffff'
      x='-8.50'
      y='-8.50'
      transform='translate(187.75,179.25) rotate(-0.1)'
      width='17.00'
      height='17.00'
      rx='0.43'
    />
    <rect
      fill='#ffffff'
      x='-8.63'
      y='-8.50'
      transform='translate(221.88,179.25) rotate(-0.1)'
      width='17.26'
      height='17.00'
      rx='0.81'
    />
    <rect
      fill='#ffffff'
      x='-8.50'
      y='-8.50'
      transform='translate(256.00,179.25) rotate(-0.1)'
      width='17.00'
      height='17.00'
      rx='0.60'
    />
    <rect
      fill='#ffffff'
      x='-8.62'
      y='-8.50'
      transform='translate(290.13,179.25) rotate(-0.1)'
      width='17.24'
      height='17.00'
      rx='0.69'
    />
    <rect
      fill='#ffffff'
      x='42.75'
      y='196.25'
      width='17.00'
      height='136.50'
      rx='0.43'
    />
    <rect
      fill='#ffffff'
      x='93.78'
      y='196.25'
      width='17.22'
      height='136.52'
      rx='0.67'
    />
    <rect
      fill='#ffffff'
      x='401.00'
      y='196.26'
      width='17.24'
      height='136.52'
      rx='0.73'
    />
    <rect
      fill='#ffffff'
      x='452.25'
      y='196.26'
      width='17.00'
      height='136.48'
      rx='0.26'
    />
    <rect
      fill='#ffffff'
      x='-8.50'
      y='-8.60'
      transform='translate(187.75,213.35) rotate(0.2)'
      width='17.00'
      height='17.20'
      rx='0.66'
    />
    <rect
      fill='#ffffff'
      x='-8.63'
      y='-8.59'
      transform='translate(221.88,213.34) rotate(0.3)'
      width='17.26'
      height='17.18'
      rx='0.88'
    />
    <rect
      fill='#ffffff'
      x='-8.50'
      y='-8.60'
      transform='translate(256.00,213.34) rotate(0.2)'
      width='17.00'
      height='17.20'
      rx='0.64'
    />
    <rect
      fill='#ffffff'
      x='-8.62'
      y='-8.60'
      transform='translate(290.12,213.35) rotate(0.1)'
      width='17.24'
      height='17.20'
      rx='0.91'
    />
    <rect
      fill='#ffffff'
      x='-8.50'
      y='-8.59'
      transform='translate(324.25,213.34) rotate(0.2)'
      width='17.00'
      height='17.18'
      rx='0.62'
    />
    <rect
      fill='#ffffff'
      x='-8.50'
      y='-8.50'
      transform='translate(187.75,247.50) rotate(-0.1)'
      width='17.00'
      height='17.00'
      rx='0.43'
    />
    <rect
      fill='#ffffff'
      x='-8.62'
      y='-8.50'
      transform='translate(221.88,247.50) rotate(0.1)'
      width='17.24'
      height='17.00'
      rx='0.73'
    />
    <rect
      fill='#ffffff'
      x='-8.50'
      y='-8.50'
      transform='translate(256.00,247.50) rotate(-0.1)'
      width='17.00'
      height='17.00'
      rx='0.51'
    />
    <rect
      fill='#ffffff'
      x='-8.63'
      y='-8.50'
      transform='translate(290.13,247.50) rotate(-0.1)'
      width='17.26'
      height='17.00'
      rx='0.60'
    />
    <rect
      fill='#ffffff'
      x='-8.51'
      y='-8.50'
      transform='translate(324.26,247.50) rotate(-0.1)'
      width='17.02'
      height='17.00'
      rx='0.60'
    />
    <rect
      fill='#ffffff'
      x='-8.50'
      y='-8.62'
      transform='translate(187.75,281.62) rotate(-0.1)'
      width='17.00'
      height='17.24'
      rx='0.70'
    />
    <rect
      fill='#ffffff'
      x='-8.63'
      y='-8.62'
      transform='translate(221.87,281.62) rotate(0.1)'
      width='17.26'
      height='17.24'
      rx='0.91'
    />
    <rect
      fill='#ffffff'
      x='-8.50'
      y='-8.61'
      transform='translate(256.00,281.61) rotate(0.2)'
      width='17.00'
      height='17.22'
      rx='0.66'
    />
    <rect
      fill='#ffffff'
      x='-8.63'
      y='-8.62'
      transform='translate(290.13,281.62) rotate(-0.1)'
      width='17.26'
      height='17.24'
      rx='0.96'
    />
    <rect
      fill='#ffffff'
      x='315.75'
      y='273.01'
      width='17.02'
      height='17.22'
      rx='0.64'
    />
  </svg>
);

export const userCount = (
  <svg viewBox='0 0 1440 809.999993'>
    <path
      fill='#ffffff'
      d='M 545.03125 291.5 L 894.832031 291.5 L 894.832031 378.949219 L 545.03125 378.949219 Z M 515.882812 393.523438 C 515.882812 401.550781 522.429688 408.101562 530.457031 408.101562 L 909.40625 408.101562 C 917.433594 408.101562 923.980469 401.550781 923.980469 393.523438 L 923.980469 276.925781 C 923.980469 268.898438 917.433594 262.351562 909.40625 262.351562 L 530.457031 262.351562 C 522.429688 262.351562 515.882812 268.898438 515.882812 276.925781 L 515.882812 393.523438 '
    />
    <path
      fill='#ffffff'
      d='M 545.03125 87.449219 L 836.53125 87.449219 L 836.53125 174.898438 L 545.03125 174.898438 Z M 530.457031 204.050781 L 851.105469 204.050781 C 859.132812 204.050781 865.683594 197.503906 865.683594 189.476562 L 865.683594 72.875 C 865.683594 64.847656 859.132812 58.300781 851.105469 58.300781 L 530.457031 58.300781 C 522.429688 58.300781 515.882812 64.847656 515.882812 72.875 L 515.882812 189.476562 C 515.882812 197.503906 522.429688 204.050781 530.457031 204.050781 '
    />
    <path
      fill='#ffffff'
      d='M 545.03125 495.550781 L 982.28125 495.550781 L 982.28125 583 L 545.03125 583 Z M 515.882812 597.574219 C 515.882812 605.601562 522.429688 612.148438 530.457031 612.148438 L 996.855469 612.148438 C 1004.882812 612.148438 1011.433594 605.601562 1011.433594 597.574219 L 1011.433594 480.976562 C 1011.433594 472.949219 1004.882812 466.398438 996.855469 466.398438 L 530.457031 466.398438 C 522.429688 466.398438 515.882812 472.949219 515.882812 480.976562 L 515.882812 597.574219 '
    />
    <g clipPath='url(#ab441f582c)'>
      <path
        fill='#ffffff'
        d='M 1128.03125 787.050781 L 545.03125 787.050781 L 545.03125 699.601562 L 1128.03125 699.601562 Z M 1142.605469 670.449219 L 530.457031 670.449219 C 522.429688 670.449219 515.882812 676.996094 515.882812 685.023438 L 515.882812 801.625 C 515.882812 809.652344 522.429688 816.199219 530.457031 816.199219 L 1142.605469 816.199219 C 1150.632812 816.199219 1157.183594 809.652344 1157.183594 801.625 L 1157.183594 685.023438 C 1157.183594 676.996094 1150.632812 670.449219 1142.605469 670.449219 '
      />
    </g>
    <path
      fill='#ffffff'
      d='M 472.15625 0 C 464.128906 0 457.582031 6.546875 457.582031 14.574219 L 457.582031 859.925781 C 457.582031 867.953125 464.128906 874.5 472.15625 874.5 C 480.183594 874.5 486.730469 867.953125 486.730469 859.925781 L 486.730469 14.574219 C 486.730469 6.546875 480.183594 0 472.15625 0 '
    />
    <g clipPath='url(#df627334dd)'>
      <path
        fill='#ffffff'
        d='M 355.558594 787.050781 C 331.417969 787.050781 311.832031 767.464844 311.832031 743.324219 C 311.832031 719.183594 331.417969 699.601562 355.558594 699.601562 C 379.695312 699.601562 399.28125 719.183594 399.28125 743.324219 C 399.28125 767.464844 379.695312 787.050781 355.558594 787.050781 Z M 355.558594 670.449219 C 315.363281 670.449219 282.683594 703.128906 282.683594 743.324219 C 282.683594 783.519531 315.363281 816.199219 355.558594 816.199219 C 395.753906 816.199219 428.433594 783.519531 428.433594 743.324219 C 428.433594 703.128906 395.753906 670.449219 355.558594 670.449219 '
      />
    </g>
    <g clipPath='url(#393a6b31fb)'>
      <path
        fill='#ffffff'
        d='M 355.558594 583 C 331.417969 583 311.832031 563.414062 311.832031 539.273438 C 311.832031 515.136719 331.417969 495.550781 355.558594 495.550781 C 379.695312 495.550781 399.28125 515.136719 399.28125 539.273438 C 399.28125 563.414062 379.695312 583 355.558594 583 Z M 355.558594 466.398438 C 315.363281 466.398438 282.683594 499.078125 282.683594 539.273438 C 282.683594 579.46875 315.363281 612.148438 355.558594 612.148438 C 395.753906 612.148438 428.433594 579.46875 428.433594 539.273438 C 428.433594 499.078125 395.753906 466.398438 355.558594 466.398438 '
      />
    </g>
    <g clipPath='url(#1ef8f82dcc)'>
      <path
        fill='#ffffff'
        d='M 355.558594 378.949219 C 331.417969 378.949219 311.832031 359.363281 311.832031 335.226562 C 311.832031 311.085938 331.417969 291.5 355.558594 291.5 C 379.695312 291.5 399.28125 311.085938 399.28125 335.226562 C 399.28125 359.363281 379.695312 378.949219 355.558594 378.949219 Z M 355.558594 262.351562 C 315.363281 262.351562 282.683594 295.03125 282.683594 335.226562 C 282.683594 375.421875 315.363281 408.101562 355.558594 408.101562 C 395.753906 408.101562 428.433594 375.421875 428.433594 335.226562 C 428.433594 295.03125 395.753906 262.351562 355.558594 262.351562 '
      />
    </g>
    <g clipPath='url(#cc24d55f6d)'>
      <path
        fill='#ffffff'
        d='M 355.558594 174.898438 C 331.417969 174.898438 311.832031 155.316406 311.832031 131.175781 C 311.832031 107.035156 331.417969 87.449219 355.558594 87.449219 C 379.695312 87.449219 399.28125 107.035156 399.28125 131.175781 C 399.28125 155.316406 379.695312 174.898438 355.558594 174.898438 Z M 355.558594 58.300781 C 315.363281 58.300781 282.683594 90.980469 282.683594 131.175781 C 282.683594 171.371094 315.363281 204.050781 355.558594 204.050781 C 395.753906 204.050781 428.433594 171.371094 428.433594 131.175781 C 428.433594 90.980469 395.753906 58.300781 355.558594 58.300781 '
      />
    </g>
  </svg>
);

export const activeTopics = (
  <svg viewBox='0 0 1440 809.999993'>
    <path
      fill='#ffffff'
      d='M 1180.75 430.589844 C 1080.640625 430.589844 1001.070312 351.03125 1001.070312 250.941406 C 1001.070312 150.855469 1080.640625 71.296875 1180.75 71.296875 C 1280.855469 71.296875 1360.429688 150.855469 1360.429688 250.941406 C 1360.429688 351.03125 1280.855469 430.589844 1180.75 430.589844 Z M 1180.75 122.625 C 1108.878906 122.625 1052.40625 179.082031 1052.40625 250.941406 C 1052.40625 322.800781 1108.878906 379.261719 1180.75 379.261719 C 1252.621094 379.261719 1309.089844 322.800781 1309.089844 250.941406 C 1309.089844 179.082031 1252.621094 122.625 1180.75 122.625 Z M 1180.75 122.625 '
    />
    <path
      fill='#ffffff'
      d='M 1437.433594 738.554688 L 1131.980469 738.554688 C 1116.578125 738.554688 1106.308594 728.289062 1106.308594 712.890625 C 1106.308594 697.492188 1116.578125 687.226562 1131.980469 687.226562 L 1386.097656 687.226562 C 1373.261719 587.136719 1285.988281 507.582031 1183.316406 507.582031 C 1149.945312 507.582031 1119.144531 515.277344 1090.910156 530.675781 C 1078.074219 535.808594 1062.675781 533.242188 1057.539062 520.410156 C 1052.40625 507.582031 1054.972656 492.183594 1067.808594 487.050781 C 1103.742188 469.085938 1142.246094 458.820312 1183.316406 458.820312 C 1324.492188 458.820312 1440 574.304688 1440 715.457031 L 1440 738.554688 Z M 1437.433594 738.554688 '
    />
    <path
      fill='#ffffff'
      d='M 256.683594 430.589844 C 156.578125 430.589844 77.003906 351.03125 77.003906 250.941406 C 77.003906 150.855469 156.578125 71.296875 256.683594 71.296875 C 356.792969 71.296875 436.363281 150.855469 436.363281 250.941406 C 436.363281 351.03125 356.792969 430.589844 256.683594 430.589844 Z M 256.683594 122.625 C 184.8125 122.625 128.34375 179.082031 128.34375 250.941406 C 128.34375 322.800781 184.8125 379.261719 256.683594 379.261719 C 328.554688 379.261719 385.027344 322.800781 385.027344 250.941406 C 385.027344 179.082031 328.554688 122.625 256.683594 122.625 Z M 256.683594 122.625 '
    />
    <path
      fill='#ffffff'
      d='M 305.453125 738.554688 L 0 738.554688 L 0 712.890625 C 0 571.738281 115.507812 456.253906 256.683594 456.253906 C 297.753906 456.253906 336.257812 463.953125 369.625 481.917969 C 382.460938 487.050781 387.59375 502.449219 382.460938 515.277344 C 377.328125 528.109375 361.925781 533.242188 349.089844 528.109375 C 318.289062 515.277344 287.488281 507.582031 256.683594 507.582031 C 151.445312 507.582031 66.738281 587.136719 53.902344 687.226562 L 308.019531 687.226562 C 323.421875 687.226562 333.691406 697.492188 333.691406 712.890625 C 333.691406 728.289062 320.855469 738.554688 305.453125 738.554688 Z M 305.453125 738.554688 '
    />
    <g clipPath='url(#d2e39badd2)'>
      <path
        fill='#ffffff'
        d='M 718.714844 430.589844 C 605.777344 430.589844 513.367188 338.199219 513.367188 225.277344 C 513.367188 112.359375 605.777344 19.96875 718.714844 19.96875 C 831.65625 19.96875 924.0625 112.359375 924.0625 225.277344 C 924.0625 338.199219 831.65625 430.589844 718.714844 430.589844 Z M 718.714844 71.296875 C 634.011719 71.296875 564.707031 140.589844 564.707031 225.277344 C 564.707031 309.96875 634.011719 379.261719 718.714844 379.261719 C 803.421875 379.261719 872.726562 309.96875 872.726562 225.277344 C 872.726562 140.589844 803.421875 71.296875 718.714844 71.296875 Z M 718.714844 71.296875 '
      />
    </g>
    <path
      fill='#ffffff'
      d='M 1026.738281 789.882812 L 564.707031 789.882812 C 549.304688 789.882812 539.039062 779.617188 539.039062 764.21875 C 539.039062 748.820312 549.304688 738.554688 564.707031 738.554688 L 975.402344 738.554688 C 962.566406 610.234375 852.191406 507.582031 718.714844 507.582031 C 577.539062 507.582031 462.03125 623.066406 462.03125 764.21875 C 462.03125 779.617188 451.765625 789.882812 436.363281 789.882812 C 420.960938 789.882812 410.695312 779.617188 410.695312 764.21875 C 410.695312 594.835938 549.304688 456.253906 718.714844 456.253906 C 888.128906 456.253906 1026.738281 594.835938 1026.738281 764.21875 Z M 1026.738281 789.882812 '
    />
  </svg>
);

export const activeChatters = (
  <svg xmlns='http://www.w3.org/2000/svg' width='1920' viewBox='0 0 1440 810'>
    <path
      fill='#ffffff'
      d='M 745.410156 33.773438 L 765.753906 67.113281 C 737.164062 87.808594 722.804688 118.757812 718.664062 146.871094 C 717.566406 154.34375 723.289062 161.019531 730.839844 161.085938 L 763.78125 161.085938 C 776.15625 161.085938 785.835938 170.6875 785.835938 183.074219 L 785.835938 265.8125 C 785.835938 278.195312 776.167969 287.773438 763.78125 287.773438 L 693.273438 287.773438 C 680.953125 287.773438 671.425781 278.195312 671.425781 265.8125 L 671.425781 168.296875 C 671.425781 115.308594 701.648438 62.972656 745.410156 33.773438 Z M 742.484375 3.4375 C 682.9375 33.523438 646.730469 101.957031 646.730469 168.308594 C 646.730469 200.839844 646.730469 265.824219 646.730469 265.824219 C 646.730469 291.390625 667.691406 312.488281 693.285156 312.488281 L 763.792969 312.488281 C 789.445312 312.488281 810.46875 291.46875 810.46875 265.824219 L 810.46875 183.085938 C 810.46875 157.425781 789.445312 136.40625 763.792969 136.40625 L 745.878906 136.40625 C 752.085938 115.84375 765.480469 94.640625 788.828125 81.835938 C 795.035156 78.4375 797.125 70.546875 793.457031 64.550781 L 758.542969 7.941406 C 753.835938 0.367188 748.808594 0.25 742.484375 3.4375 Z M 742.484375 3.4375 '
      fillOpacity='1'
      fillRule='evenodd'
    />
    <path
      fill='#ffffff'
      d='M 545.949219 33.773438 L 566.292969 67.113281 C 537.78125 87.808594 523.34375 118.757812 519.253906 146.871094 C 518.105469 154.34375 523.894531 161.019531 531.378906 161.085938 L 564.371094 161.085938 C 576.695312 161.085938 586.375 170.6875 586.375 183.074219 L 586.375 265.8125 C 586.375 278.195312 576.707031 287.773438 564.371094 287.773438 L 493.878906 287.773438 C 481.480469 287.773438 471.953125 278.195312 471.953125 265.8125 L 471.953125 168.296875 C 471.964844 115.308594 502.253906 62.972656 545.949219 33.773438 Z M 543.007812 3.4375 C 483.515625 33.523438 447.257812 101.957031 447.257812 168.308594 C 447.257812 200.839844 447.257812 265.824219 447.257812 265.824219 C 447.257812 291.390625 468.214844 312.488281 493.878906 312.488281 L 564.371094 312.488281 C 589.96875 312.488281 611.074219 291.46875 611.074219 265.824219 L 611.074219 183.085938 C 611.074219 157.425781 589.96875 136.40625 564.371094 136.40625 L 546.484375 136.40625 C 552.613281 115.84375 566.085938 94.640625 589.355469 81.835938 C 595.5625 78.4375 597.652344 70.546875 593.980469 64.550781 L 559.066406 7.941406 C 554.363281 0.367188 549.332031 0.25 543.007812 3.4375 Z M 543.007812 3.4375 '
      fillOpacity='1'
      fillRule='evenodd'
    />
    <path
      fill='#ffffff'
      d='M 406.503906 136.394531 C 349.664062 136.394531 303.527344 182.511719 303.527344 239.277344 L 303.527344 587.511719 C 303.527344 644.277344 349.664062 690.40625 406.503906 690.40625 L 639.582031 690.40625 L 709.410156 778.59375 C 734.042969 809.671875 782.164062 793.226562 782.164062 757.847656 L 782.164062 690.40625 L 1032.730469 690.40625 C 1089.570312 690.40625 1135.574219 644.261719 1135.574219 587.511719 L 1135.574219 239.277344 C 1135.574219 182.511719 1089.570312 136.394531 1032.730469 136.394531 L 851.300781 136.394531 C 834.640625 136.121094 834.640625 161.308594 851.300781 161.097656 L 1032.730469 161.097656 C 1076.292969 161.097656 1110.867188 195.734375 1110.867188 239.277344 L 1110.867188 587.511719 C 1110.867188 631.054688 1076.292969 665.714844 1032.730469 665.714844 L 769.832031 665.714844 C 763.023438 665.714844 757.457031 671.28125 757.457031 678.101562 L 757.457031 755 C 757.457031 776.488281 736.628906 773.238281 728.320312 762.746094 L 655.222656 670.339844 C 652.925781 667.414062 649.304688 665.730469 645.582031 665.730469 L 406.503906 665.730469 C 362.9375 665.730469 328.234375 631.082031 328.234375 587.523438 L 328.234375 239.277344 C 328.234375 195.796875 362.9375 161.097656 406.503906 161.097656 C 423.164062 161.308594 423.164062 136.121094 406.503906 136.394531 Z M 406.503906 136.394531 '
      fillOpacity='1'
      fillRule='evenodd'
    />
  </svg>
);

export const MinusIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
  >
    <path
      d='M5.63786 8.05409C5.19305 8.05409 4.83245 8.41468 4.83245 8.8595C4.83245 9.30432 5.19305 9.66491 5.63786 9.66491H12.0811C12.526 9.66491 12.8865 9.30432 12.8865 8.8595C12.8865 8.41468 12.526 8.05409 12.0811 8.05409H5.63786Z'
      fill='#FC6758'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.8595 0C3.96653 0 0 3.96653 0 8.8595C0 13.7525 3.96653 17.719 8.8595 17.719C13.7525 17.719 17.719 13.7525 17.719 8.8595C17.719 3.96653 13.7525 0 8.8595 0ZM1.61082 8.8595C1.61082 4.85616 4.85616 1.61082 8.8595 1.61082C12.8628 1.61082 16.1082 4.85616 16.1082 8.8595C16.1082 12.8628 12.8628 16.1082 8.8595 16.1082C4.85616 16.1082 1.61082 12.8628 1.61082 8.8595Z'
      fill='#FC6758'
    />
  </svg>
);

export const AmazonIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='100'
    height='31'
    viewBox='0 0 100 31'
    fill='none'
  >
    <g clip-path='url(#clip0_6742_3257)'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M62.0345 23.959C56.245 28.225 47.824 30.4975 40.5608 30.4975C30.3854 30.4975 21.2626 26.7563 14.3152 20.5325C13.7889 20.0432 14.2451 19.3787 14.9117 19.7633C22.3854 24.0989 31.6135 26.6864 41.1573 26.6864C47.5784 26.6864 54.666 25.3577 61.1923 22.5954C62.1745 22.2108 62.9818 23.2598 62.0344 23.959H62.0345Z'
        fill='#FF9900'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M64.4544 21.2012C63.7177 20.2572 59.5421 20.7466 57.6825 20.9914C57.1211 21.0613 57.0158 20.5718 57.5421 20.2222C60.8755 17.8795 66.3141 18.5788 66.9456 19.348C67.5772 20.1173 66.7702 25.5714 63.6469 28.1592C63.1558 28.5438 62.6995 28.334 62.9102 27.8095C63.6123 26.0612 65.1912 22.1799 64.4544 21.2012Z'
        fill='#FF9900'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M57.7892 3.78723V1.51394C57.7852 1.43942 57.797 1.3649 57.8238 1.29523C57.8506 1.22555 57.8918 1.16227 57.9448 1.10951C57.9977 1.05674 58.0612 1.01567 58.1312 0.98896C58.2011 0.962249 58.2759 0.950497 58.3506 0.954468H68.5261C68.6793 0.951255 68.8276 1.00807 68.9391 1.1127C69.0507 1.21732 69.1166 1.3614 69.1227 1.51394V3.43702C69.1227 3.7517 68.842 4.17106 68.3507 4.87064L63.0876 12.3532C65.0526 12.3182 67.123 12.5979 68.8771 13.5766C69.263 13.7864 69.3682 14.1361 69.4034 14.4507V16.8633C69.4034 17.213 69.0525 17.5973 68.6668 17.3878C65.544 15.7444 61.3685 15.5696 57.93 17.4228C57.5791 17.5976 57.1934 17.248 57.1934 16.8983V14.5908C57.1934 14.2412 57.1934 13.6121 57.5793 13.0524L63.6846 4.34617H58.3858C58.2327 4.34939 58.0844 4.29264 57.9729 4.18813C57.8614 4.08362 57.7954 3.93968 57.7892 3.78723ZM20.7015 17.8776H17.6138C17.4755 17.8636 17.3455 17.8048 17.2441 17.71C17.1426 17.6152 17.0752 17.4898 17.0524 17.3531V1.54893C17.0585 1.39641 17.1243 1.25235 17.2359 1.14773C17.3474 1.04311 17.4957 0.986281 17.6488 0.989466H20.526C20.6683 0.99161 20.8047 1.04654 20.9085 1.14352C21.0123 1.24051 21.0761 1.37258 21.0875 1.51394V3.57692H21.1576C21.8942 1.58394 23.3331 0.639894 25.2278 0.639894C27.1576 0.639894 28.3856 1.58394 29.2278 3.57692C29.9645 1.58394 31.684 0.639894 33.5088 0.639894C34.807 0.639894 36.2106 1.16436 37.0878 2.38819C38.0699 3.71681 37.8597 5.63989 37.8597 7.35319V17.3532C37.8537 17.5057 37.7878 17.6498 37.6762 17.7544C37.5647 17.859 37.4164 17.9158 37.2633 17.9127H34.2103C33.8945 17.8777 33.6488 17.633 33.6488 17.3532V8.96149C33.6488 8.29713 33.719 6.61883 33.5787 5.98947C33.3332 4.94053 32.6665 4.62585 31.7541 4.62585C31.3513 4.63728 30.9606 4.76584 30.6302 4.99571C30.2998 5.22557 30.044 5.54671 29.8944 5.91957C29.5786 6.72372 29.6138 8.05245 29.6138 8.96149V17.3532C29.6077 17.5057 29.5418 17.6498 29.4303 17.7544C29.3187 17.859 29.1705 17.9158 29.0173 17.9127H25.9296C25.6138 17.8777 25.3682 17.633 25.3682 17.3532V8.96149C25.3682 7.21319 25.6488 4.59085 23.4735 4.59085C21.263 4.59085 21.3331 7.1083 21.3331 8.96149V17.3532C21.3111 17.5027 21.2344 17.6389 21.1179 17.7357C21.0014 17.8325 20.8531 17.883 20.7015 17.8777V17.8776ZM77.8945 0.639894C82.491 0.639894 84.9823 4.55596 84.9823 9.55596C84.9823 14.3812 82.2455 18.2272 77.8945 18.2272C73.4033 18.2272 70.9471 14.3112 70.9471 9.41606C70.912 4.48596 73.4033 0.639469 77.8945 0.639469V0.639894ZM77.8945 3.89159C75.6138 3.89159 75.4735 7.00351 75.4735 8.92659C75.4735 10.8497 75.4384 14.9755 77.8595 14.9755C80.2455 14.9755 80.3858 11.6538 80.3858 9.62585C80.3858 8.29713 80.3156 6.68883 79.9296 5.43C79.5787 4.31106 78.877 3.89159 77.8945 3.89159ZM90.912 17.8776H87.8243C87.5086 17.8426 87.2629 17.5979 87.2629 17.3181V1.47872C87.2822 1.33434 87.3532 1.20177 87.4628 1.1054C87.5724 1.00903 87.7133 0.955361 87.8595 0.954254H90.7366C90.8671 0.958839 90.9925 1.00571 91.0938 1.08774C91.1952 1.16978 91.2669 1.28251 91.2981 1.40883V3.82138H91.3682C92.2454 1.65351 93.4384 0.639572 95.5788 0.639572C96.9472 0.639572 98.3156 1.12894 99.1928 2.49277C99.9998 3.75149 99.9998 5.88436 99.9998 7.42287V17.3879C99.9786 17.5285 99.9059 17.6563 99.7958 17.7467C99.6856 17.837 99.5458 17.8835 99.4032 17.8772H96.3153C96.0346 17.8422 95.789 17.6326 95.7539 17.3879V8.7867C95.7539 7.0384 95.9644 4.52074 93.824 4.52074C93.0874 4.52074 92.3855 5.0101 92.0346 5.77947C91.6135 6.75819 91.5435 7.70255 91.5435 8.78649V17.3184C91.5239 17.472 91.4491 17.6133 91.333 17.7161C91.2169 17.819 91.0673 17.8765 90.9119 17.8779L90.912 17.8776ZM49.6842 10.3252C49.6842 11.514 49.7193 12.528 49.1227 13.6124C48.6316 14.4866 47.8596 15.0111 46.9824 15.0111C45.7894 15.0111 45.0877 14.102 45.0877 12.7733C45.0877 10.151 47.4385 9.66138 49.6842 9.66138V10.3252ZM52.807 17.8427C52.707 17.9296 52.5821 17.9832 52.45 17.9957C52.3178 18.0083 52.1851 17.9792 52.0704 17.9126C51.0529 17.0734 50.8427 16.6538 50.2809 15.8496C48.5967 17.5623 47.3686 18.0873 45.1932 18.0873C42.5967 18.0873 40.5616 16.4789 40.5616 13.2971C40.5616 10.7797 41.93 9.10138 43.8604 8.26213C45.5446 7.52808 47.8958 7.38798 49.6849 7.17819V6.79362C49.6849 6.05957 49.755 5.18521 49.299 4.55585C48.9131 3.99638 48.2112 3.7517 47.5802 3.7517C46.3872 3.7517 45.3346 4.34606 45.0889 5.60489C45.0188 5.88457 44.8434 6.16436 44.5626 6.16436L41.5802 5.84968C41.3346 5.77979 41.0539 5.605 41.124 5.22032C41.8257 1.58394 45.0889 0.5 48.0363 0.5C49.5451 0.5 51.5099 0.884574 52.7029 2.0384C54.2117 3.43702 54.0713 5.32564 54.0713 7.35309V12.1433C54.0713 13.5769 54.6678 14.2063 55.2292 15.0104C55.4397 15.2901 55.4747 15.6398 55.2292 15.8146C54.5625 16.339 53.4397 17.3181 52.8082 17.8426L52.807 17.8427ZM9.15766 10.3252C9.15766 11.514 9.19278 12.528 8.59623 13.6124C8.10515 14.4866 7.33309 15.0111 6.45587 15.0111C5.26287 15.0111 4.56116 14.102 4.56116 12.7733C4.56116 10.151 6.91204 9.66138 9.15766 9.66138V10.3252ZM12.2454 17.8427C12.1454 17.9296 12.0205 17.9832 11.8884 17.9957C11.7562 18.0083 11.6234 17.9792 11.5088 17.9126C10.4913 17.0734 10.2811 16.6538 9.71931 15.8496C8.03512 17.5623 6.80699 18.0873 4.63162 18.0873C2.03509 18.0873 0 16.4789 0 13.2971C0 10.7797 1.3684 9.10138 3.29877 8.26213C4.98296 7.52808 7.33416 7.38798 9.12329 7.17819V6.79362C9.12329 6.05957 9.19342 5.18521 8.73736 4.55585C8.35144 3.99638 7.64962 3.7517 7.01859 3.7517C5.82558 3.7517 4.77297 4.34606 4.52732 5.60489C4.45718 5.88457 4.28178 6.16436 4.00101 6.16436L1.01856 5.84968C0.773022 5.77979 0.492254 5.605 0.562393 5.22032C1.2641 1.58394 4.52732 0.5 7.47465 0.5C8.98344 0.5 10.9483 0.884574 12.1413 2.0384C13.6501 3.43702 13.5097 5.32564 13.5097 7.35309V12.1433C13.5097 13.5769 14.1061 14.2063 14.6676 15.0104C14.8781 15.2901 14.9131 15.6398 14.6676 15.8146C14.0009 16.339 12.8781 17.3181 12.2465 17.8426L12.2454 17.8427Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_6742_3257'>
        <rect
          width='100'
          height='30'
          fill='white'
          transform='translate(0 0.5)'
        />
      </clipPath>
    </defs>
  </svg>
);

export const CrossIconWhite = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
  >
    <path
      d='M14.3706 0.343621C14.2742 0.238148 14.1597 0.15447 14.0336 0.0973768C13.9076 0.0402834 13.7725 0.0108954 13.636 0.0108954C13.4995 0.0108954 13.3644 0.0402834 13.2384 0.0973768C13.1123 0.15447 12.9978 0.238148 12.9014 0.343621L7.80619 5.89579L2.71095 0.332243C2.61449 0.226909 2.49996 0.143353 2.37392 0.0863469C2.24788 0.0293405 2.11279 1.10987e-09 1.97637 0C1.83994 -1.10988e-09 1.70485 0.0293405 1.57881 0.0863469C1.45277 0.143353 1.33824 0.226909 1.24178 0.332243C1.14531 0.437577 1.06879 0.562627 1.01658 0.700252C0.964371 0.837878 0.9375 0.985385 0.9375 1.13435C0.9375 1.28331 0.964371 1.43082 1.01658 1.56845C1.06879 1.70607 1.14531 1.83112 1.24178 1.93646L6.33701 7.5L1.24178 13.0635C1.14531 13.1689 1.06879 13.2939 1.01658 13.4316C0.964371 13.5692 0.9375 13.7167 0.9375 13.8657C0.9375 14.0146 0.964371 14.1621 1.01658 14.2997C1.06879 14.4374 1.14531 14.5624 1.24178 14.6678C1.33824 14.7731 1.45277 14.8566 1.57881 14.9137C1.70485 14.9707 1.83994 15 1.97637 15C2.11279 15 2.24788 14.9707 2.37392 14.9137C2.49996 14.8566 2.61449 14.7731 2.71095 14.6678L7.80619 9.10421L12.9014 14.6678C12.9979 14.7731 13.1124 14.8566 13.2385 14.9137C13.3645 14.9707 13.4996 15 13.636 15C13.7724 15 13.9075 14.9707 14.0336 14.9137C14.1596 14.8566 14.2741 14.7731 14.3706 14.6678C14.4671 14.5624 14.5436 14.4374 14.5958 14.2997C14.648 14.1621 14.6749 14.0146 14.6749 13.8657C14.6749 13.7167 14.648 13.5692 14.5958 13.4316C14.5436 13.2939 14.4671 13.1689 14.3706 13.0635L9.27536 7.5L14.3706 1.93646C14.7665 1.50411 14.7665 0.775962 14.3706 0.343621Z'
      fill='white'
    />
  </svg>
);

export const FilledStar = (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='star'>
      <path
        id='Vector'
        d='M16.0097 7.47641L16 7.52496V7.52795L15.9817 7.53712L15.9258 7.59157L12.8508 10.5916L12.6619 10.7759L12.7075 11.0359L13.4571 15.3083C13.4824 15.4651 13.392 15.5852 13.2861 15.6245H13.2859H13.2857H13.2854H13.2852H13.285H13.2848H13.2845H13.2843H13.2841H13.2839H13.2836H13.2834H13.2832H13.283H13.2827H13.2825H13.2823H13.2821H13.2818H13.2816H13.2814H13.2812H13.281H13.2807H13.2805H13.2803H13.2801H13.2798H13.2796H13.2794H13.2792H13.279H13.2787H13.2785H13.2783H13.2781H13.2779H13.2776H13.2774H13.2772H13.277H13.2768H13.2765H13.2763H13.2761H13.2759H13.2757H13.2754H13.2752H13.275H13.2748H13.2746H13.2743H13.2741H13.2739H13.2737H13.2735H13.2732H13.273H13.2728H13.2726H13.2724H13.2721H13.2719H13.2717H13.2715H13.2713H13.271H13.2708H13.2706H13.2704H13.2702H13.2699H13.2697H13.2695H13.2693H13.269H13.2688H13.2686H13.2684H13.2682H13.2679H13.2677H13.2675H13.2673H13.267H13.2668H13.2666H13.2664H13.2661H13.2659H13.2657H13.2655H13.2652H13.265H13.2648H13.2646H13.2643H13.2641H13.2639H13.2636H13.2634H13.2632H13.263H13.2627H13.2625H13.2623H13.262H13.2618H13.2616H13.2613H13.2611H13.2609H13.2606H13.2604H13.2602H13.2599H13.2597H13.2595H13.2592H13.259H13.2588H13.2585H13.2583H13.258H13.2578H13.2576H13.2573H13.2571H13.2568H13.2566H13.2564H13.2561H13.2559H13.2556H13.2554H13.2551H13.2549H13.2547H13.2544H13.2542H13.2539H13.2537H13.2534H13.2532H13.2529H13.2527H13.2524H13.2522H13.2519H13.2517H13.2514H13.2511H13.2509H13.2506H13.2504H13.2501H13.2499H13.2496H13.2493H13.2491H13.2488H13.2486H13.2483H13.248H13.2478H13.2475H13.2472H13.247H13.2467H13.2464H13.2462H13.2459H13.2456H13.2454H13.2451H13.2448H13.2445H13.2443H13.244H13.2437H13.2434H13.2431H13.2429H13.2426H13.2423H13.242H13.2417H13.2415H13.2412H13.2409H13.2406H13.2403H13.24H13.2397H13.2394H13.2392H13.2389H13.2386H13.2383H13.238H13.2377H13.2374H13.2371H13.2368H13.2365H13.2362H13.2359H13.2356H13.2353H13.235H13.2347H13.2343H13.234H13.2337H13.2334H13.2331H13.2328H13.2325H13.2322H13.2318H13.2315H13.2312H13.2309H13.2306H13.2302H13.2299H13.2296H13.2293H13.2289H13.2286H13.2283H13.2279H13.2276H13.2273H13.2269H13.2266H13.2263H13.2259H13.2256H13.2252H13.2249H13.2246H13.2242H13.2239H13.2235H13.2232H13.2228H13.2225H13.2221H13.2218H13.2214H13.221H13.2207H13.2203H13.22H13.2196H13.2192H13.2189H13.2185H13.2181H13.2178H13.2174H13.217H13.2167H13.2163H13.2159H13.2155H13.2151H13.2148H13.2144H13.214H13.2136H13.2132H13.2128H13.2124H13.212H13.2117H13.2113H13.2109H13.2105H13.2101H13.2097H13.2093H13.2089H13.2085H13.208H13.2076H13.2072H13.2068H13.2064H13.206H13.2056H13.2052H13.2047H13.2043H13.2039H13.2035H13.203H13.2026H13.2022H13.2017H13.2013H13.2009H13.2004H13.2C13.161 15.6245 13.1317 15.6244 13.1048 15.6236C13.0985 15.6234 13.0929 15.6231 13.0878 15.6229L13.0589 15.6076L9.23394 13.5826L9 13.4587L8.76606 13.5826L4.94106 15.6076L4.92923 15.6138L4.91775 15.6207C4.8546 15.6586 4.79439 15.6626 4.73742 15.6456C4.68076 15.6286 4.61646 15.5863 4.56581 15.5112C4.55638 15.4855 4.55122 15.4467 4.55019 15.3419L5.29248 11.1109L5.33809 10.8509L5.14916 10.6666L2.07685 7.6692C1.97382 7.56472 1.97439 7.43219 2.07855 7.32802L2.13593 7.27065L2.14605 7.2504C2.15416 7.24983 2.16377 7.24947 2.175 7.24947H2.20992L2.24449 7.24461L6.51949 6.64461L6.78462 6.6074L6.90063 6.36611L8.76371 2.4909C8.81468 2.41383 8.87997 2.37061 8.93742 2.35338C8.99439 2.33629 9.0546 2.34032 9.11775 2.37821L9.13422 2.38809L9.15139 2.39668C9.18474 2.41335 9.19684 2.42254 9.19958 2.42488C9.20192 2.42762 9.21111 2.43972 9.22779 2.47307L11.1778 6.37307L11.2953 6.60809L11.5555 6.64461L15.8305 7.24461L15.8651 7.24947H15.8948C15.9001 7.25122 15.9261 7.26135 15.9603 7.30968C15.9814 7.33958 15.997 7.37404 16.0052 7.40721C16.0134 7.4404 16.0122 7.46393 16.0097 7.47641Z'
        fill='#F2A742'
        stroke='#C45500'
      />
    </g>
  </svg>
);

export const HalfStar = (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='half-star'>
      <path
        id='Vector'
        d='M5.89706 6.58521L6.15719 6.54741L6.27352 6.31169L8.29173 2.22235L7.84336 2.00106L8.29173 2.22235C8.29979 2.20601 8.30795 2.19958 8.31405 2.19596C8.32194 2.19128 8.3336 2.1875 8.34778 2.1875C8.36196 2.1875 8.37362 2.19128 8.3815 2.19596C8.38761 2.19958 8.39576 2.20601 8.40383 2.22235L8.40383 2.22235L10.4221 6.31169L10.5384 6.54741L10.7985 6.58521L15.3114 7.24097L15.3833 6.74617L15.3114 7.24097C15.3294 7.24359 15.338 7.24936 15.3434 7.25405C15.3502 7.26011 15.3574 7.27003 15.3618 7.28351C15.3662 7.297 15.3662 7.30925 15.3642 7.31818C15.3626 7.32509 15.3591 7.33483 15.346 7.34755L15.346 7.34757L12.0805 10.5307L11.8922 10.7142L11.9367 10.9733L12.7075 15.4679L12.7075 15.468C12.7106 15.4859 12.7078 15.4958 12.705 15.5023C12.7013 15.5108 12.6941 15.5207 12.6827 15.529C12.6712 15.5373 12.6595 15.5411 12.6504 15.542C12.6433 15.5426 12.633 15.5422 12.6169 15.5338C12.6169 15.5338 12.6169 15.5338 12.6169 15.5338L8.58045 13.4117L8.34778 13.2894L8.11511 13.4117L4.07873 15.5338C4.07872 15.5338 4.0787 15.5338 4.07868 15.5338C4.06259 15.5422 4.05223 15.5426 4.04516 15.542C4.03602 15.5411 4.02435 15.5373 4.01287 15.529C4.00139 15.5206 3.99418 15.5107 3.99054 15.5023C3.98773 15.4958 3.98492 15.4858 3.988 15.4679L3.49519 15.3834L3.988 15.4679L4.75889 10.9733L4.80333 10.7142L4.61509 10.5307L1.34956 7.34757C1.33651 7.33485 1.33292 7.32511 1.33136 7.31819C1.32935 7.30924 1.32936 7.29698 1.33374 7.2835C1.33812 7.27001 1.34532 7.2601 1.3522 7.25404C1.35753 7.24936 1.36615 7.24359 1.38418 7.24097L5.89706 6.58521ZM7.84773 12.6563L7.84773 13.1563H8.34773C8.35801 13.1563 8.36791 13.1587 8.37683 13.1634L8.37686 13.1634L11.6662 14.8927L12.563 15.3642L12.3917 14.3657L11.7635 10.703C11.7635 10.703 11.7635 10.7029 11.7635 10.7029C11.76 10.6825 11.7668 10.6619 11.7814 10.6477L11.7815 10.6476L14.4426 8.05362L15.168 7.34646L14.1655 7.20077L10.4879 6.66639C10.4879 6.66639 10.4879 6.66639 10.4879 6.66639C10.4675 6.66342 10.4499 6.65063 10.4408 6.6322L9.99246 6.85348L10.4408 6.6322L8.79615 3.29972L7.84778 3.521L7.84773 12.6563Z'
        fill='#F2A742'
        stroke='#C45500'
      />
    </g>
  </svg>
);

export const DownArrowIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
  >
    <path
      d='M6.032 8.99998C5.89965 9.00074 5.76847 8.97554 5.64595 8.92581C5.52343 8.87607 5.412 8.8028 5.31804 8.71018L1.29573 4.71292C1.10638 4.52474 1 4.26952 1 4.0034C1 3.73728 1.10638 3.48206 1.29573 3.29389C1.48509 3.10572 1.7419 3 2.00969 3C2.27748 3 2.5343 3.10572 2.72365 3.29389L6.032 6.59163L9.34034 3.30388C9.53271 3.14017 9.78016 3.05462 10.0332 3.06434C10.2863 3.07405 10.5264 3.17831 10.7055 3.35628C10.8846 3.53426 10.9895 3.77283 10.9992 4.02434C11.009 4.27584 10.9229 4.52175 10.7582 4.71292L6.7359 8.71018C6.5486 8.8948 6.2958 8.99888 6.032 8.99998Z'
      fill='#555555'
    />
  </svg>
);

export const DeleteProductIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='58'
    height='58'
    viewBox='0 0 58 58'
    fill='none'
  >
    <g clip-path='url(#clip0_6923_2128)'>
      <path
        d='M31.5932 29.0008L39.4232 21.1708C39.6872 20.8626 39.8251 20.4661 39.8094 20.0606C39.7938 19.6552 39.6257 19.2705 39.3388 18.9836C39.0518 18.6967 38.6672 18.5286 38.2617 18.5129C37.8562 18.4972 37.4598 18.6352 37.1516 18.8991L29.3216 26.6486L21.4432 18.7702C21.135 18.5063 20.7386 18.3684 20.3331 18.384C19.9276 18.3997 19.543 18.5678 19.2561 18.8547C18.9691 19.1416 18.801 19.5263 18.7854 19.9317C18.7697 20.3372 18.9076 20.7337 19.1716 21.0419L27.0338 29.0008L19.3327 36.6052C19.164 36.7496 19.0271 36.9274 18.9304 37.1273C18.8336 37.3271 18.7793 37.5449 18.7707 37.7667C18.7622 37.9886 18.7995 38.2099 18.8805 38.4166C18.9615 38.6234 19.0844 38.8111 19.2414 38.9682C19.3984 39.1252 19.5862 39.248 19.7929 39.329C19.9997 39.41 20.2209 39.4474 20.4428 39.4388C20.6647 39.4303 20.8824 39.3759 21.0823 39.2792C21.2822 39.1825 21.4599 39.0455 21.6044 38.8769L29.2894 31.1919L36.926 38.8286C37.2342 39.0925 37.6307 39.2304 38.0362 39.2148C38.4416 39.1991 38.8263 39.031 39.1132 38.7441C39.4001 38.4571 39.5682 38.0725 39.5839 37.667C39.5995 37.2615 39.4616 36.8651 39.1977 36.5569L31.5932 29.0008Z'
        fill='#FC6758'
      />
      <path
        d='M29.0004 54.7743C23.9021 54.7743 18.9182 53.2625 14.6791 50.43C10.4399 47.5975 7.13594 43.5715 5.18488 38.8613C3.23383 34.151 2.72334 28.9679 3.71798 23.9675C4.71262 18.9671 7.16772 14.374 10.7728 10.7689C14.3779 7.16381 18.9711 4.70872 23.9715 3.71407C28.9719 2.71943 34.1549 3.22992 38.8652 5.18098C43.5754 7.13204 47.6014 10.436 50.4339 14.6752C53.2664 18.9143 54.7782 23.8982 54.7782 28.9965C54.7782 35.8332 52.0624 42.3899 47.2281 47.2242C42.3938 52.0585 35.8371 54.7743 29.0004 54.7743ZM29.0004 6.44098C24.5394 6.44098 20.1785 7.76384 16.4693 10.2423C12.76 12.7207 9.86901 16.2434 8.16183 20.3649C6.45465 24.4864 6.00798 29.0216 6.87829 33.3969C7.7486 37.7723 9.89681 41.7913 13.0513 44.9457C16.2057 48.1002 20.2247 50.2484 24.6001 51.1187C28.9754 51.989 33.5106 51.5423 37.6321 49.8352C41.7536 48.128 45.2763 45.237 47.7547 41.5277C50.2331 37.8185 51.556 33.4576 51.556 28.9965C51.556 23.0144 49.1796 17.2773 44.9496 13.0474C40.7196 8.81737 34.9826 6.44098 29.0004 6.44098Z'
        fill='#FC6758'
      />
    </g>
    <defs>
      <clipPath id='clip0_6923_2128'>
        <rect width='58' height='58' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const UserIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
  >
    <path
      d='M9 1C4.5816 1 1 4.5816 1 9C1 13.4184 4.5816 17 9 17C13.4184 17 17 13.4184 17 9C17 4.5816 13.4184 1 9 1Z'
      stroke='black'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M2.81641 14.0799C2.81641 14.0799 4.59961 11.8031 8.99961 11.8031C13.3996 11.8031 15.1836 14.0799 15.1836 14.0799M8.99961 9.00313C9.63613 9.00313 10.2466 8.75027 10.6967 8.30018C11.1468 7.85009 11.3996 7.23964 11.3996 6.60313C11.3996 5.96661 11.1468 5.35616 10.6967 4.90607C10.2466 4.45598 9.63613 4.20312 8.99961 4.20312C8.36309 4.20312 7.75264 4.45598 7.30255 4.90607C6.85246 5.35616 6.59961 5.96661 6.59961 6.60313C6.59961 7.23964 6.85246 7.85009 7.30255 8.30018C7.75264 8.75027 8.36309 9.00313 8.99961 9.00313Z'
      stroke='black'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const UserIcon2 = (
  <svg
    width='30'
    height='30'
    viewBox='0 0 30 30'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M15 1.6481e-10C16.9698 -9.23342e-06 18.9203 0.387969 20.7402 1.14178C22.5601 1.8956 24.2137 3.00049 25.6066 4.39336C26.9995 5.78624 28.1044 7.43983 28.8582 9.25971C29.612 11.0796 30 13.0301 30 15C30 23.2842 23.2842 30 15 30C6.71575 30 0 23.2842 0 15C0 6.71575 6.71575 1.6481e-10 15 1.6481e-10ZM16.5 16.5H13.5C9.78644 16.5 6.59826 18.7491 5.22316 21.9596C7.39891 25.0106 10.9671 27 15 27C19.0328 27 22.601 25.0106 24.7768 21.9594C23.4017 18.7491 20.2136 16.5 16.5 16.5ZM15 4.5C12.5147 4.5 10.5 6.51473 10.5 8.99999C10.5 11.4853 12.5147 13.5 15 13.5C17.4852 13.5 19.5 11.4853 19.5 8.99999C19.5 6.51473 17.4853 4.5 15 4.5Z'
      fill='#A2A2A2'
    />
  </svg>
);

export const FlipkartIcon = (
  <svg
    width='88'
    height='24'
    viewBox='0 0 88 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.7564 2.78263L14.0013 1.18827C14.043 0.93813 13.97 0.68796 13.8033 0.49515C13.6417 0.30234 13.402 0.19287 13.1467 0.19287H3.46451C3.03721 0.19287 2.67771 0.50027 2.60991 0.92237L0.0096086 17.3632C-0.0268914 17.6133 0.0409143 17.8688 0.207614 18.0616C0.369214 18.2544 0.608912 18.369 0.859012 18.369H3.09451C3.52191 18.369 3.87621 18.0616 3.94921 17.6395L4.95491 11.261H10.4943C10.9164 11.261 11.2759 10.9536 11.3437 10.5315L11.573 9.1402C11.6094 8.8901 11.5417 8.6348 11.3749 8.442C11.2082 8.244 10.9685 8.1344 10.7131 8.1344H5.48641L6.16911 3.51747H12.8966C13.3343 3.51226 13.6939 3.20993 13.7564 2.78263ZM64.507 8.27L64.439 8.2438C63.84 8.0614 63.142 7.96265 62.376 7.96265C61.13 7.96265 60.182 8.4679 59.562 9.4685C58.957 10.4534 58.644 11.5635 58.644 12.762C58.644 13.5176 58.775 14.1532 59.035 14.6482C59.306 15.1589 59.692 15.4248 60.182 15.4248C60.729 15.4248 61.359 15.0703 62.063 14.3772C62.751 13.6998 63.381 12.8871 63.923 11.9699L64.507 8.27ZM68.572 6.37847L66.795 17.655C66.727 18.0823 66.367 18.3848 65.94 18.3848H64.622C64.387 18.3848 64.163 18.2908 64.001 18.1189C63.84 17.9521 63.751 17.7229 63.762 17.4884L63.814 16.0917L63.658 16.2637C63.652 16.2689 63.147 16.8317 62.563 17.2851C61.693 17.9625 60.729 18.3273 60.625 18.369C60.088 18.567 59.51 18.6659 58.905 18.6659C57.576 18.6659 56.586 18.1917 55.862 17.2225C55.143 16.2584 54.783 14.9767 54.783 13.4238C54.783 12.6161 54.866 11.8188 55.023 11.058C55.184 10.2972 55.466 9.5259 55.867 8.7598C56.268 7.99902 56.774 7.32153 57.368 6.75352C57.957 6.18551 58.738 5.72165 59.681 5.36729C60.625 5.01815 61.703 4.8411 62.876 4.8411C64.319 4.8411 66.003 5.02352 67.879 5.3935C68.342 5.4873 68.645 5.91468 68.572 6.37847ZM78.014 4.97138C77.128 5.17982 76.263 5.72177 75.69 6.14387C75.039 6.62328 74.106 7.63951 74.09 7.64993L73.934 7.82194L74.017 6.02911C74.028 5.79461 73.944 5.56012 73.777 5.38816C73.616 5.21619 73.387 5.12252 73.152 5.12252H71.823C71.396 5.12252 71.036 5.42471 70.969 5.85202L69.15 17.384C69.114 17.6342 69.186 17.8843 69.348 18.0772C69.51 18.27 69.749 18.3794 70.005 18.3794H72.058C72.485 18.3794 72.845 18.072 72.912 17.6499L73.871 11.5112C74.418 10.7399 75.127 10.0781 75.987 9.5361C76.628 9.1349 77.284 8.8744 77.941 8.7754C78.301 8.718 78.587 8.4421 78.655 8.0825L79.051 5.97186C79.108 5.68525 79.015 5.39343 78.801 5.1902C78.603 4.98697 78.301 4.90884 78.014 4.97138ZM36.815 10.7453C36.815 9.9845 36.68 9.3487 36.419 8.8588C36.148 8.3481 35.768 8.0876 35.278 8.0876C34.731 8.0876 34.095 8.4369 33.397 9.1351C32.704 9.8178 32.078 10.6253 31.531 11.5425L30.9477 15.2373L31.021 15.2581C31.62 15.4457 32.313 15.5393 33.084 15.5393C34.335 15.5393 35.283 15.034 35.898 14.0335C36.503 13.0538 36.815 11.949 36.815 10.7453ZM39.593 6.28966C40.307 7.25371 40.672 8.5358 40.672 10.0835C40.672 11.1048 40.531 12.1052 40.255 13.0536C39.978 14.002 39.541 14.9244 38.952 15.7999C38.368 16.6649 37.524 17.3736 36.44 17.8947C35.351 18.421 34.059 18.6922 32.605 18.6922C32.032 18.6922 31.307 18.6349 30.4526 18.5151L30.3641 18.5046L30.2077 20.0679C30.2025 20.0836 30.2025 20.099 30.2025 20.1199L29.7492 22.8661C29.6762 23.283 29.3218 23.5854 28.8997 23.5854H26.8622C26.6069 23.5854 26.3724 23.4759 26.2108 23.2831C26.0441 23.0903 25.9711 22.84 26.0128 22.5847L28.6705 5.85202C28.7382 5.42992 29.0978 5.12761 29.5251 5.12761H30.8435C31.078 5.12761 31.307 5.22141 31.469 5.38816C31.63 5.56012 31.719 5.78939 31.709 6.01868L31.656 7.4362L31.813 7.23824C31.828 7.22261 33.084 5.6957 35.007 5.09122C35.539 4.92447 36.049 4.8411 36.565 4.8411C37.873 4.84631 38.869 5.31519 39.593 6.28966ZM87.133 5.12252H85.528L85.883 2.8297C85.919 2.57957 85.846 2.32419 85.685 2.13659C85.523 1.94378 85.278 1.8343 85.028 1.8343H83.407C83.027 1.8343 82.688 2.08441 82.579 2.45439L81.792 5.12252H80.906C80.479 5.12252 80.125 5.42483 80.057 5.84693L79.854 7.0871C79.817 7.33723 79.88 7.59249 80.052 7.7853C80.213 7.97811 80.453 8.0876 80.708 8.0876H81.245L80.286 14.2261C80.218 14.6117 80.182 15.0131 80.182 15.4352C80.182 16.5243 80.468 17.3164 81.063 17.8583C81.646 18.3899 82.537 18.6659 83.72 18.6659C84.429 18.6659 85.429 18.369 85.549 18.3273C85.643 18.2908 85.82 18.2336 85.841 18.2232C85.878 18.2076 85.914 18.1918 85.945 18.1761C86.195 18.0406 86.357 17.7958 86.388 17.5197L86.539 16.2482C86.565 15.9824 86.472 15.7113 86.274 15.5289C86.216 15.4768 86.159 15.4301 86.091 15.3884C86.044 15.3676 86.003 15.3465 85.956 15.3309C85.924 15.3205 85.846 15.3048 85.539 15.31C85.466 15.31 85.388 15.3154 85.31 15.3154C85.169 15.3154 85.08 15.31 85.033 15.2996C84.913 15.2788 84.616 15.2163 84.465 15.0808C84.392 15.0183 84.168 14.8203 84.168 14.0907C84.168 14.0178 84.174 13.9084 84.194 13.7521L85.075 8.0929H86.894C87.305 8.0929 87.665 7.80107 87.743 7.39981L87.983 6.15939C88.035 5.90404 87.967 5.64368 87.8 5.44566C87.639 5.23722 87.394 5.12252 87.133 5.12252ZM54.47 5.47162C54.309 5.25275 54.048 5.12252 53.777 5.12252H51.63C51.25 5.12252 50.911 5.37795 50.802 5.73751C50.619 6.36284 50.276 7.08178 49.77 7.88428C49.067 9.0151 48.488 9.7135 47.998 10.0262L47.92 10.0626C47.748 10.1512 47.477 10.2813 46.529 10.4481L46.409 10.4689L47.894 1.18827C47.931 0.93813 47.863 0.68275 47.696 0.49515C47.535 0.30234 47.295 0.18753 47.045 0.18753H44.992C44.564 0.18753 44.205 0.49518 44.137 0.91728L41.526 17.3894C41.484 17.6395 41.557 17.8897 41.719 18.0825C41.881 18.2753 42.125 18.3899 42.376 18.3899H44.429C44.856 18.3899 45.216 18.0825 45.283 17.6604L45.956 13.3663H47.243L49.014 17.8428C49.145 18.1763 49.463 18.3899 49.817 18.3899H52.047C52.521 18.3899 52.912 18.0042 52.912 17.5247C52.912 17.4101 52.886 17.2904 52.839 17.181L50.812 11.9542L50.854 11.9178C51.693 11.1622 52.553 10.0886 53.413 8.739C53.97 7.86351 54.366 7.01929 54.601 6.24285C54.684 5.97187 54.632 5.69048 54.47 5.47162ZM24.7413 3.98641C25.5959 3.98641 26.2369 3.76754 26.6433 3.3246C27.055 2.87645 27.2583 2.3242 27.2583 1.62591C27.2583 1.08396 27.1071 0.67758 26.7997 0.40661C26.4974 0.13563 26.0285 0 25.4031 0C24.5485 0 23.9075 0.22409 23.5063 0.66182C23.0894 1.10997 22.8862 1.66756 22.8862 2.36584C22.8862 2.90779 23.0425 3.3143 23.3448 3.58006C23.6574 3.85625 24.1108 3.98641 24.7413 3.98641ZM25.4344 5.12252H23.4021C22.9748 5.12252 22.6204 5.42483 22.5475 5.84693L20.7288 17.384C20.6923 17.6342 20.7601 17.8896 20.9268 18.0772C21.0884 18.27 21.3281 18.3794 21.5782 18.3794H23.6105C24.0378 18.3794 24.3922 18.072 24.4651 17.6499L26.2838 6.11791C26.3203 5.86778 26.2525 5.6124 26.0858 5.4248C25.9242 5.2372 25.6897 5.12252 25.4344 5.12252ZM19.5563 0.49515C19.7179 0.68796 19.796 0.93813 19.7543 1.18827L17.7533 13.9554C17.7324 14.1742 17.7272 14.3095 17.7272 14.3981C17.7272 14.8254 17.8106 15.1225 17.9721 15.2737C18.1233 15.4144 18.4568 15.4925 18.5141 15.5029C18.6965 15.529 18.8684 15.6229 18.9987 15.7584C19.1707 15.9408 19.2593 16.1907 19.2384 16.4408L19.1238 17.5873C19.0977 17.8323 18.9935 18.0354 18.8424 18.1448C18.7017 18.2386 18.5297 18.3274 18.3109 18.4107C18.092 18.4941 17.4771 18.6713 17.0498 18.6713C15.9711 18.6713 15.1373 18.4211 14.5693 17.926C14.0065 17.4362 13.7199 16.7222 13.7199 15.7999C13.7199 15.5497 13.746 15.2738 13.7981 14.9767C13.8137 14.8517 15.9711 1.07883 15.9971 0.92771C16.0649 0.50562 16.4245 0.19796 16.8518 0.19796H18.9049C19.1551 0.19275 19.3896 0.30234 19.5563 0.49515Z'
      fill='#2A55E5'
    />
  </svg>
);

export const IndiaFlagIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='33'
    height='33'
    viewBox='0 0 33 33'
    fill='none'
  >
    <path d='M33 5.5H0V27.4995H33V5.5Z' fill='#F0F0F0' />
    <path d='M33 5.5H0V12.8332H33V5.5Z' fill='#FF9811' />
    <path d='M33 20.1641H0V27.4972H33V20.1641Z' fill='#6DA544' />
    <path
      d='M16.5001 19.3303C18.0627 19.3303 19.3294 18.0636 19.3294 16.5011C19.3294 14.9386 18.0627 13.6719 16.5001 13.6719C14.9376 13.6719 13.6709 14.9386 13.6709 16.5011C13.6709 18.0636 14.9376 19.3303 16.5001 19.3303Z'
      fill='#0052B4'
    />
    <path
      d='M16.4997 18.2708C17.4762 18.2708 18.2679 17.4792 18.2679 16.5026C18.2679 15.526 17.4762 14.7344 16.4997 14.7344C15.5231 14.7344 14.7314 15.526 14.7314 16.5026C14.7314 17.4792 15.5231 18.2708 16.4997 18.2708Z'
      fill='#F0F0F0'
    />
    <path
      d='M16.5001 14.3203L17.0456 15.5575L18.3898 15.4113L17.5911 16.5023L18.3898 17.5933L17.0456 17.4471L16.5001 18.6843L15.9545 17.4471L14.6104 17.5933L15.4091 16.5023L14.6104 15.4113L15.9545 15.5575L16.5001 14.3203Z'
      fill='#0052B4'
    />
  </svg>
);

export const USAFlagIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='33'
    height='33'
    viewBox='0 0 640 480'
    fill='none'
  >
    <path fill='#bd3d44' d='M0 0h640v480H0' />
    <path
      stroke='#fff'
      strokeWidth='37'
      d='M0 55.3h640M0 129h640M0 203h640M0 277h640M0 351h640M0 425h640'
    />
    <path fill='#192f5d' d='M0 0h364.8v258.5H0' />
    <marker id='us-a' markerHeight='30' markerWidth='30'>
      <path fill='#fff' d='m14 0 9 27L0 10h28L5 27z' />
    </marker>
    <path
      fill='none'
      marker-mid='url(#us-a)'
      d='m0 0 16 11h61 61 61 61 60L47 37h61 61 60 61L16 63h61 61 61 61 60L47 89h61 61 60 61L16 115h61 61 61 61 60L47 141h61 61 60 61L16 166h61 61 61 61 60L47 192h61 61 60 61L16 218h61 61 61 61 60L0 0'
    />
  </svg>
);

export const AustraliaFLagIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='33'
    height='33'
    viewBox='0 0 640 480'
    fill='none'
  >
    <path fill='#00008B' d='M0 0h640v480H0z' />
    <path
      fill='#fff'
      d='m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z'
    />
    <path
      fill='red'
      d='M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z'
    />
    <path fill='#fff' d='M120.5 0v240h80V0h-80ZM0 80v80h320V80H0Z' />
    <path fill='red' d='M0 96.5v48h320v-48zM136.5 0v240h48V0z' />
    <path
      fill='#fff'
      d='m527 396.7-20.5 2.6 2.2 20.5-14.8-14.4-14.7 14.5 2-20.5-20.5-2.4 17.3-11.2-10.9-17.5 19.6 6.5 6.9-19.5 7.1 19.4 19.5-6.7-10.7 17.6 17.4 11.1Zm-3.7-117.2 2.7-13-9.8-9 13.2-1.5 5.5-12.1 5.5 12.1 13.2 1.5-9.8 9 2.7 13-11.6-6.6-11.6 6.6Zm-104.1-60-20.3 2.2 1.8 20.3-14.4-14.5-14.8 14.1 2.4-20.3-20.2-2.7 17.3-10.8-10.5-17.5 19.3 6.8L387 178l6.7 19.3 19.4-6.3-10.9 17.3 17.1 11.2ZM623 186.7l-20.9 2.7 2.3 20.9-15.1-14.7-15 14.8 2.1-21-20.9-2.4 17.7-11.5-11.1-17.9 20 6.7 7-19.8 7.2 19.8 19.9-6.9-11 18 17.8 11.3Zm-96.1-83.5-20.7 2.3 1.9 20.8-14.7-14.8-15.1 14.4 2.4-20.7-20.7-2.8 17.7-11L467 73.5l19.7 6.9 7.3-19.5 6.8 19.7 19.8-6.5-11.1 17.6 17.4 11.5ZM234 385.7l-45.8 5.4 4.6 45.9-32.8-32.4-33 32.2 4.9-45.9-45.8-5.8 38.9-24.8-24-39.4 43.6 15 15.8-43.4 15.5 43.5 43.7-14.7-24.3 39.2 38.8 25.1Z'
    />
  </svg>
);

export const UKFlagIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='33'
    height='33'
    viewBox='0 0 640 480'
    fill='none'
  >
    <path fill='#012169' d='M0 0h640v480H0z' />
    <path
      fill='#FFF'
      d='m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z'
    />
    <path
      fill='#C8102E'
      d='m424 281 216 159v40L369 281h55zm-184 20 6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z'
    />
    <path fill='#FFF' d='M241 0v480h160V0H241zM0 160v160h640V160H0z' />
    <path fill='#C8102E' d='M0 193v96h640v-96H0zM273 0v480h96V0h-96z' />
  </svg>
);

export const CanadaFlagIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='33'
    height='33'
    viewBox='0 0 640 480'
    fill='none'
  >
    <path fill='#fff' d='M150.1 0h339.7v480H150z' />
    <path
      fill='#d52b1e'
      d='M-19.7 0h169.8v480H-19.7zm509.5 0h169.8v480H489.9zM201 232l-13.3 4.4 61.4 54c4.7 13.7-1.6 17.8-5.6 25l66.6-8.4-1.6 67 13.9-.3-3.1-66.6 66.7 8c-4.1-8.7-7.8-13.3-4-27.2l61.3-51-10.7-4c-8.8-6.8 3.8-32.6 5.6-48.9 0 0-35.7 12.3-38 5.8l-9.2-17.5-32.6 35.8c-3.5.9-5-.5-5.9-3.5l15-74.8-23.8 13.4c-2 .9-4 .1-5.2-2.2l-23-46-23.6 47.8c-1.8 1.7-3.6 1.9-5 .7L264 130.8l13.7 74.1c-1.1 3-3.7 3.8-6.7 2.2l-31.2-35.3c-4 6.5-6.8 17.1-12.2 19.5-5.4 2.3-23.5-4.5-35.6-7 4.2 14.8 17 39.6 9 47.7z'
    />
  </svg>
);

export const AmazonIconSmall = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    width='100'
    height='100'
    viewBox='0 0 48 48'
  >
    <path
      fill='#FFB300'
      d='M39.6,39c-4.2,3.1-10.5,5-15.6,5c-7.3,0-13.8-2.9-18.8-7.4c-0.4-0.4,0-0.8,0.4-0.6c5.4,3.1,11.5,4.9,18.3,4.9c4.6,0,10.4-1,15.1-3C39.7,37.7,40.3,38.5,39.6,39z M41.1,36.9c-0.5-0.7-3.5-0.3-4.8-0.2c-0.4,0-0.5-0.3-0.1-0.6c2.3-1.7,6.2-1.2,6.6-0.6c0.4,0.6-0.1,4.5-2.3,6.3c-0.3,0.3-0.7,0.1-0.5-0.2C40.5,40.4,41.6,37.6,41.1,36.9z'
    ></path>
    <path
      fill='#37474F'
      d='M36.9,29.8c-1-1.3-2-2.4-2-4.9v-8.3c0-3.5,0-6.6-2.5-9c-2-1.9-5.3-2.6-7.9-2.6C19,5,14.2,7.2,13,13.4c-0.1,0.7,0.4,1,0.8,1.1l5.1,0.6c0.5,0,0.8-0.5,0.9-1c0.4-2.1,2.1-3.1,4.1-3.1c1.1,0,3.2,0.6,3.2,3v3c-3.2,0-6.6,0-9.4,1.2c-3.3,1.4-5.6,4.3-5.6,8.6c0,5.5,3.4,8.2,7.8,8.2c3.7,0,5.9-0.9,8.8-3.8c0.9,1.4,1.3,2.2,3,3.7c0.4,0.2,0.9,0.2,1.2-0.1l0,0c1-0.9,2.9-2.6,4-3.5C37.4,30.9,37.3,30.3,36.9,29.8z M27,22.1L27,22.1c0,2-0.1,6.9-5,6.9c-3,0-3-3-3-3c0-4.5,4.2-5,8-5V22.1z'
    ></path>
  </svg>
);

export const DisgustIcon = (x, y) => {
  return (
    <svg
      x={x - 14}
      y={y}
      xmlns='http://www.w3.org/2000/svg'
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
    >
      <circle cx='13.6499' cy='13.7143' r='12.4409' fill='#5B3300' />
      <path
        d='M14.032 0.25C6.45735 0.25 0.318359 6.389 0.318359 13.9636C0.318359 21.5383 6.45735 27.6773 14.032 27.6773C21.6066 27.6773 27.7456 21.5383 27.7456 13.9636C27.7456 6.389 21.6066 0.25 14.032 0.25ZM7.80729 14.36C6.4145 14.36 5.28955 13.2351 5.28955 11.8423C5.28955 11.5852 5.33241 11.3495 5.39669 11.1138L3.74677 10.9852L3.86462 9.48528L10.6572 10.0103L11.9214 7.82464L13.2177 8.5746L11.4821 11.5745L10.3036 11.4888C10.325 11.6066 10.325 11.7245 10.325 11.8423C10.325 13.2244 9.20008 14.36 7.80729 14.36ZM20.546 21.0347C20.546 21.0347 19.4425 20.3919 16.5283 20.7562C14.1927 21.0347 10.325 22.4489 10.325 22.4489C10.325 22.4489 12.8213 17.9492 16.8926 17.5528C20.8995 17.1456 20.546 21.0347 20.546 21.0347ZM22.7744 11.8423C22.7744 12.5816 22.4637 13.2351 21.9602 13.6958C21.1459 13.5137 20.1174 13.4494 18.8103 13.5458C18.6925 13.5565 18.5746 13.5672 18.4461 13.5779C18.0068 13.128 17.739 12.5066 17.739 11.8316C17.739 11.7137 17.7497 11.5959 17.7604 11.478L16.5819 11.5637L14.8462 8.56389L16.1426 7.81393L17.4068 9.99954L24.1994 9.47456L24.3172 10.9745L22.6673 11.1031C22.7423 11.3388 22.7744 11.5852 22.7744 11.8423Z'
        fill='url(#paint0_radial_7220_6009)'
      />
      <path
        opacity='0.5'
        d='M14 28C21.732 28 28 21.732 28 14C28 6.268 21.732 0 14 0C6.268 0 0 6.268 0 14C0 21.732 6.268 28 14 28Z'
        fill='url(#paint1_radial_7220_6009)'
      />
      <defs>
        <radialGradient
          id='paint0_radial_7220_6009'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(14.032 11.1417) rotate(60.5239) scale(223.864)'
        >
          <stop stopColor='#FED63C' />
          <stop offset='1' stopColor='#FFBB47' stopOpacity='0' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_7220_6009'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(11.2455 8.32627) scale(13.2875)'
        >
          <stop stopColor='#FFE95F' />
          <stop offset='1' stopColor='#FFBB47' stopOpacity='0' />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const AngerIcon = (x, y) => {
  return (
    <svg
      x={x - 14}
      y={y}
      xmlns='http://www.w3.org/2000/svg'
      width='28'
      height='28'
      viewBox='0 0 30 28'
      fill='none'
    >
      <path
        d='M14.5259 28C7.53846 28 0 23.6172 0 14C0 4.38283 7.53846 0 14.5259 0C18.4079 0 21.9893 1.27728 24.644 3.60644C27.5242 6.161 29.0519 9.76744 29.0519 14C29.0519 18.2326 27.5242 21.814 24.644 24.3685C21.9893 26.6977 18.3828 28 14.5259 28Z'
        fill='url(#paint0_radial_7343_2058)'
      />
      <path
        d='M26.5203 5.67188C27.8552 7.82572 28.5515 10.3903 28.5515 13.2429C28.5515 17.4755 27.0237 21.0569 24.1436 23.6114C21.4889 25.9406 17.8824 27.2429 14.0255 27.2429C9.50246 27.2429 4.75898 25.4021 1.95898 21.4976C4.6538 25.9205 9.72285 27.9942 14.5264 27.9942C18.3833 27.9942 21.9898 26.6919 24.6445 24.3628C27.5246 21.8082 29.0524 18.2268 29.0524 13.9942C29.0524 10.8035 28.1833 7.96848 26.5203 5.67188Z'
        fill='#D84213'
      />
      <path
        d='M19.6184 24.0813C19.5333 24.0487 19.4556 23.9961 19.3955 23.926C16.9587 21.394 12.929 21.3163 10.397 23.7532C10.3394 23.8108 10.2793 23.8684 10.2242 23.926C10.1641 23.9961 10.0864 24.0487 10.0013 24.0813C9.81343 24.1514 9.60055 24.1113 9.45028 23.9786C9.30252 23.8484 9.25243 23.6405 9.32756 23.4577C10.0739 21.5417 12.2929 20.0391 14.8099 20.0391C17.3268 20.0391 19.5458 21.5417 20.2921 23.4552C20.3673 23.638 20.3172 23.8459 20.1694 23.9761C20.0192 24.1088 19.8063 24.1489 19.6184 24.0813Z'
        fill='#422B0D'
      />
      <path
        d='M13.1569 15.4838C12.5959 14.7775 10.2843 13.4201 9.45031 13.0244C9.13976 12.8817 8.81668 12.7664 8.48609 12.6813C8.42599 12.6638 8.36087 12.6562 8.29826 12.6562C7.96516 12.6638 7.67965 12.9017 7.61203 13.2298C7.53439 13.5704 7.70971 13.921 8.03028 14.0613C8.42348 14.2541 9.10971 14.6198 9.82098 15.023C9.22742 15.3761 8.86427 16.0173 8.86427 16.7085V17.0741C8.86427 18.111 9.70577 18.9525 10.7426 18.9525C11.7795 18.9525 12.621 18.111 12.621 17.0741V16.7085C12.621 16.6935 12.621 16.6809 12.621 16.6659C12.889 16.6484 13.1294 16.4881 13.2471 16.2477C13.3698 15.9972 13.3348 15.6992 13.1569 15.4838Z'
        fill='#422B0D'
      />
      <path
        d='M22.0181 13.2326C21.9479 12.902 21.6574 12.6666 21.3193 12.6641C21.2567 12.6641 21.1916 12.6716 21.1315 12.6891C20.8009 12.7718 20.4778 12.887 20.1673 13.0272C19.3333 13.4179 17.0216 14.7803 16.4606 15.4816C16.2828 15.6995 16.2528 16 16.378 16.2505C16.4982 16.4934 16.7361 16.6512 17.0066 16.6687V16.7113V17.0769C17.0066 18.1138 17.8481 18.9553 18.885 18.9553C19.9218 18.9553 20.7633 18.1138 20.7633 17.0769V16.7113C20.7633 16.0226 20.4002 15.3839 19.8091 15.0308C20.5204 14.6276 21.2066 14.2619 21.5998 14.0691C21.9229 13.9288 22.1007 13.5757 22.0181 13.2326Z'
        fill='#422B0D'
      />
      <path
        d='M10.6496 15.3827C10.2939 15.2124 9.86566 15.3627 9.69285 15.7183C9.56011 15.9963 9.62022 16.3294 9.84312 16.5448C10.1988 16.7151 10.627 16.5648 10.7998 16.2092C10.9326 15.9312 10.8725 15.5981 10.6496 15.3827Z'
        fill='#896024'
      />
      <path
        d='M18.7912 15.3827C18.4355 15.2124 18.0073 15.3627 17.8344 15.7183C17.7017 15.9963 17.7618 16.3294 17.9847 16.5448C18.3404 16.7151 18.7686 16.5648 18.9414 16.2092C19.0742 15.9312 19.0141 15.5981 18.7912 15.3827Z'
        fill='#896024'
      />
      <defs>
        <radialGradient
          id='paint0_radial_7343_2058'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(14.5259 14) scale(14.2654)'
        >
          <stop offset='0.12' stopColor='#FAC742' />
          <stop offset='0.32' stopColor='#FAC440' />
          <stop offset='0.48' stopColor='#FBBA3B' />
          <stop offset='0.62' stopColor='#FBA931' />
          <stop offset='0.76' stopColor='#FC9224' />
          <stop offset='0.88' stopColor='#FE7413' />
          <stop offset='1' stopColor='#FF5100' />
        </radialGradient>
      </defs>
    </svg>
  );
};
export const FearIcon = (x, y) => {
  return (
    <svg
      x={x - 20}
      y={y - 4}
      xmlns='http://www.w3.org/2000/svg'
      width='40'
      height='45'
      viewBox='0 0 40 48'
      fill='none'
    >
      <path
        d='M19.2262 33.7024C27.2212 33.7024 33.7024 27.2212 33.7024 19.2262C33.7024 11.2312 27.2212 4.75 19.2262 4.75C11.2312 4.75 4.75 11.2312 4.75 19.2262C4.75 27.2212 11.2312 33.7024 19.2262 33.7024Z'
        fill='url(#paint0_radial_7220_5894)'
      />
      <path
        opacity='0.5'
        d='M19.2262 33.7024C27.2212 33.7024 33.7024 27.2212 33.7024 19.2262C33.7024 11.2312 27.2212 4.75 19.2262 4.75C11.2312 4.75 4.75 11.2312 4.75 19.2262C4.75 27.2212 11.2312 33.7024 19.2262 33.7024Z'
        fill='url(#paint1_radial_7220_5894)'
      />
      <path
        d='M19.2262 33.7024C27.2212 33.7024 33.7024 27.2212 33.7024 19.2262C33.7024 11.2312 27.2212 4.75 19.2262 4.75C11.2312 4.75 4.75 11.2312 4.75 19.2262C4.75 27.2212 11.2312 33.7024 19.2262 33.7024Z'
        fill='url(#paint2_linear_7220_5894)'
      />
      <path
        d='M19.2262 33.7024C27.2212 33.7024 33.7024 27.2212 33.7024 19.2262C33.7024 11.2312 27.2212 4.75 19.2262 4.75C11.2312 4.75 4.75 11.2312 4.75 19.2262C4.75 27.2212 11.2312 33.7024 19.2262 33.7024Z'
        fill='url(#paint3_linear_7220_5894)'
      />
      <path
        opacity='0.24'
        d='M19.2262 33.7024C27.2212 33.7024 33.7024 27.2212 33.7024 19.2262C33.7024 11.2312 27.2212 4.75 19.2262 4.75C11.2312 4.75 4.75 11.2312 4.75 19.2262C4.75 27.2212 11.2312 33.7024 19.2262 33.7024Z'
        fill='url(#paint4_radial_7220_5894)'
      />
      <path
        d='M15.7611 12.0997C15.6706 11.4121 14.9921 11.0592 13.9154 11.204C13.0016 11.3307 11.0925 12.1902 9.99776 14.4973C9.79874 14.9226 10.2149 15.0854 10.4321 14.7959C11.1649 13.8188 13.273 12.4073 15.0735 12.4073C15.8063 12.4073 15.7611 12.0997 15.7611 12.0997Z'
        fill='url(#paint5_linear_7220_5894)'
      />
      <path
        d='M14.5037 19.849C15.2732 19.849 15.897 18.9052 15.897 17.7409C15.897 16.5766 15.2732 15.6328 14.5037 15.6328C13.7342 15.6328 13.1104 16.5766 13.1104 17.7409C13.1104 18.9052 13.7342 19.849 14.5037 19.849Z'
        fill='url(#paint6_radial_7220_5894)'
      />
      <path
        d='M14.5037 16.3459C15.1008 16.3459 15.6256 16.8707 15.897 17.6397C15.8789 16.4997 15.2637 15.5859 14.5037 15.5859C13.7437 15.5859 13.1284 16.4997 13.1104 17.6397C13.3818 16.8616 13.8975 16.3459 14.5037 16.3459Z'
        fill='url(#paint7_linear_7220_5894)'
      />
      <path
        d='M23.949 19.849C24.7185 19.849 25.3423 18.9052 25.3423 17.7409C25.3423 16.5766 24.7185 15.6328 23.949 15.6328C23.1794 15.6328 22.5557 16.5766 22.5557 17.7409C22.5557 18.9052 23.1794 19.849 23.949 19.849Z'
        fill='url(#paint8_radial_7220_5894)'
      />
      <path
        d='M23.949 16.3928C23.3518 16.3928 22.8271 16.9176 22.5557 17.6867C22.5738 16.5467 23.189 15.6328 23.949 15.6328C24.709 15.6328 25.3242 16.5467 25.3423 17.6867C25.0709 16.9176 24.5552 16.3928 23.949 16.3928Z'
        fill='url(#paint9_linear_7220_5894)'
      />
      <path
        d='M22.692 12.0997C22.7824 11.4121 23.461 11.0592 24.5377 11.204C25.4515 11.3307 27.3605 12.1902 28.4553 14.4973C28.6543 14.9226 28.2381 15.0854 28.021 14.7959C27.2881 13.8188 25.18 12.4073 23.3796 12.4073C22.6467 12.4073 22.692 12.0997 22.692 12.0997Z'
        fill='url(#paint10_linear_7220_5894)'
      />
      <path
        d='M16.1047 29.0844C17.5162 28.7044 18.24 28.4511 19.2262 28.4511C20.2123 28.4511 20.9362 28.7044 22.3476 29.0844C23.6595 29.4373 24.4014 28.6954 24.2476 27.6187C23.7319 25.3478 21.5333 23.6016 19.2262 23.6016C16.9823 23.6016 14.8471 25.203 14.25 27.3654C13.9423 28.5778 14.6933 29.4644 16.1047 29.0844Z'
        fill='url(#paint11_radial_7220_5894)'
      />
      <path
        d='M14.2501 27.7092C14.8473 25.963 16.9825 24.6601 19.2263 24.6601C21.5334 24.6601 23.732 26.0716 24.2477 27.9082C24.2477 27.9354 24.2568 27.9625 24.2658 27.9897C24.2749 27.872 24.2658 27.7454 24.2477 27.6187C23.732 25.3478 21.5334 23.6016 19.2263 23.6016C16.9825 23.6016 14.8473 25.203 14.2501 27.3654C14.2049 27.5554 14.1777 27.7363 14.1777 27.9082C14.2049 27.8359 14.232 27.7725 14.2501 27.7092Z'
        fill='url(#paint12_linear_7220_5894)'
      />
      <defs>
        <radialGradient
          id='paint0_radial_7220_5894'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(16.378 13.3625) scale(17.4637)'
        >
          <stop stopColor='#FFE030' />
          <stop offset='1' stopColor='#FFB92E' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_7220_5894'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(16.378 13.3625) scale(13.7394)'
        >
          <stop stopColor='#FFEA5F' />
          <stop offset='1' stopColor='#FFBC47' stopOpacity='0' />
        </radialGradient>
        <linearGradient
          id='paint2_linear_7220_5894'
          x1='19.2262'
          y1='23.0294'
          x2='19.2262'
          y2='4.70086'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_7220_5894'
          x1='19.2262'
          y1='20.8891'
          x2='19.2262'
          y2='0.801658'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0099D6' stopOpacity='0' />
          <stop offset='1' stopColor='#0099D6' />
        </linearGradient>
        <radialGradient
          id='paint4_radial_7220_5894'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(27.5737 9.5522) rotate(37.7901) scale(13.2754 6.66268)'
        >
          <stop stopColor='#3640FF' />
          <stop offset='0.4629' stopColor='#1C66F3' stopOpacity='0.5371' />
          <stop offset='1' stopColor='#008EE6' stopOpacity='0' />
        </radialGradient>
        <linearGradient
          id='paint5_linear_7220_5894'
          x1='11.585'
          y1='3.96613'
          x2='13.2942'
          y2='16.6738'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.00132565' />
          <stop offset='1' stopColor='#0099D6' />
        </linearGradient>
        <radialGradient
          id='paint6_radial_7220_5894'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(14.0806 17.7932) rotate(73.8539) scale(2.04538 1.32333)'
        >
          <stop offset='0.00132565' stopColor='#7A4400' />
          <stop offset='1' stopColor='#643800' />
        </radialGradient>
        <linearGradient
          id='paint7_linear_7220_5894'
          x1='14.5002'
          y1='15.617'
          x2='14.5002'
          y2='17.5816'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.00132565' stopColor='#3C2200' />
          <stop offset='1' stopColor='#512D00' />
        </linearGradient>
        <radialGradient
          id='paint8_radial_7220_5894'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(23.5332 17.7935) rotate(73.854) scale(2.04538 1.32333)'
        >
          <stop offset='0.00132565' stopColor='#7A4400' />
          <stop offset='1' stopColor='#643800' />
        </radialGradient>
        <linearGradient
          id='paint9_linear_7220_5894'
          x1='23.9524'
          y1='15.6703'
          x2='23.9524'
          y2='17.6349'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.00132565' stopColor='#3C2200' />
          <stop offset='1' stopColor='#512D00' />
        </linearGradient>
        <linearGradient
          id='paint10_linear_7220_5894'
          x1='26.7233'
          y1='5.00816'
          x2='25.0141'
          y2='17.7158'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.00132565' />
          <stop offset='1' stopColor='#0099D6' />
        </linearGradient>
        <radialGradient
          id='paint11_radial_7220_5894'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(18.8039 26.4439) scale(3.26004 2.44403)'
        >
          <stop offset='0.00132565' stopColor='#7A4400' />
          <stop offset='1' stopColor='#643800' />
        </radialGradient>
        <linearGradient
          id='paint12_linear_7220_5894'
          x1='14.1814'
          y1='25.8004'
          x2='24.2701'
          y2='25.8004'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.00132565' stopColor='#3C2200' />
          <stop offset='1' stopColor='#512D00' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const SadnessIcon = (x, y) => {
  return (
    <svg
      x={x - 16}
      y={y - 4}
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 35 33'
      fill='none'
    >
      <path
        d='M19.2256 33.7013C27.2203 33.7013 33.7013 27.2203 33.7013 19.2256C33.7013 11.2309 27.2203 4.75 19.2256 4.75C11.2309 4.75 4.75 11.2309 4.75 19.2256C4.75 27.2203 11.2309 33.7013 19.2256 33.7013Z'
        fill='url(#paint0_radial_7220_5908)'
      />
      <path
        opacity='0.5'
        d='M19.2256 33.7013C27.2203 33.7013 33.7013 27.2203 33.7013 19.2256C33.7013 11.2309 27.2203 4.75 19.2256 4.75C11.2309 4.75 4.75 11.2309 4.75 19.2256C4.75 27.2203 11.2309 33.7013 19.2256 33.7013Z'
        fill='url(#paint1_radial_7220_5908)'
      />
      <path
        d='M19.2256 33.7013C27.2203 33.7013 33.7013 27.2203 33.7013 19.2256C33.7013 11.2309 27.2203 4.75 19.2256 4.75C11.2309 4.75 4.75 11.2309 4.75 19.2256C4.75 27.2203 11.2309 33.7013 19.2256 33.7013Z'
        fill='url(#paint2_radial_7220_5908)'
      />
      <path
        d='M10.0459 13.6105C10.08 14.3088 10.7357 14.709 11.8086 14.6494C12.7282 14.5983 14.7037 13.883 15.9724 11.6691C16.2024 11.2604 15.8021 11.0645 15.5637 11.337C14.7633 12.2482 12.5409 13.4913 10.7442 13.3551C10.0289 13.304 10.0459 13.6105 10.0459 13.6105Z'
        fill='url(#paint3_linear_7220_5908)'
      />
      <path
        d='M14.5 19.8393C15.2713 19.8393 15.8965 18.8976 15.8965 17.7361C15.8965 16.5745 15.2713 15.6328 14.5 15.6328C13.7288 15.6328 13.1035 16.5745 13.1035 17.7361C13.1035 18.8976 13.7288 19.8393 14.5 19.8393Z'
        fill='url(#paint4_radial_7220_5908)'
      />
      <path
        d='M14.5 16.3359C15.096 16.3359 15.624 16.8554 15.8965 17.6302C15.8795 16.4892 15.2578 15.5781 14.5 15.5781C13.7422 15.5781 13.1206 16.4977 13.1035 17.6302C13.376 16.8639 13.9039 16.3359 14.5 16.3359Z'
        fill='url(#paint5_linear_7220_5908)'
      />
      <path
        d='M23.9511 19.8393C24.7224 19.8393 25.3476 18.8976 25.3476 17.7361C25.3476 16.5745 24.7224 15.6328 23.9511 15.6328C23.1799 15.6328 22.5547 16.5745 22.5547 17.7361C22.5547 18.8976 23.1799 19.8393 23.9511 19.8393Z'
        fill='url(#paint6_radial_7220_5908)'
      />
      <path
        d='M28.4045 13.6652C28.3704 14.3635 27.7147 14.7637 26.6418 14.7041C25.7222 14.653 23.7467 13.9377 22.478 11.7238C22.2481 11.3151 22.6483 11.1192 22.8867 11.3917C23.6871 12.3028 25.9095 13.546 27.7062 13.4098C28.4215 13.3587 28.4045 13.6652 28.4045 13.6652Z'
        fill='url(#paint7_linear_7220_5908)'
      />
      <path
        d='M23.9511 16.3907C23.3551 16.3907 22.8271 16.9101 22.5547 17.685C22.5717 16.544 23.1933 15.6328 23.9511 15.6328C24.709 15.6328 25.3306 16.5525 25.3476 17.685C25.0751 16.9186 24.5472 16.3907 23.9511 16.3907Z'
        fill='url(#paint8_linear_7220_5908)'
      />
      <path
        d='M19.2258 24.5781C23.4748 24.5781 24.8287 28.7761 23.5344 28.1204C21.7974 27.2348 20.6989 27.1582 19.2258 27.1582C17.7527 27.1582 16.6542 27.2433 14.9172 28.1204C13.6229 28.7761 14.9768 24.5781 19.2258 24.5781Z'
        fill='#643800'
      />
      <path
        d='M19.226 25.3189C21.7295 25.3189 23.3133 26.7324 24.003 27.9075C24.0456 27.056 22.4873 24.5781 19.226 24.5781C15.9648 24.5781 14.4065 27.056 14.4491 27.9075C15.1388 26.741 16.7226 25.3189 19.226 25.3189Z'
        fill='url(#paint9_linear_7220_5908)'
      />
      <path
        d='M13.5373 26.673C14.3973 28.8273 12.8987 30.7857 11.1361 31.1093C9.37345 31.4329 7.44053 30.2578 7.3128 28.0524C7.01479 23.0115 12.8476 19.9375 12.8476 19.9375C12.8476 19.9375 12.3878 23.7693 13.5373 26.673Z'
        fill='url(#paint10_linear_7220_5908)'
      />
      <path
        d='M11.1956 27.0575C10.4974 29.2289 7.25319 29.3651 7.36387 26.8532C7.31281 27.2364 7.29575 27.6365 7.32131 28.0453C7.44904 30.2507 9.38195 31.4343 11.1446 31.1022C12.9072 30.7786 14.4058 28.8201 13.5458 26.6658C12.3878 23.7622 12.8476 19.9219 12.8476 19.9219C10.7529 24.469 11.5363 25.9931 11.1956 27.0575Z'
        fill='url(#paint11_linear_7220_5908)'
      />
      <path
        d='M12.4473 25.4482C13.12 29.1863 8.90504 30.6764 7.38086 28.5562C7.75549 30.4295 9.51812 31.4002 11.136 31.1022C12.8986 30.7786 14.3973 28.8201 13.5372 26.6658C12.3792 23.7622 12.839 19.9219 12.839 19.9219C12.839 19.9219 11.8938 22.3828 12.4473 25.4482Z'
        fill='url(#paint12_linear_7220_5908)'
      />
      <path
        d='M12.6184 27.6962C11.9457 30.5062 8.8547 30.4636 7.52637 29.0671C7.80738 29.8335 8.35234 30.4125 8.99948 30.7616C12.431 31.826 14.0659 28.3007 13.5891 26.7851C13.5721 26.7425 13.5636 26.6999 13.5465 26.6658C13.521 26.6148 13.504 26.5552 13.4869 26.4955C12.414 23.6174 12.8568 19.9219 12.8568 19.9219C11.7498 24.1283 13.4443 24.2561 12.6184 27.6962Z'
        fill='url(#paint13_linear_7220_5908)'
      />
      <path
        d='M13.5373 26.6729C14.3973 28.8272 12.8987 30.7857 11.1361 31.1093C9.37345 31.4328 7.44053 30.2578 7.3128 28.0524C7.01479 23.0115 12.8476 19.9375 12.8476 19.9375C12.8476 19.9375 12.3878 23.7693 13.5373 26.6729Z'
        fill='url(#paint14_radial_7220_5908)'
      />
      <defs>
        <radialGradient
          id='paint0_radial_7220_5908'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(16.3775 13.3591) scale(17.4629)'
        >
          <stop stopColor='#FFDF30' />
          <stop offset='1' stopColor='#FFB82E' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_7220_5908'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(16.3775 13.3591) scale(13.7389)'
        >
          <stop stopColor='#FFE95F' />
          <stop offset='1' stopColor='#FFBB47' stopOpacity='0' />
        </radialGradient>
        <radialGradient
          id='paint2_radial_7220_5908'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(13.2048 26.3132) rotate(72.6921) scale(13.077 7.03361)'
        >
          <stop stopColor='#EA672A' stopOpacity='0.5' />
          <stop offset='0.3462' stopColor='#DB641B' stopOpacity='0.2846' />
          <stop offset='0.8036' stopColor='#C15E00' stopOpacity='0' />
        </radialGradient>
        <linearGradient
          id='paint3_linear_7220_5908'
          x1='13.0355'
          y1='12.2853'
          x2='13.1362'
          y2='14.1124'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.00132565' stopColor='#3C2200' />
          <stop offset='1' stopColor='#7A4400' />
        </linearGradient>
        <radialGradient
          id='paint4_radial_7220_5908'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(14.0769 17.789) rotate(73.8539) scale(2.04529 1.32327)'
        >
          <stop offset='0.00132565' stopColor='#7A4400' />
          <stop offset='1' stopColor='#643800' />
        </radialGradient>
        <linearGradient
          id='paint5_linear_7220_5908'
          x1='14.4998'
          y1='15.6136'
          x2='14.4998'
          y2='17.5781'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.00132565' stopColor='#3C2200' />
          <stop offset='1' stopColor='#512D00' />
        </linearGradient>
        <radialGradient
          id='paint6_radial_7220_5908'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(23.529 17.7893) rotate(73.8539) scale(2.04529 1.32327)'
        >
          <stop offset='0.00132565' stopColor='#7A4400' />
          <stop offset='1' stopColor='#643800' />
        </radialGradient>
        <linearGradient
          id='paint7_linear_7220_5908'
          x1='25.4197'
          y1='12.3381'
          x2='25.3191'
          y2='14.1653'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.00132565' stopColor='#3C2200' />
          <stop offset='1' stopColor='#7A4400' />
        </linearGradient>
        <linearGradient
          id='paint8_linear_7220_5908'
          x1='23.9514'
          y1='15.6689'
          x2='23.9514'
          y2='17.6335'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.00132565' stopColor='#3C2200' />
          <stop offset='1' stopColor='#512D00' />
        </linearGradient>
        <linearGradient
          id='paint9_linear_7220_5908'
          x1='19.2259'
          y1='23.4833'
          x2='19.2259'
          y2='26.8329'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.00132565' stopColor='#3C2200' />
          <stop offset='1' stopColor='#512D00' />
        </linearGradient>
        <linearGradient
          id='paint10_linear_7220_5908'
          x1='5.53568'
          y1='22.8'
          x2='15.2962'
          y2='27.4306'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.0723628' stopColor='#17BAFD' />
          <stop offset='0.2085' stopColor='#D0F1FF' />
          <stop offset='0.668' stopColor='#80D9FD' />
          <stop offset='1' stopColor='#0098D5' />
        </linearGradient>
        <linearGradient
          id='paint11_linear_7220_5908'
          x1='18.3254'
          y1='30.3533'
          x2='4.87126'
          y2='21.2846'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#D0F1FF' />
          <stop offset='0.668' stopColor='#80D9FD' />
          <stop offset='1' stopColor='#0098D5' />
        </linearGradient>
        <linearGradient
          id='paint12_linear_7220_5908'
          x1='6.83214'
          y1='20.6794'
          x2='15.8039'
          y2='31.3029'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.566' stopColor='#80D9FD' />
          <stop offset='1' stopColor='#0098D5' />
        </linearGradient>
        <linearGradient
          id='paint13_linear_7220_5908'
          x1='7.57092'
          y1='21.0828'
          x2='14.7383'
          y2='30.7452'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.566' stopColor='#80D9FD' />
          <stop offset='1' stopColor='#0098D5' />
        </linearGradient>
        <radialGradient
          id='paint14_radial_7220_5908'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(9.87832 25.5994) rotate(-76.6192) scale(4.5458 2.67651)'
        >
          <stop stopColor='white' stopOpacity='0.45' />
          <stop offset='1' stopColor='white' stopOpacity='0' />
        </radialGradient>
      </defs>
    </svg>
  );
};
export const JoyIcon = (x, y) => {
  return (
    <svg
      x={x - 14}
      y={y}
      xmlns='http://www.w3.org/2000/svg'
      width='28'
      height='28'
      viewBox='0 0 31 29'
      fill='none'
    >
      <path
        d='M15.0447 29C7.80769 29 0 24.4606 0 14.5C0 4.53936 7.80769 0 15.0447 0C19.0653 0 22.7746 1.3229 25.5241 3.73524C28.5072 6.38104 30.0894 10.1163 30.0894 14.5C30.0894 18.8837 28.5072 22.593 25.5241 25.2388C22.7694 27.6512 19.0394 29 15.0447 29Z'
        fill='url(#paint0_radial_7220_5948)'
      />
      <path
        d='M10.0585 8.80469C8.97168 8.80469 7.9834 9.72293 7.9834 11.2482C7.9834 12.7734 8.97168 13.689 10.0585 13.689C11.148 13.689 12.1337 12.7708 12.1337 11.2482C12.1337 9.72553 11.1584 8.80469 10.0585 8.80469Z'
        fill='#422B0D'
      />
      <path
        d='M9.96942 9.82269C9.60108 9.64631 9.15752 9.80194 8.97854 10.1703C8.84107 10.4582 8.90332 10.8032 9.13418 11.0263C9.50251 11.2027 9.94607 11.047 10.1251 10.6787C10.2625 10.3908 10.2003 10.0458 9.96942 9.82269Z'
        fill='#896024'
      />
      <path
        d='M20.0204 8.80469C18.9336 8.80469 17.9453 9.72293 17.9453 11.2482C17.9453 12.7734 18.9336 13.689 20.0204 13.689C21.1073 13.689 22.0956 12.7708 22.0956 11.2482C22.0956 9.72553 21.1073 8.80469 20.0204 8.80469Z'
        fill='#422B0D'
      />
      <path
        d='M19.9167 9.82269C19.5483 9.64631 19.1048 9.80194 18.9258 10.1703C18.7883 10.4582 18.8506 10.8032 19.0814 11.0263C19.4498 11.2027 19.8933 11.047 20.0723 10.6787C20.2098 10.3908 20.1475 10.0458 19.9167 9.82269Z'
        fill='#896024'
      />
      <path
        d='M27.5655 5.875C28.9481 8.10577 29.6692 10.7619 29.6692 13.7164C29.6692 18.1001 28.0869 21.8094 25.1039 24.4552C22.3543 26.8676 18.6191 28.2164 14.6244 28.2164C9.93983 28.2164 5.02695 26.3099 2.12695 22.266C4.91801 26.8468 10.1681 28.9946 15.1432 28.9946C19.1379 28.9946 22.8731 27.6457 25.6227 25.2334C28.6057 22.5876 30.188 18.8783 30.188 14.4946C30.188 11.1899 29.2879 8.25362 27.5655 5.875Z'
        fill='#EB8F00'
      />
      <path
        d='M25.1227 16.7621C24.7596 16.1059 23.971 15.818 23.2707 16.0825C20.6093 16.8581 17.8494 17.2446 15.0765 17.2316C12.3036 17.2446 9.54365 16.8581 6.88229 16.0825C6.18453 15.818 5.39598 16.1033 5.03283 16.757C4.68005 17.408 4.93426 18.1629 5.23256 18.8139C6.89785 22.4714 10.5682 24.6606 15.0557 24.6736H15.0972C19.5847 24.6736 23.2551 22.4714 24.923 18.8139C25.2187 18.1577 25.4755 17.4132 25.1227 16.7621Z'
        fill='#422B0D'
      />
      <path
        d='M19.2292 23.6404C19.1332 23.5522 19.0347 23.4718 18.9361 23.381C17.8778 22.4498 16.5082 21.9492 15.0971 21.9777C13.6445 21.9544 12.2308 22.4368 11.0973 23.3447C10.9987 23.4251 10.8949 23.5029 10.799 23.6041C10.703 23.7053 10.6511 23.7779 10.5889 23.8635C12.0155 24.4212 13.5356 24.7065 15.0686 24.6987H15.1101C16.5782 24.6987 18.0334 24.4368 19.4082 23.9206C19.3563 23.822 19.2966 23.7286 19.2292 23.6404Z'
        fill='#ED7770'
      />
      <path
        d='M23.2702 16.0836C20.6089 16.8592 17.849 17.2457 15.0761 17.2327C12.3032 17.2457 9.54323 16.8592 6.88187 16.0836C6.18411 15.8191 5.39555 16.1044 5.03241 16.7581C4.98053 16.8566 4.93903 16.9604 4.91309 17.0667C4.99869 17.1108 5.09725 17.1549 5.21398 17.2016C8.33706 18.7657 11.7896 19.5595 15.281 19.518C18.6297 19.5569 21.9396 18.828 24.9641 17.391C25.086 17.3391 25.1871 17.2898 25.2779 17.2431C25.2572 17.0745 25.2027 16.9085 25.1223 16.7581C24.7591 16.1044 23.9706 15.8165 23.2702 16.0836Z'
        fill='white'
      />
      <path
        d='M25.1331 16.7647C24.7648 16.1085 23.9736 15.818 23.2681 16.0825C20.6067 16.8581 17.8468 17.2446 15.0765 17.2316C12.3036 17.2446 9.54365 16.8581 6.88229 16.0825C6.18453 15.818 5.39598 16.1033 5.03283 16.757C4.68005 17.408 4.93426 18.1629 5.23256 18.8139C5.36485 19.107 5.5127 19.395 5.67612 19.6725C5.67612 19.6725 5.1314 17.6545 5.60349 17.0682C5.76431 16.8192 6.03408 16.6636 6.32979 16.648C6.4517 16.648 6.57102 16.6688 6.68775 16.7051C9.3958 17.5014 12.205 17.9035 15.0298 17.8983H15.1206C17.9453 17.9035 20.7546 17.5014 23.4626 16.7051C23.5793 16.6688 23.6987 16.648 23.8206 16.648C24.1163 16.6636 24.3886 16.8192 24.5495 17.0682C25.0293 17.6545 24.4768 19.6803 24.4768 19.6803C24.6377 19.4028 24.7985 19.1174 24.9334 18.8217C25.2291 18.1706 25.4859 17.4184 25.1331 16.7647Z'
        fill='#EB8F00'
      />
      <defs>
        <radialGradient
          id='paint0_radial_7220_5948'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(15.0447 14.5) scale(14.7749 14.7749)'
        >
          <stop offset='0.5' stopColor='#FDE030' />
          <stop offset='0.92' stopColor='#F7C02B' />
          <stop offset='1' stopColor='#F4A223' />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const SurpriseIcon = (x, y) => {
  return (
    <svg
      x={x - 14}
      y={y}
      xmlns='http://www.w3.org/2000/svg'
      width='28'
      height='28'
      viewBox='0 0 32 30'
      fill='none'
    >
      <path
        d='M15.5635 30C8.07692 30 0 25.3041 0 15C0 4.69589 8.07692 0 15.5635 0C19.7227 0 23.5599 1.36852 26.4043 3.86404C29.4902 6.60107 31.127 10.4651 31.127 15C31.127 19.5349 29.4902 23.3721 26.4043 26.1091C23.5599 28.6047 19.6959 30 15.5635 30Z'
        fill='url(#paint0_radial_7220_5936)'
      />
      <path
        d='M28.4144 6.07812C29.8446 8.38582 30.5906 11.1336 30.5906 14.1899C30.5906 18.7248 28.9537 22.562 25.8679 25.2991C23.0235 27.7946 19.1595 29.1899 15.0271 29.1899C10.1809 29.1899 5.09863 27.2177 2.09863 23.0343C4.98593 27.7731 10.4171 29.9949 15.5637 29.9949C19.6961 29.9949 23.5602 28.5996 26.4045 26.1041C29.4904 23.367 31.1273 19.5298 31.1273 14.9949C31.1273 11.5763 30.1961 8.53877 28.4144 6.07812Z'
        fill='#EB8F00'
      />
      <path
        d='M19.3206 22.9191C19.3206 24.8162 17.783 26.3538 15.8859 26.3538C13.9887 26.3538 12.4512 24.8162 12.4512 22.9191C12.4512 21.022 13.9887 19.4844 15.8859 19.4844C17.7776 19.479 19.3152 21.0059 19.3206 22.8976V22.9191Z'
        fill='#422B0D'
      />
      <path
        d='M9.94747 10.7188C8.82314 10.7188 7.80078 11.6687 7.80078 13.2465C7.80078 14.8243 8.82314 15.7715 9.94747 15.7715C11.0718 15.7715 12.0942 14.8216 12.0942 13.2465C12.0942 11.6713 11.0718 10.7188 9.94747 10.7188Z'
        fill='#422B0D'
      />
      <path
        d='M9.84202 11.7705C9.46098 11.588 9.00213 11.749 8.81697 12.1301C8.67476 12.4279 8.73916 12.7848 8.97798 13.0156C9.35901 13.1981 9.81787 13.0371 10.003 12.656C10.1452 12.3582 10.0808 12.0013 9.84202 11.7705Z'
        fill='#896024'
      />
      <path
        d='M21.5744 10.7188C20.4501 10.7188 19.4277 11.6687 19.4277 13.2465C19.4277 14.8243 20.4501 15.7715 21.5744 15.7715C22.6988 15.7715 23.7211 14.8216 23.7211 13.2465C23.7211 11.6713 22.7041 10.7188 21.5744 10.7188Z'
        fill='#422B0D'
      />
      <path
        d='M21.4748 11.7705C21.0938 11.588 20.6349 11.749 20.4498 12.1301C20.3076 12.4279 20.372 12.7848 20.6108 13.0156C20.9918 13.1981 21.4507 13.0371 21.6358 12.656C21.7781 12.3582 21.7136 12.0013 21.4748 11.7705Z'
        fill='#896024'
      />
      <path
        d='M6.19955 8.32529C6.01172 8.52117 5.69776 8.52922 5.50188 8.3387C5.32477 8.16965 5.30062 7.89327 5.44284 7.6947C5.74606 7.25731 6.11905 6.87627 6.54839 6.56232C7.67272 5.69559 9.08148 5.28504 10.4956 5.41384C11.1638 5.49702 11.0323 6.35033 10.4393 6.40668C8.84535 6.5328 7.34535 7.21169 6.19955 8.32529Z'
        fill='#422B0D'
      />
      <path
        d='M25.27 8.38818C25.4578 8.58406 25.7718 8.59211 25.9676 8.40159C26.1447 8.23254 26.1689 7.95615 26.0267 7.75759C25.7288 7.32556 25.3585 6.94721 24.9345 6.63862C23.8102 5.7719 22.4014 5.36134 20.9873 5.49283C20.3218 5.57601 20.4506 6.42664 21.0437 6.48299C22.6322 6.60911 24.1242 7.28263 25.27 8.38818Z'
        fill='#422B0D'
      />
      <defs>
        <radialGradient
          id='paint0_radial_7220_5936'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(15.5635 15) scale(15.2844 15.2844)'
        >
          <stop offset='0.5' stopColor='#FDE030' />
          <stop offset='0.92' stopColor='#F7C02B' />
          <stop offset='1' stopColor='#F4A223' />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const NeutralIcon = (x, y) => {
  return (
    <svg
      x={x - 14}
      y={y - 1}
      xmlns='http://www.w3.org/2000/svg'
      width='28'
      height='28'
      viewBox='0 0 33 30 '
      fill='none'
    >
      <path
        d='M16.0823 31C8.34615 31 0 26.1476 0 15.5C0 4.85241 8.34615 0 16.0823 0C20.3801 0 24.3453 1.41413 27.2844 3.99284C30.4732 6.82111 32.1646 10.814 32.1646 15.5C32.1646 20.186 30.4732 24.1512 27.2844 26.9794C24.3453 29.5581 20.3524 31 16.0823 31Z'
        fill='url(#paint0_radial_7220_5957)'
      />
      <path
        d='M29.3609 6.28125C30.8388 8.66587 31.6097 11.5052 31.6097 14.6635C31.6097 19.3495 29.9182 23.3146 26.7295 26.1429C23.7903 28.7216 19.7975 30.1635 15.5274 30.1635C10.5197 30.1635 5.26797 28.1254 2.16797 23.8026C5.15151 28.6994 10.7637 30.9953 16.0819 30.9953C20.352 30.9953 24.3449 29.5534 27.2841 26.9747C30.4728 24.1465 32.1642 20.1813 32.1642 15.4953C32.1642 11.9627 31.202 8.82392 29.3609 6.28125Z'
        fill='#EB8F00'
      />
      <path
        d='M23.1255 22.4604H9.26147C8.64868 22.4604 8.15234 21.9641 8.15234 21.3513C8.15234 20.7385 8.64868 20.2422 9.26147 20.2422H23.1255C23.7383 20.2422 24.2346 20.7385 24.2346 21.3513C24.2346 21.9641 23.7383 22.4604 23.1255 22.4604Z'
        fill='#422B0D'
      />
      <path
        d='M10.8325 10.7969C9.6707 10.7969 8.61426 11.7784 8.61426 13.4089C8.61426 15.0393 9.6707 16.0181 10.8325 16.0181C11.9943 16.0181 13.0508 15.0365 13.0508 13.4089C13.0508 11.7812 11.9943 10.7969 10.8325 10.7969Z'
        fill='#422B0D'
      />
      <path
        d='M10.7263 11.8902C10.3326 11.7017 9.85845 11.868 9.66712 12.2618C9.52016 12.5695 9.58671 12.9383 9.83349 13.1768C10.2272 13.3653 10.7014 13.199 10.8927 12.8052C11.0397 12.4975 10.9731 12.1287 10.7263 11.8902Z'
        fill='#896024'
      />
      <path
        d='M21.4614 10.7969C20.2996 10.7969 19.2432 11.7784 19.2432 13.4089C19.2432 15.0393 20.2996 16.0181 21.4614 16.0181C22.6232 16.0181 23.6797 15.0365 23.6797 13.4089C23.6797 11.7812 22.6288 10.7969 21.4614 10.7969Z'
        fill='#422B0D'
      />
      <path
        d='M21.3591 11.8902C20.9654 11.7017 20.4913 11.868 20.2999 12.2618C20.153 12.5695 20.2195 12.9383 20.4663 13.1768C20.86 13.3653 21.3342 13.199 21.5255 12.8052C21.6725 12.4975 21.6059 12.1287 21.3591 11.8902Z'
        fill='#896024'
      />
      <defs>
        <radialGradient
          id='paint0_radial_7220_5957'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(16.0823 15.5) scale(15.7938 15.7938)'
        >
          <stop offset='0.5' stopColor='#FDE030' />
          <stop offset='0.92' stopColor='#F7C02B' />
          <stop offset='1' stopColor='#F4A223' />
        </radialGradient>
      </defs>
      {/* <text x="20" y="20">NeutralIcon</text> */}
    </svg>
  );
};

export const CreateChatterIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='48'
    height='48'
    viewBox='0 0 48 48'
    fill='none'
  >
    <path
      d='M24 14C25.1046 14 26 14.8954 26 16V22H32C33.1046 22 34 22.8954 34 24C34 25.1046 33.1046 26 32 26H26V32C26 33.1046 25.1046 34 24 34C22.8954 34 22 33.1046 22 32V26H16C14.8954 26 14 25.1046 14 24C14 22.8954 14.8954 22 16 22H22V16C22 14.8954 22.8954 14 24 14Z'
      fill='#FC6758'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M2 24C2 11.8497 11.8497 2 24 2C36.1503 2 46 11.8497 46 24C46 36.1503 36.1503 46 24 46C11.8497 46 2 36.1503 2 24ZM24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6Z'
      fill='#FC6758'
    />
  </svg>
);

export const ExportIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
  >
    <path
      d='M16.565 20.096L19.096 17.566V19.635H19.866V16.25H16.48V17.02H18.549L16.019 19.55L16.564 20.096H16.565ZM18 22.116C16.886 22.116 15.9407 21.7277 15.164 20.951C14.3873 20.1743 13.9993 19.229 14 18.115C14 17.0017 14.388 16.0567 15.164 15.28C15.94 14.5033 16.8853 14.115 18 14.115C19.114 14.115 20.0593 14.5033 20.836 15.28C21.6127 16.0567 22.0007 17.0017 22 18.115C22 19.2297 21.612 20.175 20.836 20.951C20.0587 21.727 19.1133 22.116 18 22.116ZM7.5 8.73H16.5V7.73H7.5V8.73ZM11.521 20H5.615C5.16833 20 4.78733 19.8427 4.472 19.528C4.15733 19.2133 4 18.8323 4 18.385V5.615C4 5.16833 4.15733 4.78733 4.472 4.472C4.78667 4.15733 5.16767 4 5.615 4H18.385C18.8317 4 19.2127 4.15733 19.528 4.472C19.8427 4.78667 20 5.16767 20 5.615V11.565C19.6707 11.4603 19.3403 11.3783 19.009 11.319C18.6777 11.2603 18.3413 11.231 18 11.231C17.6627 11.231 17.3347 11.2577 17.016 11.311C16.6973 11.3643 16.384 11.4397 16.076 11.537V11.5H7.5V12.5H14.087C13.5817 12.8473 13.1377 13.255 12.755 13.723C12.3723 14.191 12.0573 14.7063 11.81 15.269H7.5V16.269H11.46C11.388 16.551 11.3317 16.8353 11.291 17.122C11.251 17.4087 11.231 17.7013 11.231 18C11.231 18.3067 11.249 18.643 11.285 19.009C11.3203 19.375 11.399 19.7053 11.521 20Z'
      fill='white'
    />
  </svg>
);

export const cancelButton = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    width='32'
    height='32'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <line x1='18' y1='6' x2='6' y2='18' />
    <line x1='6' y1='6' x2='18' y2='18' />
  </svg>
);

export const PurpleUpArrowIcon = (
  <svg
    width='9'
    height='9'
    viewBox='0 0 9 9'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.5 0.03125C2.036 0.03125 0.03125 2.036 0.03125 4.5C0.03125 6.964 2.036 8.96875 4.5 8.96875C6.964 8.96875 8.96875 6.964 8.96875 4.5C8.96875 2.036 6.964 0.03125 4.5 0.03125ZM4.5 0.71875C6.59241 0.71875 8.28125 2.40759 8.28125 4.5C8.28125 6.59241 6.59241 8.28125 4.5 8.28125C2.40759 8.28125 0.71875 6.59241 0.71875 4.5C0.71875 2.40759 2.40759 0.71875 4.5 0.71875ZM4.5 2.05078L4.2525 2.29828L2.29794 4.25284L2.78125 4.7475L4.15625 3.3725V6.90625H4.84375V3.3725L6.21875 4.7475L6.70206 4.2525L4.74716 2.29794L4.49966 2.05044L4.5 2.05078Z'
      fill='#6640B8'
    />
  </svg>
);

export const Downarrow = (
  <svg
    width='8'
    height='6'
    viewBox='0 0 8 6'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      id='Vector'
      d='M7.66969 2.2341L4.78409 5.61792C4.68102 5.73904 4.55859 5.83513 4.42381 5.90069C4.28903 5.96625 4.14454 6 3.99863 6C3.85271 6 3.70823 5.96625 3.57345 5.90069C3.43867 5.83513 3.31624 5.73904 3.21317 5.61792L0.327568 2.2341C-0.374334 1.41101 0.127024 0 1.1186 0L6.88979 0C7.88137 0 8.37159 1.41101 7.66969 2.2341Z'
      fill='#1E1E1E'
    />
  </svg>
);
export const AistarIcon = (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='white'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.3093 3.1754C5.65814 2.15456 7.06864 2.12365 7.48222 3.08265L7.51722 3.17598L7.98797 4.55265C8.09585 4.86837 8.27019 5.15728 8.49922 5.39989C8.72825 5.64251 9.00665 5.83319 9.31564 5.95906L9.44222 6.00631L10.8189 6.47648C11.8397 6.82531 11.8706 8.23581 10.9122 8.6494L10.8189 8.6844L9.44222 9.15515C9.12639 9.26296 8.83737 9.43726 8.59465 9.6663C8.35193 9.89533 8.16116 10.1738 8.03522 10.4828L7.98797 10.6088L7.5178 11.9861C7.16897 13.0069 5.75847 13.0378 5.34547 12.0794L5.3093 11.9861L4.83914 10.6094C4.73133 10.2936 4.55702 10.0045 4.32799 9.76182C4.09895 9.5191 3.82052 9.32833 3.51147 9.2024L3.38547 9.15515L2.0088 8.68498C0.987387 8.33615 0.95647 6.92565 1.91547 6.51265L2.0088 6.47648L3.38547 6.00631C3.70119 5.89843 3.9901 5.72409 4.23272 5.49506C4.47533 5.26603 4.66601 4.98763 4.79189 4.67865L4.83914 4.55265L5.3093 3.1754ZM11.0802 1.16406C11.1894 1.16406 11.2963 1.19467 11.3889 1.25242C11.4815 1.31017 11.556 1.39273 11.6041 1.49073L11.6321 1.55898L11.8362 2.15748L12.4353 2.36165C12.5447 2.3988 12.6405 2.46759 12.7108 2.55929C12.781 2.65099 12.8224 2.76147 12.8298 2.87674C12.8372 2.99201 12.8102 3.10687 12.7522 3.20677C12.6942 3.30667 12.6079 3.38711 12.5041 3.4379L12.4353 3.4659L11.8368 3.67006L11.6326 4.26915C11.5954 4.37848 11.5266 4.4743 11.4348 4.54447C11.3431 4.61465 11.2326 4.65601 11.1173 4.66332C11.0021 4.67063 10.8872 4.64355 10.7874 4.58553C10.6875 4.52751 10.6071 4.44115 10.5564 4.3374L10.5284 4.26915L10.3242 3.67065L9.72514 3.46648C9.61577 3.42932 9.5199 3.36054 9.44967 3.26884C9.37944 3.17714 9.33802 3.06665 9.33064 2.95138C9.32327 2.83612 9.35028 2.72125 9.40826 2.62135C9.46624 2.52145 9.55256 2.44101 9.6563 2.39023L9.72514 2.36223L10.3236 2.15806L10.5278 1.55898C10.5671 1.44373 10.6416 1.34368 10.7406 1.27285C10.8397 1.20203 10.9584 1.16399 11.0802 1.16406Z'
      fill='#7B7B7B'
    />
  </svg>
);
export const StarIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='15'
    viewBox='0 0 16 15'
    fill='none'
  >
    <path
      d='M14.5097 5.63266L14.5 5.68121V5.6842L14.4817 5.69337L14.4258 5.74782L11.3508 8.74782L11.1619 8.93214L11.2075 9.19212L11.9571 13.4645C11.9824 13.6213 11.892 13.7414 11.7861 13.7807H11.7859H11.7857H11.7854H11.7852H11.785H11.7848H11.7845H11.7843H11.7841H11.7839H11.7836H11.7834H11.7832H11.783H11.7827H11.7825H11.7823H11.7821H11.7818H11.7816H11.7814H11.7812H11.781H11.7807H11.7805H11.7803H11.7801H11.7798H11.7796H11.7794H11.7792H11.779H11.7787H11.7785H11.7783H11.7781H11.7779H11.7776H11.7774H11.7772H11.777H11.7768H11.7765H11.7763H11.7761H11.7759H11.7757H11.7754H11.7752H11.775H11.7748H11.7746H11.7743H11.7741H11.7739H11.7737H11.7735H11.7732H11.773H11.7728H11.7726H11.7724H11.7721H11.7719H11.7717H11.7715H11.7713H11.771H11.7708H11.7706H11.7704H11.7702H11.7699H11.7697H11.7695H11.7693H11.769H11.7688H11.7686H11.7684H11.7682H11.7679H11.7677H11.7675H11.7673H11.767H11.7668H11.7666H11.7664H11.7661H11.7659H11.7657H11.7655H11.7652H11.765H11.7648H11.7646H11.7643H11.7641H11.7639H11.7636H11.7634H11.7632H11.763H11.7627H11.7625H11.7623H11.762H11.7618H11.7616H11.7613H11.7611H11.7609H11.7606H11.7604H11.7602H11.7599H11.7597H11.7595H11.7592H11.759H11.7588H11.7585H11.7583H11.758H11.7578H11.7576H11.7573H11.7571H11.7568H11.7566H11.7564H11.7561H11.7559H11.7556H11.7554H11.7551H11.7549H11.7547H11.7544H11.7542H11.7539H11.7537H11.7534H11.7532H11.7529H11.7527H11.7524H11.7522H11.7519H11.7517H11.7514H11.7511H11.7509H11.7506H11.7504H11.7501H11.7499H11.7496H11.7493H11.7491H11.7488H11.7486H11.7483H11.748H11.7478H11.7475H11.7472H11.747H11.7467H11.7464H11.7462H11.7459H11.7456H11.7454H11.7451H11.7448H11.7445H11.7443H11.744H11.7437H11.7434H11.7431H11.7429H11.7426H11.7423H11.742H11.7417H11.7415H11.7412H11.7409H11.7406H11.7403H11.74H11.7397H11.7394H11.7392H11.7389H11.7386H11.7383H11.738H11.7377H11.7374H11.7371H11.7368H11.7365H11.7362H11.7359H11.7356H11.7353H11.735H11.7347H11.7343H11.734H11.7337H11.7334H11.7331H11.7328H11.7325H11.7322H11.7318H11.7315H11.7312H11.7309H11.7306H11.7302H11.7299H11.7296H11.7293H11.7289H11.7286H11.7283H11.7279H11.7276H11.7273H11.7269H11.7266H11.7263H11.7259H11.7256H11.7252H11.7249H11.7246H11.7242H11.7239H11.7235H11.7232H11.7228H11.7225H11.7221H11.7218H11.7214H11.721H11.7207H11.7203H11.72H11.7196H11.7192H11.7189H11.7185H11.7181H11.7178H11.7174H11.717H11.7167H11.7163H11.7159H11.7155H11.7151H11.7148H11.7144H11.714H11.7136H11.7132H11.7128H11.7124H11.712H11.7117H11.7113H11.7109H11.7105H11.7101H11.7097H11.7093H11.7089H11.7085H11.708H11.7076H11.7072H11.7068H11.7064H11.706H11.7056H11.7052H11.7047H11.7043H11.7039H11.7035H11.703H11.7026H11.7022H11.7017H11.7013H11.7009H11.7004H11.7C11.661 13.7807 11.6317 13.7807 11.6048 13.7798C11.5985 13.7796 11.5929 13.7794 11.5878 13.7791L11.5589 13.7638L7.73394 11.7388L7.5 11.615L7.26606 11.7388L3.44106 13.7638L3.42923 13.7701L3.41775 13.777C3.3546 13.8149 3.29439 13.8189 3.23742 13.8018C3.18076 13.7848 3.11646 13.7425 3.06581 13.6674C3.05638 13.6418 3.05122 13.6029 3.05019 13.4981L3.79248 9.26712L3.83809 9.00714L3.64916 8.82282L0.576852 5.82545C0.473819 5.72097 0.474386 5.58844 0.578553 5.48427L0.635927 5.4269L0.646051 5.40665C0.654163 5.40608 0.663772 5.40572 0.675 5.40572H0.709917L0.744494 5.40086L5.01949 4.80086L5.28462 4.76365L5.40063 4.52236L7.26371 0.647149C7.31468 0.570075 7.37997 0.526864 7.43742 0.509629C7.49439 0.49254 7.5546 0.496573 7.61775 0.534462L7.63422 0.544341L7.65139 0.552929C7.68474 0.569604 7.69684 0.578788 7.69958 0.581131C7.70192 0.58387 7.71111 0.595965 7.72779 0.629322L9.67779 4.52932L9.7953 4.76434L10.0555 4.80086L14.3305 5.40086L14.3651 5.40572H14.3948C14.4001 5.40747 14.4261 5.4176 14.4603 5.46593C14.4814 5.49583 14.497 5.53029 14.5052 5.56346C14.5134 5.59665 14.5122 5.62018 14.5097 5.63266Z'
      fill='#F2A742'
      stroke='#C45500'
    />
  </svg>
);
export const X_ICON_WHITE = (
  <svg
    width='33'
    height='26'
    viewBox='0 0 33 26'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M25.9894 0H31.0496L19.9946 11.0133L33 26H22.8153L14.8395 16.9107L5.71339 26H0.650118L12.4746 14.22L0 0H10.4401L17.6496 8.308L25.9894 0ZM24.2135 23.36H27.0174L8.91809 2.50133H5.90919L24.2135 23.36Z'
      fill='white'
    />
  </svg>
);

export const X_icon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='37'
    height='37'
    viewBox='0 0 37 37'
    fill='none'
  >
    <path
      d='M28.0679 3.46875H33.1678L22.0261 16.2029L35.1334 33.5312H24.869L16.8307 23.0217L7.63312 33.5312H2.53021L14.4473 19.9106L1.875 3.46875H12.3969L19.6628 13.0749L28.0679 3.46875ZM26.278 30.4788H29.1039L10.8629 6.36092H7.83046L26.278 30.4788Z'
      fill='black'
    />
  </svg>
);

export const TwitterLogoX = (
  <svg
    width='22'
    height='22'
    viewBox='0 0 35 31'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M27.066 0.46875H32.1658L21.0242 13.2029L34.1314 30.5312H23.867L15.8288 20.0217L6.63117 30.5312H1.52826L13.4453 16.9106L0.873047 0.46875H11.3949L18.6608 10.0749L27.066 0.46875ZM25.2761 27.4788H28.102L9.86096 3.36092H6.82851L25.2761 27.4788Z'
      fill='white'
    />
  </svg>
);

export const X_LOGO = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 37 37'
    fill='none'
  >
    <path
      d='M28.0679 3.46875H33.1678L22.0261 16.2029L35.1334 33.5312H24.869L16.8307 23.0217L7.63312 33.5312H2.53021L14.4473 19.9106L1.875 3.46875H12.3969L19.6628 13.0749L28.0679 3.46875ZM26.278 30.4788H29.1039L10.8629 6.36092H7.83046L26.278 30.4788Z'
      fill='black'
    />
  </svg>
);

export const HorizontalArrowIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
  >
    <path
      d='M4 18.5V13.346L9.846 12L4 10.654V5.5L19.423 12L4 18.5Z'
      fill='black'
    />
  </svg>
);

export const QuestionIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
  >
    <path
      d='M14 23C14.8284 23 15.5 22.3284 15.5 21.5C15.5 20.6716 14.8284 20 14 20C13.1716 20 12.5 20.6716 12.5 21.5C12.5 22.3284 13.1716 23 14 23Z'
      fill='black'
    />
    <path
      d='M14 0C11.2311 0 8.52431 0.821086 6.22202 2.35943C3.91973 3.89777 2.12532 6.08427 1.06569 8.64243C0.00606596 11.2006 -0.271181 14.0155 0.269012 16.7313C0.809205 19.447 2.14258 21.9416 4.10051 23.8995C6.05845 25.8574 8.55301 27.1908 11.2687 27.731C13.9845 28.2712 16.7994 27.9939 19.3576 26.9343C21.9157 25.8747 24.1022 24.0803 25.6406 21.778C27.1789 19.4757 28 16.7689 28 14C28 10.287 26.525 6.72601 23.8995 4.1005C21.274 1.475 17.713 0 14 0ZM14 26C11.6266 26 9.30655 25.2962 7.33316 23.9776C5.35977 22.6591 3.8217 20.7849 2.91345 18.5922C2.0052 16.3995 1.76756 13.9867 2.23058 11.6589C2.69361 9.33114 3.83649 7.19295 5.51472 5.51472C7.19296 3.83649 9.33115 2.6936 11.6589 2.23058C13.9867 1.76755 16.3995 2.00519 18.5922 2.91345C20.7849 3.8217 22.6591 5.35977 23.9776 7.33316C25.2962 9.30655 26 11.6266 26 14C26 17.1826 24.7357 20.2348 22.4853 22.4853C20.2348 24.7357 17.1826 26 14 26Z'
      fill='black'
    />
    <path
      d='M15 6.00001H13.5C12.9087 5.99869 12.3229 6.11419 11.7764 6.33987C11.2298 6.56555 10.7332 6.89696 10.3151 7.31509C9.89696 7.73322 9.56555 8.22982 9.33987 8.77638C9.11419 9.32294 8.99869 9.90869 9.00001 10.5V11H11V10.5C11 9.83697 11.2634 9.20109 11.7322 8.73224C12.2011 8.2634 12.837 8.00001 13.5 8.00001H15C15.6631 8.00001 16.2989 8.2634 16.7678 8.73224C17.2366 9.20109 17.5 9.83697 17.5 10.5C17.5 11.1631 17.2366 11.7989 16.7678 12.2678C16.2989 12.7366 15.6631 13 15 13H13V17.5H15V15C16.1935 15 17.3381 14.5259 18.182 13.682C19.0259 12.8381 19.5 11.6935 19.5 10.5C19.5 9.30654 19.0259 8.16194 18.182 7.31803C17.3381 6.47412 16.1935 6.00001 15 6.00001Z'
      fill='black'
    />
  </svg>
);

export const SmallQuestionIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='17'
    height='17'
    viewBox='0 0 28 28'
    fill='none'
  >
    <path
      d='M14 23C14.8284 23 15.5 22.3284 15.5 21.5C15.5 20.6716 14.8284 20 14 20C13.1716 20 12.5 20.6716 12.5 21.5C12.5 22.3284 13.1716 23 14 23Z'
      fill='black'
    />
    <path
      d='M14 0C11.2311 0 8.52431 0.821086 6.22202 2.35943C3.91973 3.89777 2.12532 6.08427 1.06569 8.64243C0.00606596 11.2006 -0.271181 14.0155 0.269012 16.7313C0.809205 19.447 2.14258 21.9416 4.10051 23.8995C6.05845 25.8574 8.55301 27.1908 11.2687 27.731C13.9845 28.2712 16.7994 27.9939 19.3576 26.9343C21.9157 25.8747 24.1022 24.0803 25.6406 21.778C27.1789 19.4757 28 16.7689 28 14C28 10.287 26.525 6.72601 23.8995 4.1005C21.274 1.475 17.713 0 14 0ZM14 26C11.6266 26 9.30655 25.2962 7.33316 23.9776C5.35977 22.6591 3.8217 20.7849 2.91345 18.5922C2.0052 16.3995 1.76756 13.9867 2.23058 11.6589C2.69361 9.33114 3.83649 7.19295 5.51472 5.51472C7.19296 3.83649 9.33115 2.6936 11.6589 2.23058C13.9867 1.76755 16.3995 2.00519 18.5922 2.91345C20.7849 3.8217 22.6591 5.35977 23.9776 7.33316C25.2962 9.30655 26 11.6266 26 14C26 17.1826 24.7357 20.2348 22.4853 22.4853C20.2348 24.7357 17.1826 26 14 26Z'
      fill='black'
    />
    <path
      d='M15 6.00001H13.5C12.9087 5.99869 12.3229 6.11419 11.7764 6.33987C11.2298 6.56555 10.7332 6.89696 10.3151 7.31509C9.89696 7.73322 9.56555 8.22982 9.33987 8.77638C9.11419 9.32294 8.99869 9.90869 9.00001 10.5V11H11V10.5C11 9.83697 11.2634 9.20109 11.7322 8.73224C12.2011 8.2634 12.837 8.00001 13.5 8.00001H15C15.6631 8.00001 16.2989 8.2634 16.7678 8.73224C17.2366 9.20109 17.5 9.83697 17.5 10.5C17.5 11.1631 17.2366 11.7989 16.7678 12.2678C16.2989 12.7366 15.6631 13 15 13H13V17.5H15V15C16.1935 15 17.3381 14.5259 18.182 13.682C19.0259 12.8381 19.5 11.6935 19.5 10.5C19.5 9.30654 19.0259 8.16194 18.182 7.31803C17.3381 6.47412 16.1935 6.00001 15 6.00001Z'
      fill='black'
    />
  </svg>
);

export const HelpIcon = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11 17H13V11H11V17ZM12 9C12.2833 9 12.521 8.904 12.713 8.712C12.905 8.52 13.0007 8.28267 13 8C13 7.71667 12.904 7.47933 12.712 7.288C12.52 7.09667 12.2827 7.00067 12 7C11.7167 7 11.4793 7.096 11.288 7.288C11.0967 7.48 11.0007 7.71733 11 8C11 8.28333 11.096 8.521 11.288 8.713C11.48 8.905 11.7173 9.00067 12 9ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6867 5.825 19.9743 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26333 14.6833 2.00067 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31333 6.88333 4.02567 5.825 4.925 4.925C5.825 4.025 6.88333 3.31267 8.1 2.788C9.31667 2.26333 10.6167 2.00067 12 2C13.3833 2 14.6833 2.26267 15.9 2.788C17.1167 3.31333 18.175 4.02567 19.075 4.925C19.975 5.825 20.6877 6.88333 21.213 8.1C21.7383 9.31667 22.0007 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6867 17.1167 19.9743 18.175 19.075 19.075C18.175 19.975 17.1167 20.6877 15.9 21.213C14.6833 21.7383 13.3833 22.0007 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z'
      fill='black'
    />
  </svg>
);

export const emoji_neutral = (
  <svg
    width='36'
    height='34'
    viewBox='0 0 36 34'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M18.0148 33.2944C9.70607 33.2944 0.742188 28.0829 0.742188 16.6472C0.742188 5.21156 9.70607 0 18.0148 0C22.6307 0 26.8893 1.5188 30.046 4.28837C33.4708 7.32596 35.2874 11.6143 35.2874 16.6472C35.2874 21.6801 33.4708 25.9387 30.046 28.9763C26.8893 31.7458 22.6009 33.2944 18.0148 33.2944Z'
      fill='url(#paint0_radial_9280_18576)'
    />
    <path
      d='M32.2759 6.75C33.8632 9.31111 34.6911 12.3606 34.6911 15.7526C34.6911 20.7855 32.8745 25.0441 29.4497 28.0816C26.293 30.8512 22.0046 32.3998 17.4185 32.3998C12.0401 32.3998 6.39975 30.2109 3.07031 25.5682C6.27468 30.8274 12.3022 33.2932 18.0141 33.2932C22.6003 33.2932 26.8886 31.7446 30.0453 28.9751C33.4701 25.9375 35.2867 21.6789 35.2867 16.646C35.2867 12.852 34.2533 9.48086 32.2759 6.75Z'
      fill='#EB8F00'
    />
    <path
      d='M25.5814 24.1246H10.6912C10.0331 24.1246 9.5 23.5915 9.5 22.9334C9.5 22.2753 10.0331 21.7422 10.6912 21.7422H25.5814C26.2395 21.7422 26.7726 22.2753 26.7726 22.9334C26.7726 23.5915 26.2395 24.1246 25.5814 24.1246Z'
      fill='#422B0D'
    />
    <path
      d='M12.3746 11.5938C11.1268 11.5938 9.99219 12.648 9.99219 14.3991C9.99219 16.1501 11.1268 17.2014 12.3746 17.2014C13.6224 17.2014 14.757 16.1472 14.757 14.3991C14.757 12.651 13.6224 11.5938 12.3746 11.5938Z'
      fill='#422B0D'
    />
    <path
      d='M12.2597 12.771C11.8368 12.5685 11.3275 12.7471 11.1221 13.17C10.9642 13.5006 11.0357 13.8967 11.3007 14.1528C11.7236 14.3553 12.2329 14.1766 12.4384 13.7537C12.5962 13.4231 12.5247 13.0271 12.2597 12.771Z'
      fill='#896024'
    />
    <path
      d='M23.7887 11.5938C22.5409 11.5938 21.4062 12.648 21.4062 14.3991C21.4062 16.1501 22.5409 17.2014 23.7887 17.2014C25.0365 17.2014 26.1711 16.1472 26.1711 14.3991C26.1711 12.651 25.0424 11.5938 23.7887 11.5938Z'
      fill='#422B0D'
    />
    <path
      d='M23.6815 12.771C23.2587 12.5685 22.7494 12.7471 22.5439 13.17C22.3861 13.5006 22.4576 13.8967 22.7226 14.1528C23.1455 14.3553 23.6547 14.1766 23.8602 13.7537C24.0181 13.4231 23.9466 13.0271 23.6815 12.771Z'
      fill='#896024'
    />
    <defs>
      <radialGradient
        id='paint0_radial_9280_18576'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(18.0148 16.6472) scale(16.9628)'
      >
        <stop offset='0.5' stop-color='#FDE030' />
        <stop offset='0.92' stop-color='#F7C02B' />
        <stop offset='1' stop-color='#F4A223' />
      </radialGradient>
    </defs>
  </svg>
);

export const emoji_surprise = (
  <svg
    width='35'
    height='34'
    viewBox='0 0 35 34'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17.5279 33.1032C9.48722 33.1032 0.8125 28.0598 0.8125 16.993C0.8125 5.92625 9.48722 0.882812 17.5279 0.882812C21.995 0.882812 26.1162 2.35262 29.1711 5.03285C32.4853 7.97245 34.2433 12.1225 34.2433 16.993C34.2433 21.8635 32.4853 25.9847 29.1711 28.9244C26.1162 31.6046 21.9661 33.1032 17.5279 33.1032Z'
      fill='url(#paint0_radial_9280_18563)'
    />
    <path
      d='M31.3299 7.41406C32.8659 9.89255 33.6671 12.8437 33.6671 16.1262C33.6671 20.9968 31.9091 25.118 28.5949 28.0576C25.54 30.7378 21.39 32.2364 16.9517 32.2364C11.7469 32.2364 6.28845 30.1182 3.06641 25.6252C6.1674 30.7148 12.0005 33.101 17.5281 33.101C21.9663 33.101 26.1164 31.6024 29.1713 28.9222C32.4855 25.9826 34.2435 21.8614 34.2435 16.9908C34.2435 13.3192 33.2435 10.0568 31.3299 7.41406Z'
      fill='#EB8F00'
    />
    <path
      d='M21.5653 25.5014C21.5653 27.539 19.914 29.1904 17.8764 29.1904C15.8389 29.1904 14.1875 27.539 14.1875 25.5014C14.1875 23.4639 15.8389 21.8125 17.8764 21.8125C19.9082 21.8068 21.5596 23.4466 21.5653 25.4784V25.5014Z'
      fill='#422B0D'
    />
    <path
      d='M11.497 12.3984C10.2894 12.3984 9.19141 13.4187 9.19141 15.1133C9.19141 16.8078 10.2894 17.8252 11.497 17.8252C12.7045 17.8252 13.8026 16.805 13.8026 15.1133C13.8026 13.4215 12.7045 12.3984 11.497 12.3984Z'
      fill='#422B0D'
    />
    <path
      d='M11.3844 13.5261C10.9751 13.3301 10.4823 13.503 10.2834 13.9123C10.1307 14.2322 10.1999 14.6155 10.4564 14.8633C10.8656 15.0593 11.3584 14.8864 11.5573 14.4771C11.71 14.1572 11.6409 13.7739 11.3844 13.5261Z'
      fill='#896024'
    />
    <path
      d='M23.9853 12.3984C22.7777 12.3984 21.6797 13.4187 21.6797 15.1133C21.6797 16.8078 22.7777 17.8252 23.9853 17.8252C25.1928 17.8252 26.2908 16.805 26.2908 15.1133C26.2908 13.4215 25.1986 12.3984 23.9853 12.3984Z'
      fill='#422B0D'
    />
    <path
      d='M23.8765 13.5261C23.4673 13.3301 22.9745 13.503 22.7756 13.9123C22.6229 14.2322 22.6921 14.6155 22.9486 14.8633C23.3578 15.0593 23.8506 14.8864 24.0495 14.4771C24.2022 14.1572 24.133 13.7739 23.8765 13.5261Z'
      fill='#896024'
    />
    <path
      d='M7.47039 9.82374C7.26866 10.0341 6.93146 10.0428 6.72108 9.83815C6.53087 9.65659 6.50493 9.35974 6.65768 9.14648C6.98334 8.67672 7.38393 8.26748 7.84505 7.93029C9.05259 6.99941 10.5656 6.55847 12.0844 6.69681C12.802 6.78615 12.6608 7.70261 12.0239 7.76313C10.312 7.89859 8.70099 8.62772 7.47039 9.82374Z'
      fill='#422B0D'
    />
    <path
      d='M27.9539 9.89331C28.1557 10.1037 28.4929 10.1123 28.7033 9.90772C28.8935 9.72616 28.9194 9.42932 28.7667 9.21605C28.4468 8.75205 28.0491 8.3457 27.5937 8.01427C26.3862 7.0834 24.8731 6.64245 23.3543 6.78367C22.6396 6.87301 22.7779 7.7866 23.4149 7.84712C25.121 7.98257 26.7233 8.70594 27.9539 9.89331Z'
      fill='#422B0D'
    />
    <defs>
      <radialGradient
        id='paint0_radial_9280_18563'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(17.5279 16.993) scale(16.4156 16.4156)'
      >
        <stop offset='0.5' stop-color='#FDE030' />
        <stop offset='0.92' stop-color='#F7C02B' />
        <stop offset='1' stop-color='#F4A223' />
      </radialGradient>
    </defs>
  </svg>
);

export const emoji_joy = (
  <svg
    width='33'
    height='32'
    viewBox='0 0 33 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16.1582 31.1464C8.38556 31.1464 0 26.2711 0 15.5732C0 4.87533 8.38556 0 16.1582 0C20.4764 0 24.4602 1.42081 27.4133 4.0117C30.6171 6.85332 32.3165 10.865 32.3165 15.5732C32.3165 20.2814 30.6171 24.2652 27.4133 27.1068C24.4546 29.6977 20.4485 31.1464 16.1582 31.1464Z'
      fill='url(#paint0_radial_9280_18550)'
    />
    <path
      d='M10.8029 9.45312C9.63565 9.45312 8.57422 10.4393 8.57422 12.0774C8.57422 13.7156 9.63565 14.699 10.8029 14.699C11.973 14.699 13.0317 13.7128 13.0317 12.0774C13.0317 10.4421 11.9842 9.45312 10.8029 9.45312Z'
      fill='#422B0D'
    />
    <path
      d='M10.7044 10.5468C10.3088 10.3574 9.83237 10.5245 9.64014 10.9201C9.49249 11.2294 9.55935 11.5999 9.8073 11.8395C10.2029 12.0289 10.6793 11.8618 10.8715 11.4662C11.0192 11.1569 10.9523 10.7864 10.7044 10.5468Z'
      fill='#896024'
    />
    <path
      d='M21.5022 9.45312C20.3349 9.45312 19.2734 10.4393 19.2734 12.0774C19.2734 13.7156 20.3349 14.699 21.5022 14.699C22.6695 14.699 23.7309 13.7128 23.7309 12.0774C23.7309 10.4421 22.6695 9.45312 21.5022 9.45312Z'
      fill='#422B0D'
    />
    <path
      d='M21.3919 10.5468C20.9963 10.3574 20.5199 10.5245 20.3276 10.9201C20.18 11.2294 20.2469 11.5999 20.4948 11.8395C20.8904 12.0289 21.3668 11.8618 21.559 11.4662C21.7067 11.1569 21.6398 10.7864 21.3919 10.5468Z'
      fill='#896024'
    />
    <path
      d='M29.6026 6.3125C31.0875 8.70838 31.862 11.5611 31.862 14.7343C31.862 19.4425 30.1626 23.4263 26.9588 26.2679C24.0057 28.8588 19.994 30.3075 15.7037 30.3075C10.6724 30.3075 5.39589 28.2598 2.28125 23.9166C5.27888 28.8365 10.9175 31.1432 16.2609 31.1432C20.5512 31.1432 24.5629 29.6946 27.5159 27.1037C30.7197 24.2621 32.4191 20.2782 32.4191 15.5701C32.4191 12.0208 31.4524 8.86717 29.6026 6.3125Z'
      fill='#EB8F00'
    />
    <path
      d='M26.9797 17.9994C26.5897 17.2946 25.7428 16.9853 24.9906 17.2695C22.1323 18.1025 19.1681 18.5176 16.19 18.5036C13.2118 18.5176 10.2476 18.1025 7.38929 17.2695C6.63988 16.9853 5.79297 17.2918 5.40294 17.9938C5.02406 18.6931 5.29708 19.5038 5.61746 20.203C7.406 24.1312 11.3481 26.4825 16.1677 26.4964H16.2122C21.0318 26.4964 24.9739 24.1312 26.7652 20.203C27.0828 19.4982 27.3586 18.6987 26.9797 17.9994Z'
      fill='#422B0D'
    />
    <path
      d='M20.6548 25.3886C20.5518 25.2938 20.4459 25.2075 20.34 25.11C19.2034 24.1098 17.7324 23.5722 16.2169 23.6028C14.6568 23.5777 13.1385 24.0959 11.921 25.071C11.8152 25.1573 11.7037 25.2409 11.6007 25.3496C11.4976 25.4582 11.4419 25.5362 11.375 25.6282C12.9072 26.2271 14.5398 26.5336 16.1863 26.5252H16.2308C17.8076 26.5252 19.3705 26.2438 20.8471 25.6894C20.7913 25.5836 20.7273 25.4833 20.6548 25.3886Z'
      fill='#ED7770'
    />
    <path
      d='M24.9893 17.2707C22.1309 18.1037 19.1667 18.5188 16.1886 18.5048C13.2105 18.5188 10.2463 18.1037 7.38794 17.2707C6.63853 16.9865 5.79162 17.293 5.40159 17.995C5.34587 18.1009 5.3013 18.2123 5.27344 18.3265C5.36537 18.3739 5.47124 18.4212 5.5966 18.4714C8.95083 20.1513 12.6589 21.0038 16.4087 20.9592C20.0053 21.001 23.5601 20.2182 26.8085 18.6748C26.9394 18.619 27.048 18.5661 27.1455 18.516C27.1233 18.3349 27.0648 18.1566 26.9784 17.995C26.5884 17.293 25.7415 16.9837 24.9893 17.2707Z'
      fill='white'
    />
    <path
      d='M26.9909 18.0022C26.5953 17.2974 25.7456 16.9853 24.9878 17.2695C22.1295 18.1025 19.1653 18.5176 16.19 18.5036C13.2118 18.5176 10.2476 18.1025 7.38929 17.2695C6.63988 16.9853 5.79297 17.2918 5.40294 17.9938C5.02406 18.6931 5.29708 19.5038 5.61746 20.203C5.75954 20.5179 5.91833 20.8271 6.09385 21.1252C6.09385 21.1252 5.50881 18.9578 6.01584 18.3281C6.18857 18.0607 6.4783 17.8935 6.79589 17.8768C6.92683 17.8768 7.05498 17.8991 7.18035 17.9381C10.0888 18.7934 13.106 19.2252 16.1398 19.2196H16.2373C19.2712 19.2252 22.2883 18.7934 25.1968 17.9381C25.3221 17.8991 25.4503 17.8768 25.5812 17.8768C25.8988 17.8935 26.1913 18.0607 26.3641 18.3281C26.8795 18.9578 26.2861 21.1335 26.2861 21.1335C26.4588 20.8354 26.6315 20.529 26.7764 20.2114C27.094 19.5121 27.3698 18.7042 26.9909 18.0022Z'
      fill='#EB8F00'
    />
    <defs>
      <radialGradient
        id='paint0_radial_9280_18550'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(16.1582 15.5732) scale(15.8684)'
      >
        <stop offset='0.5' stop-color='#FDE030' />
        <stop offset='0.92' stop-color='#F7C02B' />
        <stop offset='1' stop-color='#F4A223' />
      </radialGradient>
    </defs>
  </svg>
);

export const emoji_fear = (
  <svg
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17.8896 32.878C10.3984 32.878 2.31641 28.1792 2.31641 17.8687C2.31641 7.55818 10.3984 2.85938 17.8896 2.85938C22.0514 2.85938 25.891 4.22874 28.7371 6.72582C31.8249 9.46455 33.4628 13.331 33.4628 17.8687C33.4628 22.4064 31.8249 26.246 28.7371 28.9847C25.891 31.4818 22.0245 32.878 17.8896 32.878Z'
      fill='url(#paint0_radial_9280_18617)'
    />
    <path
      d='M30.7462 8.9375C32.1773 11.2466 32.9237 13.9961 32.9237 17.0544C32.9237 21.5921 31.2859 25.4317 28.1981 28.1704C25.3519 30.6675 21.4855 32.0637 17.3505 32.0637C12.5014 32.0637 7.41593 30.0902 4.41406 25.9042C7.30316 30.646 12.7377 32.8692 17.8876 32.8692C22.0225 32.8692 25.889 31.473 28.7351 28.9759C31.8229 26.2372 33.4607 22.3976 33.4607 17.8599C33.4607 14.4391 32.529 11.3997 30.7462 8.9375Z'
      fill='#EB8F00'
    />
    <path
      d='M17.8896 32.878C10.3984 32.878 2.31641 28.1792 2.31641 17.8687C2.31641 7.55818 10.3984 2.85938 17.8896 2.85938C22.0514 2.85938 25.891 4.22874 28.7371 6.72582C31.8249 9.46455 33.4628 13.331 33.4628 17.8687C33.4628 22.4064 31.8249 26.246 28.7371 28.9847C25.891 31.4818 22.0245 32.878 17.8896 32.878Z'
      fill='url(#paint1_linear_9280_18617)'
    />
    <path
      d='M17.8896 32.878C10.3984 32.878 2.31641 28.1792 2.31641 17.8687C2.31641 7.55818 10.3984 2.85938 17.8896 2.85938C22.0514 2.85938 25.891 4.22874 28.7371 6.72582C31.8249 9.46455 33.4628 13.331 33.4628 17.8687C33.4628 22.4064 31.8249 26.246 28.7371 28.9847C25.891 31.4818 22.0245 32.878 17.8896 32.878Z'
      fill='url(#paint2_linear_9280_18617)'
    />
    <path
      d='M30.7462 8.9375C32.1773 11.2466 32.9237 13.9961 32.9237 17.0544C32.9237 21.5921 31.2859 25.4317 28.1981 28.1704C25.3519 30.6675 21.4855 32.0637 17.3505 32.0637C12.5014 32.0637 7.41593 30.0902 4.41406 25.9042C7.30316 30.646 12.7377 32.8692 17.8876 32.8692C22.0225 32.8692 25.889 31.473 28.7351 28.9759C31.8229 26.2372 33.4607 22.3976 33.4607 17.8599C33.4607 14.4391 32.529 11.3997 30.7462 8.9375Z'
      fill='#EB8F00'
    />
    <path
      d='M17.9972 30.4401C16.3809 30.4294 15.0732 29.1218 15.0625 27.5054V24.1222C15.0625 22.5005 16.3755 21.1875 17.9972 21.1875C19.619 21.1875 20.932 22.5005 20.932 24.1222V27.5081C20.9212 29.1245 19.6136 30.4294 17.9972 30.4401Z'
      fill='#422B0D'
    />
    <path
      d='M12.4386 12.2031C12.9864 12.2031 13.5234 12.3615 13.9852 12.6569C15.4996 13.6155 16.1332 15.8789 14.9115 18.2176C14.0684 19.8286 12.8011 20.5724 11.6009 20.5724C11.0532 20.5724 10.5161 20.414 10.0543 20.1186C8.53996 19.16 7.90629 16.8966 9.12798 14.5579C9.97109 12.9469 11.2357 12.2031 12.4386 12.2031Z'
      fill='white'
    />
    <path
      opacity='0.66'
      d='M32.7462 20.577C32.3783 20.3085 32.424 20.0105 31.4037 20.4213C30.9821 20.5931 30.4988 21.5598 30.4988 21.5598C30.4988 21.5598 29.7712 20.1045 28.332 22.0404C25.7168 25.5524 24.5729 25.3913 23.0344 27.0023C22.0436 28.0334 21.1871 29.0161 21.5174 30.9681C21.7026 32.0582 22.2209 32.3563 22.2209 32.3563C22.2209 32.3563 22.5377 32.3563 25.647 30.7453C28.7562 29.1342 31.4708 26.8546 32.9637 23.203'
      fill='url(#paint3_linear_9280_18617)'
    />
    <path
      d='M24.3735 27.7006C25.5415 26.8146 26.6692 26.001 27.2008 25.3002C27.7325 24.5994 28.3044 23.1307 28.6481 22.1694C28.9917 21.2082 29.9906 20.7383 30.5276 21.5599C30.6672 21.7801 30.5571 22.634 30.5276 22.9615C30.8203 22.4755 31.027 21.9412 31.1398 21.3854C31.4083 20.0751 32.7776 19.6509 33.0193 21.4123C33.0193 21.4123 34.0369 21.4525 33.5858 24.6101C33.3603 25.8399 32.9549 27.032 32.3776 28.141C30.9303 30.869 29.7973 32.1336 28.3312 33.1378C26.0382 34.7059 23.866 34.3326 23.1867 33.4412C22.0268 31.9081 22.3382 29.2445 24.3735 27.7006Z'
      fill='url(#paint4_radial_9280_18617)'
    />
    <path
      d='M30.5142 21.5625C30.5142 22.0861 30.0094 23.9092 29.8188 24.3764C29.1609 26.1083 27.9607 26.9138 28.2964 27.1876C28.632 27.4615 29.2737 26.8789 30.2 24.6798C30.4847 23.9307 30.6511 23.144 30.6887 22.3438C30.686 22.0727 30.627 21.8068 30.5142 21.5625Z'
      fill='#ED6C30'
    />
    <path
      d='M32.2821 20.2344C32.6231 20.3821 33.1306 21.354 32.3707 24.0767C31.9008 26.1334 30.3381 27.7337 30.7141 27.9136C31.1571 28.2116 32.1693 26.5335 32.8862 24.2082C33.0742 23.5047 33.1923 22.7852 33.2326 22.0602C33.2434 21.695 33.1198 20.3337 32.2821 20.2344Z'
      fill='#ED6C30'
    />
    <path
      opacity='0.66'
      d='M3.1003 20.577C3.46815 20.3085 3.4225 20.0105 4.44282 20.4213C4.86437 20.5931 5.34767 21.5598 5.34767 21.5598C5.34767 21.5598 6.07532 20.1045 7.51449 22.0404C10.1297 25.5524 11.2735 25.3913 12.8121 27.0023C13.8002 28.0334 14.6567 29.0161 14.3264 30.9681C14.1438 32.0582 13.6256 32.3563 13.6256 32.3563C13.6256 32.3563 13.1101 32.3563 10.6372 31.0943C10.4251 30.9869 10.4439 30.8768 10.1995 30.7479C7.09026 29.1369 4.37569 26.8573 2.88281 23.2057'
      fill='url(#paint5_linear_9280_18617)'
    />
    <path
      d='M11.4839 27.7006C10.3159 26.8146 9.18823 26.001 8.65659 25.3002C8.12496 24.5994 7.55304 23.1307 7.20667 22.1694C6.8603 21.2082 5.86416 20.7383 5.34058 21.5599C5.20095 21.7801 5.31104 22.634 5.34058 22.9615C5.04522 22.4755 4.83311 21.9412 4.71765 21.3854C4.44915 20.0751 3.07978 19.6509 2.83813 21.4123C2.83813 21.4123 1.8205 21.4525 2.27158 24.6101C2.49713 25.8399 2.90257 27.032 3.47985 28.141C4.9244 30.869 6.06016 32.1336 7.52619 33.1378C9.81653 34.7059 11.9887 34.3326 12.6707 33.4412C13.8226 31.9081 13.5192 29.2445 11.4839 27.7006Z'
      fill='url(#paint6_radial_9280_18617)'
    />
    <path
      d='M5.33859 21.5625C5.33859 22.0861 5.84338 23.9092 6.03401 24.3764C6.69185 26.1083 7.88937 26.9138 7.55643 27.1876C7.22348 27.4615 6.57639 26.8789 5.65005 24.6798C5.36544 23.9307 5.20165 23.144 5.16406 22.3438C5.16406 22.0727 5.22313 21.8068 5.33859 21.5625Z'
      fill='#ED6C30'
    />
    <path
      d='M3.56562 20.2344C3.2273 20.3821 2.71983 21.354 3.47969 24.0713C3.94958 26.128 5.51226 27.7283 5.13636 27.9082C4.69333 28.2062 3.68107 26.5281 2.96417 24.2029C2.77622 23.4994 2.65807 22.7798 2.6178 22.0548C2.60706 21.695 2.73057 20.3337 3.56562 20.2344Z'
      fill='#ED6C30'
    />
    <path
      d='M14.9425 18.2345C14.7438 18.9353 14.3759 19.5744 13.8685 20.098C13.3207 20.6645 12.5984 21.0297 11.8198 21.1371C10.9847 21.2418 10.139 21.0243 9.45695 20.5329C8.78569 20.0443 8.28091 19.3569 8.01509 18.5702C7.95333 18.3795 7.90232 18.1835 7.86473 17.9848C7.82982 17.7888 7.80566 17.5901 7.79223 17.3914L7.77344 17.0827L7.78686 16.7873C7.79492 16.5913 7.8164 16.398 7.85399 16.2047C8.00167 15.4636 8.29433 14.7574 8.7132 14.1291C9.11864 13.4874 9.67176 12.9531 10.3242 12.5664C10.9606 12.1825 11.7151 12.0429 12.4481 12.1717V12.2496C11.7688 12.263 11.1082 12.4939 10.5686 12.9074C10.0315 13.3182 9.58852 13.8418 9.269 14.4379C8.93337 15.0232 8.70783 15.6623 8.59774 16.3282C8.49571 16.9941 8.5521 17.6734 8.76421 18.3124C8.96828 18.9514 9.36298 19.5153 9.8973 19.9234C10.4316 20.3396 11.1002 20.5464 11.7768 20.5034C12.4481 20.4551 13.0898 20.1973 13.608 19.7677C14.1316 19.3354 14.5612 18.8038 14.8727 18.1996L14.9425 18.2345Z'
      fill='#EB8F00'
    />
    <path
      d='M23.5834 12.2031C24.7863 12.2031 26.0509 12.9549 26.894 14.5579C28.1211 16.8858 27.4821 19.16 25.9677 20.1186C25.5059 20.4166 24.9689 20.5751 24.4211 20.5751C23.2209 20.5751 21.9536 19.8232 21.1105 18.2203C19.8754 15.8897 20.5225 13.6155 22.0368 12.6569C22.4986 12.3615 23.0356 12.2031 23.5834 12.2031Z'
      fill='white'
    />
    <path
      d='M23.5857 12.1639C24.3187 12.035 25.0732 12.1747 25.7096 12.5586C26.362 12.9453 26.9151 13.4796 27.3206 14.1213C27.7421 14.7577 28.0348 15.4692 28.1798 16.2183C28.2147 16.4116 28.2389 16.605 28.2469 16.801V17.0963V17.3944C28.2308 17.7944 28.1556 18.1918 28.0267 18.5731C27.7609 19.3598 27.2588 20.0445 26.5849 20.5332C25.9029 21.0272 25.0598 21.242 24.2247 21.1373C23.438 21.0326 22.7104 20.6674 22.16 20.0982C21.6525 19.5773 21.2819 18.9383 21.0859 18.2375L21.1557 18.1999C21.4645 18.8013 21.8914 19.3356 22.4123 19.7706C22.9332 20.2029 23.575 20.4607 24.2489 20.509C24.9255 20.552 25.5941 20.3452 26.1284 19.929C26.6601 19.5182 27.0548 18.9571 27.2588 18.318C27.4709 17.679 27.5273 16.9997 27.4253 16.3338C27.3206 15.6679 27.0977 15.0235 26.7648 14.4355C26.4453 13.8394 26.0022 13.3158 25.4652 12.905C24.9255 12.4915 24.265 12.2606 23.5857 12.2472V12.1639Z'
      fill='#EB8F00'
    />
    <defs>
      <radialGradient
        id='paint0_radial_9280_18617'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(17.8896 17.8687) scale(15.2939)'
      >
        <stop offset='0.5' stop-color='#FDE030' />
        <stop offset='0.92' stop-color='#F7C02B' />
        <stop offset='1' stop-color='#F4A223' />
      </radialGradient>
      <linearGradient
        id='paint1_linear_9280_18617'
        x1='17.8896'
        y1='32.878'
        x2='17.8896'
        y2='2.85938'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0.39' stop-color='#40C0E7' stop-opacity='0' />
        <stop offset='1' stop-color='#5F7AFF' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_9280_18617'
        x1='17.8896'
        y1='32.878'
        x2='17.8896'
        y2='2.85938'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0.16' stop-color='#F4A223' />
        <stop offset='0.33' stop-color='#F7C02B' />
        <stop offset='0.81' stop-color='#FDE030' stop-opacity='0' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_9280_18617'
        x1='27.2045'
        y1='35.2964'
        x2='27.2045'
        y2='21.9518'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#ED6C30' />
        <stop offset='1' stop-color='#ED6C30' stop-opacity='0.2' />
      </linearGradient>
      <radialGradient
        id='paint4_radial_9280_18617'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(25.3832 26.2943) rotate(141.52) scale(12.0016 11.0611)'
      >
        <stop offset='0.27' stop-color='#FFF176' />
        <stop offset='1' stop-color='#FFC400' />
      </radialGradient>
      <linearGradient
        id='paint5_linear_9280_18617'
        x1='8.64065'
        y1='35.2964'
        x2='8.64065'
        y2='21.9518'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#ED6C30' />
        <stop offset='1' stop-color='#ED6C30' stop-opacity='0.2' />
      </linearGradient>
      <radialGradient
        id='paint6_radial_9280_18617'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(10.4607 26.274) rotate(38.4802) scale(12.0016 11.0611)'
      >
        <stop offset='0.27' stop-color='#FFF176' />
        <stop offset='1' stop-color='#FFC400' />
      </radialGradient>
    </defs>
  </svg>
);

export const emoji_sadness = (
  <svg
    width='34'
    height='32'
    viewBox='0 0 34 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16.9968 31.0535C9.24729 31.0535 0.886719 26.1927 0.886719 15.5268C0.886719 4.8608 9.24729 0 16.9968 0C21.3021 0 25.274 1.41657 28.2183 3.99974C31.4125 6.83289 33.1069 10.8326 33.1069 15.5268C33.1069 20.2209 31.4125 24.1929 28.2183 27.026C25.274 29.6092 21.2743 31.0535 16.9968 31.0535Z'
      fill='url(#paint0_radial_9280_18884)'
    />
    <path
      d='M30.2985 6.29688C31.779 8.68561 32.5511 11.5299 32.5511 14.6936C32.5511 19.3877 30.8568 23.3597 27.6626 26.1928C24.7183 28.776 20.7186 30.2203 16.4411 30.2203C11.4247 30.2203 6.16395 28.1788 3.05859 23.8485C6.04729 28.7538 11.6691 31.0536 16.9966 31.0536C21.2741 31.0536 25.2738 29.6093 28.2181 27.0261C31.4123 24.1929 33.1066 20.221 33.1066 15.5268C33.1066 11.9882 32.1428 8.84393 30.2985 6.29688Z'
      fill='#EB8F00'
    />
    <path
      d='M8.8765 24.9244C10.6542 21.8385 14.3984 20.5691 17.1065 20.5691C19.8147 20.5691 23.5589 21.8385 25.3365 24.9244C25.5865 25.3633 26.3004 25.1716 26.2198 24.6716C25.5365 20.5052 20.9424 18.1582 17.1065 18.0054C13.0512 17.8582 8.79317 20.7386 7.99322 24.6716C7.89601 25.1633 8.62652 25.3633 8.8765 24.9244Z'
      fill='#422B0D'
    />
    <path
      d='M11.5502 9.42188C10.3864 9.42188 9.32812 10.4051 9.32812 12.0384C9.32812 13.6716 10.3864 14.6521 11.5502 14.6521C12.7168 14.6521 13.7723 13.6688 13.7723 12.0384C13.7723 10.4079 12.7279 9.42188 11.5502 9.42188Z'
      fill='#422B0D'
    />
    <path
      d='M11.4549 10.5232C11.0604 10.3343 10.5855 10.5009 10.3938 10.8954C10.2466 11.2037 10.3133 11.5731 10.5605 11.812C10.9549 12.0008 11.4299 11.8342 11.6215 11.4398C11.7687 11.1314 11.7021 10.762 11.4549 10.5232Z'
      fill='#896024'
    />
    <path
      d='M22.2182 9.42188C21.0544 9.42188 19.9961 10.4051 19.9961 12.0384C19.9961 13.6716 21.0544 14.6521 22.2182 14.6521C23.382 14.6521 24.4403 13.6688 24.4403 12.0384C24.4403 10.4079 23.382 9.42188 22.2182 9.42188Z'
      fill='#422B0D'
    />
    <path
      d='M22.1072 10.5232C21.7128 10.3343 21.2378 10.5009 21.0462 10.8954C20.899 11.2037 20.9656 11.5731 21.2128 11.812C21.6072 12.0008 22.0822 11.8342 22.2739 11.4398C22.4211 11.1314 22.3544 10.762 22.1072 10.5232Z'
      fill='#896024'
    />
    <defs>
      <radialGradient
        id='paint0_radial_9280_18884'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(16.9968 15.5268) scale(15.8211 15.8211)'
      >
        <stop offset='0.5' stop-color='#FDE030' />
        <stop offset='0.92' stop-color='#F7C02B' />
        <stop offset='1' stop-color='#F4A223' />
      </radialGradient>
    </defs>
  </svg>
);

export const emoji_anger = (
  <svg
    width='33'
    height='31'
    viewBox='0 0 33 31'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16.562 30.7911C9.05734 30.7911 0.960938 26.0839 0.960938 15.7549C0.960938 5.42596 9.05734 0.71875 16.562 0.71875C20.7312 0.71875 24.5777 2.09057 27.4289 4.59211C30.5222 7.33575 32.163 11.2091 32.163 15.7549C32.163 20.3008 30.5222 24.1472 27.4289 26.8909C24.5777 29.3924 20.7043 30.7911 16.562 30.7911Z'
      fill='url(#paint0_radial_9869_2517)'
    ></path>
    <path
      d='M29.4437 6.8125C30.8774 9.12576 31.6251 11.8802 31.6251 14.9439C31.6251 19.4897 29.9843 23.3362 26.891 26.0798C24.0398 28.5813 20.1664 29.9801 16.0241 29.9801C11.1662 29.9801 6.07169 28.003 3.06445 23.8096C5.95872 28.5598 11.4029 30.787 16.5621 30.787C20.7044 30.787 24.5778 29.3883 27.429 26.8867C30.5223 24.1431 32.1631 20.2967 32.1631 15.7508C32.1631 12.324 31.2297 9.27908 29.4437 6.8125Z'
      fill='#D84213'
    ></path>
    <path
      d='M22.0311 26.5836C21.9396 26.5486 21.8563 26.4921 21.7917 26.4168C19.1745 23.6974 14.8465 23.614 12.1271 26.2312C12.0653 26.2931 12.0007 26.3549 11.9415 26.4168C11.877 26.4921 11.7936 26.5486 11.7021 26.5836C11.5004 26.6589 11.2718 26.6159 11.1104 26.4733C10.9517 26.3334 10.8979 26.1102 10.9786 25.9138C11.7801 23.8561 14.1633 22.2422 16.8666 22.2422C19.5699 22.2422 21.9531 23.8561 22.7547 25.9111C22.8354 26.1075 22.7816 26.3307 22.6229 26.4706C22.4615 26.6132 22.2328 26.6562 22.0311 26.5836Z'
      fill='#422B0D'
    ></path>
    <path
      d='M15.0921 17.3493C14.4896 16.5908 12.0069 15.1329 11.1112 14.7079C10.7776 14.5546 10.4306 14.4309 10.0756 14.3394C10.011 14.3206 9.94108 14.3125 9.87384 14.3125C9.51609 14.3206 9.20945 14.5761 9.13682 14.9285C9.05344 15.2943 9.24173 15.6709 9.58602 15.8215C10.0083 16.0286 10.7453 16.4213 11.5093 16.8544C10.8718 17.2337 10.4817 17.9223 10.4817 18.6647V19.0574C10.4817 20.171 11.3855 21.0747 12.4991 21.0747C13.6127 21.0747 14.5165 20.171 14.5165 19.0574V18.6647C14.5165 18.6485 14.5165 18.6351 14.5165 18.6189C14.8043 18.6001 15.0625 18.428 15.189 18.1697C15.3208 17.9007 15.2831 17.5807 15.0921 17.3493Z'
      fill='#422B0D'
    ></path>
    <path
      d='M24.6081 14.9309C24.5328 14.5758 24.2208 14.323 23.8577 14.3203C23.7904 14.3203 23.7205 14.3284 23.6559 14.3472C23.3009 14.436 22.9539 14.5597 22.6204 14.7103C21.7246 15.13 19.2419 16.5932 18.6394 17.3464C18.4484 17.5804 18.4161 17.9032 18.5506 18.1722C18.6797 18.4331 18.9353 18.6025 19.2258 18.6214V18.6671V19.0598C19.2258 20.1734 20.1296 21.0772 21.2432 21.0772C22.3568 21.0772 23.2605 20.1734 23.2605 19.0598V18.6671C23.2605 17.9274 22.8705 17.2415 22.2357 16.8622C22.9996 16.4291 23.7366 16.0364 24.1589 15.8293C24.5059 15.6787 24.6969 15.2994 24.6081 14.9309Z'
      fill='#422B0D'
    ></path>
    <path
      d='M12.3994 17.2394C12.0174 17.0565 11.5574 17.2179 11.3718 17.5999C11.2293 17.8985 11.2938 18.2562 11.5332 18.4875C11.9152 18.6704 12.3752 18.509 12.5607 18.1271C12.7033 17.8285 12.6388 17.4708 12.3994 17.2394Z'
      fill='#896024'
    ></path>
    <path
      d='M21.1415 17.2394C20.7596 17.0565 20.2996 17.2179 20.114 17.5999C19.9715 17.8985 20.036 18.2562 20.2754 18.4875C20.6574 18.6704 21.1173 18.509 21.3029 18.1271C21.4455 17.8285 21.3809 17.4708 21.1415 17.2394Z'
      fill='#896024'
    ></path>
    <defs>
      <radialGradient
        id='paint0_radial_9869_2517'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(16.562 15.7549) scale(15.3212)'
      >
        <stop offset='0.12' stop-color='#FAC742'></stop>
        <stop offset='0.32' stop-color='#FAC440'></stop>
        <stop offset='0.48' stop-color='#FBBA3B'></stop>
        <stop offset='0.62' stop-color='#FBA931'></stop>
        <stop offset='0.76' stop-color='#FC9224'></stop>
        <stop offset='0.88' stop-color='#FE7413'></stop>
        <stop offset='1' stop-color='#FF5100'></stop>
      </radialGradient>
    </defs>
  </svg>
);

export const emoji_disgust = (
  <svg
    width='32'
    height='31'
    viewBox='0 0 32 31'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='15.6237' cy='14.9554' r='13.3617' fill='#5B3300'></circle>
    <path
      d='M16.0336 0.492188C7.89829 0.492188 1.30493 7.08555 1.30493 15.2208C1.30493 23.3561 7.89829 29.9494 16.0336 29.9494C24.1688 29.9494 30.7622 23.3561 30.7622 15.2208C30.7622 7.08555 24.1688 0.492188 16.0336 0.492188ZM9.34814 15.6466C7.85227 15.6466 6.64406 14.4384 6.64406 12.9425C6.64406 12.6663 6.69009 12.4132 6.75913 12.16L4.98709 12.0219L5.11366 10.411L12.4089 10.9748L13.7667 8.62745L15.159 9.43292L13.295 12.6548L12.0292 12.5628C12.0522 12.6893 12.0522 12.8159 12.0522 12.9425C12.0522 14.4268 10.844 15.6466 9.34814 15.6466ZM23.0297 22.8153C23.0297 22.8153 21.8445 22.1249 18.7146 22.5161C16.2062 22.8153 12.0522 24.3341 12.0522 24.3341C12.0522 24.3341 14.7333 19.5013 19.1059 19.0756C23.4094 18.6383 23.0297 22.8153 23.0297 22.8153ZM25.4231 12.9425C25.4231 13.7364 25.0894 14.4384 24.5485 14.9331C23.674 14.7375 22.5694 14.6685 21.1656 14.772C21.039 14.7836 20.9124 14.7951 20.7743 14.8066C20.3026 14.3233 20.0149 13.6559 20.0149 12.931C20.0149 12.8044 20.0264 12.6778 20.0379 12.5512L18.7722 12.6433L16.9081 9.42142L18.3004 8.61594L19.6582 10.9633L26.9535 10.3995L27.08 12.0104L25.308 12.1485C25.3885 12.4017 25.4231 12.6663 25.4231 12.9425Z'
      fill='url(#paint0_radial_9869_2474)'
    ></path>
    <path
      opacity='0.5'
      d='M15.9993 30.2989C24.3036 30.2989 31.0355 23.567 31.0355 15.2627C31.0355 6.95848 24.3036 0.226562 15.9993 0.226562C7.69505 0.226562 0.963135 6.95848 0.963135 15.2627C0.963135 23.567 7.69505 30.2989 15.9993 30.2989Z'
      fill='url(#paint1_radial_9869_2474)'
    ></path>
    <defs>
      <radialGradient
        id='paint0_radial_9869_2474'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(16.0335 12.19) rotate(60.5239) scale(240.433)'
      >
        <stop stop-color='#FED63C'></stop>
        <stop offset='1' stop-color='#FFBB47' stop-opacity='0'></stop>
      </radialGradient>
      <radialGradient
        id='paint1_radial_9869_2474'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(13.0409 9.16908) scale(14.2709)'
      >
        <stop stop-color='#FFE95F'></stop>
        <stop offset='1' stop-color='#FFBB47' stop-opacity='0'></stop>
      </radialGradient>
    </defs>
  </svg>
);

export const ResetIcon = (
  <svg
    width='26'
    height='26'
    viewBox='0 0 26 26'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14.625 22.75C16.5534 22.75 18.4384 22.1782 20.0418 21.1068C21.6452 20.0355 22.8949 18.5127 23.6328 16.7312C24.3708 14.9496 24.5639 12.9892 24.1877 11.0979C23.8114 9.20656 22.8829 7.46927 21.5193 6.10571C20.1557 4.74215 18.4184 3.81355 16.5271 3.43735C14.6358 3.06114 12.6754 3.25422 10.8938 3.99218C9.11226 4.73013 7.58952 5.97982 6.51817 7.58319C5.44683 9.18657 4.875 11.0716 4.875 13V18.0375L1.95 15.1125L0.8125 16.25L5.6875 21.125L10.5625 16.25L9.425 15.1125L6.5 18.0375V13C6.5 11.393 6.97652 9.82215 7.86931 8.486C8.7621 7.14985 10.031 6.10845 11.5157 5.49348C13.0003 4.87852 14.634 4.71762 16.2101 5.03112C17.7862 5.34463 19.2339 6.11846 20.3702 7.25476C21.5065 8.39106 22.2804 9.8388 22.5939 11.4149C22.9074 12.991 22.7465 14.6247 22.1315 16.1093C21.5166 17.594 20.4752 18.8629 19.139 19.7557C17.8029 20.6485 16.232 21.125 14.625 21.125V22.75Z'
      fill='white'
    />
  </svg>
);

export const FIlterIcon = (
  <svg
    width='23'
    height='23'
    viewBox='0 0 23 23'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.9994 21.5H9.99942C9.80131 21.4974 9.61205 21.4176 9.47195 21.2775C9.33186 21.1374 9.25201 20.9481 9.24942 20.75V13L3.89942 5.69C3.81486 5.58007 3.76337 5.44832 3.75097 5.31018C3.73857 5.17204 3.76578 5.03323 3.82942 4.91C3.89317 4.78712 3.98926 4.68399 4.10734 4.61173C4.22542 4.53947 4.36099 4.50084 4.49942 4.5H19.4994C19.6378 4.50084 19.7734 4.53947 19.8915 4.61173C20.0096 4.68399 20.1057 4.78712 20.1694 4.91C20.233 5.03323 20.2603 5.17204 20.2479 5.31018C20.2355 5.44832 20.184 5.58007 20.0994 5.69L14.7494 13V20.75C14.7468 20.9481 14.667 21.1374 14.5269 21.2775C14.3868 21.4176 14.1975 21.4974 13.9994 21.5ZM10.7494 20H13.2494V12.75C13.2486 12.5907 13.3015 12.4357 13.3994 12.31L17.9994 6H5.99942L10.6194 12.31C10.7174 12.4357 10.7702 12.5907 10.7694 12.75L10.7494 20Z'
      fill='white'
    />
  </svg>
);

export const ShareIcon = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M18 22C17.1667 22 16.4583 21.7083 15.875 21.125C15.2917 20.5417 15 19.8333 15 19C15 18.8833 15.0083 18.7623 15.025 18.637C15.0417 18.5117 15.0667 18.3993 15.1 18.3L8.05 14.2C7.76667 14.45 7.45 14.646 7.1 14.788C6.75 14.93 6.38333 15.0007 6 15C5.16667 15 4.45833 14.7083 3.875 14.125C3.29167 13.5417 3 12.8333 3 12C3 11.1667 3.29167 10.4583 3.875 9.875C4.45833 9.29167 5.16667 9 6 9C6.38333 9 6.75 9.071 7.1 9.213C7.45 9.355 7.76667 9.55067 8.05 9.8L15.1 5.7C15.0667 5.6 15.0417 5.48767 15.025 5.363C15.0083 5.23833 15 5.11733 15 5C15 4.16667 15.2917 3.45833 15.875 2.875C16.4583 2.29167 17.1667 2 18 2C18.8333 2 19.5417 2.29167 20.125 2.875C20.7083 3.45833 21 4.16667 21 5C21 5.83333 20.7083 6.54167 20.125 7.125C19.5417 7.70833 18.8333 8 18 8C17.6167 8 17.25 7.92933 16.9 7.788C16.55 7.64667 16.2333 7.45067 15.95 7.2L8.9 11.3C8.93333 11.4 8.95833 11.5127 8.975 11.638C8.99167 11.7633 9 11.884 9 12C9 12.1167 8.99167 12.2377 8.975 12.363C8.95833 12.4883 8.93333 12.6007 8.9 12.7L15.95 16.8C16.2333 16.55 16.55 16.3543 16.9 16.213C17.25 16.0717 17.6167 16.0007 18 16C18.8333 16 19.5417 16.2917 20.125 16.875C20.7083 17.4583 21 18.1667 21 19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22ZM18 6C18.2833 6 18.521 5.90433 18.713 5.713C18.905 5.52167 19.0007 5.284 19 5C19 4.71667 18.904 4.47933 18.712 4.288C18.52 4.09667 18.2827 4.00067 18 4C17.7167 4 17.4793 4.096 17.288 4.288C17.0967 4.48 17.0007 4.71733 17 5C17 5.28333 17.096 5.521 17.288 5.713C17.48 5.905 17.7173 6.00067 18 6ZM6 13C6.28333 13 6.521 12.904 6.713 12.712C6.905 12.52 7.00067 12.2827 7 12C7 11.7167 6.904 11.4793 6.712 11.288C6.52 11.0967 6.28267 11.0007 6 11C5.71667 11 5.47933 11.096 5.288 11.288C5.09667 11.48 5.00067 11.7173 5 12C5 12.2833 5.096 12.521 5.288 12.713C5.48 12.905 5.71733 13.0007 6 13ZM18 20C18.2833 20 18.521 19.904 18.713 19.712C18.905 19.52 19.0007 19.2827 19 19C19 18.7167 18.904 18.4793 18.712 18.288C18.52 18.0967 18.2827 18.0007 18 18C17.7167 18 17.4793 18.096 17.288 18.288C17.0967 18.48 17.0007 18.7173 17 19C17 19.2833 17.096 19.521 17.288 19.713C17.48 19.905 17.7173 20.0007 18 20Z'
      fill='white'
    />
  </svg>
);
export const filter_icon_vector = (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20 16.605C20 16.8039 19.921 16.9947 19.7803 17.1353C19.6397 17.276 19.4489 17.355 19.25 17.355H14.15C13.983 17.9779 13.6151 18.5282 13.1034 18.9208C12.5918 19.3133 11.9649 19.526 11.32 19.526C10.6751 19.526 10.0482 19.3133 9.53658 18.9208C9.02491 18.5282 8.65704 17.9779 8.49 17.355H0.75C0.551088 17.355 0.360322 17.276 0.21967 17.1353C0.0790175 16.9947 0 16.8039 0 16.605C0 16.4061 0.0790175 16.2153 0.21967 16.0747C0.360322 15.934 0.551088 15.855 0.75 15.855H8.49C8.65704 15.2321 9.02491 14.6817 9.53658 14.2892C10.0482 13.8967 10.6751 13.6839 11.32 13.6839C11.9649 13.6839 12.5918 13.8967 13.1034 14.2892C13.6151 14.6817 13.983 15.2321 14.15 15.855H19.25C19.4489 15.855 19.6397 15.934 19.7803 16.0747C19.921 16.2153 20 16.4061 20 16.605ZM20 3.39499C20 3.5939 19.921 3.78467 19.7803 3.92532C19.6397 4.06597 19.4489 4.14499 19.25 4.14499H16.8C16.633 4.76787 16.2651 5.31823 15.7534 5.71076C15.2418 6.10329 14.6149 6.31604 13.97 6.31604C13.3251 6.31604 12.6982 6.10329 12.1866 5.71076C11.6749 5.31823 11.307 4.76787 11.14 4.14499H0.75C0.651509 4.14499 0.553982 4.12559 0.462987 4.0879C0.371993 4.05021 0.289314 3.99497 0.21967 3.92532C0.150026 3.85568 0.0947813 3.773 0.0570903 3.682C0.0193993 3.59101 0 3.49348 0 3.39499C0 3.2965 0.0193993 3.19897 0.0570903 3.10798C0.0947813 3.01698 0.150026 2.93431 0.21967 2.86466C0.289314 2.79502 0.371993 2.73977 0.462987 2.70208C0.553982 2.66439 0.651509 2.64499 0.75 2.64499H11.14C11.307 2.02212 11.6749 1.47175 12.1866 1.07922C12.6982 0.686695 13.3251 0.473938 13.97 0.473938C14.6149 0.473938 15.2418 0.686695 15.7534 1.07922C16.2651 1.47175 16.633 2.02212 16.8 2.64499H19.25C19.3489 2.64365 19.447 2.66213 19.5386 2.69934C19.6302 2.73656 19.7134 2.79175 19.7833 2.86166C19.8532 2.93158 19.9084 3.01479 19.9457 3.10639C19.9829 3.198 20.0013 3.29613 20 3.39499ZM20 9.99499C20.0013 10.0939 19.9829 10.192 19.9457 10.2836C19.9084 10.3752 19.8532 10.4584 19.7833 10.5283C19.7134 10.5982 19.6302 10.6534 19.5386 10.6906C19.447 10.7279 19.3489 10.7463 19.25 10.745H7.55C7.38296 11.3679 7.01509 11.9182 6.50342 12.3108C5.99176 12.7033 5.36489 12.916 4.72 12.916C4.07511 12.916 3.44824 12.7033 2.93658 12.3108C2.42491 11.9182 2.05704 11.3679 1.89 10.745H0.75C0.551088 10.745 0.360322 10.666 0.21967 10.5253C0.0790175 10.3847 0 10.1939 0 9.99499C0 9.79608 0.0790175 9.60531 0.21967 9.46466C0.360322 9.32401 0.551088 9.24499 0.75 9.24499H1.89C2.05704 8.62212 2.42491 8.07175 2.93658 7.67922C3.44824 7.28669 4.07511 7.07394 4.72 7.07394C5.36489 7.07394 5.99176 7.28669 6.50342 7.67922C7.01509 8.07175 7.38296 8.62212 7.55 9.24499H19.25C19.4489 9.24499 19.6397 9.32401 19.7803 9.46466C19.921 9.60531 20 9.79608 20 9.99499Z'
      fill='#2A886B'
    />
  </svg>
);
export const filter_icon = (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.0014 17.5H7.00137C6.80326 17.4974 6.614 17.4176 6.4739 17.2775C6.33381 17.1374 6.25396 16.9481 6.25137 16.75V9L0.90137 1.69C0.816811 1.58007 0.765319 1.44832 0.752922 1.31018C0.740525 1.17204 0.767736 1.03323 0.83137 0.91C0.895118 0.787121 0.991218 0.683987 1.10929 0.611731C1.22737 0.539475 1.36294 0.500841 1.50137 0.5H16.5014C16.6398 0.500841 16.7754 0.539475 16.8934 0.611731C17.0115 0.683987 17.1076 0.787121 17.1714 0.91C17.235 1.03323 17.2622 1.17204 17.2498 1.31018C17.2374 1.44832 17.1859 1.58007 17.1014 1.69L11.7514 9V16.75C11.7488 16.9481 11.6689 17.1374 11.5288 17.2775C11.3887 17.4176 11.1995 17.4974 11.0014 17.5ZM7.75137 16H10.2514V8.75C10.2506 8.59066 10.3034 8.43568 10.4014 8.31L15.0014 2H3.00137L7.62137 8.31C7.71933 8.43568 7.77216 8.59066 7.77137 8.75L7.75137 16Z'
      fill='white'
    />
  </svg>
);
export const sort_icon_white = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='white'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M22 7H2' stroke='white' strokeWidth='1.5' strokeLinecap='round' />
    <path
      opacity='0.5'
      d='M19 12H5'
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path d='M16 17H8' stroke='white' strokeWidth='1.5' strokeLinecap='round' />
  </svg>
);
export const sort_icon = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M22 7H2' stroke='black' strokeWidth='1.5' strokeLinecap='round' />
    <path
      opacity='0.5'
      d='M19 12H5'
      stroke='black'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path d='M16 17H8' stroke='black' strokeWidth='1.5' strokeLinecap='round' />
  </svg>
);

export const back_icon = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.25 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.25C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25Z'
      fill='black'
    />
    <path
      d='M5.56184 12L11.7823 18.219C11.9232 18.3598 12.0023 18.5508 12.0023 18.75C12.0023 18.9491 11.9232 19.1401 11.7823 19.281C11.6415 19.4218 11.4505 19.5009 11.2513 19.5009C11.0522 19.5009 10.8612 19.4218 10.7203 19.281L3.97034 12.531C3.9005 12.4613 3.84508 12.3785 3.80727 12.2874C3.76946 12.1963 3.75 12.0986 3.75 12C3.75 11.9013 3.76946 11.8036 3.80727 11.7125C3.84508 11.6214 3.9005 11.5386 3.97034 11.469L10.7203 4.71897C10.8612 4.57814 11.0522 4.49902 11.2513 4.49902C11.4505 4.49902 11.6415 4.57814 11.7823 4.71897C11.9232 4.8598 12.0023 5.05081 12.0023 5.24997C12.0023 5.44913 11.9232 5.64014 11.7823 5.78097L5.56184 12Z'
      fill='black'
    />
  </svg>
);

export const share_icon = (
  <svg
    width='18'
    height='20'
    viewBox='0 0 18 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clip-path='url(#clip0_118_51225)'>
      <path
        d='M15 20C14.1667 20 13.4583 19.7083 12.875 19.125C12.2917 18.5417 12 17.8333 12 17C12 16.8833 12.0083 16.7623 12.025 16.637C12.0417 16.5117 12.0667 16.3993 12.1 16.3L5.05 12.2C4.76667 12.45 4.45 12.646 4.1 12.788C3.75 12.93 3.38333 13.0007 3 13C2.16667 13 1.45833 12.7083 0.875 12.125C0.291667 11.5417 0 10.8333 0 10C0 9.16667 0.291667 8.45833 0.875 7.875C1.45833 7.29167 2.16667 7 3 7C3.38333 7 3.75 7.071 4.1 7.213C4.45 7.355 4.76667 7.55067 5.05 7.8L12.1 3.7C12.0667 3.6 12.0417 3.48767 12.025 3.363C12.0083 3.23833 12 3.11733 12 3C12 2.16667 12.2917 1.45833 12.875 0.875C13.4583 0.291667 14.1667 0 15 0C15.8333 0 16.5417 0.291667 17.125 0.875C17.7083 1.45833 18 2.16667 18 3C18 3.83333 17.7083 4.54167 17.125 5.125C16.5417 5.70833 15.8333 6 15 6C14.6167 6 14.25 5.92933 13.9 5.788C13.55 5.64667 13.2333 5.45067 12.95 5.2L5.9 9.3C5.93333 9.4 5.95833 9.51267 5.975 9.638C5.99167 9.76333 6 9.884 6 10C6 10.1167 5.99167 10.2377 5.975 10.363C5.95833 10.4883 5.93333 10.6007 5.9 10.7L12.95 14.8C13.2333 14.55 13.55 14.3543 13.9 14.213C14.25 14.0717 14.6167 14.0007 15 14C15.8333 14 16.5417 14.2917 17.125 14.875C17.7083 15.4583 18 16.1667 18 17C18 17.8333 17.7083 18.5417 17.125 19.125C16.5417 19.7083 15.8333 20 15 20ZM15 4C15.2833 4 15.521 3.90433 15.713 3.713C15.905 3.52167 16.0007 3.284 16 3C16 2.71667 15.904 2.47933 15.712 2.288C15.52 2.09667 15.2827 2.00067 15 2C14.7167 2 14.4793 2.096 14.288 2.288C14.0967 2.48 14.0007 2.71733 14 3C14 3.28333 14.096 3.521 14.288 3.713C14.48 3.905 14.7173 4.00067 15 4ZM3 11C3.28333 11 3.521 10.904 3.713 10.712C3.905 10.52 4.00067 10.2827 4 10C4 9.71667 3.904 9.47933 3.712 9.288C3.52 9.09667 3.28267 9.00067 3 9C2.71667 9 2.47933 9.096 2.288 9.288C2.09667 9.48 2.00067 9.71733 2 10C2 10.2833 2.096 10.521 2.288 10.713C2.48 10.905 2.71733 11.0007 3 11ZM15 18C15.2833 18 15.521 17.904 15.713 17.712C15.905 17.52 16.0007 17.2827 16 17C16 16.7167 15.904 16.4793 15.712 16.288C15.52 16.0967 15.2827 16.0007 15 16C14.7167 16 14.4793 16.096 14.288 16.288C14.0967 16.48 14.0007 16.7173 14 17C14 17.2833 14.096 17.521 14.288 17.713C14.48 17.905 14.7173 18.0007 15 18Z'
        fill='#2A886B'
      />
    </g>
    <defs>
      <clipPath id='clip0_118_51225'>
        <rect width='18' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const share_icon_white = (
  <svg
    width='18'
    height='20'
    viewBox='0 0 18 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15 20C14.1667 20 13.4583 19.7083 12.875 19.125C12.2917 18.5417 12 17.8333 12 17C12 16.8833 12.0083 16.7623 12.025 16.637C12.0417 16.5117 12.0667 16.3993 12.1 16.3L5.05 12.2C4.76667 12.45 4.45 12.646 4.1 12.788C3.75 12.93 3.38333 13.0007 3 13C2.16667 13 1.45833 12.7083 0.875 12.125C0.291667 11.5417 0 10.8333 0 10C0 9.16667 0.291667 8.45833 0.875 7.875C1.45833 7.29167 2.16667 7 3 7C3.38333 7 3.75 7.071 4.1 7.213C4.45 7.355 4.76667 7.55067 5.05 7.8L12.1 3.7C12.0667 3.6 12.0417 3.48767 12.025 3.363C12.0083 3.23833 12 3.11733 12 3C12 2.16667 12.2917 1.45833 12.875 0.875C13.4583 0.291667 14.1667 0 15 0C15.8333 0 16.5417 0.291667 17.125 0.875C17.7083 1.45833 18 2.16667 18 3C18 3.83333 17.7083 4.54167 17.125 5.125C16.5417 5.70833 15.8333 6 15 6C14.6167 6 14.25 5.92933 13.9 5.788C13.55 5.64667 13.2333 5.45067 12.95 5.2L5.9 9.3C5.93333 9.4 5.95833 9.51267 5.975 9.638C5.99167 9.76333 6 9.884 6 10C6 10.1167 5.99167 10.2377 5.975 10.363C5.95833 10.4883 5.93333 10.6007 5.9 10.7L12.95 14.8C13.2333 14.55 13.55 14.3543 13.9 14.213C14.25 14.0717 14.6167 14.0007 15 14C15.8333 14 16.5417 14.2917 17.125 14.875C17.7083 15.4583 18 16.1667 18 17C18 17.8333 17.7083 18.5417 17.125 19.125C16.5417 19.7083 15.8333 20 15 20ZM15 4C15.2833 4 15.521 3.90433 15.713 3.713C15.905 3.52167 16.0007 3.284 16 3C16 2.71667 15.904 2.47933 15.712 2.288C15.52 2.09667 15.2827 2.00067 15 2C14.7167 2 14.4793 2.096 14.288 2.288C14.0967 2.48 14.0007 2.71733 14 3C14 3.28333 14.096 3.521 14.288 3.713C14.48 3.905 14.7173 4.00067 15 4ZM3 11C3.28333 11 3.521 10.904 3.713 10.712C3.905 10.52 4.00067 10.2827 4 10C4 9.71667 3.904 9.47933 3.712 9.288C3.52 9.09667 3.28267 9.00067 3 9C2.71667 9 2.47933 9.096 2.288 9.288C2.09667 9.48 2.00067 9.71733 2 10C2 10.2833 2.096 10.521 2.288 10.713C2.48 10.905 2.71733 11.0007 3 11ZM15 18C15.2833 18 15.521 17.904 15.713 17.712C15.905 17.52 16.0007 17.2827 16 17C16 16.7167 15.904 16.4793 15.712 16.288C15.52 16.0967 15.2827 16.0007 15 16C14.7167 16 14.4793 16.096 14.288 16.288C14.0967 16.48 14.0007 16.7173 14 17C14 17.2833 14.096 17.521 14.288 17.713C14.48 17.905 14.7173 18.0007 15 18Z'
      fill='white'
    />
  </svg>
);
export const reset_icon = (
  <svg
    width='25'
    height='20'
    viewBox='0 0 25 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14.625 19.75C16.5534 19.75 18.4384 19.1782 20.0418 18.1068C21.6452 17.0355 22.8949 15.5127 23.6328 13.7312C24.3708 11.9496 24.5639 9.98919 24.1877 8.09787C23.8114 6.20656 22.8829 4.46927 21.5193 3.10571C20.1557 1.74215 18.4184 0.813554 16.5271 0.437348C14.6358 0.0611419 12.6754 0.254225 10.8938 0.992179C9.11226 1.73013 7.58952 2.97982 6.51817 4.58319C5.44683 6.18657 4.875 8.07164 4.875 10V15.0375L1.95 12.1125L0.8125 13.25L5.6875 18.125L10.5625 13.25L9.425 12.1125L6.5 15.0375V10C6.5 8.39303 6.97652 6.82215 7.86931 5.486C8.7621 4.14985 10.031 3.10845 11.5157 2.49348C13.0003 1.87852 14.634 1.71762 16.2101 2.03112C17.7862 2.34463 19.2339 3.11846 20.3702 4.25476C21.5065 5.39106 22.2804 6.8388 22.5939 8.4149C22.9074 9.99099 22.7465 11.6247 22.1315 13.1093C21.5166 14.594 20.4752 15.8629 19.139 16.7557C17.8029 17.6485 16.232 18.125 14.625 18.125V19.75Z'
      fill='#2A886B'
    />
  </svg>
);

export const sentinelHub_icon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='28'
    height='28'
    viewBox='0 0 25 25'
    fill='none'
  >
    <path
      d='M5.625 10.125L10.6875 13.5L15.75 10.125'
      stroke='black'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M19.125 21.375H3.375C2.77826 21.375 2.20597 21.1379 1.78401 20.716C1.36205 20.294 1.125 19.7217 1.125 19.125V7.875C1.125 7.27826 1.36205 6.70597 1.78401 6.28401C2.20597 5.86205 2.77826 5.625 3.375 5.625H18C18.5967 5.625 19.169 5.86205 19.591 6.28401C20.0129 6.70597 20.25 7.27826 20.25 7.875V10.125'
      stroke='black'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      d='M25.875 15.75H19.125M19.125 15.75L22.5 12.375M19.125 15.75L22.5 19.125'
      stroke='black'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const date_icon = (
  <svg
    width='27'
    height='26'
    viewBox='0 0 27 26'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1 12.7778C1 8.16878 1 5.86367 2.465 4.43244C3.92875 3 6.28625 3 11 3H16C20.7137 3 23.0712 3 24.535 4.43244C26 5.86367 26 8.16878 26 12.7778V15.2222C26 19.8312 26 22.1363 24.535 23.5676C23.0712 25 20.7137 25 16 25H11C6.28625 25 3.92875 25 2.465 23.5676C1 22.1363 1 19.8312 1 15.2222V12.7778Z'
      stroke='black'
      strokeWidth='1.5'
    />
    <path
      d='M7.44737 2.84615V1M19.5526 2.84615V1M2 9H25'
      stroke='black'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      d='M21 18.8333C21 19.1428 20.8683 19.4395 20.6339 19.6583C20.3995 19.8771 20.0815 20 19.75 20C19.4185 20 19.1005 19.8771 18.8661 19.6583C18.6317 19.4395 18.5 19.1428 18.5 18.8333C18.5 18.5239 18.6317 18.2272 18.8661 18.0084C19.1005 17.7896 19.4185 17.6667 19.75 17.6667C20.0815 17.6667 20.3995 17.7896 20.6339 18.0084C20.8683 18.2272 21 18.5239 21 18.8333ZM21 14.1667C21 14.4761 20.8683 14.7728 20.6339 14.9916C20.3995 15.2104 20.0815 15.3333 19.75 15.3333C19.4185 15.3333 19.1005 15.2104 18.8661 14.9916C18.6317 14.7728 18.5 14.4761 18.5 14.1667C18.5 13.8572 18.6317 13.5605 18.8661 13.3417C19.1005 13.1229 19.4185 13 19.75 13C20.0815 13 20.3995 13.1229 20.6339 13.3417C20.8683 13.5605 21 13.8572 21 14.1667ZM14.75 18.8333C14.75 19.1428 14.6183 19.4395 14.3839 19.6583C14.1495 19.8771 13.8315 20 13.5 20C13.1685 20 12.8505 19.8771 12.6161 19.6583C12.3817 19.4395 12.25 19.1428 12.25 18.8333C12.25 18.5239 12.3817 18.2272 12.6161 18.0084C12.8505 17.7896 13.1685 17.6667 13.5 17.6667C13.8315 17.6667 14.1495 17.7896 14.3839 18.0084C14.6183 18.2272 14.75 18.5239 14.75 18.8333ZM14.75 14.1667C14.75 14.4761 14.6183 14.7728 14.3839 14.9916C14.1495 15.2104 13.8315 15.3333 13.5 15.3333C13.1685 15.3333 12.8505 15.2104 12.6161 14.9916C12.3817 14.7728 12.25 14.4761 12.25 14.1667C12.25 13.8572 12.3817 13.5605 12.6161 13.3417C12.8505 13.1229 13.1685 13 13.5 13C13.8315 13 14.1495 13.1229 14.3839 13.3417C14.6183 13.5605 14.75 13.8572 14.75 14.1667ZM8.5 18.8333C8.5 19.1428 8.3683 19.4395 8.13388 19.6583C7.89946 19.8771 7.58152 20 7.25 20C6.91848 20 6.60054 19.8771 6.36612 19.6583C6.1317 19.4395 6 19.1428 6 18.8333C6 18.5239 6.1317 18.2272 6.36612 18.0084C6.60054 17.7896 6.91848 17.6667 7.25 17.6667C7.58152 17.6667 7.89946 17.7896 8.13388 18.0084C8.3683 18.2272 8.5 18.5239 8.5 18.8333ZM8.5 14.1667C8.5 14.4761 8.3683 14.7728 8.13388 14.9916C7.89946 15.2104 7.58152 15.3333 7.25 15.3333C6.91848 15.3333 6.60054 15.2104 6.36612 14.9916C6.1317 14.7728 6 14.4761 6 14.1667C6 13.8572 6.1317 13.5605 6.36612 13.3417C6.60054 13.1229 6.91848 13 7.25 13C7.58152 13 7.89946 13.1229 8.13388 13.3417C8.3683 13.5605 8.5 13.8572 8.5 14.1667Z'
      fill='black'
    />
  </svg>
);

export const download_icon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
  >
    <path
      d='M6 20H18M12 4V16M12 16L15.5 12.5M12 16L8.5 12.5'
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const report_icon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='79'
    height='79'
    viewBox='0 0 79 79'
    fill='none'
  >
    <path
      d='M72.4173 8.22852H6.58398V27.9785H72.4173V8.22852Z'
      stroke='#353CF7'
      strokeWidth='4'
      strokeLinejoin='round'
    />
    <path
      d='M6.58398 67.5285L26.6237 47.2848L37.4516 57.6535L50.689 44.4375L58.0624 51.6265'
      stroke='#353CF7'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M72.4173 26.6148V69.4065M6.58398 26.6148V49.6565M21.4228 70.7693H72.4173M27.9798 18.1026H62.5423M16.459 18.0977H18.1048'
      stroke='#353CF7'
      strokeWidth='4'
      strokeLinecap='round'
    />
  </svg>
);

export const RedCrossIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='58'
    height='58'
    viewBox='0 0 58 58'
    fill='none'
  >
    <g clip-path='url(#clip0_2_78071)'>
      <path
        d='M31.5932 29.0008L39.4232 21.1708C39.6872 20.8626 39.8251 20.4661 39.8094 20.0606C39.7938 19.6552 39.6257 19.2705 39.3388 18.9836C39.0518 18.6967 38.6672 18.5286 38.2617 18.5129C37.8562 18.4972 37.4598 18.6352 37.1516 18.8991L29.3216 26.6486L21.4432 18.7702C21.135 18.5063 20.7386 18.3684 20.3331 18.384C19.9276 18.3997 19.543 18.5678 19.2561 18.8547C18.9691 19.1416 18.801 19.5263 18.7854 19.9317C18.7697 20.3372 18.9076 20.7337 19.1716 21.0419L27.0338 29.0008L19.3327 36.6052C19.164 36.7496 19.0271 36.9274 18.9304 37.1273C18.8336 37.3271 18.7793 37.5449 18.7707 37.7667C18.7622 37.9886 18.7995 38.2099 18.8805 38.4166C18.9615 38.6234 19.0844 38.8111 19.2414 38.9682C19.3984 39.1252 19.5862 39.248 19.7929 39.329C19.9997 39.41 20.2209 39.4474 20.4428 39.4388C20.6647 39.4303 20.8824 39.3759 21.0823 39.2792C21.2822 39.1825 21.4599 39.0455 21.6044 38.8769L29.2894 31.1919L36.926 38.8286C37.2342 39.0925 37.6307 39.2304 38.0362 39.2148C38.4416 39.1991 38.8263 39.031 39.1132 38.7441C39.4001 38.4571 39.5682 38.0725 39.5839 37.667C39.5995 37.2615 39.4616 36.8651 39.1977 36.5569L31.5932 29.0008Z'
        fill='#FC6758'
      />
      <path
        d='M29.0004 54.7743C23.9021 54.7743 18.9182 53.2625 14.6791 50.43C10.4399 47.5975 7.13594 43.5715 5.18488 38.8613C3.23383 34.151 2.72334 28.9679 3.71798 23.9675C4.71262 18.9671 7.16772 14.374 10.7728 10.7689C14.3779 7.16381 18.9711 4.70872 23.9715 3.71407C28.9719 2.71943 34.1549 3.22992 38.8652 5.18098C43.5754 7.13204 47.6014 10.436 50.4339 14.6752C53.2664 18.9143 54.7782 23.8982 54.7782 28.9965C54.7782 35.8332 52.0624 42.3899 47.2281 47.2242C42.3938 52.0585 35.8371 54.7743 29.0004 54.7743ZM29.0004 6.44098C24.5394 6.44098 20.1785 7.76384 16.4693 10.2423C12.76 12.7207 9.86901 16.2434 8.16183 20.3649C6.45465 24.4864 6.00798 29.0216 6.87829 33.3969C7.7486 37.7723 9.89681 41.7913 13.0513 44.9457C16.2057 48.1002 20.2247 50.2484 24.6001 51.1187C28.9754 51.989 33.5106 51.5423 37.6321 49.8352C41.7536 48.128 45.2763 45.237 47.7547 41.5277C50.2331 37.8185 51.556 33.4576 51.556 28.9965C51.556 23.0144 49.1796 17.2773 44.9496 13.0474C40.7196 8.81737 34.9826 6.44098 29.0004 6.44098Z'
        fill='#FC6758'
      />
    </g>
    <defs>
      <clipPath id='clip0_2_78071'>
        <rect width='58' height='58' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const FlipkartIconSmall = (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='flipkart-icon 2' clip-path='url(#clip0_1796_1630)'>
      <path
        id='Vector'
        d='M13.9904 2.42656C13.9845 2.40677 13.9786 2.38698 13.9707 2.36719C9.32167 2.36917 4.67456 2.36719 0.0274558 2.36917C0.015681 2.38302 0.00783117 2.39687 0.00586871 2.41469C0.00586871 6.05025 0.00586871 9.68384 0.00390625 13.3194C0.0333432 13.5134 0.139316 13.6895 0.280613 13.8221C0.286501 13.8241 0.300238 13.826 0.306125 13.828C0.378736 13.9052 0.482747 13.9428 0.58087 13.9784C0.653481 13.9745 0.724129 14.0061 0.796741 13.9982H6.56638C6.62132 13.9963 6.67824 14.0061 6.73122 13.9844C6.73318 13.9765 6.73515 13.9626 6.73711 13.9547C6.73907 13.9448 6.74103 13.923 6.743 13.9112C6.86663 13.2145 6.98634 12.5159 7.11783 11.8193L7.1296 11.7302C6.59581 11.7282 6.06006 11.7302 5.52627 11.7282C5.39675 11.7243 5.2633 11.7282 5.13378 11.7124C4.91202 11.7025 4.6883 11.7104 4.46654 11.6886C4.1918 11.6886 3.91902 11.6629 3.64427 11.6629C3.4284 11.6411 3.21057 11.6491 2.99273 11.6392C2.85144 11.6214 2.70622 11.6293 2.56296 11.6233C2.32942 11.5976 2.09196 11.6154 1.85843 11.5897C1.61116 11.5917 1.36389 11.5699 1.11662 11.564C1.11858 11.562 1.12055 11.5541 1.12055 11.5521C1.20297 11.5541 1.28343 11.5481 1.36585 11.5462C1.54836 11.5224 1.73283 11.5382 1.91534 11.5125C2.1057 11.5125 2.2941 11.4868 2.48446 11.4868C2.65323 11.463 2.82396 11.4769 2.99273 11.4531C3.19094 11.4531 3.38523 11.4274 3.58344 11.4254C3.74632 11.4037 3.91117 11.4155 4.07405 11.3938C4.26441 11.3957 4.45281 11.3661 4.64316 11.368C4.8296 11.3463 5.01996 11.3522 5.20639 11.3324C5.18873 11.2592 5.17499 11.186 5.15929 11.1127C5.14555 11.0672 5.0906 11.0771 5.05528 11.0712C4.62943 11.0098 4.20553 10.9485 3.78164 10.8891C3.80912 10.8673 3.84641 10.8772 3.8778 10.8733C4.2075 10.8475 4.53523 10.8179 4.86492 10.7941C4.9395 10.7901 5.01211 10.7763 5.08668 10.7743C5.05332 10.6714 5.03369 10.5586 4.98856 10.4636C4.28403 10.3547 3.57951 10.2578 2.87695 10.141C3.05946 10.1113 3.24393 10.0975 3.42644 10.0777L3.44214 10.0717C4.02499 10.0104 4.6098 9.94112 5.19265 9.88373C5.9325 9.87977 6.67039 9.88175 7.41023 9.88373C7.43378 9.87977 7.475 9.89164 7.47892 9.858C7.53976 9.53739 7.59863 9.21678 7.65947 8.89617C7.74385 8.45087 7.8773 8.01152 8.08336 7.60581C8.40716 6.95271 8.91937 6.39857 9.54343 6.03046C10.1263 5.6861 10.8014 5.51986 11.4725 5.48819C11.6904 5.4684 11.9102 5.47434 12.126 5.50205C12.2673 5.53569 12.4125 5.57527 12.5244 5.67225C12.6166 5.74745 12.6716 5.85828 12.7128 5.96911C12.8031 6.23233 12.8541 6.50544 12.8973 6.78053C12.8992 6.89136 12.9189 7.01604 12.86 7.11698C12.805 7.21593 12.6951 7.26343 12.5911 7.29311C12.2124 7.39207 11.816 7.29905 11.4372 7.39207C11.1252 7.45936 10.8347 7.63351 10.6365 7.88486C10.403 8.17776 10.2794 8.54191 10.2107 8.90606C10.1577 9.23063 10.091 9.5552 10.038 9.88175C10.4108 9.88373 10.7857 9.87977 11.1605 9.88373C11.3096 9.88373 11.4627 9.96685 11.5236 10.1093C11.6021 10.2914 11.5844 10.4972 11.5589 10.6892C11.5275 10.9049 11.4765 11.1187 11.3803 11.3166C11.2998 11.4848 11.1664 11.6392 10.9839 11.6985C10.8897 11.7361 10.7876 11.7282 10.6875 11.7282C10.3579 11.7282 10.0282 11.7322 9.69846 11.7282C9.64548 11.9717 9.61015 12.221 9.56305 12.4684C9.4767 12.9493 9.39232 13.4322 9.30597 13.9151C9.30401 13.9309 9.30205 13.9646 9.30205 13.9824C9.45708 13.9903 9.61211 13.9824 9.76715 13.9864C10.9172 13.9864 12.0691 13.9844 13.2211 13.9864C13.3447 13.9903 13.4703 13.9606 13.5782 13.8993C13.643 13.8755 13.6823 13.8181 13.7392 13.7865C13.7941 13.7548 13.8098 13.6895 13.8569 13.6479C13.9079 13.5569 13.9609 13.4619 13.9649 13.355C13.9707 13.355 13.9864 13.3531 13.9943 13.3511C13.9884 9.70957 13.9943 6.06806 13.9904 2.42656Z'
        fill='url(#paint0_linear_1796_1630)'
        stroke='#FCD109'
        stroke-width='0.094'
      />
      <path
        id='Vector_2'
        d='M1.83532 0.0305025C2.00213 -0.0229326 2.17678 0.0126908 2.34752 0.000816342C5.55222 0.00279542 8.75692 0.000816342 11.9616 0.000816342C12.152 -0.00709997 12.3188 0.101749 12.4954 0.157164C12.6367 0.214557 12.7839 0.260076 12.9252 0.321427C12.9546 0.333301 12.9762 0.35903 12.9978 0.380799C12.9958 0.642038 12.9978 0.905255 12.9978 1.16847C12.9998 1.23774 12.988 1.30899 13.0115 1.37628C13.0527 1.38221 13.0743 1.41388 13.1018 1.43961C13.2313 1.49898 13.3412 1.59595 13.459 1.67512C13.6356 1.80178 13.824 1.91261 13.9967 2.04323C14.0045 2.09468 13.9986 2.14812 13.9829 2.19561C13.9653 2.25103 13.9771 2.3104 13.9712 2.36581C9.3221 2.36779 4.675 2.36581 0.0278897 2.36779C0.0180774 2.30248 0.0357396 2.23717 0.00826514 2.17582C0.00434021 2.12437 -0.0133219 2.05708 0.0357396 2.02146C0.231986 1.88292 0.440006 1.75824 0.632328 1.61179C0.752038 1.5346 0.867823 1.45544 0.983608 1.37628C1.00716 1.33669 0.999308 1.28722 0.999308 1.24368C0.999308 0.956711 0.999308 0.669745 1.00127 0.382778C1.06799 0.295699 1.18378 0.285804 1.27601 0.242264C1.46245 0.171017 1.65084 0.101749 1.83532 0.0305025ZM1.84709 0.0641468C1.5959 0.161122 1.34274 0.254138 1.09154 0.351113C1.05818 0.35705 1.04052 0.386737 1.02286 0.412465C1.02482 0.428297 1.02678 0.456004 1.02678 0.471837C1.02482 0.709326 1.02678 0.946816 1.02482 1.18431C1.02678 1.24368 1.01893 1.30305 1.04052 1.35648C1.01501 1.38221 0.987533 1.40794 0.956134 1.42773C0.671577 1.61377 0.396832 1.81563 0.112276 1.99969C0.063214 2.02937 0.00826513 2.06895 0.0239648 2.13426C0.0141525 2.16989 0.0318147 2.19957 0.0691014 2.18968C0.685314 2.18572 1.29956 2.19363 1.91578 2.18374C2.83225 2.18374 3.74675 2.18572 4.66322 2.18374L4.67696 2.1778C4.71817 2.1877 4.75938 2.18374 4.80256 2.18374C6.4628 2.18374 8.12304 2.18572 9.78524 2.18374C10.3073 2.18572 10.8312 2.18374 11.3552 2.18374C12.2187 2.18374 13.0841 2.19166 13.9476 2.1877C13.9731 2.18176 13.981 2.16395 13.9712 2.13228C13.9692 2.10062 13.981 2.05708 13.9476 2.03729C13.8103 1.97198 13.6925 1.87105 13.561 1.79188C13.5139 1.7523 13.4531 1.73053 13.4178 1.6771C13.2823 1.59991 13.1568 1.50492 13.0233 1.41982C12.9978 1.40398 12.9782 1.37825 12.9566 1.35648C12.9684 1.31492 12.9723 1.26941 12.9723 1.22587C12.9703 0.974523 12.9723 0.72318 12.9703 0.471837C12.9762 0.432255 12.9742 0.386737 12.9389 0.361009C12.7034 0.275908 12.4699 0.184871 12.2364 0.0977912C12.1637 0.0621678 12.0833 0.042377 12.0048 0.0305025H1.97465C1.93148 0.0324816 1.89026 0.0542515 1.84709 0.0641468Z'
        fill='#F8F3B5'
        stroke='#F8F3B5'
        stroke-width='0.094'
      />
      <path
        id='Vector_3'
        d='M1.0254 0.472656C1.1981 0.545882 1.38257 0.587443 1.55723 0.65869C1.65143 0.696292 1.68086 0.799204 1.72207 0.882325C1.68086 0.923886 1.6318 0.95753 1.58274 0.989196C1.40219 1.1119 1.21772 1.23064 1.03914 1.3573C1.01755 1.30387 1.0254 1.2445 1.02344 1.18512C1.0254 0.947635 1.02344 0.710146 1.0254 0.472656ZM12.4371 0.65869C12.6118 0.589422 12.7943 0.541924 12.9689 0.472656C12.9709 0.723999 12.9689 0.975342 12.9709 1.22669C12.9709 1.27022 12.967 1.31574 12.9552 1.3573C12.8021 1.25043 12.6471 1.1495 12.494 1.04461C12.4194 0.989196 12.337 0.947635 12.2703 0.880346C12.3115 0.797225 12.3429 0.696292 12.4371 0.65869Z'
        fill='#F7B402'
        stroke='#F7B402'
        stroke-width='0.094'
      />
      <path
        id='Vector_4'
        d='M4.02073 0.739099C4.2366 0.687643 4.47798 0.881593 4.46032 1.10919C4.46228 1.33282 4.22875 1.5149 4.01484 1.46344C3.92849 1.43376 3.84607 1.38824 3.79308 1.31105C3.7244 1.20616 3.7087 1.06565 3.76365 0.95086C3.80289 0.840032 3.90887 0.764827 4.02073 0.739099ZM9.61963 0.863781C9.7099 0.762848 9.85316 0.705455 9.98661 0.741078C10.0867 0.770764 10.1848 0.836074 10.228 0.935028C10.3143 1.10523 10.2476 1.3348 10.0788 1.42386C9.9297 1.50698 9.7413 1.4674 9.62748 1.34668C9.51169 1.21408 9.50384 0.996379 9.61963 0.863781Z'
        fill='#BDA727'
        stroke='#BDA727'
        stroke-width='0.094'
      />
      <path
        id='Vector_5'
        d='M1.58242 0.987756C1.63148 0.95609 1.68054 0.922446 1.72175 0.880885L1.73549 0.894739C1.74923 0.997651 1.73942 1.10254 1.74334 1.20545C1.73745 1.51419 1.74923 1.82491 1.73549 2.13364C1.16442 2.13364 0.59334 2.12968 0.0222637 2.13364C0.00656397 2.06833 0.0615129 2.02875 0.110574 1.99906C0.395131 1.81501 0.669876 1.61314 0.954432 1.42711C0.985832 1.40732 1.01331 1.38159 1.03882 1.35586C1.2174 1.2292 1.40187 1.11046 1.58242 0.987756ZM12.2504 0.948174C12.2504 0.922446 12.2562 0.900676 12.27 0.878906C12.3367 0.946195 12.4191 0.987756 12.4937 1.04317C12.6468 1.14806 12.8018 1.24899 12.9549 1.35586C12.9765 1.37763 12.9961 1.40336 13.0216 1.41919C13.1551 1.50429 13.2806 1.59929 13.4161 1.67647C13.4514 1.72991 13.5122 1.75168 13.5593 1.79126C13.6908 1.87042 13.8085 1.97136 13.9459 2.03667C13.9793 2.05646 13.9675 2.1 13.9695 2.13166C13.3984 2.13364 12.8293 2.12968 12.2582 2.13364C12.2484 2.05448 12.2543 1.97532 12.2523 1.89813C12.2523 1.58148 12.2484 1.26483 12.2504 0.948174Z'
        fill='#F7E62D'
        stroke='#F7E62D'
        stroke-width='0.094'
      />
      <path
        id='Vector_6'
        d='M13.9694 2.13303C13.3983 2.13501 12.8292 2.13105 12.2582 2.13501C12.2483 2.05585 12.2542 1.97668 12.2523 1.8995C12.2523 1.58285 12.2483 1.26619 12.2503 0.949542C12.2503 0.923814 12.2562 0.902045 12.2699 0.880275C12.3111 0.797153 12.3425 0.69622 12.4367 0.658618C12.6114 0.58935 12.7939 0.541852 12.9686 0.472584C12.9744 0.433003 12.9725 0.387484 12.9372 0.361756C12.7017 0.276656 12.4681 0.185618 12.2346 0.0985387C12.162 0.0629152 12.0815 0.0431245 12.003 0.03125H1.97289C1.92972 0.0332291 1.88851 0.0549989 1.84533 0.0648943C1.59414 0.161869 1.34098 0.254886 1.08978 0.351861C1.05642 0.357798 1.03876 0.387484 1.0211 0.413212C1.02306 0.429045 1.02502 0.456752 1.02502 0.472584C1.19772 0.54581 1.38219 0.587371 1.55685 0.658618C1.65105 0.69622 1.68049 0.799132 1.7217 0.882254L1.73543 0.896107C1.74917 0.999019 1.73936 1.10391 1.74328 1.20682C1.7374 1.51556 1.74917 1.82627 1.73543 2.13501C1.16436 2.13501 0.593282 2.13105 0.022206 2.13501C0.0123937 2.17063 0.0300559 2.20032 0.0673427 2.19042C0.683555 2.18647 1.29781 2.19438 1.91402 2.18449C2.83049 2.18449 3.74499 2.18647 4.66146 2.18449L4.6752 2.17855C4.71641 2.18845 4.75762 2.18449 4.8008 2.18449C6.46104 2.18449 8.12128 2.18647 9.78349 2.18449C10.3055 2.18647 10.8295 2.18449 11.3535 2.18449C12.2169 2.18449 13.0824 2.1924 13.9459 2.18845C13.9714 2.18251 13.9792 2.1647 13.9694 2.13303ZM3.76266 0.951521C3.80191 0.840693 3.90788 0.765488 4.01974 0.73976C4.23561 0.688304 4.47699 0.882254 4.45933 1.10985C4.46129 1.33348 4.22776 1.51556 4.01385 1.4641C3.9275 1.43442 3.84508 1.3889 3.79209 1.31171C3.72341 1.20682 3.70771 1.06631 3.76266 0.951521ZM9.61864 0.864442C9.70891 0.763509 9.85217 0.706116 9.98562 0.741739C10.0857 0.771425 10.1838 0.836735 10.227 0.935689C10.3134 1.10589 10.2466 1.33546 10.0779 1.42452C9.92871 1.50764 9.74031 1.46806 9.62649 1.34734C9.5107 1.21474 9.50286 0.99704 9.61864 0.864442Z'
        fill='url(#paint1_radial_1796_1630)'
        stroke='#FCD109'
        stroke-width='0.094'
      />
      <path
        id='Vector_7'
        d='M10.1199 3.00151C10.1474 3.00745 9.97684 2.83625 10.0102 2.82834C10.0416 2.8323 10.1607 2.73908 10.3046 2.81508C10.4484 2.89108 10.4127 3.06899 10.3964 3.1351C10.377 3.21367 10.3273 3.26374 10.2881 3.30332C10.2665 3.32113 10.218 3.34884 10.1886 3.34686C10.2063 3.24988 10.1493 3.23405 10.1454 3.1351L10.1199 3.00151Z'
        fill='url(#paint2_linear_1796_1630)'
        stroke='#FCD109'
        stroke-width='0.094'
      />
      <path
        id='Vector_8'
        d='M3.84702 3.11175C3.84309 3.2107 3.78618 3.22653 3.80384 3.32351C3.77441 3.32549 3.72593 3.29778 3.70435 3.27997C3.6651 3.24039 3.61564 3.19031 3.59621 3.11175C3.57993 3.04584 3.54421 2.86792 3.68806 2.79173C3.83191 2.71553 3.95103 2.80895 3.98243 2.80499C4.01579 2.8129 3.84525 2.98409 3.87272 2.97816L3.84702 3.11175Z'
        fill='url(#paint3_linear_1796_1630)'
        stroke='#FCD109'
        stroke-width='0.094'
      />
      <path
        id='Vector_9'
        d='M9.8624 4.27202C9.89184 4.24609 9.91147 4.24609 9.95072 4.24609C9.71522 4.76065 9.44048 5.27521 9.02738 5.67578C8.98322 5.71556 8.93652 5.75237 8.88765 5.78621C8.84035 5.82104 8.79404 5.8539 8.74792 5.88715C8.70279 5.91881 8.65785 5.95048 8.61428 5.98372C8.50242 6.04508 8.4043 6.13018 8.28066 6.16778C8.05498 6.27663 7.81163 6.34985 7.56633 6.40131C7.47017 6.41714 7.37204 6.44089 7.27392 6.44287C7.15225 6.47849 7.02272 6.45277 6.89909 6.46068C6.8304 6.47256 6.76957 6.43298 6.70284 6.44089C6.64495 6.43258 6.58725 6.42268 6.52975 6.41121C6.47147 6.39913 6.41358 6.38528 6.35627 6.36964C5.45668 6.08664 4.57357 5.39396 4.31629 4.45706C4.30472 4.39393 4.29883 4.33001 4.29883 4.26569C4.3263 4.3211 4.35476 4.37612 4.38419 4.43054C4.75019 5.23544 5.4763 5.86874 6.3341 6.05972C6.40376 6.09178 6.47912 6.0805 6.54585 6.10821C6.60668 6.10821 6.66556 6.10623 6.72443 6.12602C6.92656 6.12998 7.1287 6.128 7.33083 6.128C7.3583 6.12998 7.38382 6.11613 7.41129 6.11019C7.74825 6.09871 8.07833 6.00609 8.38565 5.86557C8.44708 5.83747 8.50772 5.80739 8.56718 5.77572C8.61919 5.74802 8.67021 5.71813 8.71966 5.68587C8.76833 5.65421 8.81543 5.62056 8.86135 5.58494C9.22461 5.29481 9.5386 4.91878 9.75192 4.48635C9.79235 4.40897 9.82963 4.33693 9.8624 4.27202Z'
        fill='#BDA727'
        stroke='#BDA727'
        stroke-width='0.094'
      />
      <path
        id='Vector_10'
        d='M9.54277 6.03048C10.1256 5.68612 10.8007 5.51988 11.4719 5.48822C11.6897 5.46843 11.9095 5.47436 12.1254 5.50207C12.2667 5.53571 12.4119 5.5753 12.5237 5.67227C12.4668 5.67623 12.4119 5.6505 12.355 5.64258C12.1941 5.61092 12.0272 5.62279 11.8644 5.61884C11.3914 5.61884 10.9145 5.65644 10.4573 5.78706C10.2179 5.86028 9.97844 5.94538 9.7606 6.07204C9.38381 6.28183 9.04431 6.5589 8.76956 6.89138C8.27895 7.45938 7.99047 8.17976 7.85113 8.914C7.78441 9.30784 7.70787 9.69969 7.64703 10.0955C7.54891 10.1054 7.44883 10.0995 7.3507 10.0995C6.91896 10.0975 6.48722 10.0955 6.05548 10.0916C5.96324 10.0955 5.87297 10.0737 5.78073 10.0797C4.99575 10.0836 4.21077 10.0777 3.42578 10.0777L3.44148 10.0718C4.02433 10.0104 4.60915 9.94114 5.192 9.88375C5.93184 9.87979 6.66973 9.88177 7.40958 9.88375C7.43313 9.87979 7.47434 9.89166 7.47826 9.85802C7.5391 9.53741 7.59797 9.2168 7.65881 8.89619C7.7432 8.4509 7.87664 8.01154 8.0827 7.60583C8.40651 6.95273 8.91871 6.39859 9.54277 6.03048Z'
        fill='#0D69B3'
        stroke='#0D69B3'
        stroke-width='0.094'
      />
      <path
        id='Vector_11'
        d='M10.4565 5.78541C10.9138 5.65479 11.3907 5.61719 11.8636 5.61719C12.0265 5.62115 12.1933 5.60927 12.3542 5.64094C12.4112 5.64885 12.4661 5.67458 12.523 5.67062C12.6153 5.74583 12.6702 5.85666 12.7114 5.96748C12.8017 6.2307 12.8527 6.50381 12.8959 6.77891C12.8979 6.88973 12.9175 7.01442 12.8586 7.11535C12.8037 7.2143 12.6938 7.2618 12.5897 7.29149C12.211 7.39044 11.8146 7.29742 11.4358 7.39044C11.1238 7.45773 10.8333 7.63189 10.6351 7.88323C10.4016 8.17614 10.278 8.54029 10.2093 8.90444C10.1563 9.22901 10.0896 9.55357 10.0366 9.88012C10.013 9.95335 9.9993 10.0325 9.98556 10.1097C10.3565 10.1156 10.7274 10.1097 11.0983 10.1137C11.2396 10.1097 11.3809 10.1176 11.5222 10.1077C11.6007 10.2898 11.583 10.4956 11.5575 10.6876C11.5261 10.9033 11.4751 11.117 11.3789 11.315C11.2984 11.4832 11.165 11.6375 10.9825 11.6969C10.8883 11.7345 10.7862 11.7266 10.6862 11.7266C10.3565 11.7266 10.0268 11.7306 9.69708 11.7266C9.64409 11.97 9.60877 12.2194 9.56167 12.4668C9.47532 12.9477 9.39093 13.4306 9.30458 13.9135C9.30262 13.9293 9.30066 13.963 9.30066 13.9808V13.9828C8.44306 13.9828 7.58743 13.9847 6.72984 13.9828C6.7318 13.9748 6.73376 13.961 6.73572 13.9531C6.73768 13.9432 6.73965 13.9214 6.74161 13.9095C6.74357 13.9254 6.74553 13.955 6.7475 13.9689C6.80048 13.9748 6.89664 14.0025 6.91038 13.9254C7.04383 13.1971 7.16746 12.4648 7.30484 11.7365C7.25185 11.7246 7.1969 11.7246 7.14195 11.7345C7.1341 11.7622 7.12625 11.7899 7.11644 11.8176L7.12821 11.7286C6.59443 11.7266 6.05867 11.7286 5.52488 11.7266C5.39536 11.7226 5.26191 11.7266 5.13239 11.7108C4.91063 11.7009 4.68691 11.7088 4.46516 11.687C4.19041 11.687 3.91763 11.6613 3.64288 11.6613C3.42701 11.6395 3.20918 11.6474 2.99135 11.6375C2.85005 11.6197 2.70483 11.6276 2.56157 11.6217C2.32804 11.596 2.09058 11.6138 1.85704 11.5881C1.60977 11.59 1.3625 11.5683 1.11523 11.5623C1.1172 11.5604 1.11916 11.5524 1.11916 11.5505C1.20158 11.5524 1.28204 11.5465 1.36447 11.5445C1.54698 11.5208 1.73145 11.5366 1.91396 11.5109C2.10431 11.5109 2.29271 11.4852 2.48307 11.4852C2.65184 11.4614 2.82258 11.4753 2.99135 11.4515C3.18956 11.4515 3.38384 11.4258 3.58205 11.4238C3.74493 11.402 3.90978 11.4139 4.07266 11.3921C4.26302 11.3941 4.45142 11.3644 4.64178 11.3664C4.82821 11.3446 5.01857 11.3506 5.205 11.3308C5.18734 11.2576 5.1736 11.1843 5.1579 11.1111C5.14417 11.0656 5.08922 11.0755 5.05389 11.0695C4.62804 11.0082 4.20415 10.9468 3.78026 10.8875C3.80773 10.8657 3.84502 10.8756 3.87642 10.8716C4.20611 10.8459 4.53384 10.8162 4.86353 10.7925C4.93811 10.7885 5.01072 10.7747 5.08529 10.7727C5.05193 10.6698 5.03231 10.557 4.98717 10.462C4.28265 10.3531 3.57812 10.2561 2.87556 10.1394C3.05807 10.1097 3.24254 10.0958 3.42505 10.0761C4.21004 10.0761 4.99502 10.082 5.78 10.078C5.87224 10.0721 5.96251 10.0939 6.05475 10.0899C6.48649 10.0939 6.91823 10.0958 7.34997 10.0978C7.4481 10.0978 7.54818 10.1038 7.6463 10.0939C7.70714 9.69805 7.78368 9.30619 7.8504 8.91235C7.98974 8.17811 8.27822 7.45773 8.76883 6.88973C9.04358 6.55725 9.38308 6.28018 9.75988 6.0704C9.97771 5.94374 10.2171 5.85864 10.4565 5.78541Z'
        fill='#107BD4'
        stroke='#107BD4'
        stroke-width='0.094'
      />
      <path
        id='Vector_12'
        d='M10.0372 9.88281C10.41 9.88479 10.7849 9.88083 11.1597 9.88479C11.3088 9.88479 11.4619 9.96791 11.5227 10.1104C11.3814 10.1203 11.2401 10.1124 11.0989 10.1163C10.7279 10.1124 10.357 10.1183 9.98614 10.1124C9.99987 10.0352 10.0136 9.95604 10.0372 9.88281ZM7.14253 11.7372C7.19748 11.7273 7.25243 11.7273 7.30541 11.7392C7.16804 12.4675 7.04441 13.1997 6.91096 13.928C6.89722 14.0052 6.80106 13.9775 6.74807 13.9716C6.74611 13.9577 6.74415 13.928 6.74219 13.9122C6.86582 13.2156 6.98553 12.517 7.11702 11.8203C7.12683 11.7926 7.13468 11.7649 7.14253 11.7372Z'
        fill='#0D69B3'
        stroke='#0D69B3'
        stroke-width='0.094'
      />
      <path
        id='Vector_13'
        d='M10.2088 3.05845C10.1931 3.02877 10.1911 2.99314 10.1911 2.9595L10.1754 2.96148C10.1519 2.8744 10.0793 2.79128 9.98507 2.78732C9.91442 2.78138 9.82611 2.78336 9.78489 2.85065C9.7064 2.95752 9.74368 3.09408 9.73976 3.2148C9.73976 3.22272 9.74172 3.23657 9.74172 3.24449C9.74172 3.32563 9.73191 3.40479 9.71817 3.48395C9.7064 3.5077 9.70051 3.53343 9.70051 3.56114C9.66715 3.74717 9.60042 3.93123 9.51015 4.09945C9.49249 4.1232 9.47875 4.14892 9.47286 4.17663C9.41399 4.27954 9.34334 4.37454 9.27073 4.46953C9.25896 4.47943 9.24914 4.4913 9.23933 4.50318C9.18831 4.56651 9.13336 4.61994 9.07645 4.67536C9.06271 4.68328 9.0529 4.69317 9.04112 4.70109C8.9744 4.7664 8.89983 4.82775 8.81936 4.87722C8.80955 4.88316 8.79974 4.89108 8.78796 4.89899C8.28557 5.23346 7.67525 5.37199 7.08062 5.37793C6.57627 5.39376 6.06799 5.28491 5.6127 5.06524C5.60485 5.06128 5.58523 5.05336 5.57738 5.0494C5.50084 5.00784 5.42234 4.97222 5.3517 4.92076C5.336 4.91285 5.3203 4.90295 5.30263 4.89504C5.23002 4.8515 5.16134 4.804 5.09658 4.74858C5.07499 4.72879 5.05144 4.71296 5.02789 4.69515C4.95724 4.63776 4.88463 4.5764 4.82379 4.50714C4.80809 4.48933 4.79239 4.47349 4.77669 4.45766C4.56279 4.23402 4.39598 3.96091 4.30767 3.66405C4.22328 3.42854 4.23506 3.17126 4.22524 2.92387C4.15459 2.81503 4.00545 2.75367 3.8877 2.82096C3.83864 2.85659 3.83275 2.9219 3.79546 2.96741C3.73463 3.62051 4.01133 4.27163 4.45289 4.74265C4.45289 4.75848 4.46074 4.76838 4.47448 4.77431C4.55297 4.84754 4.62951 4.92274 4.70801 4.99399C4.72175 5.00784 4.73745 5.0217 4.75511 5.03357C4.83361 5.09888 4.91799 5.15825 5.00041 5.21961C5.01611 5.23148 5.03181 5.24137 5.04948 5.25127C5.15741 5.3146 5.25946 5.38981 5.37525 5.43335C5.3831 5.43928 5.39683 5.44918 5.40468 5.45314C5.77755 5.63323 6.17985 5.75594 6.59197 5.79552C6.63711 5.79552 6.68224 5.79948 6.72738 5.80937C6.92363 5.82125 7.11987 5.81531 7.31612 5.81135C7.92252 5.75791 8.54854 5.60948 9.05486 5.24929L9.06075 5.25721C9.07645 5.24335 9.09018 5.23148 9.10588 5.21961C9.18634 5.16023 9.26484 5.0969 9.34334 5.03159C9.361 5.01774 9.38063 5.00191 9.39829 4.9841C9.48464 4.8891 9.58472 4.80202 9.65733 4.69317L9.66911 4.69911C9.675 4.68921 9.68481 4.66942 9.6907 4.65953C9.75742 4.56849 9.81826 4.47349 9.87713 4.3785C9.88106 4.37256 9.89087 4.36266 9.89479 4.35673L9.88694 4.34881C9.89283 4.34089 9.90657 4.32506 9.91245 4.31715C10.0204 4.09549 10.1165 3.86394 10.1499 3.61853C10.1636 3.61259 10.1715 3.60072 10.1715 3.58687C10.1735 3.5077 10.2009 3.4325 10.1931 3.35333C10.2107 3.25636 10.2127 3.15741 10.2088 3.05845Z'
        fill='white'
        stroke='white'
        stroke-width='0.094'
      />
      <g id='Group'>
        <g id='Clip path group'>
          <mask
            id='mask0_1796_1630'
            maskUnits='userSpaceOnUse'
            x='3'
            y='2'
            width='8'
            height='4'
          >
            <g id='SVGID_6_'>
              <path
                id='Vector_14'
                d='M10.2088 3.05845C10.1931 3.02877 10.1911 2.99314 10.1911 2.9595L10.1754 2.96148C10.1519 2.8744 10.0793 2.79128 9.98507 2.78732C9.91442 2.78138 9.82611 2.78336 9.78489 2.85065C9.7064 2.95752 9.74368 3.09408 9.73976 3.2148C9.73976 3.22272 9.74172 3.23657 9.74172 3.24449C9.74172 3.32563 9.73191 3.40479 9.71817 3.48395C9.7064 3.5077 9.70051 3.53343 9.70051 3.56114C9.66715 3.74717 9.60042 3.93123 9.51015 4.09945C9.49249 4.1232 9.47875 4.14892 9.47286 4.17663C9.41399 4.27954 9.34334 4.37454 9.27073 4.46953C9.25896 4.47943 9.24914 4.4913 9.23933 4.50318C9.18831 4.56651 9.13336 4.61994 9.07645 4.67536C9.06271 4.68328 9.0529 4.69317 9.04112 4.70109C8.9744 4.7664 8.89983 4.82775 8.81936 4.87722C8.80955 4.88316 8.79974 4.89108 8.78796 4.89899C8.28557 5.23346 7.67525 5.37199 7.08062 5.37793C6.57627 5.39376 6.06799 5.28491 5.6127 5.06524C5.60485 5.06128 5.58523 5.05336 5.57738 5.0494C5.50084 5.00784 5.42234 4.97222 5.3517 4.92076C5.336 4.91285 5.3203 4.90295 5.30263 4.89504C5.23002 4.8515 5.16134 4.804 5.09658 4.74858C5.07499 4.72879 5.05144 4.71296 5.02789 4.69515C4.95724 4.63776 4.88463 4.5764 4.82379 4.50714C4.80809 4.48933 4.79239 4.47349 4.77669 4.45766C4.56279 4.23402 4.39598 3.96091 4.30767 3.66405C4.22328 3.42854 4.23506 3.17126 4.22524 2.92387C4.15459 2.81503 4.00545 2.75367 3.8877 2.82096C3.83864 2.85659 3.83275 2.9219 3.79546 2.96741C3.73463 3.62051 4.01133 4.27163 4.45289 4.74265C4.45289 4.75848 4.46074 4.76838 4.47448 4.77431C4.55297 4.84754 4.62951 4.92274 4.70801 4.99399C4.72175 5.00784 4.73745 5.0217 4.75511 5.03357C4.83361 5.09888 4.91799 5.15825 5.00041 5.21961C5.01611 5.23148 5.03181 5.24137 5.04948 5.25127C5.15741 5.3146 5.25946 5.38981 5.37525 5.43335C5.3831 5.43928 5.39683 5.44918 5.40468 5.45314C5.77755 5.63323 6.17985 5.75594 6.59197 5.79552C6.63711 5.79552 6.68224 5.79948 6.72738 5.80937C6.92363 5.82125 7.11987 5.81531 7.31612 5.81135C7.92252 5.75791 8.54854 5.60948 9.05486 5.24929L9.06075 5.25721C9.07645 5.24335 9.09018 5.23148 9.10588 5.21961C9.18634 5.16023 9.26484 5.0969 9.34334 5.03159C9.361 5.01774 9.38063 5.00191 9.39829 4.9841C9.48464 4.8891 9.58472 4.80202 9.65733 4.69317L9.66911 4.69911C9.675 4.68921 9.68481 4.66942 9.6907 4.65953C9.75742 4.56849 9.81826 4.47349 9.87713 4.3785C9.88106 4.37256 9.89087 4.36266 9.89479 4.35673L9.88694 4.34881C9.89283 4.34089 9.90657 4.32506 9.91245 4.31715C10.0204 4.09549 10.1165 3.86394 10.1499 3.61853C10.1636 3.61259 10.1715 3.60072 10.1715 3.58687C10.1735 3.5077 10.2009 3.4325 10.1931 3.35333C10.2107 3.25636 10.2127 3.15741 10.2088 3.05845Z'
                fill='white'
              />
            </g>
          </mask>
          <g mask='url(#mask0_1796_1630)'>
            <g id='Group_2'>
              <path
                id='Vector_15'
                d='M3.64453 2.98985C3.80369 3.04012 4.1691 2.91366 4.27252 3.02944M3.73598 3.4779C3.88846 3.42446 4.21541 3.2978 4.35082 3.37241M3.89298 3.96613C3.96677 3.99028 4.11199 3.85966 4.18401 3.82146C4.29136 3.76447 4.40145 3.72093 4.52097 3.70232M4.12847 4.48069C4.20442 4.37184 4.29548 4.2812 4.40518 4.20402C4.5141 4.12743 4.8118 3.9224 4.93956 3.99265M4.35102 4.85019C4.43737 4.78112 4.47249 4.65861 4.56296 4.58598C4.67247 4.49811 4.84045 4.48228 4.95271 4.42805M4.72055 5.12389C4.74645 4.93252 4.93897 4.70176 5.12285 4.71818M5.00511 5.39107C5.10225 5.38117 5.18447 5.16189 5.25022 5.08768C5.34873 4.97645 5.45058 4.94202 5.58089 4.90283M5.56774 5.62856C5.56146 5.49002 5.70335 5.09322 5.86859 5.114M5.98634 5.76056C5.97947 5.59689 6.06326 5.1047 6.26108 5.08768M6.41808 6.02437C6.38059 5.79559 6.38295 5.46449 6.56193 5.29865M6.95442 6.07722C6.9344 5.88643 6.74659 5.50091 6.95442 5.35149M7.5302 5.94521C7.44052 5.84032 7.38832 5.4265 7.4256 5.31191M8.07969 5.85279C8.01042 5.72613 7.92466 5.60699 7.89856 5.45994C7.88286 5.37207 7.91033 5.2468 7.8966 5.1799M8.53754 5.65488C8.38741 5.55593 8.3458 5.19197 8.39369 5.03484M8.98243 5.45697C8.87567 5.22602 8.76184 5.04691 8.76008 4.78409M9.41417 5.03484C9.24834 4.92223 9.03659 4.71779 9.06092 4.49395M9.87201 4.6786C9.62003 4.6222 9.31742 4.3948 9.16552 4.19036M10.0814 4.2432C9.89948 4.20382 9.29877 3.96752 9.33567 3.72864M10.2776 3.78149C10.0243 3.68788 9.65575 3.60357 9.45342 3.42525M10.4083 3.35915C10.2488 3.373 10.0202 3.29503 9.85788 3.26673C9.67772 3.23546 9.51072 3.17411 9.33547 3.13472M10.2514 2.95027C9.94364 2.96888 9.65476 2.8626 9.37472 2.76562'
                stroke='#D1D1D1'
                stroke-width='2'
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_1796_1630'
        x1='6.99911'
        y1='2.36715'
        x2='6.99911'
        y2='13.9995'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#F7E830' />
        <stop offset='1' stop-color='#FDCB06' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_1796_1630'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(6.93764 7.672) scale(9.38213 9.46158)'
      >
        <stop offset='0.596' stop-color='#F29405' />
        <stop offset='0.736' stop-color='#F7D01E' />
        <stop offset='1' stop-color='#FDCB06' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_1796_1630'
        x1='10.2084'
        y1='2.78521'
        x2='10.2117'
        y2='3.33605'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#FADA1C' />
        <stop offset='1' stop-color='#FDCB06' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_1796_1630'
        x1='3.78416'
        y1='2.76159'
        x2='3.78083'
        y2='3.31243'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#FADA1C' />
        <stop offset='1' stop-color='#FDCB06' />
      </linearGradient>
      <clipPath id='clip0_1796_1630'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const FlipkartLogo = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='38'
    height='38'
    viewBox='0 0 38 38'
    fill='none'
  >
    <rect width='38' height='38' fill='#6D6D6D' />
    <g id='Active Topic - overview' clip-path='url(#clip0_2_42436)'>
      <rect
        width='1440'
        height='2882'
        transform='translate(-405 -702)'
        fill='white'
      />
      <path
        id='Rectangle 6558'
        d='M2 24C2 4.11776 18.1178 -12 38 -12H355C374.882 -12 391 4.11775 391 24V254H38C18.1177 254 2 237.882 2 218V24Z'
        fill='#6F62FE'
        fill-opacity='0.22'
      />
      <g id='Ellipse 1267'>
        <g filter='url(#filter0_i_2_42436)'>
          <ellipse cx='20' cy='20' rx='45' ry='43' fill='white' />
        </g>
        <path
          d='M64.5 20C64.5 43.4509 44.5983 62.5 20 62.5C-4.59834 62.5 -24.5 43.4509 -24.5 20C-24.5 -3.45092 -4.59834 -22.5 20 -22.5C44.5983 -22.5 64.5 -3.45092 64.5 20Z'
          stroke='#55ACEE'
          stroke-opacity='0.84'
        />
      </g>
      <g id='Group 1000005985'>
        <rect
          id='Rectangle 6544'
          x='-85.5'
          y='-94.5'
          width='524'
          height='378'
          rx='14.5'
          stroke='#D9D9D9'
        />
      </g>
      <g id='flipkart-icon 1' clip-path='url(#clip1_2_42436)'>
        <path
          id='Vector'
          d='M37.973 6.58693C37.957 6.53322 37.9411 6.4795 37.9197 6.42578C25.3008 6.43115 12.6873 6.42578 0.0736858 6.43115C0.0417257 6.46876 0.020419 6.50636 0.0150923 6.5547C0.0150923 16.4227 0.0150923 26.2853 0.00976562 36.1532C0.0896658 36.6797 0.377307 37.1578 0.760827 37.5177C0.776808 37.523 0.814094 37.5284 0.830074 37.5338C1.02716 37.7433 1.30948 37.8453 1.57581 37.942C1.7729 37.9313 1.96466 38.0172 2.16174 37.9958H17.8222C17.9713 37.9904 18.1258 38.0172 18.2696 37.9582C18.275 37.9367 18.2803 37.8991 18.2856 37.8776C18.2909 37.8507 18.2963 37.7916 18.3016 37.7594C18.6372 35.8685 18.9621 33.9723 19.319 32.0814L19.3509 31.8397C17.9021 31.8343 16.4479 31.8397 14.999 31.8343C14.6475 31.8236 14.2853 31.8343 13.9337 31.7913C13.3318 31.7645 12.7246 31.786 12.1226 31.7269C11.3769 31.7269 10.6365 31.657 9.89076 31.657C9.30482 31.598 8.71356 31.6194 8.1223 31.5926C7.73878 31.5442 7.3446 31.5657 6.95576 31.5496C6.32188 31.4798 5.67735 31.5281 5.04348 31.4583C4.37232 31.4637 3.70115 31.4046 3.02999 31.3885C3.03532 31.3831 3.04065 31.3616 3.04065 31.3562C3.26437 31.3616 3.48276 31.3455 3.70648 31.3401C4.20186 31.2757 4.70257 31.3186 5.19795 31.2488C5.71464 31.2488 6.226 31.179 6.74269 31.179C7.20078 31.1145 7.6642 31.1521 8.1223 31.0876C8.66029 31.0876 9.18764 31.0178 9.72563 31.0124C10.1677 30.9533 10.6152 30.9856 11.0573 30.9265C11.574 30.9319 12.0853 30.8513 12.602 30.8567C13.1081 30.7976 13.6248 30.8137 14.1308 30.76C14.0829 30.5612 14.0456 30.3625 14.003 30.1637C13.9657 30.0401 13.8165 30.067 13.7206 30.0509C12.5647 29.8844 11.4142 29.7178 10.2636 29.5567C10.3382 29.4976 10.4394 29.5245 10.5246 29.5137C11.4195 29.4439 12.3091 29.3633 13.204 29.2988C13.4064 29.2881 13.6035 29.2505 13.8059 29.2451C13.7153 28.9658 13.662 28.6596 13.5395 28.4018C11.6273 28.1063 9.71498 27.8431 7.80803 27.5261C8.30341 27.4456 8.80411 27.408 9.2995 27.3543L9.34211 27.3381C10.9241 27.1716 12.5115 26.9836 14.0935 26.8278C16.1017 26.8171 18.1045 26.8224 20.1127 26.8278C20.1766 26.8171 20.2884 26.8493 20.2991 26.758C20.4642 25.8878 20.624 25.0175 20.7891 24.1473C21.0182 22.9386 21.3804 21.7461 21.9397 20.6449C22.8186 18.8722 24.2089 17.3681 25.9028 16.369C27.4848 15.4343 29.3172 14.983 31.1389 14.8971C31.7301 14.8434 32.3267 14.8595 32.9127 14.9347C33.2962 15.026 33.6904 15.1334 33.994 15.3967C34.2443 15.6008 34.3935 15.9016 34.5053 16.2024C34.7504 16.9169 34.8889 17.6582 35.0061 18.4049C35.0114 18.7057 35.0646 19.0441 34.9048 19.3181C34.7557 19.5867 34.4574 19.7156 34.1751 19.7962C33.147 20.0647 32.0711 19.8123 31.043 20.0647C30.1961 20.2474 29.4077 20.7201 28.8697 21.4023C28.2358 22.1973 27.9003 23.1857 27.7138 24.1742C27.57 25.0551 27.3889 25.9361 27.2451 26.8224C28.2571 26.8278 29.2745 26.8171 30.2919 26.8278C30.6968 26.8278 31.1122 27.0534 31.2774 27.4402C31.4904 27.9344 31.4425 28.4931 31.3733 29.0141C31.288 29.5997 31.1495 30.1798 30.8885 30.717C30.6701 31.1736 30.3079 31.5926 29.8125 31.7537C29.5569 31.8558 29.2799 31.8343 29.0082 31.8343C28.1133 31.8343 27.2184 31.8451 26.3236 31.8343C26.1797 32.4951 26.0839 33.1719 25.956 33.8434C25.7216 35.1487 25.4926 36.4594 25.2582 37.7701C25.2529 37.8131 25.2476 37.9044 25.2476 37.9528C25.6684 37.9743 26.0892 37.9528 26.51 37.9635C29.6314 37.9635 32.7582 37.9582 35.885 37.9635C36.2205 37.9743 36.5614 37.8937 36.8544 37.7272C37.0302 37.6627 37.1367 37.5069 37.2912 37.421C37.4403 37.335 37.483 37.1578 37.6108 37.045C37.7493 36.7978 37.8931 36.54 37.9038 36.2499C37.9197 36.2499 37.9624 36.2446 37.9837 36.2392C37.9677 26.3551 37.9837 16.471 37.973 6.58693Z'
          fill='url(#paint0_linear_2_42436)'
          stroke='#FCD109'
          stroke-width='0.094'
        />
        <path
          id='Vector_2'
          d='M4.97822 0.0866988C5.43099 -0.0583394 5.90507 0.0383527 6.36849 0.00612204C15.067 0.0114938 23.7654 0.00612204 32.4639 0.00612204C32.9806 -0.0153651 33.4333 0.280083 33.9128 0.430493C34.2963 0.586275 34.6958 0.709826 35.0793 0.876351C35.1592 0.908582 35.2178 0.978415 35.2764 1.0375C35.2711 1.74658 35.2764 2.46103 35.2764 3.17547C35.2817 3.36349 35.2497 3.55687 35.3137 3.73951C35.4255 3.75563 35.4841 3.84158 35.5587 3.91141C35.9103 4.07256 36.2085 4.33578 36.5282 4.55065C37.0076 4.89445 37.5189 5.19527 37.9877 5.5498C38.009 5.68947 37.993 5.83451 37.9504 5.96343C37.9024 6.11384 37.9344 6.27499 37.9184 6.4254C25.2995 6.43078 12.6859 6.4254 0.0723525 6.43078C0.0457191 6.25351 0.0936592 6.07624 0.0190857 5.90971C0.00843237 5.77005 -0.0395078 5.58741 0.0936592 5.49071C0.626327 5.11469 1.19096 4.77627 1.71297 4.37875C2.0379 4.16925 2.35217 3.95438 2.66645 3.73951C2.73037 3.63208 2.70906 3.49778 2.70906 3.3796C2.70906 2.60069 2.70906 1.82178 2.71439 1.04288C2.89549 0.806518 3.20977 0.779659 3.46012 0.66148C3.96616 0.468095 4.47752 0.280083 4.97822 0.0866988ZM5.01018 0.178019C4.32837 0.441237 3.64123 0.69371 2.95941 0.956928C2.86886 0.973043 2.82092 1.05362 2.77298 1.12345C2.77831 1.16643 2.78363 1.24163 2.78363 1.28461C2.77831 1.92922 2.78363 2.57383 2.77831 3.21845C2.78363 3.3796 2.76233 3.54076 2.82092 3.68579C2.75167 3.75563 2.6771 3.82546 2.59187 3.87918C1.8195 4.38413 1.07377 4.93205 0.3014 5.43162C0.168233 5.5122 0.0190857 5.61964 0.0616992 5.79691C0.0350658 5.8936 0.0830059 5.97417 0.184213 5.94732C1.85679 5.93657 3.52404 5.95806 5.19662 5.9312C7.68418 5.9312 10.1664 5.93657 12.654 5.9312L12.6913 5.91508C12.8031 5.94194 12.915 5.9312 13.0322 5.9312C17.5385 5.9312 22.0449 5.93657 26.5566 5.9312C27.9735 5.93657 29.3957 5.9312 30.8179 5.9312C33.1617 5.9312 35.5108 5.95269 37.8545 5.94194C37.9237 5.92583 37.945 5.87748 37.9184 5.79153C37.9131 5.70559 37.945 5.58741 37.8545 5.53369C37.4816 5.35642 37.162 5.08246 36.8051 4.86759C36.6773 4.76015 36.5122 4.70106 36.4163 4.55602C36.0487 4.34652 35.7078 4.08868 35.3456 3.85769C35.2764 3.81472 35.2231 3.74488 35.1645 3.68579C35.1965 3.57299 35.2071 3.44944 35.2071 3.33126C35.2018 2.64904 35.2071 1.96682 35.2018 1.28461C35.2178 1.17717 35.2125 1.05362 35.1166 0.983787C34.4774 0.7528 33.8435 0.505698 33.2096 0.269339C33.0125 0.172647 32.7941 0.11893 32.5811 0.0866988H5.35642C5.23923 0.0920706 5.12737 0.15116 5.01018 0.178019Z'
          fill='#F8F3B5'
          stroke='#F8F3B5'
          stroke-width='0.094'
        />
        <path
          id='Vector_3'
          d='M2.78462 1.28516C3.25337 1.48391 3.75408 1.59672 4.22815 1.7901C4.48383 1.89217 4.56373 2.1715 4.67559 2.39712C4.56373 2.50992 4.43057 2.60124 4.2974 2.68719C3.80735 3.02024 3.30664 3.34255 2.82191 3.68634C2.76332 3.54131 2.78462 3.38015 2.7793 3.219C2.78462 2.57438 2.7793 1.92977 2.78462 1.28516ZM33.7593 1.7901C34.2333 1.60209 34.7287 1.47317 35.2028 1.28516C35.2081 1.96737 35.2028 2.64959 35.2081 3.33181C35.2081 3.44999 35.1975 3.57354 35.1655 3.68634C34.75 3.39627 34.3292 3.12231 33.9137 2.8376C33.7113 2.68719 33.4876 2.57438 33.3065 2.39174C33.4184 2.16613 33.5036 1.89217 33.7593 1.7901Z'
          fill='#F7B402'
          stroke='#F7B402'
          stroke-width='0.094'
        />
        <path
          id='Vector_4'
          d='M10.9128 2.0078C11.4988 1.86813 12.154 2.39457 12.106 3.01232C12.1113 3.61933 11.4775 4.11354 10.8969 3.97387C10.6625 3.8933 10.4388 3.76974 10.295 3.56025C10.1085 3.27554 10.0659 2.89414 10.2151 2.58258C10.3216 2.28176 10.6092 2.07763 10.9128 2.0078ZM26.1099 2.34622C26.3549 2.07226 26.7437 1.91648 27.106 2.01317C27.3776 2.09375 27.6439 2.27102 27.7611 2.53961C27.9955 3.00158 27.8144 3.62471 27.3563 3.86644C26.9515 4.09205 26.4401 3.98462 26.1312 3.65694C25.8169 3.29703 25.7956 2.70613 26.1099 2.34622Z'
          fill='#BDA727'
          stroke='#BDA727'
          stroke-width='0.094'
        />
        <path
          id='Vector_5'
          d='M4.29681 2.68607C4.42998 2.60012 4.56315 2.5088 4.67501 2.396L4.7123 2.4336C4.74958 2.71293 4.72295 2.99764 4.7336 3.27697C4.71762 4.11497 4.74958 4.95834 4.7123 5.79634C3.16223 5.79634 1.61217 5.78559 0.062104 5.79634C0.0194906 5.61907 0.168638 5.51163 0.301805 5.43105C1.07417 4.93148 1.81991 4.38356 2.59228 3.87861C2.6775 3.82489 2.75208 3.75506 2.82132 3.68522C3.30605 3.34143 3.80676 3.01912 4.29681 2.68607ZM33.2526 2.57864C33.2526 2.5088 33.2686 2.44971 33.3059 2.39062C33.487 2.57327 33.7107 2.68607 33.9132 2.83648C34.3286 3.12119 34.7494 3.39515 35.1649 3.68522C35.2235 3.74431 35.2768 3.81415 35.346 3.85712C35.7082 4.08811 36.0491 4.34595 36.4167 4.55545C36.5126 4.70049 36.6777 4.75958 36.8055 4.86702C37.1624 5.08189 37.482 5.35585 37.8549 5.53312C37.9454 5.58684 37.9135 5.70502 37.9188 5.79096C36.3688 5.79634 34.824 5.78559 33.2739 5.79634C33.2473 5.58146 33.2633 5.36659 33.258 5.15709C33.258 4.29761 33.2473 3.43812 33.2526 2.57864Z'
          fill='#F7E62D'
          stroke='#F7E62D'
          stroke-width='0.094'
        />
        <path
          id='Vector_6'
          d='M37.9187 5.79077C36.3686 5.79614 34.8239 5.7854 33.2738 5.79614C33.2472 5.58127 33.2631 5.3664 33.2578 5.1569C33.2578 4.29742 33.2472 3.43793 33.2525 2.57845C33.2525 2.50861 33.2685 2.44952 33.3058 2.39043C33.4176 2.16482 33.5028 1.89086 33.7585 1.78879C34.2326 1.60078 34.728 1.47186 35.2021 1.28385C35.218 1.17641 35.2127 1.05286 35.1168 0.983025C34.4776 0.752039 33.8438 0.504937 33.2099 0.268578C33.0128 0.171886 32.7944 0.118168 32.5813 0.0859375H5.35667C5.23948 0.0913093 5.12762 0.150399 5.01043 0.177258C4.32862 0.440475 3.64148 0.692949 2.95966 0.956167C2.86911 0.972282 2.82117 1.05286 2.77323 1.12269C2.77855 1.16567 2.78388 1.24087 2.78388 1.28385C3.25263 1.4826 3.75334 1.59541 4.22741 1.78879C4.48309 1.89086 4.56299 2.17019 4.67485 2.3958L4.71214 2.43341C4.74943 2.71274 4.72279 2.99744 4.73345 3.27678C4.71747 4.11478 4.74943 4.95815 4.71214 5.79614C3.16208 5.79614 1.61201 5.7854 0.0619477 5.79614C0.0353143 5.89284 0.0832544 5.97341 0.184461 5.94655C1.85704 5.93581 3.52429 5.9573 5.19687 5.93044C7.68443 5.93044 10.1667 5.93581 12.6542 5.93044L12.6915 5.91432C12.8034 5.94118 12.9152 5.93044 13.0324 5.93044C17.5388 5.93044 22.0452 5.93581 26.5569 5.93044C27.9738 5.93581 29.396 5.93044 30.8182 5.93044C33.1619 5.93044 35.511 5.95193 37.8547 5.94118C37.924 5.92507 37.9453 5.87672 37.9187 5.79077ZM10.2146 2.58382C10.3211 2.283 10.6088 2.07887 10.9124 2.00904C11.4983 1.86937 12.1535 2.3958 12.1056 3.01356C12.1109 3.62057 11.477 4.11478 10.8964 3.97511C10.662 3.89453 10.4383 3.77098 10.2945 3.56148C10.1081 3.27678 10.0655 2.89538 10.2146 2.58382ZM26.1094 2.34746C26.3544 2.0735 26.7433 1.91772 27.1055 2.01441C27.3772 2.09498 27.6435 2.27225 27.7607 2.54084C27.9951 3.00282 27.8139 3.62594 27.3559 3.86767C26.951 4.09329 26.4397 3.98585 26.1307 3.65817C25.8164 3.29826 25.7951 2.70737 26.1094 2.34746Z'
          fill='url(#paint1_radial_2_42436)'
          stroke='#FCD109'
          stroke-width='0.094'
        />
        <path
          id='Vector_7'
          d='M27.4678 8.14974C27.5423 8.16586 27.0794 7.7012 27.17 7.67971C27.2552 7.69045 27.5786 7.43744 27.969 7.64372C28.3594 7.84999 28.2625 8.33292 28.2183 8.51234C28.1656 8.7256 28.0308 8.8615 27.9243 8.96894C27.8657 9.01728 27.7341 9.09249 27.6542 9.08712C27.7021 8.8239 27.5477 8.78092 27.537 8.51234L27.4678 8.14974Z'
          fill='url(#paint2_linear_2_42436)'
          stroke='#FCD109'
          stroke-width='0.094'
        />
        <path
          id='Vector_8'
          d='M10.4394 8.44226C10.4287 8.71085 10.2743 8.75382 10.3222 9.01704C10.2423 9.02241 10.1107 8.94721 10.0521 8.89886C9.94561 8.79142 9.81138 8.65552 9.75864 8.44226C9.71443 8.26338 9.61748 7.78046 10.0079 7.57364C10.3984 7.36683 10.7217 7.62038 10.8069 7.60963C10.8975 7.63112 10.4346 8.09578 10.5092 8.07966L10.4394 8.44226Z'
          fill='url(#paint3_linear_2_42436)'
          stroke='#FCD109'
          stroke-width='0.094'
        />
        <path
          id='Vector_9'
          d='M26.7711 11.5899C26.851 11.5195 26.9042 11.5195 27.0108 11.5195C26.3716 12.9162 25.6258 14.3129 24.5046 15.4001C24.3847 15.5081 24.2579 15.608 24.1253 15.6999C23.9969 15.7944 23.8712 15.8836 23.746 15.9738C23.6235 16.0598 23.5015 16.1457 23.3833 16.236C23.0797 16.4025 22.8133 16.6335 22.4778 16.7355C21.8652 17.031 21.2047 17.2297 20.5388 17.3694C20.2778 17.4124 20.0115 17.4768 19.7452 17.4822C19.4149 17.5789 19.0634 17.5091 18.7278 17.5306C18.5413 17.5628 18.3762 17.4554 18.1951 17.4768C18.038 17.4543 17.8814 17.4274 17.7253 17.3963C17.5671 17.3635 17.41 17.3259 17.2544 17.2835C14.8127 16.5153 12.4157 14.6352 11.7173 12.0922C11.6859 11.9208 11.6699 11.7473 11.6699 11.5727C11.7445 11.7231 11.8217 11.8725 11.9016 12.0202C12.8951 14.2049 14.8659 15.9239 17.1942 16.4422C17.3833 16.5293 17.5879 16.4986 17.769 16.5738C17.9341 16.5738 18.0939 16.5685 18.2537 16.6222C18.8023 16.6329 19.351 16.6276 19.8996 16.6276C19.9742 16.6329 20.0435 16.5953 20.118 16.5792C21.0326 16.5481 21.9286 16.2967 22.7627 15.9153C22.9295 15.839 23.0941 15.7573 23.2555 15.6714C23.3966 15.5962 23.5351 15.5151 23.6693 15.4275C23.8014 15.3416 23.9293 15.2502 24.0539 15.1535C25.0399 14.366 25.8922 13.3454 26.4712 12.1717C26.5809 11.9616 26.6821 11.7661 26.7711 11.5899Z'
          fill='#BDA727'
          stroke='#BDA727'
          stroke-width='0.094'
        />
        <path
          id='Vector_10'
          d='M25.9021 16.3668C27.4841 15.4321 29.3165 14.9809 31.1382 14.8949C31.7295 14.8412 32.3261 14.8573 32.912 14.9325C33.2955 15.0238 33.6897 15.1313 33.9933 15.3945C33.8388 15.4052 33.6897 15.3354 33.5352 15.3139C33.0984 15.228 32.6457 15.2602 32.2035 15.2495C30.9198 15.2495 29.6254 15.3515 28.3843 15.7061C27.7345 15.9048 27.0846 16.1358 26.4933 16.4796C25.4706 17.049 24.5491 17.801 23.8034 18.7035C22.4717 20.2452 21.6887 22.2005 21.3105 24.1935C21.1294 25.2625 20.9216 26.3261 20.7565 27.4004C20.4902 27.4273 20.2185 27.4112 19.9522 27.4112C18.7803 27.4058 17.6084 27.4004 16.4366 27.3897C16.1862 27.4004 15.9412 27.3413 15.6908 27.3575C13.5602 27.3682 11.4295 27.3521 9.29883 27.3521L9.34144 27.336C10.9235 27.1694 12.5108 26.9814 14.0928 26.8256C16.101 26.8149 18.1038 26.8203 20.112 26.8256C20.1759 26.8149 20.2878 26.8471 20.2984 26.7558C20.4635 25.8856 20.6233 25.0154 20.7885 24.1451C21.0175 22.9365 21.3797 21.7439 21.939 20.6427C22.8179 18.87 24.2082 17.3659 25.9021 16.3668Z'
          fill='#0D69B3'
          stroke='#0D69B3'
          stroke-width='0.094'
        />
        <path
          id='Vector_11'
          d='M28.3843 15.7066C29.6254 15.3521 30.9198 15.25 32.2035 15.25C32.6456 15.2607 33.0984 15.2285 33.5352 15.3145C33.6897 15.3359 33.8388 15.4058 33.9933 15.395C34.2436 15.5992 34.3928 15.9 34.5046 16.2008C34.7497 16.9153 34.8882 17.6566 35.0054 18.4032C35.0107 18.7041 35.0639 19.0425 34.9041 19.3164C34.755 19.585 34.4567 19.714 34.1744 19.7945C33.1463 20.0631 32.0704 19.8106 31.0423 20.0631C30.1954 20.2458 29.407 20.7185 28.869 21.4007C28.2351 22.1957 27.8996 23.1841 27.7131 24.1725C27.5693 25.0535 27.3882 25.9345 27.2444 26.8208C27.1805 27.0196 27.1432 27.2344 27.1059 27.4439C28.1126 27.4601 29.1194 27.4439 30.1261 27.4547C30.5096 27.4439 30.8932 27.4654 31.2767 27.4386C31.4897 27.9328 31.4418 28.4914 31.3726 29.0125C31.2873 29.598 31.1488 30.1782 30.8878 30.7154C30.6694 31.172 30.3072 31.591 29.8118 31.7521C29.5562 31.8542 29.2792 31.8327 29.0075 31.8327C28.1126 31.8327 27.2177 31.8434 26.3229 31.8327C26.179 32.4934 26.0832 33.1703 25.9553 33.8417C25.721 35.1471 25.4919 36.4578 25.2575 37.7685C25.2522 37.8115 25.2469 37.9028 25.2469 37.9512V37.9565C22.9191 37.9565 20.5967 37.9619 18.2689 37.9565C18.2743 37.935 18.2796 37.8974 18.2849 37.876C18.2902 37.8491 18.2956 37.79 18.3009 37.7578C18.3062 37.8007 18.3115 37.8813 18.3169 37.9189C18.4607 37.935 18.7217 38.0102 18.759 37.8007C19.1212 35.8239 19.4568 33.8364 19.8296 31.8596C19.6858 31.8273 19.5367 31.8273 19.3875 31.8542C19.3662 31.9294 19.3449 32.0046 19.3183 32.0798L19.3502 31.8381C17.9014 31.8327 16.4472 31.8381 14.9983 31.8327C14.6468 31.822 14.2846 31.8327 13.933 31.7897C13.3311 31.7629 12.7239 31.7844 12.1219 31.7253C11.3762 31.7253 10.6358 31.6554 9.89006 31.6554C9.30413 31.5963 8.71286 31.6178 8.1216 31.591C7.73808 31.5426 7.34391 31.5641 6.95506 31.548C6.32119 31.4782 5.67666 31.5265 5.04278 31.4567C4.37162 31.462 3.70046 31.403 3.0293 31.3868C3.03462 31.3815 3.03995 31.36 3.03995 31.3546C3.26367 31.36 3.48206 31.3439 3.70579 31.3385C4.20117 31.274 4.70187 31.317 5.19726 31.2472C5.71394 31.2472 6.2253 31.1773 6.74199 31.1773C7.20009 31.1129 7.66351 31.1505 8.1216 31.086C8.6596 31.086 9.18694 31.0162 9.72493 31.0108C10.167 30.9517 10.6145 30.984 11.0566 30.9249C11.5733 30.9302 12.0847 30.8497 12.6013 30.855C13.1074 30.7959 13.6241 30.8121 14.1301 30.7583C14.0822 30.5596 14.0449 30.3608 14.0023 30.1621C13.965 30.0385 13.8158 30.0654 13.7199 30.0493C12.5641 29.8827 11.4135 29.7162 10.2629 29.5551C10.3375 29.496 10.4387 29.5228 10.5239 29.5121C11.4188 29.4423 12.3084 29.3617 13.2033 29.2972C13.4057 29.2865 13.6028 29.2489 13.8052 29.2435C13.7146 28.9642 13.6613 28.658 13.5388 28.4001C11.6266 28.1047 9.71428 27.8415 7.80733 27.5245C8.30271 27.4439 8.80342 27.4063 9.2988 27.3526C11.4295 27.3526 13.5601 27.3687 15.6908 27.358C15.9412 27.3419 16.1862 27.401 16.4365 27.3902C17.6084 27.401 18.7803 27.4063 19.9522 27.4117C20.2185 27.4117 20.4902 27.4278 20.7565 27.401C20.9216 26.3266 21.1294 25.263 21.3105 24.194C21.6887 22.2011 22.4717 20.2458 23.8033 18.7041C24.5491 17.8016 25.4706 17.0495 26.4933 16.4801C27.0846 16.1363 27.7344 15.9054 28.3843 15.7066Z'
          fill='#107BD4'
          stroke='#107BD4'
          stroke-width='0.094'
        />
        <path
          id='Vector_12'
          d='M27.2443 26.8203C28.2563 26.8257 29.2737 26.8149 30.2911 26.8257C30.696 26.8257 31.1114 27.0513 31.2766 27.4381C30.8931 27.4649 30.5095 27.4434 30.126 27.4542C29.1193 27.4434 28.1125 27.4596 27.1058 27.4434C27.1431 27.2339 27.1804 27.0191 27.2443 26.8203ZM19.3874 31.8537C19.5366 31.8268 19.6857 31.8268 19.8295 31.859C19.4567 33.8359 19.1211 35.8234 18.7589 37.8002C18.7216 38.0097 18.4606 37.9345 18.3168 37.9184C18.3114 37.8808 18.3061 37.8002 18.3008 37.7573C18.6364 35.8664 18.9613 33.9702 19.3182 32.0793C19.3448 32.0041 19.3661 31.9289 19.3874 31.8537Z'
          fill='#0D69B3'
          stroke='#0D69B3'
          stroke-width='0.094'
        />
        <path
          id='Vector_13'
          d='M27.7096 8.3004C27.6669 8.21982 27.6616 8.12313 27.6616 8.03181L27.619 8.03718C27.5551 7.80082 27.358 7.57521 27.1023 7.56446C26.9106 7.54835 26.6709 7.55372 26.559 7.73636C26.3459 8.02643 26.4471 8.39709 26.4365 8.72477C26.4365 8.74625 26.4418 8.78386 26.4418 8.80534C26.4418 9.02559 26.4152 9.24046 26.3779 9.45533C26.3459 9.51979 26.33 9.58962 26.33 9.66483C26.2394 10.1698 26.0583 10.6694 25.8133 11.126C25.7653 11.1904 25.728 11.2602 25.7121 11.3355C25.5523 11.6148 25.3605 11.8726 25.1634 12.1305C25.1314 12.1573 25.1048 12.1896 25.0782 12.2218C24.9397 12.3937 24.7905 12.5387 24.6361 12.6891C24.5988 12.7106 24.5721 12.7375 24.5402 12.759C24.3591 12.9362 24.1567 13.1028 23.9383 13.2371C23.9116 13.2532 23.885 13.2747 23.853 13.2962C22.4894 14.204 20.8328 14.58 19.2188 14.5961C17.8499 14.6391 16.4703 14.3437 15.2345 13.7474C15.2132 13.7366 15.1599 13.7152 15.1386 13.7044C14.9309 13.5916 14.7178 13.4949 14.526 13.3552C14.4834 13.3338 14.4408 13.3069 14.3929 13.2854C14.1958 13.1672 14.0093 13.0383 13.8336 12.8879C13.775 12.8342 13.711 12.7912 13.6471 12.7429C13.4554 12.5871 13.2583 12.4206 13.0932 12.2325C13.0505 12.1842 13.0079 12.1412 12.9653 12.0982C12.3847 11.4912 11.9319 10.7499 11.6922 9.94416C11.4632 9.30492 11.4952 8.60659 11.4685 7.93511C11.2768 7.63967 10.8719 7.47314 10.5523 7.65578C10.4192 7.75247 10.4032 7.92974 10.302 8.05329C10.1368 9.82598 10.8879 11.5933 12.0864 12.8718C12.0864 12.9148 12.1077 12.9416 12.145 12.9577C12.3581 13.1565 12.5658 13.3606 12.7789 13.554C12.8162 13.5916 12.8588 13.6292 12.9067 13.6614C13.1198 13.8387 13.3488 13.9999 13.5726 14.1664C13.6152 14.1986 13.6578 14.2255 13.7057 14.2523C13.9987 14.4242 14.2757 14.6284 14.59 14.7465C14.6113 14.7627 14.6485 14.7895 14.6699 14.8003C15.6819 15.2891 16.7739 15.6221 17.8925 15.7296C18.015 15.7296 18.1375 15.7403 18.26 15.7672C18.7927 15.7994 19.3254 15.7833 19.858 15.7725C21.504 15.6275 23.2032 15.2246 24.5775 14.247L24.5935 14.2684C24.6361 14.2308 24.6734 14.1986 24.716 14.1664C24.9344 14.0052 25.1474 13.8333 25.3605 13.6561C25.4084 13.6185 25.4617 13.5755 25.5096 13.5271C25.744 13.2693 26.0157 13.0329 26.2128 12.7375L26.2447 12.7536C26.2607 12.7267 26.2873 12.673 26.3033 12.6462C26.4844 12.3991 26.6496 12.1412 26.8094 11.8834C26.82 11.8673 26.8466 11.8404 26.8573 11.8243L26.836 11.8028C26.852 11.7813 26.8893 11.7383 26.9052 11.7169C27.1982 11.1152 27.4592 10.4867 27.5498 9.82061C27.587 9.8045 27.6084 9.77226 27.6084 9.73466C27.6137 9.51979 27.6883 9.31566 27.6669 9.10079C27.7149 8.83757 27.7202 8.56899 27.7096 8.3004Z'
          fill='white'
          stroke='white'
          stroke-width='0.094'
        />
        <g id='Group'>
          <g id='Clip path group'>
            <mask
              id='mask0_2_42436'
              maskUnits='userSpaceOnUse'
              x='10'
              y='7'
              width='18'
              height='9'
            >
              <g id='SVGID_6_'>
                <path
                  id='Vector_14'
                  d='M27.7096 8.3004C27.6669 8.21982 27.6616 8.12313 27.6616 8.03181L27.619 8.03718C27.5551 7.80082 27.358 7.57521 27.1023 7.56446C26.9106 7.54835 26.6709 7.55372 26.559 7.73636C26.3459 8.02643 26.4471 8.39709 26.4365 8.72477C26.4365 8.74625 26.4418 8.78386 26.4418 8.80534C26.4418 9.02559 26.4152 9.24046 26.3779 9.45533C26.3459 9.51979 26.33 9.58962 26.33 9.66483C26.2394 10.1698 26.0583 10.6694 25.8133 11.126C25.7653 11.1904 25.728 11.2602 25.7121 11.3355C25.5523 11.6148 25.3605 11.8726 25.1634 12.1305C25.1314 12.1573 25.1048 12.1896 25.0782 12.2218C24.9397 12.3937 24.7905 12.5387 24.6361 12.6891C24.5988 12.7106 24.5721 12.7375 24.5402 12.759C24.3591 12.9362 24.1567 13.1028 23.9383 13.2371C23.9116 13.2532 23.885 13.2747 23.853 13.2962C22.4894 14.204 20.8328 14.58 19.2188 14.5961C17.8499 14.6391 16.4703 14.3437 15.2345 13.7474C15.2132 13.7366 15.1599 13.7152 15.1386 13.7044C14.9309 13.5916 14.7178 13.4949 14.526 13.3552C14.4834 13.3338 14.4408 13.3069 14.3929 13.2854C14.1958 13.1672 14.0093 13.0383 13.8336 12.8879C13.775 12.8342 13.711 12.7912 13.6471 12.7429C13.4554 12.5871 13.2583 12.4206 13.0932 12.2325C13.0505 12.1842 13.0079 12.1412 12.9653 12.0982C12.3847 11.4912 11.9319 10.7499 11.6922 9.94416C11.4632 9.30492 11.4952 8.60659 11.4685 7.93511C11.2768 7.63967 10.8719 7.47314 10.5523 7.65578C10.4192 7.75247 10.4032 7.92974 10.302 8.05329C10.1368 9.82598 10.8879 11.5933 12.0864 12.8718C12.0864 12.9148 12.1077 12.9416 12.145 12.9577C12.3581 13.1565 12.5658 13.3606 12.7789 13.554C12.8162 13.5916 12.8588 13.6292 12.9067 13.6614C13.1198 13.8387 13.3488 13.9999 13.5726 14.1664C13.6152 14.1986 13.6578 14.2255 13.7057 14.2523C13.9987 14.4242 14.2757 14.6284 14.59 14.7465C14.6113 14.7627 14.6485 14.7895 14.6699 14.8003C15.6819 15.2891 16.7739 15.6221 17.8925 15.7296C18.015 15.7296 18.1375 15.7403 18.26 15.7672C18.7927 15.7994 19.3254 15.7833 19.858 15.7725C21.504 15.6275 23.2032 15.2246 24.5775 14.247L24.5935 14.2684C24.6361 14.2308 24.6734 14.1986 24.716 14.1664C24.9344 14.0052 25.1474 13.8333 25.3605 13.6561C25.4084 13.6185 25.4617 13.5755 25.5096 13.5271C25.744 13.2693 26.0157 13.0329 26.2128 12.7375L26.2447 12.7536C26.2607 12.7267 26.2873 12.673 26.3033 12.6462C26.4844 12.3991 26.6496 12.1412 26.8094 11.8834C26.82 11.8673 26.8466 11.8404 26.8573 11.8243L26.836 11.8028C26.852 11.7813 26.8893 11.7383 26.9052 11.7169C27.1982 11.1152 27.4592 10.4867 27.5498 9.82061C27.587 9.8045 27.6084 9.77226 27.6084 9.73466C27.6137 9.51979 27.6883 9.31566 27.6669 9.10079C27.7149 8.83757 27.7202 8.56899 27.7096 8.3004Z'
                  fill='white'
                />
              </g>
            </mask>
            <g mask='url(#mask0_2_42436)'>
              <g id='Group_2'>
                <path
                  id='Vector_15'
                  d='M9.89258 8.12034C10.3246 8.25679 11.3164 7.91353 11.5971 8.22778M10.1408 9.44502C10.5547 9.29999 11.4421 8.95619 11.8096 9.15871M10.5669 10.7702C10.7672 10.8358 11.1614 10.4812 11.3569 10.3776C11.6483 10.2229 11.9471 10.1047 12.2715 10.0542M11.2061 12.1669C11.4123 11.8715 11.6594 11.6254 11.9572 11.4159C12.2528 11.208 13.0609 10.6515 13.4077 10.8422M11.8102 13.1698C12.0446 12.9823 12.1399 12.6498 12.3855 12.4527C12.6827 12.2142 13.1387 12.1712 13.4433 12.024M12.8132 13.9127C12.8835 13.3933 13.4061 12.7669 13.9052 12.8115M13.5856 14.6379C13.8492 14.6111 14.0724 14.0159 14.2509 13.8144C14.5183 13.5125 14.7947 13.4191 15.1484 13.3127M15.1127 15.2825C15.0957 14.9065 15.4808 13.8295 15.9293 13.8859M16.2489 15.6408C16.2303 15.1966 16.4577 13.8606 16.9946 13.8144M17.4208 16.3569C17.319 15.7359 17.3254 14.8372 17.8112 14.3871M18.8766 16.5003C18.8222 15.9825 18.3125 14.9361 18.8766 14.5305M20.4394 16.142C20.196 15.8573 20.0543 14.7341 20.1555 14.4231M21.9309 15.8912C21.7428 15.5474 21.5101 15.224 21.4392 14.8249C21.3966 14.5864 21.4712 14.2463 21.4339 14.0648M23.1736 15.354C22.7661 15.0854 22.6532 14.0975 22.7831 13.671M24.3811 14.8168C24.0914 14.1899 23.7824 13.7038 23.7776 12.9904M25.553 13.671C25.1029 13.3654 24.5282 12.8104 24.5942 12.2029M26.7957 12.7041C26.1118 12.551 25.2904 11.9338 24.8781 11.3789M27.3641 11.5223C26.8703 11.4154 25.2398 10.774 25.3399 10.1256M27.8968 10.2691C27.2091 10.015 26.2087 9.78613 25.6596 9.30213M28.2515 9.12272C27.8185 9.16032 27.1979 8.94867 26.7574 8.87185C26.2684 8.78698 25.8151 8.62045 25.3394 8.51356M27.8254 8.01291C26.9902 8.0634 26.2061 7.77494 25.4459 7.51172'
                  stroke='#D1D1D1'
                  stroke-width='2'
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <defs>
      <filter
        id='filter0_i_2_42436'
        x='-25'
        y='-23'
        width='90'
        height='86'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset />
        <feGaussianBlur stdDeviation='5.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.246842 0 0 0 0 0.246842 0 0 0 0 0.246842 0 0 0 0.25 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_2_42436'
        />
      </filter>
      <linearGradient
        id='paint0_linear_2_42436'
        x1='18.9967'
        y1='6.42568'
        x2='18.9967'
        y2='37.9991'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#F7E830' />
        <stop offset='1' stop-color='#FDCB06' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_2_42436'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(18.8324 20.8251) scale(25.4658 25.6814)'
      >
        <stop offset='0.596' stop-color='#F29405' />
        <stop offset='0.736' stop-color='#F7D01E' />
        <stop offset='1' stop-color='#FDCB06' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_2_42436'
        x1='27.708'
        y1='7.56265'
        x2='27.717'
        y2='9.05778'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#FADA1C' />
        <stop offset='1' stop-color='#FDCB06' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_2_42436'
        x1='10.2688'
        y1='7.49185'
        x2='10.2597'
        y2='8.98697'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#FADA1C' />
        <stop offset='1' stop-color='#FDCB06' />
      </linearGradient>
      <clipPath id='clip0_2_42436'>
        <rect
          width='1440'
          height='2882'
          fill='white'
          transform='translate(-405 -702)'
        />
      </clipPath>
      <clipPath id='clip1_2_42436'>
        <rect width='38' height='38' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

/* export const FlipkartPlus = (
 
); */

export const InstagramLogo = (
  <svg
    width='34'
    height='34'
    viewBox='0 0 34 34'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='skill-icons:instagram' clip-path='url(#clip0_2385_10179)'>
      <g id='Group'>
        <path
          id='Vector'
          d='M26.0312 0H7.96875C3.56773 0 0 3.56773 0 7.96875V26.0312C0 30.4323 3.56773 34 7.96875 34H26.0312C30.4323 34 34 30.4323 34 26.0312V7.96875C34 3.56773 30.4323 0 26.0312 0Z'
          fill='url(#paint0_radial_2385_10179)'
        />
        <path
          id='Vector_2'
          d='M26.0312 0H7.96875C3.56773 0 0 3.56773 0 7.96875V26.0312C0 30.4323 3.56773 34 7.96875 34H26.0312C30.4323 34 34 30.4323 34 26.0312V7.96875C34 3.56773 30.4323 0 26.0312 0Z'
          fill='url(#paint1_radial_2385_10179)'
        />
        <path
          id='Vector_3'
          d='M17.0012 3.71875C13.3943 3.71875 12.9415 3.73455 11.5249 3.79897C10.111 3.86378 9.14587 4.08757 8.30145 4.41602C7.4278 4.75522 6.68684 5.20904 5.94867 5.94748C5.20984 6.68578 4.75602 7.42674 4.41575 8.29998C4.08638 9.14467 3.86232 10.1102 3.7987 11.5235C3.73535 12.9402 3.71875 13.3931 3.71875 17.0001C3.71875 20.6072 3.73469 21.0585 3.79897 22.4751C3.86405 23.889 4.08784 24.8541 4.41602 25.6986C4.75548 26.5722 5.2093 27.3132 5.94774 28.0513C6.68578 28.7902 7.42674 29.245 8.29972 29.5842C9.1448 29.9127 10.1101 30.1365 11.5237 30.2013C12.9405 30.2657 13.3928 30.2815 16.9996 30.2815C20.6069 30.2815 21.0582 30.2657 22.4748 30.2013C23.8887 30.1365 24.8549 29.9127 25.7 29.5842C26.5733 29.245 27.3132 28.7902 28.0511 28.0513C28.7899 27.3132 29.2436 26.5722 29.584 25.699C29.9104 24.8541 30.1346 23.8887 30.201 22.4753C30.2646 21.0588 30.2812 20.6072 30.2812 17.0001C30.2812 13.3931 30.2646 12.9405 30.201 11.5237C30.1346 10.1098 29.9104 9.1448 29.584 8.30038C29.2436 7.42674 28.7899 6.68578 28.0511 5.94748C27.3124 5.20877 26.5735 4.75495 25.6992 4.41615C24.8525 4.08757 23.8869 3.86365 22.4729 3.79897C21.0562 3.73455 20.6052 3.71875 16.9971 3.71875H17.0012ZM15.8097 6.11216C16.1634 6.11163 16.558 6.11216 17.0012 6.11216C20.5474 6.11216 20.9676 6.12491 22.368 6.18853C23.6629 6.24777 24.3658 6.46412 24.8339 6.64594C25.4538 6.88659 25.8956 7.1744 26.3602 7.63937C26.8251 8.10422 27.1127 8.54688 27.3541 9.16672C27.5359 9.63422 27.7525 10.3371 27.8115 11.632C27.8751 13.0321 27.8889 13.4526 27.8889 16.9971C27.8889 20.5416 27.8751 20.9622 27.8115 22.3622C27.7522 23.6571 27.5359 24.3599 27.3541 24.8276C27.1134 25.4474 26.8251 25.8887 26.3602 26.3533C25.8954 26.8182 25.454 27.1058 24.8339 27.3466C24.3663 27.5292 23.6629 27.7451 22.368 27.8043C20.9679 27.8679 20.5474 27.8817 17.0012 27.8817C13.4548 27.8817 13.0345 27.8679 11.6345 27.8043C10.3396 27.7445 9.63674 27.5282 9.16818 27.3464C8.54848 27.1056 8.10568 26.8179 7.64084 26.3531C7.17599 25.8882 6.88832 25.4466 6.647 24.8265C6.46518 24.3589 6.24856 23.656 6.18959 22.3611C6.12598 20.961 6.11323 20.5405 6.11323 16.9938C6.11323 13.4471 6.12598 13.0288 6.18959 11.6287C6.24883 10.3337 6.46518 9.6309 6.647 9.16273C6.88779 8.5429 7.17599 8.10023 7.64097 7.63539C8.10581 7.17055 8.54848 6.88274 9.16831 6.64155C9.63648 6.45894 10.3396 6.24312 11.6345 6.18362C12.8597 6.12823 13.3345 6.11163 15.8097 6.10884V6.11216ZM24.0907 8.31738C23.2108 8.31738 22.497 9.03059 22.497 9.9106C22.497 10.7905 23.2108 11.5044 24.0907 11.5044C24.9706 11.5044 25.6845 10.7905 25.6845 9.9106C25.6845 9.03072 24.9706 8.31685 24.0907 8.31685V8.31738ZM17.0012 10.1795C13.2346 10.1795 10.1807 13.2334 10.1807 17.0001C10.1807 20.7668 13.2346 23.8193 17.0012 23.8193C20.7679 23.8193 23.8207 20.7668 23.8207 17.0001C23.8207 13.2336 20.7676 10.1795 17.0009 10.1795H17.0012ZM17.0012 12.573C19.4461 12.573 21.4284 14.5549 21.4284 17.0001C21.4284 19.4451 19.4461 21.4273 17.0012 21.4273C14.5561 21.4273 12.5742 19.4451 12.5742 17.0001C12.5742 14.5549 14.5561 12.573 17.0012 12.573Z'
          fill='white'
        />
      </g>
    </g>
    <defs>
      <radialGradient
        id='paint0_radial_2385_10179'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(9.03125 36.6187) rotate(-90) scale(33.6965 31.3404)'
      >
        <stop stop-color='#FFDD55' />
        <stop offset='0.1' stop-color='#FFDD55' />
        <stop offset='0.5' stop-color='#FF543E' />
        <stop offset='1' stop-color='#C837AB' />
      </radialGradient>
      <radialGradient
        id='paint1_radial_2385_10179'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(-5.69513 2.4492) rotate(78.681) scale(15.0625 62.0882)'
      >
        <stop stop-color='#3771C8' />
        <stop offset='0.128' stop-color='#3771C8' />
        <stop offset='1' stop-color='#6600FF' stop-opacity='0' />
      </radialGradient>
      <clipPath id='clip0_2385_10179'>
        <rect width='34' height='34' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const FacebookLogo = (
  <svg
    width='39'
    height='39'
    viewBox='0 0 39 39'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M39 19.5C39 8.73052 30.2695 0 19.5 0C8.73052 0 0 8.73052 0 19.5C0 29.2329 7.13091 37.3003 16.4531 38.7631V25.1367H11.502V19.5H16.4531V15.2039C16.4531 10.3167 19.3644 7.61719 23.8186 7.61719C25.9521 7.61719 28.1836 7.99805 28.1836 7.99805V12.7969H25.7248C23.3023 12.7969 22.5469 14.3001 22.5469 15.8422V19.5H27.9551L27.0905 25.1367H22.5469V38.7631C31.8691 37.3003 39 29.2331 39 19.5Z'
      fill='#1877F2'
    />
    <path
      d='M27.0905 25.1367L27.9551 19.5H22.5469V15.8422C22.5469 14.2999 23.3023 12.7969 25.7248 12.7969H28.1836V7.99805C28.1836 7.99805 25.9521 7.61719 23.8185 7.61719C19.3644 7.61719 16.4531 10.3167 16.4531 15.2039V19.5H11.502V25.1367H16.4531V38.7631C17.4611 38.921 18.4798 39.0002 19.5 39C20.5202 39.0002 21.5389 38.921 22.5469 38.7631V25.1367H27.0905Z'
      fill='white'
    />
  </svg>
);

export const FbWhiteIcon = (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M32 16C32 7.1635 24.8365 0 16 0C7.1635 0 0 7.1635 0 16C0 23.986 5.851 30.6054 13.5 31.8056V20.625H9.4375V16H13.5V12.475C13.5 8.465 15.8888 6.25 19.5435 6.25C21.294 6.25 23.125 6.5625 23.125 6.5625V10.5H21.1075C19.1199 10.5 18.5 11.7334 18.5 12.9987V16H22.9375L22.2281 20.625H18.5V31.8056C26.149 30.6054 32 23.9861 32 16Z'
      fill='white'
    />
  </svg>
);

export const InstagramIconSmall = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <g clip-path='url(#clip0_2385_10174)'>
      <path
        d='M12.25 0H3.75C1.67893 0 0 1.67893 0 3.75V12.25C0 14.3211 1.67893 16 3.75 16H12.25C14.3211 16 16 14.3211 16 12.25V3.75C16 1.67893 14.3211 0 12.25 0Z'
        fill='url(#paint0_radial_2385_10174)'
      />
      <path
        d='M12.25 0H3.75C1.67893 0 0 1.67893 0 3.75V12.25C0 14.3211 1.67893 16 3.75 16H12.25C14.3211 16 16 14.3211 16 12.25V3.75C16 1.67893 14.3211 0 12.25 0Z'
        fill='url(#paint1_radial_2385_10174)'
      />
      <path
        d='M8.00056 1.75C6.30319 1.75 6.09013 1.75744 5.4235 1.78775C4.75813 1.81825 4.30394 1.92356 3.90656 2.07812C3.49544 2.23775 3.14675 2.45131 2.79938 2.79881C2.45169 3.14625 2.23813 3.49494 2.078 3.90587C1.923 4.30338 1.81756 4.75775 1.78762 5.42281C1.75781 6.0895 1.75 6.30263 1.75 8.00006C1.75 9.6975 1.7575 9.90987 1.78775 10.5765C1.81838 11.2419 1.92369 11.6961 2.07812 12.0934C2.23787 12.5046 2.45144 12.8533 2.79894 13.2006C3.14625 13.5483 3.49494 13.7624 3.90575 13.922C4.30344 14.0766 4.75769 14.1819 5.42294 14.2124C6.08962 14.2427 6.3025 14.2501 7.99981 14.2501C9.69738 14.2501 9.90975 14.2427 10.5764 14.2124C11.2417 14.1819 11.6964 14.0766 12.0941 13.922C12.5051 13.7624 12.8532 13.5483 13.2005 13.2006C13.5482 12.8533 13.7617 12.5046 13.9219 12.0936C14.0755 11.6961 14.181 11.2417 14.2122 10.5766C14.2422 9.91 14.25 9.6975 14.25 8.00006C14.25 6.30263 14.2422 6.08962 14.2122 5.42294C14.181 4.75756 14.0755 4.30344 13.9219 3.90606C13.7617 3.49494 13.5482 3.14625 13.2005 2.79881C12.8529 2.45119 12.5052 2.23762 12.0938 2.07819C11.6953 1.92356 11.2409 1.81819 10.5755 1.78775C9.90881 1.75744 9.69656 1.75 7.99862 1.75H8.00056ZM7.43988 2.87631C7.60631 2.87606 7.792 2.87631 8.00056 2.87631C9.66938 2.87631 9.86712 2.88231 10.5261 2.91225C11.1355 2.94012 11.4663 3.04194 11.6866 3.1275C11.9783 3.24075 12.1862 3.37619 12.4048 3.595C12.6236 3.81375 12.7589 4.02206 12.8725 4.31375C12.9581 4.53375 13.06 4.8645 13.0878 5.47388C13.1177 6.13275 13.1242 6.33062 13.1242 7.99862C13.1242 9.66663 13.1177 9.86456 13.0878 10.5234C13.0599 11.1327 12.9581 11.4635 12.8725 11.6836C12.7593 11.9753 12.6236 12.1829 12.4048 12.4016C12.1861 12.6203 11.9784 12.7557 11.6866 12.869C11.4665 12.9549 11.1355 13.0565 10.5261 13.0844C9.86725 13.1143 9.66938 13.1208 8.00056 13.1208C6.33169 13.1208 6.13387 13.1143 5.47506 13.0844C4.86569 13.0563 4.53494 12.9544 4.31444 12.8689C4.02281 12.7556 3.81444 12.6202 3.59569 12.4014C3.37694 12.1827 3.24156 11.9749 3.128 11.6831C3.04244 11.463 2.9405 11.1322 2.91275 10.5229C2.88281 9.864 2.87681 9.66613 2.87681 7.99706C2.87681 6.32806 2.88281 6.13119 2.91275 5.47231C2.94062 4.86294 3.04244 4.53219 3.128 4.31187C3.24131 4.02019 3.37694 3.81188 3.59575 3.59313C3.8145 3.37438 4.02281 3.23894 4.3145 3.12544C4.53481 3.0395 4.86569 2.93794 5.47506 2.90994C6.05162 2.88387 6.27506 2.87606 7.43988 2.87475V2.87631ZM11.3368 3.91406C10.9228 3.91406 10.5868 4.24969 10.5868 4.66381C10.5868 5.07788 10.9228 5.41381 11.3368 5.41381C11.7509 5.41381 12.0868 5.07788 12.0868 4.66381C12.0868 4.24975 11.7509 3.91381 11.3368 3.91381V3.91406ZM8.00056 4.79038C6.22806 4.79038 4.79094 6.2275 4.79094 8.00006C4.79094 9.77262 6.22806 11.2091 8.00056 11.2091C9.77312 11.2091 11.2098 9.77262 11.2098 8.00006C11.2098 6.22756 9.773 4.79038 8.00044 4.79038H8.00056ZM8.00056 5.91669C9.15112 5.91669 10.0839 6.84938 10.0839 8.00006C10.0839 9.15063 9.15112 10.0834 8.00056 10.0834C6.84994 10.0834 5.91725 9.15063 5.91725 8.00006C5.91725 6.84938 6.84994 5.91669 8.00056 5.91669Z'
        fill='white'
      />
    </g>
    <defs>
      <radialGradient
        id='paint0_radial_2385_10174'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(4.25 17.2323) rotate(-90) scale(15.8572 14.7484)'
      >
        <stop stop-color='#FFDD55' />
        <stop offset='0.1' stop-color='#FFDD55' />
        <stop offset='0.5' stop-color='#FF543E' />
        <stop offset='1' stop-color='#C837AB' />
      </radialGradient>
      <radialGradient
        id='paint1_radial_2385_10174'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(-2.68006 1.15256) rotate(78.681) scale(7.08825 29.218)'
      >
        <stop stop-color='#3771C8' />
        <stop offset='0.128' stop-color='#3771C8' />
        <stop offset='1' stop-color='#6600FF' stop-opacity='0' />
      </radialGradient>
      <clipPath id='clip0_2385_10174'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const SidePanelIcon = (
  <svg
    width='19'
    height='19'
    viewBox='0 0 19 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.576 2.6105L17.1 9.78397L9.576 16.9574L8.2365 15.6713L13.4615 10.6897H0V8.87823H13.4615L8.2365 3.89665L9.576 2.6105ZM17.1 9.78397V18.8414H19V0.726562H17.1V9.78397Z'
      fill='#727272'
    />
  </svg>
);

export const FbBlackIcon = (
  <svg
    width='16'
    height='29'
    viewBox='0 0 16 29'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.68757 29H9.84379V16.7742H15.3905L16 10.6995H9.84379V7.63158C9.84379 7.22677 10.0059 6.83855 10.2946 6.55231C10.5832 6.26607 10.9747 6.10526 11.3828 6.10526H16V0H11.3828C9.34193 0 7.38461 0.804039 5.94146 2.23524C4.49832 3.66644 3.68757 5.60756 3.68757 7.63158V10.6995H0.609465L0 16.7742H3.68757V29Z'
      fill='black'
    />
  </svg>
);

export const TwitterBlackIcon = (
  <svg
    width='33'
    height='30'
    viewBox='0 0 33 30'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0.623718 0.543945H4.28782L26.2724 29.8567H22.6083L0.623718 0.543945ZM7.2191 0.543945H10.8832L32.8678 29.8567H29.2037L7.2191 0.543945Z'
      fill='black'
    />
    <path
      d='M3.55484 0.543945H10.883V3.47522H3.55484V0.543945ZM22.6082 29.8567H29.9364V26.9255H22.6082V29.8567Z'
      fill='black'
      fill-opacity='0.7'
    />
    <path
      d='M26.2724 0.543945H31.4021L6.48623 29.8567H1.35649L26.2724 0.543945Z'
      fill='black'
      fill-opacity='0.7'
    />
  </svg>
);

export const LinkedInBlackIcon = (
  <svg
    width='30'
    height='31'
    viewBox='0 0 30 31'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M11.1435 10.802H16.7145V13.6695C17.517 12.0203 19.575 10.5385 22.6665 10.5385C28.593 10.5385 30 13.8214 30 19.8447V31H24V21.2164C24 17.7862 23.1975 15.8519 21.1545 15.8519C18.321 15.8519 17.1435 17.9366 17.1435 21.2148V31H11.1435V10.802ZM0.855 30.7365H6.855V10.5385H0.855V30.7365ZM7.7145 3.9525C7.71472 4.47218 7.61498 4.98672 7.42108 5.46621C7.22718 5.94571 6.94298 6.3806 6.585 6.7456C6.22596 7.11468 5.80006 7.40704 5.33163 7.60598C4.86321 7.80491 4.36144 7.90652 3.855 7.905C2.8344 7.90263 1.85537 7.48694 1.128 6.74715C0.77145 6.3808 0.488298 5.94541 0.294744 5.46587C0.10119 4.98634 0.00103233 4.47207 0 3.9525C0 2.90315 0.405 1.89875 1.1295 1.15785C1.85505 0.415218 2.83526 -0.000967391 3.8565 1.68858e-06C4.8795 1.68858e-06 5.8605 0.416952 6.585 1.15785C7.3095 1.89875 7.7145 2.90315 7.7145 3.9525Z'
      fill='black'
    />
  </svg>
);

export const CopyLinkIcon = (
  <svg
    width='31'
    height='31'
    viewBox='0 0 31 31'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17.5991 2.33591C18.3236 1.59985 19.1865 1.01449 20.1383 0.613583C21.0901 0.212679 22.1118 0.00416398 23.1445 6.17316e-05C24.1772 -0.00404052 25.2006 0.196351 26.1555 0.589681C27.1104 0.983011 27.978 1.5615 28.7083 2.29178C29.4385 3.02206 30.017 3.88969 30.4103 4.84463C30.8037 5.79957 31.004 6.82293 30.9999 7.8557C30.9958 8.88847 30.7873 9.9102 30.3864 10.862C29.9855 11.8138 29.4002 12.6768 28.6642 13.4012L23.695 18.3706L21.3744 16.0532L26.3436 11.0822C27.1961 10.2301 27.6752 9.07427 27.6755 7.86891C27.6758 6.66356 27.1973 5.50745 26.3452 4.65492C25.4931 3.80239 24.3373 3.32327 23.132 3.32296C21.9267 3.32265 20.7706 3.80118 19.9181 4.65328L14.9472 9.62424L12.6283 7.30522L17.5991 2.33591ZM21.0759 12.2417L12.1953 21.1209L9.87638 18.8019L18.7553 9.92272L21.0759 12.2417ZM9.57954 14.9904L4.61036 19.9614C3.75785 20.8139 3.27891 21.9702 3.27891 23.1759C3.27891 24.3815 3.75785 25.5378 4.61036 26.3903C5.46287 27.2429 6.61912 27.7218 7.82475 27.7218C9.03038 27.7218 10.1866 27.2429 11.0391 26.3903L16.0083 21.4194L18.3273 23.7384L13.3581 28.7077C11.8908 30.1753 9.90058 30.9998 7.82533 31C5.75008 31.0002 3.75976 30.1759 2.29223 28.7085C0.824692 27.2412 0.000153801 25.2509 2.15141e-08 23.1756C-0.000153758 21.1003 0.82409 19.11 2.29141 17.6424L7.26059 12.6731L9.57954 14.9904Z'
      fill='black'
    />
  </svg>
);

export const BrandAstraNavigator = (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='40' height='40' rx='5' fill='white' fill-opacity='0.6' />
    <path
      d='M12.6282 20.0605C11.1266 19.5262 10.3758 19.259 10.1521 18.8538C9.95825 18.5026 9.94918 18.0787 10.1278 17.7196C10.334 17.3052 11.0727 17.0062 12.5501 16.4082L26.4758 10.7716C27.9308 10.1826 28.6584 9.88816 29.118 10.0391C29.5169 10.1702 29.8298 10.4831 29.9608 10.882C30.1118 11.3416 29.8174 12.0692 29.2284 13.5242L23.5918 27.4499C22.9938 28.9273 22.6948 29.666 22.2804 29.8722C21.9213 30.0508 21.4974 30.0418 21.1462 29.8479C20.741 29.6242 20.4738 28.8734 19.9395 27.3718L18.3037 22.7744C18.1997 22.4823 18.1478 22.3362 18.0629 22.2142C17.9877 22.1062 17.8938 22.0123 17.7858 21.9371C17.6638 21.8522 17.5177 21.8003 17.2256 21.6963L12.6282 20.0605Z'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const HolisticView = (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='0.664062'
      width='40'
      height='40'
      rx='5'
      fill='white'
      fill-opacity='0.6'
    />
    <path
      d='M22.6641 13H28.6641'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M22.6641 16H25.6641'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M29.6641 19.5C29.6641 24.75 25.4141 29 20.1641 29C14.9141 29 10.6641 24.75 10.6641 19.5C10.6641 14.25 14.9141 10 20.1641 10'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M30.6641 30L28.6641 28'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const WhyTrends = (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='0.335938'
      width='40'
      height='40'
      rx='5'
      fill='white'
      fill-opacity='0.6'
    />
    <path
      d='M17.3359 30H23.3359C28.3359 30 30.3359 28 30.3359 23V17C30.3359 12 28.3359 10 23.3359 10H17.3359C12.3359 10 10.3359 12 10.3359 17V23C10.3359 28 12.3359 30 17.3359 30Z'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M15.6641 22.4898L18.0441 19.3998C18.3841 18.9598 19.0141 18.8798 19.4541 19.2198L21.2841 20.6598C21.7241 20.9998 22.3541 20.9198 22.6941 20.4898L25.0041 17.5098'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const BenchMark = (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='40' height='40' rx='5' fill='white' fill-opacity='0.6' />
    <path
      d='M10 30H30'
      stroke='#063257'
      stroke-width='1.5'
      stroke-miterlimit='10'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M17.75 12V30H22.25V12C22.25 10.9 21.8 10 20.45 10H19.55C18.2 10 17.75 10.9 17.75 12Z'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M11 18V30H15V18C15 16.9 14.6 16 13.4 16H12.6C11.4 16 11 16.9 11 18Z'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M25 23V30H29V23C29 21.9 28.6 21 27.4 21H26.6C25.4 21 25 21.9 25 23Z'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);
export const Multichannel = (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='0.664062'
      width='40'
      height='40'
      rx='5'
      fill='white'
      fill-opacity='0.6'
    />
    <path
      d='M10.6641 10V27C10.6641 28.66 12.0041 30 13.6641 30H30.6641'
      stroke='#063257'
      stroke-width='1.5'
      stroke-miterlimit='10'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M13.6641 25L18.2541 19.64C19.0141 18.76 20.3641 18.7 21.1841 19.53L22.1341 20.48C22.9541 21.3 24.3041 21.25 25.0641 20.37L29.6641 15'
      stroke='#063257'
      stroke-width='1.5'
      stroke-miterlimit='10'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);
export const GenAI = (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='0.335938'
      width='40'
      height='40'
      rx='5'
      fill='white'
      fill-opacity='0.6'
    />
    <path
      d='M14.2381 25H26.4281C28.3281 25 29.3281 24 29.3281 22.1V10H11.3281V22.1C11.3381 24 12.3381 25 14.2381 25Z'
      stroke='#063257'
      stroke-width='1.5'
      stroke-miterlimit='10'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M10.3359 10H30.3359'
      stroke='#063257'
      stroke-width='1.5'
      stroke-miterlimit='10'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M16.3359 30L20.3359 28V25'
      stroke='#063257'
      stroke-width='1.5'
      stroke-miterlimit='10'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M24.3359 30L20.3359 28'
      stroke='#063257'
      stroke-width='1.5'
      stroke-miterlimit='10'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M15.8359 19L18.9859 16.37C19.2359 16.16 19.5659 16.22 19.7359 16.5L20.9359 18.5C21.1059 18.78 21.4359 18.83 21.6859 18.63L24.8359 16'
      stroke='#063257'
      stroke-width='1.5'
      stroke-miterlimit='10'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);
export const Publishing = (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='40' height='40' rx='5' fill='white' fill-opacity='0.6' />
    <path
      d='M20.3672 16.8799H25.6172'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M14.3828 16.8799L15.1328 17.6299L17.3828 15.3799'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M20.3672 23.8799H25.6172'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M14.3828 23.8799L15.1328 24.6299L17.3828 22.3799'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M17 30H23C28 30 30 28 30 23V17C30 12 28 10 23 10H17C12 10 10 12 10 17V23C10 28 12 30 17 30Z'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const UnderstandLanguage = (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='0.664062'
      width='40'
      height='40'
      rx='5'
      fill='white'
      fill-opacity='0.6'
    />
    <path
      d='M26.6641 26.8597H25.9041C25.1041 26.8597 24.3441 27.1697 23.7841 27.7297L22.074 29.4197C21.294 30.1897 20.0241 30.1897 19.2441 29.4197L17.5341 27.7297C16.9741 27.1697 16.2041 26.8597 15.4141 26.8597H14.6641C13.0041 26.8597 11.6641 25.5298 11.6641 23.8898V12.9797C11.6641 11.3397 13.0041 10.0098 14.6641 10.0098H26.6641C28.3241 10.0098 29.6641 11.3397 29.6641 12.9797V23.8898C29.6641 25.5198 28.3241 26.8597 26.6641 26.8597Z'
      stroke='#063257'
      stroke-width='1.5'
      stroke-miterlimit='10'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M20.666 17.9998C21.9528 17.9998 22.996 16.9566 22.996 15.6698C22.996 14.383 21.9528 13.3398 20.666 13.3398C19.3791 13.3398 18.3359 14.383 18.3359 15.6698C18.3359 16.9566 19.3791 17.9998 20.666 17.9998Z'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M24.6641 23.6599C24.6641 21.8599 22.8741 20.3999 20.6641 20.3999C18.4541 20.3999 16.6641 21.8599 16.6641 23.6599'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const EnterPriseCompatibility = (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='0.335938'
      width='40'
      height='40'
      rx='5'
      fill='white'
      fill-opacity='0.6'
    />
    <path
      d='M25.2969 14.1699C27.2969 15.5599 28.6769 17.7699 28.9569 20.3199'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M11.8281 20.3702C12.0881 17.8302 13.4481 15.6202 15.4281 14.2202'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M16.5234 28.9399C17.6834 29.5299 19.0034 29.8599 20.3934 29.8599C21.7334 29.8599 22.9934 29.5599 24.1234 29.0099'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M20.3972 15.7001C21.9325 15.7001 23.1772 14.4555 23.1772 12.9201C23.1772 11.3848 21.9325 10.1401 20.3972 10.1401C18.8618 10.1401 17.6172 11.3848 17.6172 12.9201C17.6172 14.4555 18.8618 15.7001 20.3972 15.7001Z'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M13.1628 27.9199C14.6982 27.9199 15.9428 26.6752 15.9428 25.1399C15.9428 23.6045 14.6982 22.3599 13.1628 22.3599C11.6275 22.3599 10.3828 23.6045 10.3828 25.1399C10.3828 26.6752 11.6275 27.9199 13.1628 27.9199Z'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M27.5066 27.9199C29.0419 27.9199 30.2866 26.6752 30.2866 25.1399C30.2866 23.6045 29.0419 22.3599 27.5066 22.3599C25.9712 22.3599 24.7266 23.6045 24.7266 25.1399C24.7266 26.6752 25.9712 27.9199 27.5066 27.9199Z'
      stroke='#063257'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const LandingSpeaker = (
  <svg
    width='110'
    height='100'
    viewBox='0 0 110 100'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M28.0955 100H22.3089C19.8066 100 17.7734 97.9814 17.7734 95.497V50.3105H40.4508L35.9153 93.0125C35.6025 97.0498 32.1618 100 28.0955 100Z'
      fill='white'
    />
    <path
      d='M10.8923 36.0249H3.54168C1.97773 36.0249 0.726562 37.2671 0.726562 38.8199V45.497C0.726562 47.0498 1.97773 48.292 3.54168 48.292H10.8923V36.0249Z'
      fill='#2FC9C1'
    />
    <path
      d='M98.0027 53.8823C104.222 53.8823 109.263 48.8767 109.263 42.7021C109.263 36.5275 104.222 31.522 98.0027 31.522C91.7837 31.522 86.7422 36.5275 86.7422 42.7021C86.7422 48.8767 91.7837 53.8823 98.0027 53.8823Z'
      fill='#078E84'
    />
    <path
      d='M98.6333 5.59007V79.5033C98.6333 81.0561 98.0077 82.4536 97.0694 83.3852C96.131 84.3169 94.7234 84.938 93.1595 84.938C91.1263 84.938 89.0932 83.8511 88.1548 81.9877C82.5246 71.1181 57.8141 67.2361 47.6484 67.2361V17.7019C57.8141 17.7019 82.5246 13.8199 88.1548 2.95032C89.0932 1.08696 90.9699 0 93.1595 0C96.131 0 98.6333 2.48448 98.6333 5.59007Z'
      fill='white'
    />
    <path
      d='M93.1532 0C91.1201 0 89.087 1.08696 88.1486 2.95032C88.1486 3.1056 87.9922 3.26088 87.9922 3.26088V81.5219C87.9922 81.6772 88.1486 81.8325 88.1486 81.8325C89.087 83.6958 90.9637 84.7828 93.1532 84.7828C94.7172 84.7828 96.1247 84.1616 97.0631 83.23C98.0015 82.2983 98.6271 80.9008 98.6271 79.348V5.59007C98.6271 2.48448 96.1247 0 93.1532 0Z'
      fill='#078E84'
    />
    <path
      d='M98.6271 72.3607V79.3483C98.6271 80.901 98.0015 82.2986 97.0631 83.2302C96.1247 84.3172 94.7172 84.9383 93.1532 84.9383C91.1201 84.9383 89.087 83.8514 88.1486 81.988C88.1486 81.8327 87.9922 81.6774 87.9922 81.6774V64.752C91.7457 66.7706 95.3428 69.4103 98.6271 72.3607Z'
      fill='#078E84'
    />
    <path
      d='M47.6402 67.2359H23.2426C13.7024 67.2359 6.03906 59.6272 6.03906 50.1551V34.7824C6.03906 25.3104 13.7024 17.7017 23.2426 17.7017H47.6402V67.2359Z'
      fill='#078E84'
    />
    <path
      d='M6.20312 36.8013V50.3106C6.20312 59.7827 13.8665 67.3914 23.4066 67.3914H47.6479V53.882H23.2502C13.8665 53.7268 6.20312 46.1181 6.20312 36.8013Z'
      fill='#05776C'
    />
    <path
      d='M47.6484 67.2359C57.9705 67.2359 82.5246 71.1179 88.1548 81.9875C89.0932 83.8508 90.9699 84.9378 93.1595 84.9378C94.7234 84.9378 96.131 84.3167 97.0694 83.385C98.0077 82.4533 98.6333 81.0558 98.6333 79.503V72.5154C79.7095 54.8135 47.6484 53.7266 47.6484 53.7266C47.6484 53.8818 47.6484 66.7701 47.6484 67.2359Z'
      fill='#5EE5DB'
    />
    <path
      d='M98.6271 72.3607V79.3483C98.6271 80.901 98.0015 82.2986 97.0631 83.2302C96.1247 84.3172 94.7172 84.9383 93.1532 84.9383C91.1201 84.9383 89.087 83.8514 88.1486 81.988C88.1486 81.8327 87.9922 81.6774 87.9922 81.5222V64.752C91.7457 66.7706 95.3428 69.4103 98.6271 72.3607Z'
      fill='#05776C'
    />
  </svg>
);

export const LandingMessage = (
  <svg
    width='114'
    height='100'
    viewBox='0 0 114 100'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clip-path='url(#clip0_568_4444)'>
      <path
        d='M105.048 27.9849H36.7596C31.7219 27.9849 27.6172 32.0893 27.6172 37.1267V98.8804C27.6172 99.8132 28.7367 100.373 29.483 99.6267L40.3046 88.8058C42.1704 86.9401 44.7825 85.8207 47.3946 85.8207H104.861C109.899 85.8207 114.003 81.7162 114.003 76.6789V36.9401C114.003 31.9028 110.085 27.9849 105.048 27.9849Z'
        fill='white'
      />
      <path
        d='M9.32897 0H79.4828C84.707 0 88.8118 4.10448 88.8118 9.32836V72.9478C88.8118 73.8806 87.5057 74.4403 86.7594 73.694L75.5647 62.5C73.6989 60.6343 71.0867 59.5149 68.288 59.5149H9.32897C4.10475 59.5149 0 55.4104 0 50.1866V9.32836C0 4.10448 4.10475 0 9.32897 0Z'
        fill='#2FC9C1'
      />
      <path
        d='M9.32897 0H79.4828C84.707 0 88.8118 4.10448 88.8118 9.32836V72.9478C88.8118 73.8806 87.5057 74.4403 86.7594 73.694L75.5647 62.5C73.6989 60.6343 71.0867 59.5149 68.288 59.5149H9.32897C4.10475 59.5149 0 55.4104 0 50.1866V9.32836C0 4.10448 4.10475 0 9.32897 0Z'
        fill='#2FC9C1'
      />
      <path
        d='M79.4811 0H74.0703C79.2945 0 83.3993 4.10448 83.3993 9.32836V70.3358L86.7577 73.694C87.504 74.4403 88.8101 73.8806 88.8101 72.9478V9.32836C88.8101 4.10448 84.7053 0 79.4811 0Z'
        fill='#078E84'
      />
      <path
        d='M68.4771 12.3135H20.7128C19.2201 12.3135 17.9141 13.6194 17.9141 15.112C17.9141 16.6045 19.2201 17.9105 20.7128 17.9105H68.4771C69.9697 17.9105 71.2758 16.6045 71.2758 15.112C71.2758 13.6194 69.9697 12.3135 68.4771 12.3135Z'
        fill='#078E84'
      />
      <path
        d='M68.4771 41.418H20.7128C19.2201 41.418 17.9141 42.7239 17.9141 44.2165C17.9141 45.709 19.2201 47.015 20.7128 47.015H68.4771C69.9697 47.015 71.2758 45.709 71.2758 44.2165C71.2758 42.7239 69.9697 41.418 68.4771 41.418Z'
        fill='#078E84'
      />
      <path
        d='M68.4771 27.2388H20.7128C19.2201 27.2388 17.9141 28.5447 17.9141 30.0373C17.9141 31.5298 19.2201 32.8358 20.7128 32.8358H68.4771C69.9697 32.8358 71.2758 31.5298 71.2758 30.0373C71.2758 28.3582 69.9697 27.2388 68.4771 27.2388Z'
        fill='#078E84'
      />
    </g>
    <defs>
      <clipPath id='clip0_568_4444'>
        <rect width='114' height='100' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const LandingRocket = (
  <svg
    width='100'
    height='100'
    viewBox='0 0 100 100'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clip-path='url(#clip0_568_4462)'>
      <path
        d='M47.8977 69.3763L31.3359 52.8145L24.8897 59.2607L41.4515 75.8225L47.8977 69.3763Z'
        fill='#078E84'
      />
      <path
        d='M3.78682 65.6382C13.0435 51.7532 28.331 53.296 28.331 53.296L51.6129 24.404C14.446 17.9523 6.73212 45.1613 0 61.9916L3.78682 65.6382Z'
        fill='#078E84'
      />
      <path
        d='M34.3594 96.3535C48.2444 87.0969 46.8418 71.6691 46.8418 71.6691L75.7338 48.3872C82.1855 85.5541 54.9765 93.268 38.1462 100.14L34.3594 96.3535Z'
        fill='#078E84'
      />
      <path
        d='M46.7012 71.669C100.979 61.2903 100.278 7.43341 99.9971 0.140284C92.5638 -0.280474 38.8471 -0.981739 28.3281 53.296L46.7012 71.669Z'
        fill='white'
      />
      <path
        d='M100.002 0.140252C99.0206 0 97.4778 0 95.3741 0C95.0936 15.1473 89.764 57.784 42.0781 67.0407L46.7065 71.669C100.984 61.2903 100.283 7.43338 100.002 0.140252Z'
        fill='#5EE5DB'
      />
      <path
        d='M94.3875 33.2401C100.418 18.0928 100.138 3.6468 99.9976 0.0002358C96.4913 -0.140017 81.9051 -0.420522 66.7578 5.61033L94.3875 33.2401Z'
        fill='#078E84'
      />
      <path
        d='M67.1826 47.5459C74.6962 47.5459 80.7871 41.455 80.7871 33.9414C80.7871 26.4279 74.6962 20.3369 67.1826 20.3369C59.6691 20.3369 53.5781 26.4279 53.5781 33.9414C53.5781 41.455 59.6691 47.5459 67.1826 47.5459Z'
        fill='#078E84'
      />
      <path
        d='M73.4946 40.2529C69.9883 43.7593 64.3782 43.7593 60.8719 40.2529C57.3656 36.7466 57.3656 31.1365 60.8719 27.6302C64.3782 24.1239 69.9883 24.1239 73.4946 27.6302C77.001 31.1365 77.001 36.7466 73.4946 40.2529Z'
        fill='white'
      />
      <path
        d='M73.4955 27.7702C73.215 27.4897 72.9345 27.2092 72.5137 26.9287C75.1785 30.435 74.898 35.3439 71.6722 38.5697C68.4464 41.7955 63.5376 42.076 60.0312 39.4112C60.3118 39.6917 60.5923 40.1124 60.8728 40.3929C64.3791 43.8993 69.9892 43.8993 73.4955 40.3929C77.0018 36.7464 77.0018 31.1363 73.4955 27.7702Z'
        fill='#5EE5DB'
      />
      <path
        d='M30.0104 84.1516C20.1927 93.9692 9.253 90.7434 9.253 90.7434C9.253 90.7434 5.74669 80.0842 15.8449 70.1263C20.7537 65.2175 27.9066 64.376 31.8336 68.303C35.7607 72.2301 34.9192 79.2427 30.0104 84.1516Z'
        fill='#078E84'
      />
      <path
        d='M25.1032 81.7673C20.3346 86.5359 15.0051 84.9931 15.0051 84.9931C15.0051 84.9931 13.322 79.8038 18.2309 74.895C20.6152 72.5107 24.1215 72.0899 25.9447 74.0534C27.9083 76.017 27.4875 79.383 25.1032 81.7673Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_568_4462'>
        <rect width='100' height='100' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const LandingLaptop = (
  <svg
    width='148'
    height='100'
    viewBox='0 0 148 100'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clip-path='url(#clip0_568_4486)'>
      <path
        d='M132.494 91.5541H18.376C14.1619 91.5541 10.9592 88.1757 10.9592 84.1216V7.43243C10.7906 3.37838 14.1619 0 18.376 0H132.494C136.54 0 139.911 3.37838 139.911 7.43243V83.9527C139.911 88.1757 136.54 91.5541 132.494 91.5541Z'
        fill='#078E84'
      />
      <path
        d='M128.625 80.2207V11.3018L22.2605 11.3018L22.2605 80.2207L128.625 80.2207Z'
        fill='white'
      />
      <path
        d='M128.612 11.3174H121.195V80.2363H128.612V11.3174Z'
        fill='#5EE5DB'
      />
      <path
        d='M143.955 86.6552H93.3859L91.026 90.2025H56.9759L54.616 86.4863H4.04649C1.34945 86.4863 -0.504762 89.189 0.338063 91.7228C2.69797 98.8174 9.44057 99.9998 17.026 99.9998H131.313C138.898 99.9998 145.641 98.9863 148.001 91.7228C148.675 89.189 146.652 86.6552 143.955 86.6552Z'
        fill='#2FC9C1'
      />
      <path
        d='M60.0125 45.9458H44.3359V71.9593H60.0125V45.9458Z'
        fill='#5EE5DB'
      />
      <path
        d='M80.9109 40.7095H65.2344V71.9595H80.9109V40.7095Z'
        fill='#2FC9C1'
      />
      <path
        d='M100.802 28.3784H85.125V71.9595H100.802V28.3784Z'
        fill='#078E84'
      />
    </g>
    <defs>
      <clipPath id='clip0_568_4486'>
        <rect width='148' height='100' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const LandingCheckBox = (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M18.8809 2.83545H2.28047C1.67558 2.83566 1.09553 3.07609 0.667886 3.50389C0.240238 3.93168 -3.54716e-08 4.51181 0 5.1167V21.7175C0.000207072 22.3222 0.240537 22.9022 0.668162 23.3298C1.09579 23.7574 1.67571 23.9977 2.28047 23.9979H18.8809C19.4857 23.9977 20.0657 23.7574 20.4933 23.3296C20.9209 22.9019 21.1612 22.3219 21.1613 21.7171V5.1167C21.1613 4.51181 20.9211 3.93168 20.4934 3.50389C20.0658 3.07609 19.4857 2.83566 18.8809 2.83545ZM19.9434 20.5933C19.9435 20.8583 19.8914 21.1208 19.79 21.3657C19.6887 21.6106 19.5401 21.8331 19.3527 22.0205C19.1654 22.208 18.9429 22.3567 18.6981 22.4582C18.4532 22.5597 18.1908 22.612 17.9258 22.612H3.2375C2.97236 22.6121 2.70981 22.56 2.46484 22.4586C2.21986 22.3571 1.99728 22.2084 1.8098 22.021C1.62232 21.8335 1.47362 21.6109 1.37221 21.3659C1.27079 21.121 1.21865 20.8584 1.21875 20.5933V5.90537C1.21875 5.64028 1.27097 5.37779 1.37243 5.13289C1.47388 4.88798 1.62259 4.66546 1.81005 4.47804C1.99752 4.29061 2.22006 4.14195 2.46499 4.04054C2.70991 3.93913 2.97241 3.88696 3.2375 3.88701H17.9258C18.4609 3.88753 18.9738 4.10037 19.3521 4.47879C19.7304 4.85722 19.943 5.3703 19.9434 5.90537V20.5933Z'
      fill='#344549'
    />
    <path
      d='M21.9012 0.812717C18.893 3.4174 16.1332 6.18069 13.8024 9.41428C12.7742 10.8408 11.966 12.4256 11.2192 14.0108C10.868 14.7569 10.6582 15.533 10.461 16.3092C9.0262 14.9756 7.62971 13.6041 6.05471 12.4186C4.93167 11.5737 1.16214 14.2233 2.47854 15.2147C4.83792 16.9897 6.80276 19.1994 9.09573 21.0533C10.0559 21.8279 12.1836 20.1467 12.6821 19.4401C14.3231 17.1158 14.5473 14.2725 15.7438 11.7362C17.5703 7.85764 20.809 4.67365 24.0055 1.90412C26.3922 -0.161501 23.5086 -0.579079 21.902 0.811155'
      fill='url(#paint0_linear_647_6371)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_647_6371'
        x1='24.9998'
        y1='-0.611115'
        x2='13.5591'
        y2='21.2529'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#419477' />
        <stop offset='1' stop-color='#134A87' />
      </linearGradient>
    </defs>
  </svg>
);

export const TimerRounded = (
  <svg
    width='80'
    height='80'
    viewBox='0 0 80 80'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='80' height='80' rx='40' fill='url(#paint0_linear_594_5922)' />
    <path
      d='M39.9974 57.9167C31.2641 57.9167 24.1641 50.8167 24.1641 42.0833C24.1641 33.35 31.2641 26.25 39.9974 26.25C48.7307 26.25 55.8307 33.35 55.8307 42.0833C55.8307 50.8167 48.7307 57.9167 39.9974 57.9167ZM39.9974 28.75C32.6474 28.75 26.6641 34.7333 26.6641 42.0833C26.6641 49.4333 32.6474 55.4167 39.9974 55.4167C47.3474 55.4167 53.3307 49.4333 53.3307 42.0833C53.3307 34.7333 47.3474 28.75 39.9974 28.75Z'
      fill='#A1D823'
    />
    <path
      d='M40 42.9167C39.3167 42.9167 38.75 42.35 38.75 41.6667V33.3334C38.75 32.65 39.3167 32.0834 40 32.0834C40.6833 32.0834 41.25 32.65 41.25 33.3334V41.6667C41.25 42.35 40.6833 42.9167 40 42.9167Z'
      fill='#A1D823'
    />
    <path
      d='M45 24.5834H35C34.3167 24.5834 33.75 24.0167 33.75 23.3334C33.75 22.65 34.3167 22.0834 35 22.0834H45C45.6833 22.0834 46.25 22.65 46.25 23.3334C46.25 24.0167 45.6833 24.5834 45 24.5834Z'
      fill='#A1D823'
    />
    <defs>
      <linearGradient
        id='paint0_linear_594_5922'
        x1='13'
        y1='9'
        x2='64.5'
        y2='72'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#063257' />
        <stop offset='1' stop-color='#006867' />
      </linearGradient>
    </defs>
  </svg>
);

export const AIPowered = (
  <svg
    width='80'
    height='80'
    viewBox='0 0 80 80'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='80' height='80' rx='40' fill='url(#paint0_linear_594_5923)' />
    <path
      d='M51.113 51.1167L54.813 49.2667V44.6334M43.6964 36.3L39.9964 38.15L43.6964 36.3ZM39.9964 38.15L36.2964 36.3L39.9964 38.15ZM39.9964 38.15V42.7834V38.15ZM54.813 30.7334L51.113 32.5834L54.813 30.7334ZM54.813 30.7334L51.113 28.8834L54.813 30.7334ZM54.813 30.7334V35.3667V30.7334ZM43.6964 25.1834L39.9964 23.3334L36.2964 25.1834H43.6964ZM25.1797 30.7334L28.8797 28.8834L25.1797 30.7334ZM25.1797 30.7334L28.8797 32.5834L25.1797 30.7334ZM25.1797 30.7334V35.3667V30.7334ZM39.9964 56.6667L36.2964 54.8167L39.9964 56.6667ZM39.9964 56.6667L43.6964 54.8167L39.9964 56.6667ZM39.9964 56.6667V52.0334V56.6667ZM28.8797 51.1167L25.1797 49.2667V44.6334L28.8797 51.1167Z'
      stroke='#A1D823'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_594_5923'
        x1='13'
        y1='9'
        x2='64.5'
        y2='72'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#063257' />
        <stop offset='1' stop-color='#006867' />
      </linearGradient>
    </defs>
  </svg>
);

export const EnterpriseGrade = (
  <svg
    width='80'
    height='80'
    viewBox='0 0 80 80'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='80' height='80' rx='40' fill='url(#paint0_linear_594_5924)' />
    <path
      d='M35.0026 56.6667H45.0026C53.3359 56.6667 56.6693 53.3334 56.6693 45V35C56.6693 26.6667 53.3359 23.3334 45.0026 23.3334H35.0026C26.6693 23.3334 23.3359 26.6667 23.3359 35V45C23.3359 53.3334 26.6693 56.6667 35.0026 56.6667Z'
      stroke='#A1D823'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M47.1392 42.6834C45.2559 44.5667 42.5559 45.1501 40.1725 44.4001L35.8559 48.7001C35.5559 49.0167 34.9392 49.2167 34.4892 49.1501L32.4892 48.8834C31.8225 48.8001 31.2225 48.1667 31.1225 47.5167L30.8559 45.5167C30.7892 45.0834 31.0059 44.4667 31.3059 44.1501L35.6059 39.8501C34.8725 37.4667 35.4392 34.7667 37.3225 32.8834C40.0225 30.1834 44.4225 30.1834 47.1392 32.8834C49.8392 35.5667 49.8392 39.9667 47.1392 42.6834Z'
      stroke='#A1D823'
      stroke-width='2'
      stroke-miterlimit='10'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M37.4167 47.1334L36 45.7001'
      stroke='#A1D823'
      stroke-width='2'
      stroke-miterlimit='10'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M42.3242 37.8332H42.3391'
      stroke='#A1D823'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_594_5924'
        x1='13'
        y1='9'
        x2='64.5'
        y2='72'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#063257' />
        <stop offset='1' stop-color='#006867' />
      </linearGradient>
    </defs>
  </svg>
);

export const LandingLeftArrow = (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M30 20.0002L10 20.0002M10 20.0002L18.3333 28.3335M10 20.0002L18.3333 11.6668'
      stroke='#97E484'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const LandingRightArrow = (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10 19.9998H30M30 19.9998L21.6667 11.6665M30 19.9998L21.6667 28.3332'
      stroke='#97E484'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const MenuIcon = (
  <svg
    width='31'
    height='32'
    viewBox='0 0 31 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.33203 8.34277H25.8676M5.33203 16.0436H25.8676M5.33203 23.7445H25.8676'
      stroke='black'
      stroke-width='2.56695'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const CompetitiveAnalysis = (
  <svg
    width='20'
    height='22'
    viewBox='0 0 20 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17 15.5V9.5C17 6.672 17 5.257 16.121 4.379C15.243 3.5 13.828 3.5 11 3.5H8M8 3.5C8 2.8 9.994 1.492 10.5 1M8 3.5C8 4.2 9.994 5.508 10.5 6M3 6V12C3 14.828 3 16.243 3.879 17.121C4.757 18 6.172 18 9 18H12M12 18C12 18.7 10.006 20.009 9.5 20.5M12 18C12 17.3 10.006 15.991 9.5 15.5'
      stroke='white'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M17 19.5C18.1046 19.5 19 18.6046 19 17.5C19 16.3954 18.1046 15.5 17 15.5C15.8954 15.5 15 16.3954 15 17.5C15 18.6046 15.8954 19.5 17 19.5Z'
      stroke='white'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M3 5.5C4.10457 5.5 5 4.60457 5 3.5C5 2.39543 4.10457 1.5 3 1.5C1.89543 1.5 1 2.39543 1 3.5C1 4.60457 1.89543 5.5 3 5.5Z'
      stroke='white'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const AddIconPost = (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9 0C4.03754 0 0 4.03754 0 9C0 13.9625 4.03754 18 9 18C13.9625 18 18 13.9625 18 9C18 4.03754 13.9625 0 9 0ZM9 1.38462C13.2141 1.38462 16.6154 4.78592 16.6154 9C16.6154 13.2141 13.2141 16.6154 9 16.6154C4.78592 16.6154 1.38462 13.2141 1.38462 9C1.38462 4.78592 4.78592 1.38462 9 1.38462ZM8.30769 4.84615V8.30769H4.84615V9.69231H8.30769V13.1538H9.69231V9.69231H13.1538V8.30769H9.69231V4.84615H8.30769Z'
      fill='black'
    />
  </svg>
);

export const Post = (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.5 1.42969H9.5C9.89782 1.42969 10.2794 1.58772 10.5607 1.86903C10.842 2.15033 11 2.53186 11 2.92969V6.92969C11 7.32751 10.842 7.70904 10.5607 7.99035C10.2794 8.27165 9.89782 8.42969 9.5 8.42969H6.021L2.799 10.8337C2.72464 10.8892 2.63632 10.9229 2.54391 10.931C2.45149 10.9392 2.35864 10.9214 2.27572 10.8798C2.19281 10.8382 2.1231 10.7743 2.07441 10.6954C2.02572 10.6164 1.99995 10.5255 2 10.4327V8.42969C1.73478 8.42969 1.48043 8.32433 1.29289 8.13679C1.10536 7.94926 1 7.6949 1 7.42969V2.92969C1 2.53186 1.15804 2.15033 1.43934 1.86903C1.72064 1.58772 2.10218 1.42969 2.5 1.42969ZM7.5 5.92969C7.76522 5.92969 8.01957 5.82433 8.20711 5.63679C8.39464 5.44926 8.5 5.1949 8.5 4.92969C8.5 4.66447 8.39464 4.41012 8.20711 4.22258C8.01957 4.03504 7.76522 3.92969 7.5 3.92969C7.23478 3.92969 6.98043 4.03504 6.79289 4.22258C6.60536 4.41012 6.5 4.66447 6.5 4.92969C6.5 5.1949 6.60536 5.44926 6.79289 5.63679C6.98043 5.82433 7.23478 5.92969 7.5 5.92969ZM4.5 5.92969C4.76522 5.92969 5.01957 5.82433 5.20711 5.63679C5.39464 5.44926 5.5 5.1949 5.5 4.92969C5.5 4.66447 5.39464 4.41012 5.20711 4.22258C5.01957 4.03504 4.76522 3.92969 4.5 3.92969C4.23478 3.92969 3.98043 4.03504 3.79289 4.22258C3.60536 4.41012 3.5 4.66447 3.5 4.92969C3.5 5.1949 3.60536 5.44926 3.79289 5.63679C3.98043 5.82433 4.23478 5.92969 4.5 5.92969Z'
      fill='#2A886B'
    />
  </svg>
);

export const Profile = (
  <svg
    width='11'
    height='11'
    viewBox='0 0 11 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M3.05556 2.44444C3.05556 1.79614 3.31309 1.17438 3.77152 0.715961C4.22994 0.257539 4.85169 0 5.5 0C6.14831 0 6.77006 0.257539 7.22848 0.715961C7.68691 1.17438 7.94444 1.79614 7.94444 2.44444C7.94444 3.09275 7.68691 3.71451 7.22848 4.17293C6.77006 4.63135 6.14831 4.88889 5.5 4.88889C4.85169 4.88889 4.22994 4.63135 3.77152 4.17293C3.31309 3.71451 3.05556 3.09275 3.05556 2.44444ZM3.05556 6.11111C2.24517 6.11111 1.46798 6.43303 0.894952 7.00606C0.321924 7.57909 0 8.35628 0 9.16667C0 9.6529 0.193154 10.1192 0.536971 10.463C0.880788 10.8068 1.3471 11 1.83333 11H9.16667C9.6529 11 10.1192 10.8068 10.463 10.463C10.8068 10.1192 11 9.6529 11 9.16667C11 8.35628 10.6781 7.57909 10.105 7.00606C9.53202 6.43303 8.75483 6.11111 7.94444 6.11111H3.05556Z'
      fill='#2A886B'
    />
  </svg>
);

export const LocationGreen = (
  <svg
    width='9'
    height='13'
    viewBox='0 0 9 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.5 6.175C4.07376 6.175 3.66498 6.0038 3.36358 5.69905C3.06218 5.3943 2.89286 4.98098 2.89286 4.55C2.89286 4.11902 3.06218 3.7057 3.36358 3.40095C3.66498 3.0962 4.07376 2.925 4.5 2.925C4.92624 2.925 5.33502 3.0962 5.63642 3.40095C5.93782 3.7057 6.10714 4.11902 6.10714 4.55C6.10714 4.7634 6.06557 4.97471 5.98481 5.17186C5.90404 5.36901 5.78566 5.54815 5.63642 5.69905C5.48718 5.84994 5.31001 5.96964 5.11503 6.0513C4.92004 6.13297 4.71105 6.175 4.5 6.175ZM4.5 0C3.30653 0 2.16193 0.479374 1.31802 1.33266C0.474106 2.18595 0 3.34326 0 4.55C0 7.9625 4.5 13 4.5 13C4.5 13 9 7.9625 9 4.55C9 3.34326 8.52589 2.18595 7.68198 1.33266C6.83807 0.479374 5.69347 0 4.5 0Z'
      fill='#2A886B'
    />
  </svg>
);

export const CloseCircle = (
  <svg
    width='13'
    height='13'
    viewBox='0 0 13 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.4987 7.26094L8.06953 8.83177C8.16884 8.93108 8.29523 8.98073 8.4487 8.98073C8.60217 8.98073 8.72856 8.93108 8.82787 8.83177C8.92717 8.73247 8.97682 8.60608 8.97682 8.4526C8.97682 8.29913 8.92717 8.17274 8.82787 8.07344L7.25703 6.5026L8.82787 4.93177C8.92717 4.83247 8.97682 4.70608 8.97682 4.5526C8.97682 4.39913 8.92717 4.27274 8.82787 4.17344C8.72856 4.07413 8.60217 4.02448 8.4487 4.02448C8.29523 4.02448 8.16884 4.07413 8.06953 4.17344L6.4987 5.74427L4.92787 4.17344C4.82856 4.07413 4.70217 4.02448 4.5487 4.02448C4.39523 4.02448 4.26884 4.07413 4.16953 4.17344C4.07023 4.27274 4.02057 4.39913 4.02057 4.5526C4.02057 4.70608 4.07023 4.83247 4.16953 4.93177L5.74037 6.5026L4.16953 8.07344C4.07023 8.17274 4.02057 8.29913 4.02057 8.4526C4.02057 8.60608 4.07023 8.73247 4.16953 8.83177C4.26884 8.93108 4.39523 8.98073 4.5487 8.98073C4.70217 8.98073 4.82856 8.93108 4.92787 8.83177L6.4987 7.26094ZM6.4987 11.9193C5.74939 11.9193 5.04523 11.777 4.3862 11.4924C3.72717 11.2079 3.15391 10.822 2.66641 10.3349C2.17891 9.84776 1.79306 9.27449 1.50887 8.6151C1.22467 7.95572 1.08239 7.25155 1.08203 6.5026C1.08167 5.75366 1.22395 5.04949 1.50887 4.3901C1.79378 3.73072 2.17963 3.15745 2.66641 2.67031C3.15318 2.18317 3.72645 1.79733 4.3862 1.51277C5.04595 1.22822 5.75012 1.08594 6.4987 1.08594C7.24728 1.08594 7.95145 1.22822 8.6112 1.51277C9.27095 1.79733 9.84421 2.18317 10.331 2.67031C10.8178 3.15745 11.2038 3.73072 11.4891 4.3901C11.7744 5.04949 11.9164 5.75366 11.9154 6.5026C11.9143 7.25155 11.772 7.95572 11.4885 8.6151C11.2051 9.27449 10.8192 9.84776 10.331 10.3349C9.84277 10.822 9.2695 11.2081 8.6112 11.493C7.95289 11.7779 7.24873 11.92 6.4987 11.9193ZM6.4987 10.8359C7.70842 10.8359 8.73307 10.4161 9.57266 9.57656C10.4122 8.73698 10.832 7.71233 10.832 6.5026C10.832 5.29288 10.4122 4.26823 9.57266 3.42865C8.73307 2.58906 7.70842 2.16927 6.4987 2.16927C5.28898 2.16927 4.26432 2.58906 3.42474 3.42865C2.58516 4.26823 2.16537 5.29288 2.16537 6.5026C2.16537 7.71233 2.58516 8.73698 3.42474 9.57656C4.26432 10.4161 5.28898 10.8359 6.4987 10.8359Z'
      fill='#2A2929'
    />
  </svg>
);

export const ChevronUp = (
  <svg
    width='10'
    height='7'
    viewBox='0 0 10 7'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9 6L5 1L3 3.5L1 6'
      stroke='#636363'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const ChevronDown = (
  <svg
    width='10'
    height='7'
    viewBox='0 0 10 7'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1 1L5 6L7 3.5L9 1'
      stroke='#636363'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const ProfileBlack = (
  <svg
    width='11'
    height='11'
    viewBox='0 0 11 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M3.05556 2.44444C3.05556 1.79614 3.31309 1.17438 3.77152 0.715961C4.22994 0.257539 4.85169 0 5.5 0C6.14831 0 6.77006 0.257539 7.22848 0.715961C7.68691 1.17438 7.94444 1.79614 7.94444 2.44444C7.94444 3.09275 7.68691 3.71451 7.22848 4.17293C6.77006 4.63135 6.14831 4.88889 5.5 4.88889C4.85169 4.88889 4.22994 4.63135 3.77152 4.17293C3.31309 3.71451 3.05556 3.09275 3.05556 2.44444ZM3.05556 6.11111C2.24517 6.11111 1.46798 6.43303 0.894951 7.00606C0.321924 7.57909 0 8.35628 0 9.16667C0 9.6529 0.193154 10.1192 0.536971 10.463C0.880788 10.8068 1.3471 11 1.83333 11H9.16667C9.6529 11 10.1192 10.8068 10.463 10.463C10.8068 10.1192 11 9.6529 11 9.16667C11 8.35628 10.6781 7.57909 10.105 7.00606C9.53202 6.43303 8.75483 6.11111 7.94444 6.11111H3.05556Z'
      fill='black'
    />
  </svg>
);

export const MessageBlack = (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.5 1.42969H9.5C9.89782 1.42969 10.2794 1.58772 10.5607 1.86903C10.842 2.15033 11 2.53186 11 2.92969V6.92969C11 7.32751 10.842 7.70904 10.5607 7.99035C10.2794 8.27165 9.89782 8.42969 9.5 8.42969H6.021L2.799 10.8337C2.72464 10.8892 2.63632 10.9229 2.54391 10.931C2.45149 10.9392 2.35864 10.9214 2.27572 10.8798C2.19281 10.8382 2.1231 10.7743 2.07441 10.6954C2.02572 10.6164 1.99995 10.5255 2 10.4327V8.42969C1.73478 8.42969 1.48043 8.32433 1.29289 8.13679C1.10536 7.94926 1 7.6949 1 7.42969V2.92969C1 2.53186 1.15804 2.15033 1.43934 1.86903C1.72064 1.58772 2.10218 1.42969 2.5 1.42969ZM7.5 5.92969C7.76522 5.92969 8.01957 5.82433 8.20711 5.63679C8.39464 5.44926 8.5 5.1949 8.5 4.92969C8.5 4.66447 8.39464 4.41012 8.20711 4.22258C8.01957 4.03504 7.76522 3.92969 7.5 3.92969C7.23478 3.92969 6.98043 4.03504 6.79289 4.22258C6.60536 4.41012 6.5 4.66447 6.5 4.92969C6.5 5.1949 6.60536 5.44926 6.79289 5.63679C6.98043 5.82433 7.23478 5.92969 7.5 5.92969ZM4.5 5.92969C4.76522 5.92969 5.01957 5.82433 5.20711 5.63679C5.39464 5.44926 5.5 5.1949 5.5 4.92969C5.5 4.66447 5.39464 4.41012 5.20711 4.22258C5.01957 4.03504 4.76522 3.92969 4.5 3.92969C4.23478 3.92969 3.98043 4.03504 3.79289 4.22258C3.60536 4.41012 3.5 4.66447 3.5 4.92969C3.5 5.1949 3.60536 5.44926 3.79289 5.63679C3.98043 5.82433 4.23478 5.92969 4.5 5.92969Z'
      fill='black'
    />
  </svg>
);

export const GreenTick = (
  <svg
    width='20'
    height='16'
    viewBox='0 0 20 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0.93714 7.1809C3.55732 10.1518 5.07789 12.0528 7.46227 15.3727C10.9205 10.712 14.4497 6.04132 19.9768 1.1617L18.6944 0.501045C14.1091 3.84007 10.4797 7.07519 7.20638 11.0287C5.39728 9.31639 3.36219 7.89939 1.53604 6.60094L0.93714 7.1809Z'
      fill='#2D8955'
    />
  </svg>
);

export const PositiveSentiment = (
  <svg
    width='19'
    height='19'
    viewBox='0 0 19 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.5 18.5874C4.93017 18.5874 0 15.6779 0 9.2937C0 2.90948 4.93017 0 9.5 0C12.0388 0 14.381 0.847905 16.1172 2.39408C18.0009 4.08989 19 6.48398 19 9.2937C19 12.1034 18.0009 14.4809 16.1172 16.1767C14.381 17.7229 12.0224 18.5874 9.5 18.5874Z'
      fill='#03C652'
    />
    <path
      d='M4.70967 10.9178C5.75795 12.7649 7.96588 13.5247 9.56286 13.5247C11.1598 13.5247 13.3678 12.7649 14.4161 10.9178C14.5635 10.6552 14.9844 10.7699 14.9369 11.0691C14.534 13.563 11.8248 14.9678 9.56286 15.0593C7.17148 15.1474 4.66054 13.4233 4.18881 11.0691C4.13148 10.7749 4.56226 10.6552 4.70967 10.9178Z'
      fill='#422B0D'
    />
    <path
      d='M6.28581 5.64062C5.59952 5.64062 4.97546 6.22917 4.97546 7.20676C4.97546 8.18434 5.59952 8.77122 6.28581 8.77122C6.97374 8.77122 7.59615 8.18268 7.59615 7.20676C7.59615 6.23083 6.98029 5.64062 6.28581 5.64062Z'
      fill='#422B0D'
    />
    <path
      d='M6.23286 6.3005C6.00028 6.18744 5.72019 6.2872 5.60717 6.52328C5.52036 6.70783 5.55967 6.92895 5.70545 7.07193C5.93804 7.18498 6.21812 7.08523 6.33114 6.84914C6.41795 6.6646 6.37864 6.44348 6.23286 6.3005Z'
      fill='white'
    />
    <path
      d='M12.5809 5.64062C11.8946 5.64062 11.2705 6.22917 11.2705 7.20676C11.2705 8.18434 11.8946 8.77122 12.5809 8.77122C13.2671 8.77122 13.8912 8.18268 13.8912 7.20676C13.8912 6.23083 13.2671 5.64062 12.5809 5.64062Z'
      fill='#422B0D'
    />
    <path
      d='M12.5115 6.3005C12.279 6.18744 11.9989 6.2872 11.8859 6.52328C11.799 6.70783 11.8384 6.92895 11.9841 7.07193C12.2167 7.18498 12.4968 7.08523 12.6098 6.84914C12.6966 6.6646 12.6573 6.44348 12.5115 6.3005Z'
      fill='white'
    />
  </svg>
);

export const NegativeSentiment = (
  <svg
    width='19'
    height='20'
    viewBox='0 0 19 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.5 19.521C4.93017 19.521 0 16.6115 0 10.2273C0 3.84307 4.93017 0.933594 9.5 0.933594C12.0388 0.933594 14.381 1.7815 16.1172 3.32768C18.0009 5.02349 19 7.41757 19 10.2273C19 13.037 18.0009 15.4145 16.1172 17.1103C14.381 18.6565 12.0224 19.521 9.5 19.521Z'
      fill='#FF4343'
    />
    <path
      d='M17.3427 4.70312C18.2157 6.13293 18.6711 7.83539 18.6711 9.72904C18.6711 12.5388 17.672 14.9162 15.7883 16.612C14.0521 18.1582 11.6935 19.0227 9.17109 19.0227C6.21299 19.0227 3.11075 17.8008 1.27954 15.2088C3.04195 18.1449 6.35713 19.5215 9.49868 19.5215C12.0211 19.5215 14.3797 18.657 16.1159 17.1108C17.9995 15.415 18.9987 13.0375 18.9987 10.2278C18.9987 8.10971 18.4303 6.22769 17.3427 4.70312Z'
      fill='#EB8F00'
    />
    <path
      d='M4.71053 15.8517C5.7588 14.0046 7.96673 13.2448 9.56372 13.2448C11.1607 13.2448 13.3686 14.0046 14.4169 15.8517C14.5643 16.1144 14.9853 15.9997 14.9378 15.7004C14.5348 13.2066 11.8257 11.8017 9.56372 11.7103C7.17234 11.6221 4.66139 13.3462 4.18967 15.7004C4.13234 15.9947 4.56311 16.1144 4.71053 15.8517Z'
      fill='#422B0D'
    />
    <path
      d='M6.28703 6.57422C5.60074 6.57422 4.97668 7.16276 4.97668 8.14035C4.97668 9.11793 5.60074 9.70482 6.28703 9.70482C6.97496 9.70482 7.59737 9.11627 7.59737 8.14035C7.59737 7.16443 6.98151 6.57422 6.28703 6.57422Z'
      fill='#422B0D'
    />
    <path
      d='M6.23201 7.23409C5.99942 7.12104 5.71934 7.22079 5.60632 7.45687C5.51951 7.64142 5.55882 7.86254 5.70459 8.00552C5.93718 8.11857 6.21727 8.01882 6.33028 7.78274C6.41709 7.59819 6.37778 7.37707 6.23201 7.23409Z'
      fill='#896024'
    />
    <path
      d='M12.5805 6.57422C11.8942 6.57422 11.2701 7.16276 11.2701 8.14035C11.2701 9.11793 11.8942 9.70482 12.5805 9.70482C13.2668 9.70482 13.8908 9.11627 13.8908 8.14035C13.8908 7.16443 13.2668 6.57422 12.5805 6.57422Z'
      fill='#422B0D'
    />
    <path
      d='M12.5106 7.23409C12.278 7.12104 11.9979 7.22079 11.8849 7.45687C11.7981 7.64142 11.8374 7.86254 11.9832 8.00552C12.2157 8.11857 12.4958 8.01882 12.6088 7.78274C12.6957 7.59819 12.6563 7.37707 12.5106 7.23409Z'
      fill='#896024'
    />
  </svg>
);

export const NeutralSentimenr = (
  <svg
    width='36'
    height='34'
    viewBox='0 0 36 34'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M18.0148 33.9825C9.70607 33.9825 0.742188 28.6926 0.742188 17.085C0.742188 5.47742 9.70607 0.1875 18.0148 0.1875C22.6307 0.1875 26.8893 1.72913 30.046 4.54035C33.4708 7.62361 35.2874 11.9765 35.2874 17.085C35.2874 22.1936 33.4708 26.5162 30.046 29.5994C26.8893 32.4107 22.6009 33.9825 18.0148 33.9825Z'
      fill='url(#paint0_radial_1195_67688)'
    />
    <path
      d='M32.2759 7.03906C33.8632 9.63868 34.6911 12.734 34.6911 16.177C34.6911 21.2856 32.8745 25.6082 29.4497 28.6915C26.293 31.5027 22.0046 33.0745 17.4185 33.0745C12.0401 33.0745 6.39975 30.8528 3.07031 26.1402C6.27468 31.4785 12.3022 33.9814 18.0141 33.9814C22.6003 33.9814 26.8886 32.4095 30.0453 29.5983C33.4701 26.515 35.2867 22.1924 35.2867 17.0839C35.2867 13.2328 34.2533 9.81098 32.2759 7.03906Z'
      fill='#EB8F00'
    />
    <path
      d='M25.5814 24.6761H10.6912C10.0331 24.6761 9.5 24.135 9.5 23.4669C9.5 22.7989 10.0331 22.2578 10.6912 22.2578H25.5814C26.2395 22.2578 26.7726 22.7989 26.7726 23.4669C26.7726 24.135 26.2395 24.6761 25.5814 24.6761Z'
      fill='#422B0D'
    />
    <path
      d='M12.3746 11.9531C11.1268 11.9531 9.99219 13.0232 9.99219 14.8006C9.99219 16.578 11.1268 17.6451 12.3746 17.6451C13.6224 17.6451 14.757 16.575 14.757 14.8006C14.757 13.0262 13.6224 11.9531 12.3746 11.9531Z'
      fill='#422B0D'
    />
    <path
      d='M12.2597 13.1472C11.8368 12.9417 11.3275 13.123 11.1221 13.5523C10.9642 13.8878 11.0357 14.2898 11.3007 14.5498C11.7236 14.7553 12.2329 14.574 12.4384 14.1447C12.5962 13.8092 12.5247 13.4072 12.2597 13.1472Z'
      fill='#896024'
    />
    <path
      d='M23.7887 11.9531C22.5409 11.9531 21.4062 13.0232 21.4062 14.8006C21.4062 16.578 22.5409 17.6451 23.7887 17.6451C25.0365 17.6451 26.1711 16.575 26.1711 14.8006C26.1711 13.0262 25.0424 11.9531 23.7887 11.9531Z'
      fill='#422B0D'
    />
    <path
      d='M23.6815 13.1472C23.2587 12.9417 22.7494 13.123 22.5439 13.5523C22.3861 13.8878 22.4576 14.2898 22.7226 14.5498C23.1455 14.7553 23.6547 14.574 23.8602 14.1447C24.0181 13.8092 23.9466 13.4072 23.6815 13.1472Z'
      fill='#896024'
    />
    <defs>
      <radialGradient
        id='paint0_radial_1195_67688'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(18.0148 17.085) scale(16.9628 17.2178)'
      >
        <stop offset='0.5' stop-color='#FDE030' />
        <stop offset='0.92' stop-color='#F7C02B' />
        <stop offset='1' stop-color='#F4A223' />
      </radialGradient>
    </defs>
  </svg>
);

export const CalendarFilter = (
  <svg
    width='19'
    height='19'
    viewBox='0 0 19 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0.980469 9.53419C0.980469 6.37312 0.980469 4.79216 1.96256 3.81056C2.94382 2.82812 4.52423 2.82813 7.6842 2.82813H11.0361C14.196 2.82813 15.7764 2.82812 16.7577 3.81056C17.7398 4.79216 17.7398 6.37312 17.7398 9.53419V11.2107C17.7398 14.3718 17.7398 15.9527 16.7577 16.9343C15.7764 17.9168 14.196 17.9168 11.0361 17.9168H7.6842C4.52423 17.9168 2.94382 17.9168 1.96256 16.9343C0.980469 15.9527 0.980469 14.3718 0.980469 11.2107V9.53419Z'
      stroke='black'
      stroke-width='1.5'
    />
    <path
      d='M5.16928 2.8277V1.57031M13.5489 2.8277V1.57031M1.39844 7.01899H17.3198'
      stroke='black'
      stroke-width='1.5'
      stroke-linecap='round'
    />
    <path
      d='M14.3915 13.7225C14.3915 13.9449 14.3032 14.1581 14.1461 14.3153C13.9889 14.4725 13.7758 14.5608 13.5536 14.5608C13.3313 14.5608 13.1182 14.4725 12.961 14.3153C12.8039 14.1581 12.7156 13.9449 12.7156 13.7225C12.7156 13.5002 12.8039 13.287 12.961 13.1298C13.1182 12.9726 13.3313 12.8843 13.5536 12.8843C13.7758 12.8843 13.9889 12.9726 14.1461 13.1298C14.3032 13.287 14.3915 13.5002 14.3915 13.7225ZM14.3915 10.3695C14.3915 10.5918 14.3032 10.805 14.1461 10.9622C13.9889 11.1194 13.7758 11.2078 13.5536 11.2078C13.3313 11.2078 13.1182 11.1194 12.961 10.9622C12.8039 10.805 12.7156 10.5918 12.7156 10.3695C12.7156 10.1472 12.8039 9.93397 12.961 9.77677C13.1182 9.61957 13.3313 9.53125 13.5536 9.53125C13.7758 9.53125 13.9889 9.61957 14.1461 9.77677C14.3032 9.93397 14.3915 10.1472 14.3915 10.3695ZM10.2017 13.7225C10.2017 13.9449 10.1134 14.1581 9.95626 14.3153C9.79912 14.4725 9.58598 14.5608 9.36373 14.5608C9.14149 14.5608 8.92835 14.4725 8.7712 14.3153C8.61405 14.1581 8.52577 13.9449 8.52577 13.7225C8.52577 13.5002 8.61405 13.287 8.7712 13.1298C8.92835 12.9726 9.14149 12.8843 9.36373 12.8843C9.58598 12.8843 9.79912 12.9726 9.95626 13.1298C10.1134 13.287 10.2017 13.5002 10.2017 13.7225ZM10.2017 10.3695C10.2017 10.5918 10.1134 10.805 9.95626 10.9622C9.79912 11.1194 9.58598 11.2078 9.36373 11.2078C9.14149 11.2078 8.92835 11.1194 8.7712 10.9622C8.61405 10.805 8.52577 10.5918 8.52577 10.3695C8.52577 10.1472 8.61405 9.93397 8.7712 9.77677C8.92835 9.61957 9.14149 9.53125 9.36373 9.53125C9.58598 9.53125 9.79912 9.61957 9.95626 9.77677C10.1134 9.93397 10.2017 10.1472 10.2017 10.3695ZM6.01187 13.7225C6.01187 13.9449 5.92358 14.1581 5.76643 14.3153C5.60929 14.4725 5.39615 14.5608 5.1739 14.5608C4.95166 14.5608 4.73852 14.4725 4.58137 14.3153C4.42422 14.1581 4.33594 13.9449 4.33594 13.7225C4.33594 13.5002 4.42422 13.287 4.58137 13.1298C4.73852 12.9726 4.95166 12.8843 5.1739 12.8843C5.39615 12.8843 5.60929 12.9726 5.76643 13.1298C5.92358 13.287 6.01187 13.5002 6.01187 13.7225ZM6.01187 10.3695C6.01187 10.5918 5.92358 10.805 5.76643 10.9622C5.60929 11.1194 5.39615 11.2078 5.1739 11.2078C4.95166 11.2078 4.73852 11.1194 4.58137 10.9622C4.42422 10.805 4.33594 10.5918 4.33594 10.3695C4.33594 10.1472 4.42422 9.93397 4.58137 9.77677C4.73852 9.61957 4.95166 9.53125 5.1739 9.53125C5.39615 9.53125 5.60929 9.61957 5.76643 9.77677C5.92358 9.93397 6.01187 10.1472 6.01187 10.3695Z'
      fill='black'
    />
  </svg>
);

export const BackArrow = (
  <svg
    width='17'
    height='15'
    viewBox='0 0 17 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1.43614 6.45703H15.784C15.9742 6.45703 16.1567 6.53261 16.2912 6.66715C16.4258 6.80169 16.5014 6.98416 16.5014 7.17442C16.5014 7.36469 16.4258 7.54716 16.2912 7.6817C16.1567 7.81623 15.9742 7.89181 15.784 7.89181H1.43614C1.24588 7.89181 1.06341 7.81623 0.928869 7.6817C0.794332 7.54716 0.71875 7.36469 0.71875 7.17442C0.71875 6.98416 0.794332 6.80169 0.928869 6.66715C1.06341 6.53261 1.24588 6.45703 1.43614 6.45703Z'
      fill='black'
    />
    <path
      d='M1.73307 7.17482L7.68311 13.1234C7.81782 13.2581 7.89349 13.4408 7.89349 13.6313C7.89349 13.8218 7.81782 14.0045 7.68311 14.1393C7.5484 14.274 7.3657 14.3496 7.1752 14.3496C6.98469 14.3496 6.80199 14.274 6.66728 14.1393L0.210761 7.68273C0.143952 7.61609 0.0909477 7.53693 0.0547819 7.44977C0.0186161 7.36262 0 7.26918 0 7.17482C0 7.08046 0.0186161 6.98702 0.0547819 6.89987C0.0909477 6.81271 0.143952 6.73355 0.210761 6.66691L6.66728 0.210384C6.80199 0.0756774 6.98469 0 7.1752 0C7.3657 0 7.5484 0.0756774 7.68311 0.210384C7.81782 0.345091 7.89349 0.527793 7.89349 0.718297C7.89349 0.908802 7.81782 1.0915 7.68311 1.22621L1.73307 7.17482Z'
      fill='black'
    />
  </svg>
);
